import React, { useEffect, useRef, useState } from "react";
import './Css/FinishingSchedule.css';
import './Css/FinishingSchedule-responsive.css';
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";
import { addWeeks, addDays } from "date-fns";

import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Image } from 'primereact/image';
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { Tooltip } from "primereact/tooltip";
import { Nullable } from "primereact/ts-helpers";

import NoDataCreated from "../../Components/NoDataCreated";
import PageLoader from "../../Components/PageLoader";
import ErrorPage from "../../Components/ErrorPage";
import FileInput from "../../Components/FileInput";
import CustomTableLoader from "../../Components/CustomTableLoader";
import TableButton from "../../Components/TableButton";
import TableActionLoader from "../../Components/TableActionLoader";
import TextInput from "../../Components/TextInput";
import NumberInput from "../../Components/NumberInput";
import MulipleFileInput from "../../Components/MulipleFileInput";
import DataException from "../../Components/DataException";
import Textarea from "../../Components/TextArea";
import DataListModalSearch from "../../Components/DataListModal/DataListModalSearch";
import DataListModalClose from "../../Components/DataListModal/DataListModalClose";
import TableActionButton from "../../Components/TableActionButton";
import DatePicker from "../../Components/DatePicker";
import DataListModalInput from "../../Components/DataListModal/DataListModalInput";
import FeatureDataViewModal from "./FeatureDataViewModal";
import ShareModal from "../../Components/ShareModal";
import { goToTop } from "../../Components/goToTop";
import { getAppCurrencyType, useGoBack } from "../../Utils/Common";
import { checkFileOtherList, checkFileOthers, checkModelSelected, checkNumber, checkText } from "../../Utils/Validator";
import { noImageIcon } from "../../Utils/appData";
import { formatDate, parseStringToDate } from "../../Utils/getDate";

import {
    fetchFSProjectList,
    fetchFSApplianceList,
    fetchFSBrandList,
    fetchFSColorList,
    fetchFSItemList,
    fetchFSLocationList,
    fetchFSTypeList,
    fetchFSPaintList,
    fetchFSAccessoryList,
    fetchFSAccessorySubList,
    fetchFSFloorFinishingList,
    fetchFSTileList,
    fetchFSTileShopList,
    fetchFSDoorList,
    fetchFSDoorSizeList,
    FSAccessoryListArgs,
    FSBrandListArgs,
    FSColorListArgs,
    FSTypeListArgs,
    FSLocationListArgs,
    fetchFSBathroomList,
    fetchFSBathroomFeatureList,
    fetchFSKitchenList,
    FSItemArgs,
    fetchFSMainFeatureList,
    fetchFSKitchenCollectionList,
    fetchFSKitchenFinishList,
    fetchFSKitchenRangeList,
    fetchFSLightList,
    fetchFSOtherList,
    fetchFSKitchenStyleList,
} from "../../Controllers/Thunks/FinishingScheduleThunks";
import { FSMainFeature, FSFeature, FSProject, FeatureOption } from "../../Controllers/Types/FinishingSchedule/FinishingSchedule";
import { FSLocation } from "../../Controllers/Types/FinishingSchedule/Location";
import { FSColor } from "../../Controllers/Types/FinishingSchedule/Color";
import { FSBrand } from "../../Controllers/Types/FinishingSchedule/Brand";
import { FSType } from "../../Controllers/Types/FinishingSchedule/Type";
import { FSTileShop } from "../../Controllers/Types/FinishingSchedule/Tile/TileShop";
import { FSTile, FSTileData } from "../../Controllers/Types/FinishingSchedule/Tile/Tile";
import { FSPaint, FSPaintData } from "../../Controllers/Types/FinishingSchedule/Paint/Paint";
import { FSAccessory } from "../../Controllers/Types/FinishingSchedule/Accessory/Accessory";
import { FSAccessorySub } from "../../Controllers/Types/FinishingSchedule/Accessory/AccessorySub";
import { addFSFeatures, deleteFSFeature, deleteFSFile, fsOrderProcess, shareFSFeature } from "../../Api/FinishingScheduleService/FinishingScheduleService";
import { FSAccessoryData } from "../../Controllers/Types/FinishingSchedule/Accessory/AccessoryData";
import { FSDoor, FSDoorData } from "../../Controllers/Types/FinishingSchedule/Door/Door";
import { FSDoorSize } from "../../Controllers/Types/FinishingSchedule/Door/DoorSize";
import { FSFloorFinishingData } from "../../Controllers/Types/FinishingSchedule/FloorFinishing/FloorFinishing";
import { FSItem } from "../../Controllers/Types/FinishingSchedule/Item";
import { FSBathroom, FSBathroomData, FSBathroomFeatureData } from "../../Controllers/Types/FinishingSchedule/Bathroom/Bathroom";
import { FSBathroomFeature } from "../../Controllers/Types/FinishingSchedule/Bathroom/BathroomFeature";
import { FSBathroomSubFeature } from "../../Controllers/Types/FinishingSchedule/Bathroom/BathroomSubFeature";
import { FSAppliance } from "../../Controllers/Types/FinishingSchedule/Appliance";
import { FSKitchen, FSKitchenData } from "../../Controllers/Types/FinishingSchedule/Kitchen/Kitchen";
import { FSKitchenRange } from "../../Controllers/Types/FinishingSchedule/Kitchen/KitchenRange";
import { FSKitchenCollection } from "../../Controllers/Types/FinishingSchedule/Kitchen/KitchenCollection";
import { FSKitchenFinish } from "../../Controllers/Types/FinishingSchedule/Kitchen/KitchenFinish";
import { fsPaintCreate, fsPaintDelete, fsPaintUpdate } from "../../Api/FinishingScheduleService/PaintService/PaintService";
import { createFSBrand, deleteFSBrand, updateFSBrand } from "../../Api/FinishingScheduleService/BrandService";
import { createFSColor, deleteFSColor, updateFSColor } from "../../Api/FinishingScheduleService/ColorService";
import { createFSLocation, deleteFSLocation, updateFSLocation } from "../../Api/FinishingScheduleService/LocationService";
import { fsAccessoryCreate, fsAccessoryDelete, fsAccessoryUpdate } from "../../Api/FinishingScheduleService/PaintService/PaintAccessoryService";
import { createFSAccessoryCategory, deleteFSAccessoryCategory, updateFSAccessoryCategory } from "../../Api/FinishingScheduleService/PaintService/AccessoryService";
import { createFSAccessorySubCategory, deleteFSAccessorySubCategory, updateFSAccessorySubCategory } from "../../Api/FinishingScheduleService/PaintService/AccessorySubService";
import { createFSType, deleteFSType, updateFSType } from "../../Api/FinishingScheduleService/TypeService";
import { createFSShop, deleteFSShop, updateFSShop } from "../../Api/FinishingScheduleService/TilesService/TileShop";
import { fsTileLocationCreate, fsTileLocationDelete, fsTileLocationUpdate, fsTilesCreate, fsTilesDelete, fsTilesUpdate } from "../../Api/FinishingScheduleService/TilesService/TilesService";
import { fsDoorCreate, fsDoorDelete, fsDoorUpdate } from "../../Api/FinishingScheduleService/DoorService/DoorService";
import { fsFloorFinishCreate, fsFloorFinishDelete, fsFloorFinishUpdate } from "../../Api/FinishingScheduleService/FloorFinishingService/FloorFinishingService";
import { FSLight, FSLightData } from "../../Controllers/Types/FinishingSchedule/Light/Light";
import { addFSLightLocation, deleteFSLightLocation, fsLightCreate, fsLightDelete, fsLightUpdate } from "../../Api/FinishingScheduleService/LightService/LightService";
import { createFSItem, deleteFSItem, updateFSItem } from "../../Api/FinishingScheduleService/ItemService";
import { FSOther, FSOtherData } from "../../Controllers/Types/FinishingSchedule/Other/Other";
import { addFSOthersLocation, deleteFSOthersLocation, fsOthersCreate, fsOthersDelete, fsOthersUpdate } from "../../Api/FinishingScheduleService/OthersService/OthersService";
import { createFSKitchenRange, deleteFSKitchenRange, updateFSKitchenRange } from "../../Api/FinishingScheduleService/KitchenService/KitchenRangeService";
import { fsKitchenApplianceCreate, fsKitchenApplianceUpdate, fsKitchenBaseUnitCreate, fsKitchenBaseUnitUpdate, fsKitchenDelete, fsKitchenDoorCreate, fsKitchenDoorUpdate, fsKitchenHandleCreate, fsKitchenHandleUpdate, fsKitchenTypeCreate, fsKitchenTypeUpdate, fsKitchenWallUnitCreate, fsKitchenWallUnitUpdate, fsKitchenWorktopCreate, fsKitchenWorktopUpdate } from "../../Api/FinishingScheduleService/KitchenService/KitchenService";
import { createFSAppliance, deleteFSAppliance, updateFSAppliance } from "../../Api/FinishingScheduleService/ApplianceService";
import { addFSBathroomFeature, addFSBathroomLocation, addFSBathroomSubFeature, deleteFSBathroomFeature, deleteFSBathroomLocation, deleteFSBathroomSubFeature, fsBathroomCreate, fsBathroomDelete, fsBathroomUpdate, updateFSBathroomSubFeature } from "../../Api/FinishingScheduleService/BathroomService/BathroomService";
import { FSDataOrder } from "../../Controllers/Types/FinishingSchedule/Order";
import { ShareContactType, mapShareContactType } from "../../Controllers/Types/Share/ShareContactType";
import { ShareContactTypes } from "../../Controllers/Types/HeyTraderTypes/ShareContactTypes";
import FSReportConfigModal from "./FSReportConfigModal";
import { FSKitchenStyle } from "../../Controllers/Types/FinishingSchedule/Kitchen/KitchenStyle";
import { createFSKitchenStyle, deleteFSKitchenStyle, updateFSKitchenStyle } from "../../Api/FinishingScheduleService/KitchenService/KitchenStyleService";

const FinishingSchedule: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const goBack = useGoBack();
    const toast = useRef<Toast>(null);
    const currencySymbol = getAppCurrencyType();
    const vatPercentage = Number(localStorage.getItem('vat_percentage') || 0);

    const {
        loadingFSProjects, errorFSProjects, fsProjects,
        loadingFSMainFeatures, errorFSMainFeatures, fsMainFeatures,
        loadingFSAppliances, errorFSAppliances, fsAppliances,
        loadingFSBrands, errorFSBrands, fsBrands,
        loadingFSColors, errorFSColors, fsColors,
        loadingFSItems, errorFSItems, fsItems,
        loadingFSLocations, errorFSLocations, fsLocations,
        loadingFSTypes, errorFSTypes, fsTypes,
        loadingFSPaints, errorFSPaints, fsPaints,
        loadingFSAccessories, errorFSAccessories, fsAccessories,
        loadingFSSubAccessories, errorFSSubAccessories, fsSubAccessories,
        loadingFSFloorFinishing, errorFSFloorFinishing, fsFloorFinishing,
        loadingFSTiles, errorFSTiles, fsTiles,
        loadingFSTileShops, errorFSTileShops, fsTileShops,
        loadingFSDoors, errorFSDoors, fsDoors,
        loadingFSDoorSizes, errorFSDoorSizes, fsDoorSizes,
        loadingFSBathrooms, errorFSBathrooms, fsBathrooms,
        loadingFSBathroomFeatures, errorFSBathroomFeatures, fsBathroomFeatures,
        loadingFSKitchens, errorFSKitchens, fsKitchens,
        loadingFSKitchenCollections, errorFSKitchenCollections, fsKitchenCollections,
        loadingFSKitchenFinishes, errorFSKitchenFinishes, fsKitchenFinishes,
        loadingFSKitchenRanges, errorFSKitchenRanges, fsKitchenRanges,
        loadingFSKitchenStyles, errorFSKitchenStyles, fsKitchenStyles,
        loadingFSLights, errorFSLights, fsLights,
        loadingFSOthers, errorFSOthers, fsOthers
    } = useAppSelector((state) => state?.finishingSchedule);

    const [loading, setLoading] = useState<boolean>(false);
    const [shareLoading, setShareLoading] = useState<boolean>(false);
    const [initialDataLoading, setInitialDataLoading] = useState<boolean>(false);
    const [initialSubDataLoading, setInitialSubDataLoading] = useState<boolean>(false);
    const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
    const [navigateFrom, setNavigateFrom] = useState<string | null>(null);
    const [isOwnProject, setIsOwnProject] = useState<boolean>(false);
    const [customLoading, setCustomLoading] = useState<boolean>(false);
    const [customDataState, setCustomDataState] = useState<"Add" | "Edit">("Add");
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

    const [finishingScheduleProject, setFinishingScheduleProject] = useState<FSProject | null>(null);
    const [finishingScheduleFeatures, setFinishingScheduleFeatures] = useState<FSFeature[]>([]);
    const [activeFSFeature, setActiveFSFeature] = useState<FSFeature | null>(null);

    const [subCategories] = useState<string[]>(['Type', 'Base Units', 'Wall Units', 'Worktop', 'Door', 'Handle', 'Appliance', 'Paint']);
    type SubCategory = typeof subCategories[number];
    const [selectedSubCategory, setSelectedSubCategory] = useState<SubCategory | null>(null);
    const [fileDeleteLoadingIndex, setFileDeleteLoadingIndex] = useState<number | null>(null);

    const [fsMainFeatureData, setFSMainFeatureData] = useState<FSMainFeature[]>([]);
    const [showFSMainFeatureListModal, setShowFSMainFeatureListModal] = useState<boolean>(false);
    const [fsMainFeatureSearchKey, setFSMainFeatureSearchKey] = useState<string>('');
    const [selectedFSMainFeatures, setSelectedFSMainFeatures] = useState<FSMainFeature[]>([]);
    const [mainFeatureDeleteLoading, setMainFeatureDeleteLoading] = useState<boolean>(false);
    const [showFSDataViewModal, setShowFSDataViewModal] = useState<boolean>(false);

    /* ************************************************************* Location */
    const [showLocationListModal, setShowLocationListModal] = useState<boolean>(false);
    const [showMultiLocationListModal, setShowMultiLocationListModal] = useState<boolean>(false);
    const [fsLocationsData, setFSLocationsData] = useState<FSLocation[]>([]);
    const [fsLocationSearchKey, setFSLocationSearchKey] = useState<string>('');
    const [selectedFSLocation, setSelectedFSLocation] = useState<FSLocation | null>(null);
    const [selectedFSLocations, setSelectedFSLocations] = useState<FSLocation[]>([]);
    const [customLocationName, setCustomLocationName] = useState<string>('');
    const [customLocationNameError, setCustomLocationNameError] = useState<string>('');
    const [selectedCustomLocation, setSelectedCustomLocation] = useState<FSLocation | null>(null);
    const [customLocationUpdateHasChanges, setCustomLocationUpdateHasChanges] = useState<boolean>(false);
    const [deleteLocationLoadingId, setDeleteLocationLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Color */
    const [showColorListModal, setShowColorListModal] = useState<boolean>(false);
    const [fsColorsData, setFSColorsData] = useState<FSColor[]>([]);
    const [fsColorSearchKey, setFSColorSearchKey] = useState<string>('');
    const [selectedFSColor, setSelectedFSColor] = useState<FSColor | null>(null);
    const [customColorName, setCustomColorName] = useState<string>('');
    const [customColorCode, setCustomColorCode] = useState<string>('');
    const [customColorNameError, setCustomColorNameError] = useState<string>('');
    const [customColorCodeError, setCustomColorCodeError] = useState<string>('');
    const [selectedCustomColor, setSelectedCustomColor] = useState<FSColor | null>(null);
    const [customColorUpdateHasChanges, setCustomColorUpdateHasChanges] = useState<boolean>(false);
    const [deleteColorLoadingId, setDeleteColorLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Brand */
    const [showBrandListModal, setShowBrandListModal] = useState<boolean>(false);
    const [fsBrandsData, setFSBrandsData] = useState<FSBrand[]>([]);
    const [fsBrandSearchKey, setFSBrandSearchKey] = useState<string>('');
    const [selectedFSBrand, setSelectedFSBrand] = useState<FSBrand | null>(null);
    const [customBrandName, setCustomBrandName] = useState<string>('');
    const [customBrandNameError, setCustomBrandNameError] = useState<string>('');
    const [selectedCustomBrand, setSelectedCustomBrand] = useState<FSBrand | null>(null);
    const [customBrandUpdateHasChanges, setCustomBrandUpdateHasChanges] = useState<boolean>(false);
    const [deleteBrandLoadingId, setDeleteBrandLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Type */
    const [showTypeListModal, setShowTypeListModal] = useState<boolean>(false);
    const [fsTypesData, setFSTypesData] = useState<FSType[]>([]);
    const [fsTypeSearchKey, setFSTypeSearchKey] = useState<string>('');
    const [selectedFSType, setSelectedFSType] = useState<FSType | null>(null);
    const [customTypeName, setCustomTypeName] = useState<string>('');
    const [customTypeNameError, setCustomTypeNameError] = useState<string>('');
    const [selectedCustomType, setSelectedCustomType] = useState<FSType | null>(null);
    const [customTypeUpdateHasChanges, setCustomTypeUpdateHasChanges] = useState<boolean>(false);
    const [deleteTypeLoadingId, setDeleteTypeLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Accessory */
    const [showAccessoryListModal, setShowAccessoryListModal] = useState<boolean>(false);
    const [fsAccessoriesData, setFSAccessoriesData] = useState<FSAccessory[]>([]);
    const [fsAccessorySearchKey, setFSAccessorySearchKey] = useState<string>('');
    const [selectedFSAccessory, setSelectedFSAccessory] = useState<FSAccessory | null>(null);
    const [customAccessoryName, setCustomAccessoryName] = useState<string>('');
    const [customAccessoryNameError, setCustomAccessoryNameError] = useState<string>('');
    const [selectedCustomAccessory, setSelectedCustomAccessory] = useState<FSAccessory | null>(null);
    const [customAccessoryUpdateHasChanges, setCustomAccessoryUpdateHasChanges] = useState<boolean>(false);
    const [deleteAccessoryLoadingId, setDeleteAccessoryLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Sub accessory */
    const [showAccessorySubListModal, setShowAccessorySubListModal] = useState<boolean>(false);
    const [fsSubAccessoriesData, setFSSubAccessoriesData] = useState<FSAccessorySub[]>([]);
    const [fsAccessorySubSearchKey, setFSAccessorySubSearchKey] = useState<string>('');
    const [selectedFSAccessorySub, setSelectedFSAccessorySub] = useState<FSAccessorySub | null>(null);
    const [customAccessorySubName, setCustomAccessorySubName] = useState<string>('');
    const [customAccessorySubNameError, setCustomAccessorySubNameError] = useState<string>('');
    const [selectedCustomAccessorySub, setSelectedCustomAccessorySub] = useState<FSAccessorySub | null>(null);
    const [customAccessorySubUpdateHasChanges, setCustomAccessorySubUpdateHasChanges] = useState<boolean>(false);
    const [deleteAccessorySubLoadingId, setDeleteAccessorySubLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Tile shop */
    const [showTileShopListModal, setShowTileShopListModal] = useState<boolean>(false);
    const [fsTileShopsData, setFSTileShopsData] = useState<FSTileShop[]>([]);
    const [fsTileShopSearchKey, setFSTileShopSearchKey] = useState<string>('');
    const [selectedFSTileShop, setSelectedFSTileShop] = useState<FSTileShop | null>(null);
    const [customTileShopName, setCustomTileShopName] = useState<string>('');
    const [customTileShopNameError, setCustomTileShopNameError] = useState<string>('');
    const [selectedCustomTileShop, setSelectedCustomTileShop] = useState<FSTileShop | null>(null);
    const [customTileShopUpdateHasChanges, setCustomTileShopUpdateHasChanges] = useState<boolean>(false);
    const [deleteTileShopLoadingId, setDeleteTileShopLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Item */
    const [showItemListModal, setShowItemListModal] = useState<boolean>(false);
    const [fsItemsData, setFSItemsData] = useState<FSItem[]>([]);
    const [fsItemSearchKey, setFSItemSearchKey] = useState<string>('');
    const [selectedFSItem, setSelectedFSItem] = useState<FSItem | null>(null);
    const [customItemName, setCustomItemName] = useState<string>('');
    const [customItemNameError, setCustomItemNameError] = useState<string>('');
    const [selectedCustomItem, setSelectedCustomItem] = useState<FSItem | null>(null);
    const [customItemUpdateHasChanges, setCustomItemUpdateHasChanges] = useState<boolean>(false);
    const [deleteItemLoadingId, setDeleteItemLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Appliance */
    const [showApplianceListModal, setShowApplianceListModal] = useState<boolean>(false);
    const [fsAppliancesData, setFSAppliancesData] = useState<FSAppliance[]>([]);
    const [fsApplianceSearchKey, setFSApplianceSearchKey] = useState<string>('');
    const [selectedFSAppliance, setSelectedFSAppliance] = useState<FSAppliance | null>(null);
    const [customApplianceName, setCustomApplianceName] = useState<string>('');
    const [customApplianceNameError, setCustomApplianceNameError] = useState<string>('');
    const [selectedCustomAppliance, setSelectedCustomAppliance] = useState<FSAppliance | null>(null);
    const [customApplianceUpdateHasChanges, setCustomApplianceUpdateHasChanges] = useState<boolean>(false);
    const [deleteApplianceLoadingId, setDeleteApplianceLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Kitchen range */
    const [showKitchenRangeListModal, setShowKitchenRangeListModal] = useState<boolean>(false);
    const [fsKitchenRangesData, setFSKitchenRangesData] = useState<FSKitchenRange[]>([]);
    const [fsKitchenRangeSearchKey, setFSKitchenRangeSearchKey] = useState<string>('');
    const [selectedFSKitchenRange, setSelectedFSKitchenRange] = useState<FSKitchenRange | null>(null);
    const [customKitchenRangeName, setCustomKitchenRangeName] = useState<string>('');
    const [customKitchenRangeNameError, setCustomKitchenRangeNameError] = useState<string>('');
    const [selectedCustomKitchenRange, setSelectedCustomKitchenRange] = useState<FSKitchenRange | null>(null);
    const [customKitchenRangeUpdateHasChanges, setCustomKitchenRangeUpdateHasChanges] = useState<boolean>(false);
    const [deleteKitchenRangeLoadingId, setDeleteKitchenRangeLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Kitchen style */
    const [showKitchenStyleListModal, setShowKitchenStyleListModal] = useState<boolean>(false);
    const [fsKitchenStylesData, setFSKitchenStylesData] = useState<FSKitchenStyle[]>([]);
    const [fsKitchenStyleSearchKey, setFSKitchenStyleSearchKey] = useState<string>('');
    const [selectedFSKitchenStyle, setSelectedFSKitchenStyle] = useState<FSKitchenStyle | null>(null);
    const [customKitchenStyleName, setCustomKitchenStyleName] = useState<string>('');
    const [customKitchenStyleNameError, setCustomKitchenStyleNameError] = useState<string>('');
    const [selectedCustomKitchenStyle, setSelectedCustomKitchenStyle] = useState<FSKitchenStyle | null>(null);
    const [customKitchenStyleUpdateHasChanges, setCustomKitchenStyleUpdateHasChanges] = useState<boolean>(false);
    const [deleteKitchenStyleLoadingId, setDeleteKitchenStyleLoadingId] = useState<number | null>(null);
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Door fields */
    const [fsDoorData, setFSDoorData] = useState<FSDoor[]>([]);
    const [fsDoorAccessoryData, setFSDoorAccessoryData] = useState<FSDoor | null>(null);
    const [selectedFSDoorData, setSelectedFSDoorData] = useState<FSDoor | null>(null);
    const [showDoorDetailModal, setShowDoorDetailModal] = useState<boolean>(false);
    const [doorDetailDeleteLoadingId, setDoorDetailDeleteLoadingId] = useState<number | null>(null);
    const [selectedDoorDetail, setSelectedDoorDetail] = useState<FSDoorData | null>(null);
    const [doorDetailUpdateHasChanges, setDoorDetailUpdateHasChanges] = useState<boolean>(false);
    const [doorFinishStatuses] = useState<string[]>(['Prefinished', 'Half-Finished', 'Unfinished']);
    const [doorFireResistanceRating, setDoorFireResistanceRating] = useState<'FD30' | 'FD60' | null>(null);
    const [doorSizeType, setDoorSizeType] = useState<'Standard size' | 'Non standard size'>('Standard size');
    const [doorSize, setDoorSize] = useState<FSDoorSize | null>(null);
    const [doorManualSize, setDoorManualSize] = useState<string | null>(null);
    const [doorNumber, setDoorNumber] = useState<number | null>(null);
    const [doorFinishStatus, setDoorFinishStatus] = useState<'Prefinished' | 'Half-Finished' | 'Unfinished'>('Prefinished');
    const [doorNote, setDoorNote] = useState<string | null>(null);
    const [doorImageFile, setDoorImageFile] = useState<File | null>(null);
    const [doorImageFileName, setDoorImageFileName] = useState<string>("");
    const [doorFiles, setDoorFiles] = useState<File[]>([]);

    // errors
    const [doorColorError, setDoorColorError] = useState<string>('');
    const [doorFireResistanceRatingError, setDoorFireResistanceRatingError] = useState<string>('');
    const [doorSizeError, setDoorSizeError] = useState<string>('');
    const [doorSizeTypeError, setDoorSizeTypeError] = useState<string>('');
    const [doorManualSizeError, setDoorManualSizeError] = useState<string>('');
    const [doorNumberError, setDoorNumberError] = useState<string>('');
    const [doorFinishStatusError, setDoorFinishStatusError] = useState<string>('');
    const [doorNoteError, setDoorNoteError] = useState<string>('');
    const [doorImageFileError, setDoorImageFileError] = useState<string>('');
    const [doorFilesError, setDoorFilesError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Paint fields */
    const [fsPaintData, setFSPaintData] = useState<FSPaint | null>(null);
    const [fsPaintAccessoryData, setFSPaintAccessoryData] = useState<FSPaint | null>(null);
    const [showPaintDetailModal, setShowPaintDetailModal] = useState<boolean>(false);
    const [paintDetailDeleteLoadingId, setPaintDetailDeleteLoadingId] = useState<number | null>(null);
    const [selectedPaintDetail, setSelectedPaintDetail] = useState<FSPaintData | null>(null);
    const [paintDetailUpdateHasChanges, setPaintDetailUpdateHasChanges] = useState<boolean>(false);
    const [paintTypes] = useState<string[]>(['Wall', 'Ceiling']);
    const [paintType, setPaintType] = useState<'Wall' | 'Ceiling' | null>(null);
    const [paintLink, setPaintLink] = useState<string | null>(null);
    const [paintImageFile, setPaintImageFile] = useState<File | null>(null);
    const [paintImageFileName, setPaintImageFileName] = useState<string>("");
    const [paintFiles, setPaintFiles] = useState<File[]>([]);

    // errors
    const [paintBrandError, setPaintBrandError] = useState<string>('');
    const [paintTypeError, setPaintTypeError] = useState<string>('');
    const [paintColorError, setPaintColorError] = useState<string>('');
    const [paintLocationError, setPaintLocationError] = useState<string>('');
    const [paintLinkError, setPaintLinkError] = useState<string>('');
    const [paintImageFileError, setPaintImageFileError] = useState<string>('');
    const [paintFilesError, setPaintFilesError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Bathroom fields */
    // Bathroom location
    const [selectedBathroom, setSelectedBathroom] = useState<FSBathroom | null>(null);
    const [activeBathroomLocation, setActiveBathroomLocation] = useState<FSBathroom | null>(null);
    const [showBathroomLocationModal, setShowBathroomLocationModal] = useState<boolean>(false);
    const [bathroomLocationDeleteLoadingId, setBathroomLocationDeleteLoadingId] = useState<number | null>(null);
    const [bathroomLocationError, setBathroomLocationError] = useState<string>('');

    // Bathroom feature
    const [selectedBathroomFeature, setSelectedBathroomFeature] = useState<FSBathroomFeatureData | null>(null);
    const [bathroomFeatureData, setBathroomFeatureData] = useState<FSBathroomFeature[]>([]);
    const [selectedBathroomFeatures, setSelectedBathroomFeatures] = useState<FSBathroomFeature[]>([]);
    const [showBathroomFeatureListModal, setShowBathroomFeatureListModal] = useState<boolean>(false);
    const [fsBathroomFeatureSearchKey, setFSBathroomFeatureSearchKey] = useState<string>('');
    const [bathroomFeatureDeleteLoadingId, setBathroomFeatureDeleteLoadingId] = useState<number | null>(null);

    // Bathroom sub feature
    const [selectedBathroomDetail, setSelectedBathroomDetail] = useState<FSBathroomData | null>(null);
    const [bathroomSubFeatureData, setBathroomSubFeatureData] = useState<FSBathroomSubFeature[]>([]);
    const [selectedBathroomSubFeatures, setSelectedBathroomSubFeatures] = useState<FSBathroomSubFeature[]>([]);
    const [showBathroomSubFeatureListModal, setShowBathroomSubFeatureListModal] = useState<boolean>(false);
    const [fsBathroomSubFeatureSearchKey, setFSBathroomSubFeatureSearchKey] = useState<string>('');
    const [customBathroomSubFeatureName, setCustomBathroomSubFeatureName] = useState<string>('');
    const [customBathroomSubFeatureNameError, setCustomBathroomSubFeatureNameError] = useState<string>('');
    const [selectedCustomBathroomSubFeature, setSelectedCustomBathroomSubFeature] = useState<FSBathroomSubFeature | null>(null);
    const [customBathroomSubFeatureUpdateHasChanges, setCustomBathroomSubFeatureUpdateHasChanges] = useState<boolean>(false);
    const [deleteBathroomSubFeatureLoadingId, setDeleteBathroomSubFeatureLoadingId] = useState<number | null>(null);

    // Bathroom detail
    const [showBathroomDetailModal, setShowBathroomDetailModal] = useState<boolean>(false);
    const [bathroomDetailUpdateHasChanges, setBathroomDetailUpdateHasChanges] = useState<boolean>(false);
    const [bathroomDetailDeleteLoadingId, setBathroomDetailDeleteLoadingId] = useState<number | null>(null);
    const [bathroomName, setBathroomName] = useState<string>('');
    const [bathroomSize, setBathroomSize] = useState<string>('');
    const [bathroomLink, setBathroomLink] = useState<string | null>(null);
    const [bathroomImageFile, setBathroomImageFile] = useState<File | null>(null);
    const [bathroomImageFileName, setBathroomImageFileName] = useState<string>("");
    const [bathroomFiles, setBathroomFiles] = useState<File[]>([]);

    // error
    const [bathroomNameError, setBathroomNameError] = useState<string>('');
    const [bathroomBrandError, setBathroomBrandError] = useState<string>('');
    const [bathroomColorError, setBathroomColorError] = useState<string>('');
    const [bathroomSizeError, setBathroomSizeError] = useState<string>('');
    const [bathroomLinkError, setBathroomLinkError] = useState<string>('');
    const [bathroomImageFileError, setBathroomImageFileError] = useState<string>('');
    const [bathroomFilesError, setBathroomFilesError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Kitchen fields */
    // Kitchen detail
    const [fsKitchenData, setFSKitchenData] = useState<FSKitchen | null>(null);
    const kitchenOptions = ['Type', 'Base Units', 'Wall Units', 'Worktop', 'Door', 'Handle'] as const;
    type KitchenOption = typeof kitchenOptions[number];
    const [selectedKitchenOption, setSelectedKitchenOption] = useState<KitchenOption | null>(null);
    const [showKitchenOptionModal, setShowKitchenOptionModal] = useState<boolean>(false);
    const [showKitchenDetailModal, setShowKitchenDetailModal] = useState<boolean>(false);
    const [kitchenDetailUpdateHasChanges, setKitchenDetailUpdateHasChanges] = useState<boolean>(false);
    const [kitchenDetailDeleteLoadingId, setKitchenDetailDeleteLoadingId] = useState<number | null>(null);
    const [selectedKitchenDetail, setSelectedKitchenDetail] = useState<FSKitchenData | null>(null);
    const [selectedFSKitchenCollection, setSelectedFSKitchenCollection] = useState<FSKitchenCollection | null>(null);
    const [selectedFSKitchenFinish, setSelectedFSKitchenFinish] = useState<FSKitchenFinish | null>(null);
    const [kitchenLink, setKitchenLink] = useState<string | null>(null);
    const [kitchenDepth, setKitchenDepth] = useState<number | null>(null);
    const [kitchenThickness, setKitchenThickness] = useState<number | null>(null);
    const [kitchenName, setKitchenName] = useState<string>('');
    const [kitchenNumber, setKitchenNumber] = useState<number | null>(null);
    const [kitchenImageFile, setKitchenImageFile] = useState<File | null>(null);
    const [kitchenImageFileName, setKitchenImageFileName] = useState<string>("");
    const [kitchenFiles, setKitchenFiles] = useState<File[]>([]);

    // error
    const [kitchenBrandError, setKitchenBrandError] = useState<string>('');
    const [kitchenNameError, setKitchenNameError] = useState<string>('');
    const [kitchenDepthError, setKitchenDepthError] = useState<string>('');
    const [kitchenThicknessError, setKitchenThicknessError] = useState<string>('');
    const [kitchenStyleError, setKitchenStyleError] = useState<string>('');
    const [kitchenNumberError, setKitchenNumberError] = useState<string>('');
    const [kitchenCollectionError, setKitchenCollectionError] = useState<string>('');
    const [kitchenRangeError, setKitchenRangeError] = useState<string>('');
    const [kitchenColorError, setKitchenColorError] = useState<string>('');
    const [kitchenTypeError, setKitchenTypeError] = useState<string>('');
    const [kitchenFinishError, setKitchenFinishError] = useState<string>('');
    const [kitchenLinkError, setKitchenLinkError] = useState<string>('');
    const [kitchenImageFileError, setKitchenImageFileError] = useState<string>('');
    const [kitchenFilesError, setKitchenFilesError] = useState<string>('');


    // Kitchen appliance detail
    const [fsKitchenApplianceData, setFSKitchenApplianceData] = useState<FSKitchen | null>(null);
    const [selectedKitchenApplianceDetail, setSelectedKitchenApplianceDetail] = useState<FSKitchenData | null>(null);
    const [showKitchenApplianceDetailModal, setShowKitchenApplianceDetailModal] = useState<boolean>(false);
    const [kitchenApplianceDetailUpdateHasChanges, setKitchenApplianceDetailUpdateHasChanges] = useState<boolean>(false);
    const [kitchenApplianceDetailDeleteLoadingId, setKitchenApplianceDetailDeleteLoadingId] = useState<number | null>(null);
    const [kitchenApplianceName, setKitchenApplianceName] = useState<string>('');
    const [kitchenApplianceLink, setKitchenApplianceLink] = useState<string | null>(null);
    const [kitchenApplianceFiles, setKitchenApplianceFiles] = useState<File[]>([]);
    const [kitchenApplianceImageFile, setKitchenApplianceImageFile] = useState<File | null>(null);
    const [kitchenApplianceImageFileName, setKitchenApplianceImageFileName] = useState<string>("");

    // error
    const [kitchenApplianceError, setKitchenApplianceError] = useState<string>('');
    const [kitchenApplianceBrandError, setKitchenApplianceBrandError] = useState<string>('');
    const [kitchenApplianceNameError, setKitchenApplianceNameError] = useState<string>('');
    const [kitchenApplianceColorError, setKitchenApplianceColorError] = useState<string>('');
    const [kitchenApplianceLinkError, setKitchenApplianceLinkError] = useState<string>('');
    const [kitchenApplianceFilesError, setKitchenApplianceFilesError] = useState<string>('');
    const [kitchenApplianceImageFileError, setKitchenApplianceImageFileError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Tiles fields */
    const [fsTilesData, setFSTilesData] = useState<FSTile[]>([]);
    const [activeTileLocation, setActiveTileLocation] = useState<FSTile | null>(null);
    const [fsTilesAccessoryData, setFSTilesAccessoryData] = useState<FSTile | null>(null);
    const [showTilesModal, setShowTilesModal] = useState<boolean>(false);
    const [tileLocation, setTileLocation] = useState<string>('');
    const [tileLocationUpdateHasChanges, setTileLocationUpdateHasChanges] = useState<boolean>(false);
    const [tileDetailUpdateHasChanges, setTileDetailUpdateHasChanges] = useState<boolean>(false);
    const [tileDetailDeleteLoadingId, setTileDetailDeleteLoadingId] = useState<number | null>(null);
    const [selectedTile, setSelectedTile] = useState<FSTile | null>(null);
    const [selectedTileDetail, setSelectedTileDetail] = useState<FSTileData | null>(null);
    const [showTileDetailModal, setShowTileDetailModal] = useState<boolean>(false);
    const [tileName, setTileName] = useState<string>('');
    const [tileQuantity, setTileQuantity] = useState<number | null>(null);
    const [tileSize, setTileSize] = useState<number | null>(null);
    const [tileLink, setTileLink] = useState<string | null>(null);
    const [tileImageFile, setTileImageFile] = useState<File | null>(null);
    const [tileImageFileName, setTileImageFileName] = useState<string>("");
    const [tileFiles, setTileFiles] = useState<File[]>([]);

    // errors
    const [tileLocationError, setTileLocationError] = useState<string>('');
    const [tileTypeError, setTileTypeError] = useState<string>('');
    const [tileNameError, setTileNameError] = useState<string>('');
    const [tileQuantityError, setTileQuantityError] = useState<string>('');
    const [tileShopError, setTileShopError] = useState<string>('');
    const [tileColorError, setTileColorError] = useState<string>('');
    const [tileSizeError, setTileSizeError] = useState<string>('');
    const [tileLinkError, setTileLinkError] = useState<string>('');
    const [tileImageFileError, setTileImageFileError] = useState<string>('');
    const [tileFilesError, setTileFilesError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Floor finishing fields */
    const [floorFinishingData, setFloorFinishingData] = useState<FSFloorFinishingData[]>([]);
    const [selectedFloorFinishingData, setSelectedFloorFinishingData] = useState<FSFloorFinishingData | null>(null);
    const [showFloorFinishingDetailModal, setShowFloorFinishingDetailModal] = useState<boolean>(false);
    const [floorFinishingDetailUpdateHasChanges, setFloorFinishingDetailUpdateHasChanges] = useState<boolean>(false);
    const [floorFinishingDetailDeleteLoadingId, setFloorFinishingDetailDeleteLoadingId] = useState<number | null>(null);
    const [floorFinishingName, setFloorFinishingName] = useState<string>('');
    const [floorFinishingLink, setFloorFinishingLink] = useState<string | null>(null);
    const [floorFinishingNote, setFloorFinishingNote] = useState<string | null>(null);
    const [floorFinishingImageFile, setFloorFinishingImageFile] = useState<File | null>(null);
    const [floorFinishingImageFileName, setFloorFinishingImageFileName] = useState<string>("");
    const [floorFinishingFiles, setFloorFinishingFiles] = useState<File[]>([]);

    // errors
    const [floorFinishingLocationError, setFloorFinishingLocationError] = useState<string>('');
    const [floorFinishingTypeError, setFloorFinishingTypeError] = useState<string>('');
    const [floorFinishingNameError, setFloorFinishingNameError] = useState<string>('');
    const [floorFinishingBrandError, setFloorFinishingBrandError] = useState<string>('');
    const [floorFinishingLinkError, setFloorFinishingLinkError] = useState<string>('');
    const [floorFinishingNoteError, setFloorFinishingNoteError] = useState<string>('');
    const [floorFinishingImageFileError, setFloorFinishingImageFileError] = useState<string>('');
    const [floorFinishingFilesError, setFloorFinishingFilesError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Light fields */
    // Light location
    const [fsLightsData, setFSLightsData] = useState<FSLight[]>([]);
    const [activeLightLocation, setActiveLightLocation] = useState<FSLight | null>(null);
    const [showLightLocationModal, setShowLightLocationModal] = useState<boolean>(false);
    const [lightLocationDeleteLoadingId, setLightLocationDeleteLoadingId] = useState<number | null>(null);
    const [lightLocationError, setLightLocationError] = useState<string>('');

    // Light details
    const [showLightDetailModal, setShowLightDetailModal] = useState<boolean>(false);
    const [lightDetailUpdateHasChanges, setLightDetailUpdateHasChanges] = useState<boolean>(false);
    const [lightDetailDeleteLoadingId, setLightDetailDeleteLoadingId] = useState<number | null>(null);
    const [selectedLightDetail, setSelectedLightDetail] = useState<FSLightData | null>(null);
    const [lightNumber, setLightNumber] = useState<number | null>(null);
    const [lightLink, setLightLink] = useState<string | null>(null);
    const [lightImageFile, setLightImageFile] = useState<File | null>(null);
    const [lightImageFileName, setLightImageFileName] = useState<string>("");
    const [lightFiles, setLightFiles] = useState<File[]>([]);

    // errors
    const [lightItemError, setLightItemError] = useState<string>('');
    const [lightNumberError, setLightNumberError] = useState<string>('');
    const [lightTypeError, setLightTypeError] = useState<string>('');
    const [lightLinkError, setLightLinkError] = useState<string>('');
    const [lightImageFileError, setLightImageFileError] = useState<string>('');
    const [lightFilesError, setLightFilesError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Other fields */
    // Other location
    const [fsOthersData, setFSOthersData] = useState<FSOther[]>([]);
    const [activeOtherLocation, setActiveOtherLocation] = useState<FSOther | null>(null);
    const [showOtherLocationModal, setShowOtherLocationModal] = useState<boolean>(false);
    const [otherLocationDeleteLoadingId, setOtherLocationDeleteLoadingId] = useState<number | null>(null);
    const [otherLocationError, setOtherLocationError] = useState<string>('');

    // Other details
    const [showOtherDetailModal, setShowOtherDetailModal] = useState<boolean>(false);
    const [otherDetailUpdateHasChanges, setOtherDetailUpdateHasChanges] = useState<boolean>(false);
    const [otherDetailDeleteLoadingId, setOtherDetailDeleteLoadingId] = useState<number | null>(null);
    const [selectedOtherDetail, setSelectedOtherDetail] = useState<FSOtherData | null>(null);
    const [otherFlooringScreed, setOtherFlooringScreed] = useState<string>('');
    const [otherNumber, setOtherNumber] = useState<number | null>(null);
    const [otherLink, setOtherLink] = useState<string | null>(null);
    const [otherImageFile, setOtherImageFile] = useState<File | null>(null);
    const [otherImageFileName, setOtherImageFileName] = useState<string>("");
    const [otherFiles, setOtherFiles] = useState<File[]>([]);

    // errors
    const [otherFlooringScreedError, setOtherFlooringScreedError] = useState<string>('');
    const [otherBrandError, setOtherBrandError] = useState<string>('');
    const [otherNumberError, setOtherNumberError] = useState<string>('');
    const [otherLinkError, setOtherLinkError] = useState<string>('');
    const [otherImageFileError, setOtherImageFileError] = useState<string>('');
    const [otherFilesError, setOtherFilesError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Accessory detail fields */
    const [fsDataAccessory, setFSDataAccessory] = useState<FSAccessoryData[]>([]);
    const [loadingAccessoryData, setLoadingAccessoryData] = useState<boolean>(false);
    const [showAccessoryDetailModal, setShowAccessoryDetailModal] = useState<boolean>(false);
    const [accessoryDetailDeleteLoadingId, setAccessoryDetailDeleteLoadingId] = useState<number | null>(null);
    const [selectedAccessoryDetail, setSelectedAccessoryDetail] = useState<FSAccessoryData | null>(null);
    const [accessoryDetailUpdateHasChanges, setAccessoryDetailUpdateHasChanges] = useState<boolean>(false);
    const [accessoryNumber, setAccessoryNumber] = useState<number | null>(null);
    const [accessoryReference, setAccessoryReference] = useState<string | null>(null);
    const [accessoryLink, setAccessoryLink] = useState<string | null>(null);
    const [accessoryImageFile, setAccessoryImageFile] = useState<File | null>(null);
    const [accessoryImageFileName, setAccessoryImageFileName] = useState<string>("");
    const [accessoryFiles, setAccessoryFiles] = useState<File[]>([]);

    // errors
    const [accessoryNameError, setAccessoryNameError] = useState<string>('');
    const [subAccessoryNameError, setSubAccessoryNameError] = useState<string>('');
    const [accessoryNumberError, setAccessoryNumberError] = useState<string>('');
    const [accessoryReferenceError, setAccessoryReferenceError] = useState<string>('');
    const [accessoryLinkError, setAccessoryLinkError] = useState<string>('');
    const [accessoryImageFileError, setAccessoryImageFileError] = useState<string>('');
    const [accessoryFilesError, setAccessoryFilesError] = useState<string>('');
    /* ************************************************************* */


    /* ************************************************************* Order fields */
    const [orderDataId, setOrderDataId] = useState<number | null>(null);
    const [orderTitle, setOrderTitle] = useState<string | null>(null);
    const [showOrderModal, setShowOrderModal] = useState<boolean>(false);
    const [selectedOrderData, setSelectedOrderData] = useState<FSDataOrder | null>(null);
    const [orderDetailUpdateHasChanges, setOrderDetailUpdateHasChanges] = useState<boolean>(false);
    const [orderIsForAccessory, setOrderIsForAccessory] = useState<1 | 0>(0);
    const [orderStatuses] = useState<string[]>(['Pending', 'Ordered', 'Instore', 'Onsite'])
    const [orderStatus, setOrderStatus] = useState<'Pending' | 'Ordered' | 'Instore' | 'Onsite'>('Pending');
    const [orderWeekCount, setOrderWeekCount] = useState<number | null>(null);
    const [orderDayCount, setOrderDayCount] = useState<number | null>(null);
    const [orderDate, setOrderDate] = useState<Nullable<Date>>(null);
    const [orderIsPriceIncluded, setOrderIsPriceIncluded] = useState<1 | 0>(0);
    const [orderPrice, setOrderPrice] = useState<number | null>(null);
    const [orderIsVatIncluded, setOrderIsVatIncluded] = useState<1 | 0>(1);
    const [orderNote, setOrderNote] = useState<string | null>(null);

    // error
    const [orderStatusError, setOrderStatusError] = useState<string>('');
    const [orderWeekError, setOrderWeekError] = useState<string>('');
    const [orderDayError, setOrderDayError] = useState<string>('');
    const [orderDateError, setOrderDateError] = useState<string>('');
    const [orderPriceError, setOrderPriceError] = useState<string>('');
    const [orderNoteError, setOrderNoteError] = useState<string>('');
    /* ************************************************************* */

    /* ************************************************************* Share fields */
    const [showContactShareModal, setShowContactShareModal] = useState<boolean>(false);
    const [finishingScheduleContactsData, setFinishingScheduleContactsData] = useState<ShareContactTypes[]>([]);
    const [projectContactIds, setProjectContactIds] = useState<number[]>([]);
    const [sharedList, setSharedList] = useState<ShareContactType[]>([]);
    /* ************************************************************* */

    /* ************************************************************* Report fields */
    const [showReportConfigModal, setShowReportConfigModal] = useState<boolean>(false);
    const [selectedFeatureOptions, setSelectedFeatureOptions] = useState<FeatureOption[]>([]);
    /* ************************************************************* */

    const canModify = (isOwnProject || activeFSFeature?.can_edit === true);

    /* ************************************************************* Permission handler */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) =>
            hasPermission(state, screen, permission)
        );
    };

    const hasPermissionForAddMainFeature = useCanEdit("Finishing Schedule", "add_main_feature") && canModify;
    const hasPermissionForDeleteMainFeature = useCanEdit("Finishing Schedule", "delete_main_feature") && canModify;
    const hasPermissionForAddBrand = useCanEdit("Finishing Schedule", "add_brand") && canModify;
    const hasPermissionForUpdateBrand = useCanEdit("Finishing Schedule", "update_brand") && canModify;
    const hasPermissionForDeleteBrand = useCanEdit("Finishing Schedule", "delete_brand") && canModify;
    const hasPermissionForAddColor = useCanEdit("Finishing Schedule", "add_color") && canModify;
    const hasPermissionForUpdateColor = useCanEdit("Finishing Schedule", "update_color") && canModify;
    const hasPermissionForDeleteColor = useCanEdit("Finishing Schedule", "delete_color") && canModify;
    const hasPermissionForAddLocation = useCanEdit("Finishing Schedule", "add_location") && canModify;
    const hasPermissionForUpdateLocation = useCanEdit("Finishing Schedule", "update_location") && canModify;
    const hasPermissionForDeleteLocation = useCanEdit("Finishing Schedule", "delete_location") && canModify;
    const hasPermissionForDeleteFile = useCanEdit("Finishing Schedule", "delete_file") && canModify;
    const hasPermissionForAddAccessory = useCanEdit("Finishing Schedule", "add_accessory") && canModify;
    const hasPermissionForUpdateAccessory = useCanEdit("Finishing Schedule", "update_accessory") && canModify;
    const hasPermissionForDeleteAccessory = useCanEdit("Finishing Schedule", "delete_accessory") && canModify;
    const hasPermissionForAddSubAccessory = useCanEdit("Finishing Schedule", "add_sub_accessory") && canModify;
    const hasPermissionForUpdateSubAccessory = useCanEdit("Finishing Schedule", "update_sub_accessory") && canModify;
    const hasPermissionForDeleteSubAccessory = useCanEdit("Finishing Schedule", "delete_sub_accessory") && canModify;
    const hasPermissionForAddAccessoryDetail = useCanEdit("Finishing Schedule", "add_accessory_detail") && canModify;
    const hasPermissionForUpdateAccessoryDetail = useCanEdit("Finishing Schedule", "update_accessory_detail") && canModify;
    const hasPermissionForDeleteAccessoryDetail = useCanEdit("Finishing Schedule", "delete_accessory_detail") && canModify;
    const hasPermissionForAddDoor = useCanEdit("Finishing Schedule", "add_door") && canModify;
    const hasPermissionForUpdateDoor = useCanEdit("Finishing Schedule", "update_door") && canModify;
    const hasPermissionForDeleteDoor = useCanEdit("Finishing Schedule", "delete_door") && canModify;
    const hasPermissionForAddPaint = useCanEdit("Finishing Schedule", "add_paint") && canModify;
    const hasPermissionForUpdatePaint = useCanEdit("Finishing Schedule", "update_paint") && canModify;
    const hasPermissionForDeletePaint = useCanEdit("Finishing Schedule", "delete_paint") && canModify;
    const hasPermissionForAddTileLocation = useCanEdit("Finishing Schedule", "add_tile_location") && canModify;
    const hasPermissionForUpdateTileLocation = useCanEdit("Finishing Schedule", "update_tile_location") && canModify;
    const hasPermissionForDeleteTileLocation = useCanEdit("Finishing Schedule", "delete_tile_location") && canModify;
    const hasPermissionForAddTileShop = useCanEdit("Finishing Schedule", "add_tile_shop") && canModify;
    const hasPermissionForUpdateTileShop = useCanEdit("Finishing Schedule", "update_tile_shop") && canModify;
    const hasPermissionForDeleteTileShop = useCanEdit("Finishing Schedule", "delete_tile_shop") && canModify;
    const hasPermissionForAddTile = useCanEdit("Finishing Schedule", "add_tile") && canModify;
    const hasPermissionForUpdateTile = useCanEdit("Finishing Schedule", "update_tile") && canModify;
    const hasPermissionForDeleteTile = useCanEdit("Finishing Schedule", "delete_tile") && canModify;
    const hasPermissionForAddType = useCanEdit("Finishing Schedule", "add_type") && canModify;
    const hasPermissionForUpdateType = useCanEdit("Finishing Schedule", "update_type") && canModify;
    const hasPermissionForDeleteType = useCanEdit("Finishing Schedule", "delete_type") && canModify;
    const hasPermissionForAddBathroom = useCanEdit("Finishing Schedule", "add_bathroom") && canModify;
    const hasPermissionForUpdateBathroom = useCanEdit("Finishing Schedule", "update_bathroom") && canModify;
    const hasPermissionForDeleteBathroom = useCanEdit("Finishing Schedule", "delete_bathroom") && canModify;
    const hasPermissionForAddBathroomLocation = useCanEdit("Finishing Schedule", "add_bathroom_location") && canModify;
    const hasPermissionForDeleteBathroomLocation = useCanEdit("Finishing Schedule", "delete_bathroom_location") && canModify;
    const hasPermissionForAddBathroomFeature = useCanEdit("Finishing Schedule", "add_bathroom_feature") && canModify;
    const hasPermissionForDeleteBathroomFeature = useCanEdit("Finishing Schedule", "delete_bathroom_feature") && canModify;
    const hasPermissionForAddBathroomSubFeature = useCanEdit("Finishing Schedule", "add_bathroom_sub_feature") && canModify;
    const hasPermissionForAddSubFeature = useCanEdit("Finishing Schedule", "add_sub_feature") && canModify;
    const hasPermissionForUpdateSubFeature = useCanEdit("Finishing Schedule", "update_sub_feature") && canModify;
    const hasPermissionForDeleteSubFeature = useCanEdit("Finishing Schedule", "delete_sub_feature") && canModify;
    const hasPermissionForAddFloorFinishing = useCanEdit("Finishing Schedule", "add_floor_finishing") && canModify;
    const hasPermissionForUpdateFloorFinishing = useCanEdit("Finishing Schedule", "update_floor_finishing") && canModify;
    const hasPermissionForDeleteFloorFinishing = useCanEdit("Finishing Schedule", "delete_floor_finishing") && canModify;
    const hasPermissionForAddItem = useCanEdit("Finishing Schedule", "add_item") && canModify;
    const hasPermissionForUpdateItem = useCanEdit("Finishing Schedule", "update_item") && canModify;
    const hasPermissionForDeleteItem = useCanEdit("Finishing Schedule", "delete_item") && canModify;
    const hasPermissionForAddAppliance = useCanEdit("Finishing Schedule", "add_appliance") && canModify;
    const hasPermissionForUpdateAppliance = useCanEdit("Finishing Schedule", "update_appliance") && canModify;
    const hasPermissionForDeleteAppliance = useCanEdit("Finishing Schedule", "delete_appliance") && canModify;
    const hasPermissionForAddKitchen = useCanEdit("Finishing Schedule", "add_kitchen") && canModify;
    const hasPermissionForUpdateKitchen = useCanEdit("Finishing Schedule", "update_kitchen") && canModify;
    const hasPermissionForDeleteKitchen = useCanEdit("Finishing Schedule", "delete_kitchen") && canModify;
    const hasPermissionForAddKitchenAppliance = useCanEdit("Finishing Schedule", "add_kitchen_appliance") && canModify;
    const hasPermissionForUpdateKitchenAppliance = useCanEdit("Finishing Schedule", "update_kitchen_appliance") && canModify;
    const hasPermissionForDeleteKitchenAppliance = useCanEdit("Finishing Schedule", "delete_kitchen_appliance") && canModify;
    const hasPermissionForAddKitchenRange = useCanEdit("Finishing Schedule", "add_kitchen_range") && canModify;
    const hasPermissionForUpdateKitchenRange = useCanEdit("Finishing Schedule", "update_kitchen_range") && canModify;
    const hasPermissionForDeleteKitchenRange = useCanEdit("Finishing Schedule", "delete_kitchen_range") && canModify;
    const hasPermissionForAddKitchenStyle = useCanEdit("Finishing Schedule", "add_kitchen_style") && canModify;
    const hasPermissionForUpdateKitchenStyle = useCanEdit("Finishing Schedule", "update_kitchen_style") && canModify;
    const hasPermissionForDeleteKitchenStyle = useCanEdit("Finishing Schedule", "delete_kitchen_style") && canModify;
    const hasPermissionForAddLightLocation = useCanEdit("Finishing Schedule", "add_light_location") && canModify;
    const hasPermissionForDeleteLightLocation = useCanEdit("Finishing Schedule", "delete_light_location") && canModify;
    const hasPermissionForAddLight = useCanEdit("Finishing Schedule", "add_light") && canModify;
    const hasPermissionForUpdateLight = useCanEdit("Finishing Schedule", "update_light") && canModify;
    const hasPermissionForDeleteLight = useCanEdit("Finishing Schedule", "delete_light") && canModify;
    const hasPermissionForAddOthersLocation = useCanEdit("Finishing Schedule", "add_others_location") && canModify;
    const hasPermissionForDeleteOthersLocation = useCanEdit("Finishing Schedule", "delete_others_location") && canModify;
    const hasPermissionForAddOthers = useCanEdit("Finishing Schedule", "add_others") && canModify;
    const hasPermissionForUpdateOthers = useCanEdit("Finishing Schedule", "update_others") && canModify;
    const hasPermissionForDeleteOthers = useCanEdit("Finishing Schedule", "delete_others") && canModify;
    const hasPermissionForOrderProcess = useCanEdit("Finishing Schedule", "order_process") && canModify;
    const hasPermissionForShareFeature = useCanEdit("Finishing Schedule", "share_feature") && canModify;
    /* ************************************************************* */

    useEffect(() => {
        if (location?.state && location?.state?.navigateFrom) {
            setNavigateFrom(location?.state?.navigateFrom)
        } else {
            setNavigateFrom(null);
        }
    }, [location.state]);

    useEffect(() => {
        if (location.state && location.state.projectData) {
            const stateProject = location.state.projectData as FSProject;

            setIsOwnProject(stateProject.is_own_project!);

            const activeProject = fsProjects.filter(
                (e) => e.project_id === stateProject.project_id
            );

            if (activeProject.length > 0) {
                setFinishingScheduleProject(activeProject[0] as FSProject);
            } else {
                setFinishingScheduleProject(stateProject);
            }
        }
    }, [location.state, fsProjects]);

    useEffect(() => {
        finishingScheduleProjectDataGet();
    }, [dispatch]);

    const finishingScheduleProjectDataGet = async () => {
        setInitialDataLoading(true);
        await dispatch(fetchFSProjectList());
        setInitialDataLoading(false);
    }

    useEffect(() => {
        if (finishingScheduleProject?.feature_list?.length) {
            setFinishingScheduleFeatures(finishingScheduleProject.feature_list);

            const savedFeatureId = localStorage.getItem("activeFSFeatureId");

            if (savedFeatureId) {
                const savedFeature = finishingScheduleProject.feature_list.find(
                    (f) => f.id.toString() === savedFeatureId
                );
                if (savedFeature) {
                    setActiveFSFeature(savedFeature);
                    return;
                }
            }

            setActiveFSFeature(finishingScheduleProject.feature_list[0]);
        } else {
            setFinishingScheduleFeatures([]);
            setActiveFSFeature(null);
        }
    }, [finishingScheduleProject]);

    useEffect(() => {
        if (!activeFSFeature) return;

        switch (activeFSFeature.feature) {
            case 'Light':
                setInitialSubDataLoading(true);
                fsLightDataGet();
                break;
            case 'Door':
                setInitialSubDataLoading(true);
                fsDoorDataGet();
                break;
            case 'Paint':
                setInitialSubDataLoading(true);
                fsPaintDataGet();
                break;
            case 'Bathroom':
                setInitialSubDataLoading(true);
                fsBathroomDataGet();
                break;
            case 'Kitchen':
                setInitialSubDataLoading(true);
                fsKitchenDataGet();
                break;
            case 'Tiles':
                setInitialSubDataLoading(true);
                fsTileDataGet();
                break;
            case 'Floor Finishing':
                setInitialSubDataLoading(true);
                fsFloorFinishingDataGet();
                break;
            case 'Others':
                setInitialSubDataLoading(true);
                fsOtherDataGet();
                break;
            default:
                break;
        }
    }, [activeFSFeature]);

    const fsDoorDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSDoorList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const fsPaintDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSPaintList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const fsTileDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSTileList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const fsFloorFinishingDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSFloorFinishingList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const fsBathroomDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSBathroomList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const fsKitchenDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSKitchenList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const fsLightDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSLightList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const fsOtherDataGet = async () => {
        if (!activeFSFeature?.id) return;

        await dispatch(fetchFSOtherList(activeFSFeature?.id!));
        setInitialSubDataLoading(false);
    }

    const handleSelectFSFeature = (feature: FSFeature) => {
        setActiveFSFeature(feature);
        localStorage.setItem("activeFSFeatureId", feature.id.toString());
        goToTop();
    }

    useEffect(() => {
        if (activeFSFeature) {
            const feature = activeFSFeature?.feature;

            if (feature === 'Paint') {
                const paintAccessory = (fsPaints.find(paint => paint?.location_name?.toLowerCase() === 'accessory') || null);

                setFSPaintAccessoryData(paintAccessory || null);
                setFSDataAccessory(paintAccessory?.data_accessory || []);
            } else if (feature === 'Tiles') {
                const tilesAccessory = (fsTiles.find(tile => tile?.location_name?.toLowerCase() === 'accessory') || null);

                setFSTilesAccessoryData(tilesAccessory || null);
                setFSDataAccessory(tilesAccessory?.data_accessory || []);
            } else if (feature === 'Door') {
                const doorAccessory = (fsDoors.find(tile => tile?.location_name?.toLowerCase() === 'accessory') || null);

                setFSDoorAccessoryData(doorAccessory || null);
                setFSDataAccessory(doorAccessory?.data_accessory || []);
            } else if (feature === 'Floor Finishing') {
                setFSDataAccessory(fsFloorFinishing?.data_accessory || []);
            }
            else {
                setFSDataAccessory([]);
            }
        }
    }, [activeFSFeature, fsPaints, fsTiles, fsDoors, fsFloorFinishing])


    /* ************************************************************* Finishing schedule features */
    useEffect(() => {
        const fetchMainFeatureData = async () => {
            await dispatch(fetchFSMainFeatureList());
        }

        fetchMainFeatureData();
    }, [])

    useEffect(() => {
        if (fsMainFeatures && fsMainFeatures?.length > 0) {
            const filteredData = fsMainFeatures.filter((feature) =>
                feature
                    ?.feature!.toLowerCase()
                    .includes(fsMainFeatureSearchKey.toLowerCase())
            );

            setFSMainFeatureData(filteredData);
        } else {
            setFSMainFeatureData([]);
        }
    }, [fsMainFeatures, fsMainFeatureSearchKey])

    const handleCloseFSMainFeatureListModal = () => {
        setShowFSMainFeatureListModal(false);
        setFSMainFeatureSearchKey('');
        setSelectedFSMainFeatures([]);
    }

    const handleAddFSMainFeature = () => {
        setShowFSMainFeatureListModal(true);
    }

    useEffect(() => {
        if (location?.state && location?.state.openStatus && initialDataLoading === false) {
            const addStatus: number = location.state.openStatus;

            if (addStatus === 1) {
                handleAddFSMainFeature();
            }
        }
    }, [location?.state, initialDataLoading]);

    const handleSelectFSMainFeatures = (feature: FSMainFeature, isChecked: boolean) => {
        if (isChecked) {
            setSelectedFSMainFeatures((prevState) => [...prevState, feature]);
        } else {
            setSelectedFSMainFeatures((prevState) =>
                prevState.filter(
                    (existingFeature) => existingFeature.id !== feature.id
                )
            );
        }
    };

    const isSelectedFSMainFeature = (feature: FSMainFeature): boolean =>
        selectedFSMainFeatures.some(
            (existingFeature) => existingFeature?.id === feature?.id
        );

    const isAlreadyExistFSMainFeature = (feature: FSMainFeature): boolean => {
        return finishingScheduleFeatures.some(
            (existingFeature) => existingFeature?.main_feature_id === feature?.id
        );
    };

    function checkCredentialsForFSMainFeature(): boolean {
        return selectedFSMainFeatures.length > 0;
    }

    // Add main feature API
    const addFSMainFeatures = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForFSMainFeature()) return;

        setLoading(true);

        try {
            const project_id = finishingScheduleProject?.project_id;
            const featuresList = selectedFSMainFeatures;

            const data = await addFSFeatures(project_id!, featuresList);

            if (data.statusCode === 200) {
                finishingScheduleProjectDataGet();
                handleCloseFSMainFeatureListModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Feature(s) added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the feature.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteFSMainFeature = (feature: FSFeature) => {
        const mainFeatureId = feature?.id;

        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>Are you sure you want to delete the <b className="text-capitalize">{feature?.feature}</b> feature from this project?</span>
                    <span>This action will <b>delete all</b> records associated with it.</span>
                </div>
            ),
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteFSMainFeature(mainFeatureId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Delete main feature API
    const deleteFSMainFeature = async (mainFeatureId: number) => {
        if (!mainFeatureId) return;

        setMainFeatureDeleteLoading(true);

        try {
            const id = mainFeatureId;
            const data = await deleteFSFeature(id);

            if (data.statusCode === 200) {
                finishingScheduleProjectDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Feature deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the feature.",
                life: 3000,
            });
        } finally {
            setMainFeatureDeleteLoading(false);
        }
    }

    /* Modal header */
    const fsMainFeatureModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Add feature(S)
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseFSMainFeatureListModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const fsMainFeatureModalFooter = (
        <React.Fragment>
            <div className="custom_modal_footer">
                <Button
                    label="Cancel"
                    className="custom_btn secondary"
                    onClick={handleCloseFSMainFeatureListModal}
                />

                <Button
                    label={loading ? 'Processing' :
                        `Add${selectedFSMainFeatures?.length > 0 ? `(${String(selectedFSMainFeatures?.length).padStart(2, '0')})` : ''}`
                    }
                    onClick={addFSMainFeatures}
                    loading={loading}
                    className="custom_btn primary"
                    disabled={selectedFSMainFeatures?.length === 0}
                />
            </div>
        </React.Fragment>
    );

    // Share feature
    useEffect(() => {
        if (!finishingScheduleProject) return;

        setFinishingScheduleContactsData(finishingScheduleProject.contact ?? []);
    }, [finishingScheduleProject]);

    useEffect(() => {
        if (finishingScheduleContactsData?.length) {
            const contactIds = finishingScheduleContactsData.map(contact => contact.id);
            setProjectContactIds(contactIds);
        } else {
            setProjectContactIds([]);
        }
    }, [finishingScheduleContactsData]);

    useEffect(() => {
        if (!activeFSFeature) return;
        const shareList = activeFSFeature.share_list ?? [];

        if (shareList.length > 0) {
            const results: ShareContactType[] = shareList.map((e) => {
                const dt: Partial<ShareContactType> = {
                    id: e.id,
                    first_name: e.first_name,
                    last_name: e.last_name!,
                    profile_image: e.profile_image,
                    email: e.email!,
                    role_name: e.role_name,
                    type: e.main_type!,
                    by: e.by,
                    can_edit: e.can_edit,
                    can_view: 1,
                };

                return mapShareContactType(dt);
            });

            setSharedList(results);
        } else {
            setSharedList([]);
        }
    }, [activeFSFeature]);


    const handleCloseShareModal = () => {
        setShowContactShareModal(false);
        setSharedList([]);
    }

    const handleShareFeature = () => {
        setShowContactShareModal(true);
    }

    const shareFeature = async (selectedContacts: ShareContactType[]) => {
        if (!activeFSFeature || selectedContacts?.length === 0) return;

        const shareData = selectedContacts.filter((e) => e.can_view !== 0 || e.can_edit !== 0)
        setLoading(true);

        try {
            const fs_feature_id = activeFSFeature?.id;
            const share: ShareContactType[] = shareData;

            const res = await shareFSFeature(fs_feature_id!, share);

            if (res.statusCode === 200) {
                handleCloseShareModal();

                setShareLoading(true);
                await dispatch(fetchFSProjectList());
                setShareLoading(false);

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: `${activeFSFeature?.feature} feature `,
                        life: 3000
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: `There was an error sharing the ${(activeFSFeature?.feature)?.toLowerCase} feature.`,
                        life: 3000
                    });
                }
            }
        } catch (error) {
            console.error("Error sharing the feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: `Something went wrong while sharing the ${(activeFSFeature?.feature)?.toLowerCase} feature.`,
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }
    /* ************************************************************* */


    /* ************************************************************* Location */
    useEffect(() => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        const fetchData = async () => {
            if (feature === 'Paint' || feature === 'Floor Finishing' || feature === 'Light' || feature === 'Bathroom' || feature === 'Others') {
                await fsLocationsDataGet();
            }
        };

        fetchData();
    }, [activeFSFeature]);

    const fsLocationsDataGet = async () => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        if (feature === 'Light' || feature === 'Bathroom' || feature === 'Others') {
            await dispatch(fetchFSLocationList({
                category: feature as FSLocationListArgs['category'],
                sub_category: null
            }));
        } else if (feature === 'Paint' || feature === 'Floor Finishing') {
            await dispatch(fetchFSLocationList({
                category: feature as FSLocationListArgs['category'],
                sub_category: feature as FSLocationListArgs['sub_category'],
            }));
        }
    };

    useEffect(() => {
        if (fsLocations && fsLocations?.length > 0) {
            const filteredData = fsLocations.filter((location) =>
                location
                    ?.location_name!.toLowerCase()
                    .includes(fsLocationSearchKey.toLowerCase())
            );

            setFSLocationsData(filteredData);
        } else {
            setFSLocationsData([]);
        }
    }, [fsLocations, fsLocationSearchKey])

    const handleCloseLocationListModal = () => {
        setShowLocationListModal(false);
        setFSLocationSearchKey('');
        handleResetCustomFSLocationFields();
    }

    const handleResetCustomFSLocationFields = () => {
        setCustomLocationName('');
        setCustomLocationNameError('');
        setCustomDataState('Add');
        setSelectedCustomLocation(null);
    }

    const handleAddLocation = () => {
        setShowLocationListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectLocation = (location: FSLocation) => {
        setSelectedFSLocation(location);

        setTimeout(() => {
            handleCloseLocationListModal();
        }, 200);
    };

    useEffect(() => {
        checkText(customLocationName, false, setCustomLocationNameError);
    }, [customLocationName]);

    function checkCredentialsForLocation(): boolean {
        const isValidCustomLocationName = checkText(customLocationName, true, setCustomLocationNameError);

        return isValidCustomLocationName;
    }

    function showAPIErrorForLocation(keyName: string, error: string): void {
        if (keyName === "location_name") {
            setCustomLocationNameError(error);
        }
    }

    // Location add API
    const handleCreateCustomFSLocation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForLocation()) return;

        setCustomLoading(true);

        try {
            const category = activeFSFeature?.feature;
            const sub_category = (
                (activeFSFeature?.feature !== 'Bathroom' &&
                    activeFSFeature?.feature !== 'Light' &&
                    activeFSFeature?.feature !== 'Others')
                    ? activeFSFeature?.feature : null
            );
            const location_name = customLocationName;

            const data = await createFSLocation(category!, sub_category!, location_name);

            if (data.statusCode === 200) {
                await fsLocationsDataGet();
                handleResetCustomFSLocationFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Location added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForLocation(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the location.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the location:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the location.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleEditCustomLocation = (location: FSLocation) => {
        if (location) {
            setSelectedCustomLocation(location);

            setCustomLocationName(location?.location_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomLocation(null);
        }
    }

    useEffect(() => {
        if (selectedCustomLocation) {
            if (customLocationName && customLocationName !== selectedCustomLocation?.location_name) {
                setCustomLocationUpdateHasChanges(true);
            } else {
                setCustomLocationUpdateHasChanges(false);
            }
        }
    }, [selectedCustomLocation, customLocationName]);

    // Location update API
    const handleUpdateCustomFSLocation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForLocation() || selectedCustomLocation === null) return;

        setCustomLoading(true);

        try {
            const location_name = customLocationName;
            const id = selectedCustomLocation?.id;

            const data = await updateFSLocation(location_name, id);

            if (data.statusCode === 200) {
                await fsLocationsDataGet();
                handleResetCustomFSLocationFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Location updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForLocation(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the location.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the location:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the location.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleDeleteCustomFSLocation = (location: FSLocation) => {
        if (location) {
            handleResetCustomFSLocationFields();
            const customLocationId = location?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b className="text-capitalize">{location?.location_name}</b> location?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSLocation(customLocationId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Location delete API
    const deleteCustomFSLocation = async (customLocationId: number) => {
        if (!customLocationId) return;

        setDeleteLocationLoadingId(customLocationId);

        try {
            const id = customLocationId;
            const result = await deleteFSLocation(id);

            if (result.statusCode === 200) {
                await fsLocationsDataGet();
                setSelectedFSLocation(null);
                setSelectedFSLocations((prev) =>
                    prev ? prev.filter((loc) => loc.id !== customLocationId) : []
                );

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Location deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the location.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the location:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the location.",
                life: 3000,
            });
        } finally {
            setDeleteLocationLoadingId(null);
        }
    }

    // For multi location
    const handleCloseMultiLocationListModal = (isClear: boolean) => {
        if (isClear) {
            setSelectedFSLocations([]);
        }

        setFSLocationSearchKey('');
        handleResetCustomFSLocationFields();
        setShowMultiLocationListModal(false);
    }

    const handleAddMultiLocation = () => {
        setShowMultiLocationListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectMultiLocation = (location: FSLocation, isChecked: boolean) => {
        if (isChecked) {
            setSelectedFSLocations((prevState) => [...prevState, location]);
        } else {
            setSelectedFSLocations((prevState) =>
                prevState.filter(
                    (existingLocation) => existingLocation.id !== location.id
                )
            );
        }
    };

    const isSelectedLocation = (location: FSLocation): boolean =>
        selectedFSLocations.some(
            (existingLocation) => existingLocation?.id === location?.id
        );

    const isAlreadyExistLocation = (location: FSLocation): boolean => {
        const feature = activeFSFeature?.feature;

        if (feature === 'Bathroom') {
            return fsBathrooms.some(
                (existingLocation) => existingLocation?.location_id === location?.id
            );
        } else if (feature === 'Light') {
            return fsLightsData.some(
                (existingLocation) => existingLocation?.location_id === location?.id
            );
        } else if (feature === 'Others') {
            return fsOthersData.some(
                (existingLocation) => existingLocation?.location_id === location?.id
            );
        } else {
            return false;
        }
    };

    const locationModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Cancel"
                className="custom_btn secondary"
                onClick={() => handleCloseMultiLocationListModal(true)}
            />

            <Button
                label={`Add${selectedFSLocations?.length > 0 ? `(${String(selectedFSLocations?.length).padStart(2, '0')})` : ''}`}
                onClick={() => handleCloseMultiLocationListModal(false)}
                className="custom_btn primary"
                disabled={selectedFSLocations?.length === 0}
            />
        </div>
    );
    /* ************************************************************* */

    /* ************************************************************* Color */
    useEffect(() => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        const fetchData = async () => {
            if (feature === 'Paint' || feature === 'Kitchen' || feature === 'Tiles' || feature === 'Door' || feature === 'Bathroom') {
                await fsColorsDataGet();
            }
        };

        fetchData();
    }, [activeFSFeature, selectedSubCategory]);

    const fsColorsDataGet = async () => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        if (feature === 'Paint' || feature === 'Tiles' || feature === 'Door' || feature === 'Bathroom') {
            await dispatch(fetchFSColorList({ category: feature, sub_category: null }));
        } else if (feature === 'Kitchen' && selectedSubCategory !== null) {
            await dispatch(
                fetchFSColorList({
                    category: 'Kitchen',
                    sub_category: selectedSubCategory as FSColorListArgs["sub_category"],
                })
            );
        }
    };

    useEffect(() => {
        if (fsColors && fsColors?.length > 0) {
            const filteredData = fsColors.filter((color) =>
                color
                    ?.color_name!.toLowerCase()
                    .includes(fsColorSearchKey.toLowerCase())
            );

            setFSColorsData(filteredData);
        } else {
            setFSColorsData([]);
        }
    }, [fsColors, fsColorSearchKey])

    const handleCloseColorListModal = () => {
        setShowColorListModal(false);
        setFSColorSearchKey('');
        handleResetCustomFSColorFields();
    }

    const handleResetCustomFSColorFields = () => {
        setCustomColorName('');
        setCustomColorCode('');
        setCustomColorNameError('');
        setCustomColorCodeError('');
        setCustomDataState('Add');
        setSelectedCustomColor(null);
    }

    const handleAddColor = () => {
        setShowColorListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectColor = (color: FSColor) => {
        setSelectedFSColor(color);

        setTimeout(() => {
            handleCloseColorListModal();
        }, 200);
    };

    function showAPIErrorForColor(keyName: string, error: string): void {
        if (keyName === "color_name") {
            setCustomColorNameError(error);
        }

        if (keyName === "color_code") {
            setCustomColorCodeError(error);
        }
    }

    useEffect(() => {
        checkText(customColorName, false, setCustomColorNameError);
    }, [customColorName]);

    useEffect(() => {
        checkText(customColorCode, false, setCustomColorCodeError);
    }, [customColorCode]);

    function checkCredentialsForColor(): boolean {
        const isValidCustomColorName = checkText(customColorName, true, setCustomColorNameError);
        const isValidCustomColorCode = checkText(customColorCode, true, setCustomColorCodeError);

        return isValidCustomColorName && isValidCustomColorCode;
    }

    // Color add API
    const handleCreateCustomFSColor = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForColor()) return;

        setCustomLoading(true);

        try {
            const category = activeFSFeature?.feature;
            const sub_category = activeFSFeature?.feature === 'Kitchen' ? selectedSubCategory : null;
            const color_name = customColorName;
            const color_code = customColorCode;

            const data = await createFSColor(category!, sub_category, color_name, color_code);

            if (data.statusCode === 200) {
                await fsColorsDataGet();
                handleResetCustomFSColorFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Color added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForColor(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the color.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the color:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the color.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleEditCustomColor = (color: FSColor) => {
        if (color) {
            setSelectedCustomColor(color);

            setCustomColorName(color?.color_name || '');
            setCustomColorCode(color?.color_code || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomColor(null);
        }
    }

    useEffect(() => {
        if (selectedCustomColor) {
            if (customColorName && customColorName !== selectedCustomColor?.color_name) {
                setCustomColorUpdateHasChanges(true);
            } else if (customColorCode && customColorCode !== selectedCustomColor?.color_code) {
                setCustomColorUpdateHasChanges(true);
            } else {
                setCustomColorUpdateHasChanges(false);
            }
        }
    }, [selectedCustomColor, customColorName, customColorCode]);

    // Color update API
    const handleUpdateCustomFSColor = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForColor() || selectedCustomColor === null) return;

        setCustomLoading(true);

        try {
            const color_name = customColorName;
            const color_code = customColorCode;
            const id = selectedCustomColor?.id;

            const data = await updateFSColor(color_name, color_code, id);

            if (data.statusCode === 200) {
                await fsColorsDataGet();
                handleResetCustomFSColorFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Color updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForColor(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the color.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the color:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the color.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleDeleteCustomFSColor = (color: FSColor) => {
        if (color) {
            handleResetCustomFSColorFields();
            const customColorId = color?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b className="text-capitalize">{color?.color_name}</b> color?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSColor(customColorId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Color delete API
    const deleteCustomFSColor = async (customColorId: number) => {
        if (!customColorId) return;

        setDeleteColorLoadingId(customColorId);

        try {
            const id = customColorId;
            const result = await deleteFSColor(id);

            if (result.statusCode === 200) {
                await fsColorsDataGet();
                setSelectedFSColor(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Color deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the color.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the color:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the color.",
                life: 3000,
            });
        } finally {
            setDeleteColorLoadingId(null);
        }
    }
    /* ************************************************************* */

    /* ************************************************************* Brand */
    useEffect(() => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        const fetchData = async () => {
            if (feature === 'Paint' || feature === 'Kitchen' || feature === 'Bathroom' || feature === 'Floor Finishing' || feature === 'Others') {
                await fsBrandsDataGet();
            }
        };

        fetchData();
    }, [activeFSFeature, selectedSubCategory]);

    const fsBrandsDataGet = async () => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        if (feature === 'Paint' || feature === 'Bathroom' || feature === 'Floor Finishing' || feature === 'Others') {
            await dispatch(fetchFSBrandList({ category: feature, sub_category: null }));
        } else if (feature === 'Kitchen' && selectedSubCategory !== null) {
            await dispatch(
                fetchFSBrandList({
                    category: 'Kitchen',
                    sub_category: selectedSubCategory as FSBrandListArgs["sub_category"],
                })
            );
        }
    };

    useEffect(() => {
        if (fsBrands && fsBrands?.length > 0) {
            const filteredData = fsBrands.filter((brand) =>
                brand
                    ?.brand_name!.toLowerCase()
                    .includes(fsBrandSearchKey.toLowerCase())
            );

            setFSBrandsData(filteredData);
        } else {
            setFSBrandsData([]);
        }
    }, [fsBrands, fsBrandSearchKey])

    const handleCloseBrandListModal = () => {
        setShowBrandListModal(false);
        setFSBrandSearchKey('');
        handleResetCustomFSBrandFields();
    }

    const handleResetCustomFSBrandFields = () => {
        setCustomBrandName('');
        setCustomBrandNameError('');
        setCustomDataState('Add');
        setSelectedCustomBrand(null);
    }

    const handleAddBrand = () => {
        setShowBrandListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectBrand = (brand: FSBrand) => {
        setSelectedFSBrand(brand);

        setTimeout(() => {
            handleCloseBrandListModal();
        }, 200);
    };

    function showAPIErrorForBrand(keyName: string, error: string): void {
        if (keyName === "brand_name") {
            setCustomBrandNameError(error);
        }
    }

    useEffect(() => {
        checkText(customBrandName, false, setCustomBrandNameError);
    }, [customBrandName])

    function checkCredentialsForBrand(): boolean {
        const isValidCustomBrandName = checkText(customBrandName, true, setCustomBrandNameError);

        return isValidCustomBrandName;
    }

    // Brand add API
    const handleCreateCustomFSBrand = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForBrand()) return;

        setCustomLoading(true);

        try {
            const category = activeFSFeature?.feature;
            const sub_category = activeFSFeature?.feature === 'Kitchen' ? selectedSubCategory : null;
            const brand_name = customBrandName;

            const data = await createFSBrand(category!, sub_category, brand_name);

            if (data.statusCode === 200) {
                await fsBrandsDataGet();
                handleResetCustomFSBrandFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Brand added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForBrand(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the brand.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the brand:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the brand.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleEditCustomBrand = (brand: FSBrand) => {
        if (brand) {
            setSelectedCustomBrand(brand);

            setCustomBrandName(brand?.brand_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomBrand(null);
        }
    }

    useEffect(() => {
        if (selectedCustomBrand) {
            if (customBrandName && customBrandName !== selectedCustomBrand?.brand_name) {
                setCustomBrandUpdateHasChanges(true);
            } else {
                setCustomBrandUpdateHasChanges(false);
            }
        }
    }, [selectedCustomBrand, customBrandName]);

    // Brand update API
    const handleUpdateCustomFSBrand = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForBrand() || selectedCustomBrand === null) return;

        setCustomLoading(true);

        try {
            const brand_name = customBrandName;
            const id = selectedCustomBrand?.id;

            const data = await updateFSBrand(brand_name, id);

            if (data.statusCode === 200) {
                await fsBrandsDataGet();
                handleResetCustomFSBrandFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Brand updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForBrand(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the brand.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the brand:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the brand.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleDeleteCustomFSBrand = (brand: FSBrand) => {
        if (brand) {
            handleResetCustomFSBrandFields();
            const customBrandId = brand?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b className="text-capitalize">{brand?.brand_name}</b> brand?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSBrand(customBrandId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Brand delete API
    const deleteCustomFSBrand = async (customBrandId: number) => {
        if (!customBrandId) return;

        setDeleteBrandLoadingId(customBrandId);

        try {
            const id = customBrandId;
            const result = await deleteFSBrand(id);

            if (result.statusCode === 200) {
                await fsBrandsDataGet();
                setSelectedFSBrand(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Brand deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the brand.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the brand:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the brand.",
                life: 3000,
            });
        } finally {
            setDeleteBrandLoadingId(null);
        }
    }
    /* ************************************************************* */

    /* ************************************************************* Type */
    useEffect(() => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        const fetchData = async () => {
            if (feature === 'Tiles' || feature === 'Light' || feature === 'Floor Finishing' || feature === 'Kitchen') {
                await fsTypesDataGet();
            }
        };

        fetchData();
    }, [activeFSFeature, selectedSubCategory]);

    const fsTypesDataGet = async () => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        if (feature === 'Tiles' || feature === 'Light' || feature === 'Floor Finishing') {
            await dispatch(fetchFSTypeList({ category: feature, sub_category: null }));
        } else if (feature === 'Kitchen' && selectedSubCategory !== null) {
            await dispatch(
                fetchFSTypeList({
                    category: 'Kitchen',
                    sub_category: selectedSubCategory as FSTypeListArgs["sub_category"],
                })
            );
        }
    };

    useEffect(() => {
        if (fsTypes && fsTypes?.length > 0) {
            const filteredData = fsTypes.filter((type) =>
                type
                    ?.type_name!.toLowerCase()
                    .includes(fsTypeSearchKey.toLowerCase())
            );

            setFSTypesData(filteredData);
        } else {
            setFSTypesData([]);
        }
    }, [fsTypes, fsTypeSearchKey])

    const handleCloseTypeListModal = () => {
        setShowTypeListModal(false);
        setFSTypeSearchKey('');
        handleResetCustomFSTypeFields();
    }

    const handleResetCustomFSTypeFields = () => {
        setCustomTypeName('');
        setCustomTypeNameError('');
        setCustomDataState('Add');
        setSelectedCustomType(null);
    }

    const handleAddType = () => {
        setShowTypeListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectType = (type: FSType) => {
        setSelectedFSType(type);

        setTimeout(() => {
            handleCloseTypeListModal();
        }, 200);
    };

    function showAPIErrorForType(keyName: string, error: string): void {
        if (keyName === "type_name") {
            setCustomTypeNameError(error);
        }
    }

    useEffect(() => {
        checkText(customTypeName, false, setCustomTypeNameError);
    }, [customTypeName])

    function checkCredentialsForType(): boolean {
        const isValidCustomTypeName = checkText(customTypeName, true, setCustomTypeNameError);

        return isValidCustomTypeName;
    }

    // Type add API
    const handleCreateCustomFSType = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForType()) return;

        setCustomLoading(true);

        try {
            const category = activeFSFeature?.feature;
            const sub_category = selectedSubCategory;
            const location_name = customTypeName;

            const data = await createFSType(category!, sub_category, location_name);

            if (data.statusCode === 200) {
                await fsTypesDataGet();
                handleResetCustomFSTypeFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Type added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForType(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the type.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the type:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the type.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleEditCustomType = (type: FSType) => {
        if (type) {
            setSelectedCustomType(type);

            setCustomTypeName(type?.type_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomType(null);
        }
    }

    useEffect(() => {
        if (selectedCustomType) {
            if (customTypeName && customTypeName !== selectedCustomType?.type_name) {
                setCustomTypeUpdateHasChanges(true);
            } else {
                setCustomTypeUpdateHasChanges(false);
            }
        }
    }, [selectedCustomType, customTypeName]);

    // Type update API
    const handleUpdateCustomFSType = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForType() || selectedCustomType === null) return;

        setCustomLoading(true);

        try {
            const type_name = customTypeName;
            const id = selectedCustomType?.id;

            const data = await updateFSType(type_name, id);

            if (data.statusCode === 200) {
                await fsTypesDataGet();
                handleResetCustomFSTypeFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Type updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForType(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the type.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the type:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the type.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleDeleteCustomFSType = (type: FSType) => {
        if (type) {
            handleResetCustomFSTypeFields();
            const customTypeId = type?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>type</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSType(customTypeId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Type delete API
    const deleteCustomFSType = async (customTypeId: number) => {
        if (!customTypeId) return;

        setDeleteTypeLoadingId(customTypeId);

        try {
            const id = customTypeId;
            const result = await deleteFSType(id);

            if (result.statusCode === 200) {
                await fsTypesDataGet();
                setSelectedFSType(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Type deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the type.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the type:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the type.",
                life: 3000,
            });
        } finally {
            setDeleteTypeLoadingId(null);
        }
    }
    /* ************************************************************* */


    /* ************************************************************* Accessory */
    const isAccessoryCategory = (
        feature: FSFeature["feature"]
    ): feature is FSAccessoryListArgs["category"] => {
        return ['Paint', 'Tiles', 'Door', 'Floor Finishing'].includes(feature);
    };

    const fsAccessoriesDataGet = async (category: FSAccessoryListArgs["category"]) => {
        await dispatch(fetchFSAccessoryList({ category }));
    };

    useEffect(() => {
        if (activeFSFeature && isAccessoryCategory(activeFSFeature.feature)) {
            fsAccessoriesDataGet(activeFSFeature.feature);
        }
    }, [activeFSFeature]);

    useEffect(() => {
        if (fsAccessories && fsAccessories?.length > 0) {
            const filteredData = fsAccessories.filter((accessory) =>
                accessory
                    ?.accessory_name!.toLowerCase()
                    .includes(fsAccessorySearchKey.toLowerCase())
            );

            setFSAccessoriesData(filteredData);
        } else {
            setFSAccessoriesData([]);
        }
    }, [fsAccessories, fsAccessorySearchKey])

    const handleCloseAccessoryListModal = () => {
        setShowAccessoryListModal(false);
        setFSAccessorySearchKey('');
        handleResetCustomFSAccessoryFields();
    }

    const handleResetCustomFSAccessoryFields = () => {
        setCustomAccessoryName('');
        setCustomAccessoryNameError('');
        setCustomDataState('Add');
        setSelectedCustomAccessory(null);
    }

    const handleAddAccessory = () => {
        setShowAccessoryListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectAccessory = (accessory: FSAccessory) => {
        setSelectedFSAccessory(accessory);
        setSelectedFSAccessorySub(null);

        setTimeout(() => {
            handleCloseAccessoryListModal();
        }, 200);
    };

    function showAPIErrorForAccessory(keyName: string, error: string): void {
        if (keyName === "accessory_name") {
            setCustomAccessoryNameError(error);
        }
    }

    useEffect(() => {
        checkText(customAccessoryName, false, setCustomAccessoryNameError);
    }, [customAccessoryName]);

    function checkCredentialsForAccessory(): boolean {
        const isValidCustomAccessoryName = checkText(customAccessoryName, true, setCustomAccessoryNameError);

        return isValidCustomAccessoryName;
    }

    // Accessory add API
    const handleCreateCustomFSAccessory = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForAccessory()) return;

        setCustomLoading(true);

        try {
            const category = activeFSFeature?.feature;
            const accessory_name = customAccessoryName;

            const data = await createFSAccessoryCategory(category!, accessory_name);

            if (data.statusCode === 200) {
                if (activeFSFeature && isAccessoryCategory(activeFSFeature.feature)) {
                    await fsAccessoriesDataGet(activeFSFeature.feature);
                }

                handleResetCustomFSAccessoryFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Accessory added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAccessory(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the accessory.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the accessory:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the accessory.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleEditCustomAccessory = (accessory: FSAccessory) => {
        if (accessory) {
            setSelectedCustomAccessory(accessory);

            setCustomAccessoryName(accessory?.accessory_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomAccessory(null);
        }
    }

    useEffect(() => {
        if (selectedCustomAccessory) {
            if (customAccessoryName && customAccessoryName !== selectedCustomAccessory?.accessory_name) {
                setCustomAccessoryUpdateHasChanges(true);
            } else {
                setCustomAccessoryUpdateHasChanges(false);
            }
        }
    }, [selectedCustomAccessory, customAccessoryName]);

    // Accessory update API
    const handleUpdateCustomFSAccessory = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForAccessory() || selectedCustomAccessory === null) return;

        setCustomLoading(true);

        try {
            const accessory_name = customAccessoryName;
            const id = selectedCustomAccessory?.id;

            const data = await updateFSAccessoryCategory(accessory_name, id);

            if (data.statusCode === 200) {
                if (activeFSFeature && isAccessoryCategory(activeFSFeature.feature)) {
                    await fsAccessoriesDataGet(activeFSFeature.feature);
                }

                handleResetCustomFSAccessoryFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Accessory updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAccessory(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the accessory.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the accessory:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the accessory.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleDeleteCustomFSAccessory = (accessory: FSAccessory) => {
        if (accessory) {
            handleResetCustomFSAccessoryFields();
            const customAccessoryId = accessory?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>accessory</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSAccessory(customAccessoryId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Accessory delete API
    const deleteCustomFSAccessory = async (customAccessoryId: number) => {
        if (!customAccessoryId) return;

        setDeleteAccessoryLoadingId(customAccessoryId);

        try {
            const id = customAccessoryId;
            const result = await deleteFSAccessoryCategory(id);

            if (result.statusCode === 200) {
                if (activeFSFeature && isAccessoryCategory(activeFSFeature.feature)) {
                    await fsAccessoriesDataGet(activeFSFeature.feature);
                }

                setSelectedFSAccessory(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Accessory deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the accessory.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the accessory:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the accessory.",
                life: 3000,
            });
        } finally {
            setDeleteAccessoryLoadingId(null);
        }
    }
    /* ************************************************************* */

    /* ************************************************************* Sub accessory */
    useEffect(() => {
        const fetchSubAccessories = async () => {
            await fsSubAccessoriesDataGet();
        };

        fetchSubAccessories();
    }, []);

    const fsSubAccessoriesDataGet = async () => {
        await dispatch(fetchFSAccessorySubList())
    }

    useEffect(() => {
        if (Array.isArray(fsSubAccessories) && selectedFSAccessory) {
            const filtered = fsSubAccessories
                .filter(subAccessory => subAccessory?.accessory_name_id === selectedFSAccessory?.id)
                .filter(subAccessory =>
                    subAccessory?.accessory_sub_name
                        ?.toLowerCase()
                        .includes(fsAccessorySubSearchKey.toLowerCase())
                );

            setFSSubAccessoriesData(filtered);
        } else {
            setFSSubAccessoriesData([]);
        }
    }, [fsSubAccessories, fsAccessorySubSearchKey, selectedFSAccessory]);

    const handleCloseAccessorySubListModal = () => {
        setShowAccessorySubListModal(false);
        setFSAccessorySubSearchKey('');
        handleResetCustomFSAccessorySubFields();
    }

    const handleResetCustomFSAccessorySubFields = () => {
        setCustomAccessorySubName('');
        setCustomAccessorySubNameError('');
        setCustomDataState('Add');
        setSelectedCustomAccessorySub(null);
    }

    const handleAddAccessorySub = () => {
        setShowAccessorySubListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectAccessorySub = (subAccessory: FSAccessorySub) => {
        setSelectedFSAccessorySub(subAccessory);

        setTimeout(() => {
            handleCloseAccessorySubListModal();
        }, 200);
    };

    function showAPIErrorForAccessorySub(keyName: string, error: string): void {
        if (keyName === "accessory_sub_name") {
            setCustomAccessorySubNameError(error);
        }
    }

    useEffect(() => {
        checkText(customAccessorySubName, false, setCustomAccessorySubNameError);
    }, [customAccessorySubName]);

    function checkCredentialsForAccessorySub(): boolean {
        const isValidCustomAccessorySubName = checkText(customAccessorySubName, true, setCustomAccessorySubNameError);

        return isValidCustomAccessorySubName;
    }

    // Sub accessory add API
    const handleCreateCustomFSAccessorySub = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForAccessorySub()) return;

        setCustomLoading(true);

        try {
            const accessory_name_id = selectedFSAccessory?.id;
            const accessory_sub_name = customAccessorySubName;

            const data = await createFSAccessorySubCategory(accessory_name_id!, accessory_sub_name);

            if (data.statusCode === 200) {
                await fsSubAccessoriesDataGet();
                handleResetCustomFSAccessorySubFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Sub accessory added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAccessorySub(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the sub accessory.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the sub accessory:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the sub accessory.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleEditCustomAccessorySub = (subAccessory: FSAccessorySub) => {
        if (subAccessory) {
            setSelectedCustomAccessorySub(subAccessory);

            setCustomAccessorySubName(subAccessory?.accessory_sub_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomAccessorySub(null);
        }
    }

    useEffect(() => {
        if (selectedCustomAccessorySub) {
            if (customAccessorySubName && customAccessorySubName !== selectedCustomAccessorySub?.accessory_sub_name) {
                setCustomAccessorySubUpdateHasChanges(true);
            } else {
                setCustomAccessorySubUpdateHasChanges(false);
            }
        }
    }, [selectedCustomAccessorySub, customAccessorySubName]);

    // Sub accessory update API
    const handleUpdateCustomFSAccessorySub = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForAccessorySub() || selectedCustomAccessorySub === null) return;

        setCustomLoading(true);

        try {
            const accessory_name_id = selectedFSAccessory?.id;
            const accessory_sub_name = customAccessorySubName;
            const id = selectedCustomAccessorySub?.id;

            const data = await updateFSAccessorySubCategory(
                accessory_name_id!,
                accessory_sub_name,
                id
            );

            if (data.statusCode === 200) {
                await fsSubAccessoriesDataGet();
                handleResetCustomFSAccessorySubFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Sub accessory updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAccessorySub(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the sub accessory.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the sub accessory:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the sub accessory.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleDeleteCustomFSAccessorySub = (subAccessory: FSAccessorySub) => {
        if (subAccessory) {
            handleResetCustomFSAccessorySubFields();
            const customAccessorySubId = subAccessory?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>sub accessory</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSAccessorySub(customAccessorySubId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Sub accessory delete API
    const deleteCustomFSAccessorySub = async (customAccessorySubId: number) => {
        if (!customAccessorySubId) return;

        setDeleteAccessorySubLoadingId(customAccessorySubId);

        try {
            const id = customAccessorySubId;
            const result = await deleteFSAccessorySubCategory(id);

            if (result.statusCode === 200) {
                await fsSubAccessoriesDataGet();
                setSelectedFSAccessorySub(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Sub accessory deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the sub accessory.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the sub accessory:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the sub accessory.",
                life: 3000,
            });
        } finally {
            setDeleteAccessorySubLoadingId(null);
        }
    }
    /* ************************************************************* */

    /* ************************************************************* Item */
    useEffect(() => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        const fetchData = async () => {
            if (feature === 'Light' || feature === 'Bathroom') {
                await fsItemsDataGet();
            }
        };

        fetchData();
    }, [activeFSFeature]);

    const fsItemsDataGet = async () => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        if (feature === 'Light' || feature === 'Bathroom') {
            await dispatch(fetchFSItemList({
                category: feature as FSItemArgs['category'],
            }));
        }
    };

    useEffect(() => {
        if (fsItems && fsItems?.length > 0) {
            const filteredData = fsItems.filter((item) =>
                item
                    ?.item_name!.toLowerCase()
                    .includes(fsItemSearchKey.toLowerCase())
            );

            setFSItemsData(filteredData);
        } else {
            setFSItemsData([]);
        }
    }, [fsItems, fsItemSearchKey])

    const handleCloseItemListModal = () => {
        setShowItemListModal(false);
        setFSItemSearchKey('');
        handleResetCustomFSItemFields();
    }

    const handleResetCustomFSItemFields = () => {
        setCustomItemName('');
        setCustomItemNameError('');
        setCustomDataState('Add');
        setSelectedCustomItem(null);
    }

    const handleAddItem = () => {
        setShowItemListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectItem = (item: FSItem) => {
        setSelectedFSItem(item);

        setTimeout(() => {
            handleCloseItemListModal();
        }, 200);
    };

    function showAPIErrorForItem(keyName: string, error: string): void {
        if (keyName === "item_name") {
            setCustomItemNameError(error);
        }
    }

    useEffect(() => {
        checkText(customItemName, false, setCustomItemNameError);
    }, [customItemName]);

    function checkCredentialsForItem(): boolean {
        const isValidCustomItemName = checkText(customItemName, true, setCustomItemNameError);

        return isValidCustomItemName;
    }

    // Item add API
    const handleCreateCustomFSItem = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForItem()) {
            setCustomLoading(true);

            const category = activeFSFeature?.feature;
            const item_name = customItemName;

            const data = await createFSItem(category!, item_name);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsItemsDataGet();
                handleResetCustomFSItemFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Item added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForItem(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the item.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleEditCustomItem = (item: FSItem) => {
        if (item) {
            setSelectedCustomItem(item);

            setCustomItemName(item?.item_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomItem(null);
        }
    }

    useEffect(() => {
        if (selectedCustomItem) {
            if (customItemName && customItemName !== selectedCustomItem?.item_name) {
                setCustomItemUpdateHasChanges(true);
            } else {
                setCustomItemUpdateHasChanges(false);
            }
        }
    }, [selectedCustomItem, customItemName]);

    // Item update API
    const handleUpdateCustomFSItem = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForItem() && selectedCustomItem !== null) {
            setCustomLoading(true);

            const category = activeFSFeature?.feature;
            const item_name = customItemName;
            const id = selectedCustomItem?.id;

            const data = await updateFSItem(category!, item_name, id!);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsItemsDataGet();
                handleResetCustomFSItemFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Item updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForItem(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the item.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleDeleteCustomFSItem = (item: FSItem) => {
        if (item) {
            handleResetCustomFSItemFields();
            const customItemId = item?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>item</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSItem(customItemId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Item delete API
    const deleteCustomFSItem = async (customItemId: number) => {
        if (customItemId) {
            setDeleteItemLoadingId(customItemId);

            const id = customItemId;
            const result = await deleteFSItem(id);

            setDeleteItemLoadingId(null);
            if (result.statusCode === 200) {
                await fsItemsDataGet();
                setSelectedFSItem(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Item deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the item.",
                        life: 3000,
                    });
                }
            }
        }
    }
    /* ************************************************************* */

    /* ************************************************************* Appliance */
    useEffect(() => {
        if (activeFSFeature && activeFSFeature?.feature === 'Kitchen') {
            const fetchAppliances = async () => {
                await fsAppliancesDataGet();
            };

            fetchAppliances();
        }
    }, [activeFSFeature]);

    const fsAppliancesDataGet = async () => {
        await dispatch(fetchFSApplianceList())
    }

    useEffect(() => {
        if (fsAppliances && fsAppliances?.length > 0) {
            const filteredData = fsAppliances.filter((appliance) =>
                appliance
                    ?.appliance_name!.toLowerCase()
                    .includes(fsApplianceSearchKey.toLowerCase())
            );

            setFSAppliancesData(filteredData);
        } else {
            setFSAppliancesData([]);
        }
    }, [fsAppliances, fsApplianceSearchKey])

    const handleCloseApplianceListModal = () => {
        setShowApplianceListModal(false);
        setFSApplianceSearchKey('');
        handleResetCustomFSApplianceFields();
    }

    const handleResetCustomFSApplianceFields = () => {
        setCustomApplianceName('');
        setCustomApplianceNameError('');
        setCustomDataState('Add');
        setSelectedCustomAppliance(null);
    }

    const handleAddAppliance = () => {
        setShowApplianceListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectAppliance = (appliance: FSAppliance) => {
        setSelectedFSAppliance(appliance);

        setTimeout(() => {
            handleCloseApplianceListModal();
        }, 200);
    };

    function showAPIErrorForAppliance(keyName: string, error: string): void {
        if (keyName === "appliance_name") {
            setCustomApplianceNameError(error);
        }
    }

    useEffect(() => {
        checkText(customApplianceName, false, setCustomApplianceNameError);
    }, [customApplianceName])

    function checkCredentialsForAppliance(): boolean {
        const isValidCustomApplianceName = checkText(customApplianceName, true, setCustomApplianceNameError);

        return isValidCustomApplianceName;
    }

    // Appliance add API
    const handleCreateCustomFSAppliance = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForAppliance()) {
            setCustomLoading(true);

            const appliance_name = customApplianceName;
            const data = await createFSAppliance(appliance_name);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsAppliancesDataGet();
                handleResetCustomFSApplianceFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Appliance added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAppliance(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the appliance.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleEditCustomAppliance = (appliance: FSAppliance) => {
        if (appliance) {
            setSelectedCustomAppliance(appliance);

            setCustomApplianceName(appliance?.appliance_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomAppliance(null);
        }
    }

    useEffect(() => {
        if (selectedCustomAppliance) {
            if (customApplianceName && customApplianceName !== selectedCustomAppliance?.appliance_name) {
                setCustomApplianceUpdateHasChanges(true);
            } else {
                setCustomApplianceUpdateHasChanges(false);
            }
        }
    }, [selectedCustomAppliance, customApplianceName]);

    // Appliance update API
    const handleUpdateCustomFSAppliance = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForAppliance() && selectedCustomAppliance !== null) {
            setCustomLoading(true);

            const appliance_name = customApplianceName;
            const id = selectedCustomAppliance?.id;

            const data = await updateFSAppliance(appliance_name, id);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsAppliancesDataGet();
                handleResetCustomFSApplianceFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Appliance updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAppliance(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the appliance.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleDeleteCustomFSAppliance = (appliance: FSAppliance) => {
        if (appliance) {
            handleResetCustomFSApplianceFields();
            const customApplianceId = appliance?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>appliance</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSAppliance(customApplianceId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Appliance delete API
    const deleteCustomFSAppliance = async (customApplianceId: number) => {
        if (customApplianceId) {
            setDeleteApplianceLoadingId(customApplianceId);

            const id = customApplianceId
            const result = await deleteFSAppliance(id);

            setDeleteApplianceLoadingId(null);
            if (result.statusCode === 200) {
                await fsAppliancesDataGet();
                setSelectedFSAppliance(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Appliance deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the appliance.",
                        life: 3000,
                    });
                }
            }
        }
    }
    /* ************************************************************* */

    /* ************************************************************* Tile shop */
    useEffect(() => {
        if (!activeFSFeature?.feature) return;
        const feature = activeFSFeature?.feature;

        const fetchData = async () => {
            if (feature === 'Tiles') {
                await fsTileShopsDataGet();
            }
        };

        fetchData();
    }, [activeFSFeature]);

    const fsTileShopsDataGet = async () => {
        await dispatch(fetchFSTileShopList());
    }

    useEffect(() => {
        if (fsTileShops && fsTileShops?.length > 0) {
            const filteredData = fsTileShops.filter((shop) =>
                shop
                    ?.shop_name!.toLowerCase()
                    .includes(fsTileShopSearchKey.toLowerCase())
            );

            setFSTileShopsData(filteredData);
        } else {
            setFSTileShopsData([]);
        }
    }, [fsTileShops, fsTileShopSearchKey])

    const handleCloseTileShopListModal = () => {
        setShowTileShopListModal(false);
        setFSTileShopSearchKey('');
        handleResetCustomFSTileShopFields();
    }

    const handleResetCustomFSTileShopFields = () => {
        setCustomTileShopName('');
        setCustomTileShopNameError('');
        setCustomDataState('Add');
        setSelectedCustomTileShop(null);
    }

    const handleAddTileShop = () => {
        setShowTileShopListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectTileShop = (shop: FSTileShop) => {
        setSelectedFSTileShop(shop);

        setTimeout(() => {
            handleCloseTileShopListModal();
        }, 200);
    };

    function showAPIErrorForTileShop(keyName: string, error: string): void {
        if (keyName === "shop_name") {
            setCustomTileShopNameError(error);
        }
    }

    useEffect(() => {
        checkText(customTileShopName, false, setCustomTileShopNameError);
    }, [customTileShopName])

    function checkCredentialsForTileShop(): boolean {
        const isValidCustomTileShopName = checkText(customTileShopName, true, setCustomTileShopNameError);

        return isValidCustomTileShopName;
    }

    // Tile shop add API
    const handleCreateCustomFSTileShop = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForTileShop()) {
            setCustomLoading(true);

            const shop_name = customTileShopName;
            const data = await createFSShop(shop_name);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsTileShopsDataGet();
                handleResetCustomFSTileShopFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Shop added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForTileShop(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the shop.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleEditCustomTileShop = (shop: FSTileShop) => {
        if (shop) {
            setSelectedCustomTileShop(shop);

            setCustomTileShopName(shop?.shop_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomTileShop(null);
        }
    }

    useEffect(() => {
        if (selectedCustomTileShop) {
            if (customTileShopName && customTileShopName !== selectedCustomTileShop?.shop_name) {
                setCustomTileShopUpdateHasChanges(true);
            } else {
                setCustomTileShopUpdateHasChanges(false);
            }
        }
    }, [selectedCustomTileShop, customTileShopName]);

    // Tile shop update API
    const handleUpdateCustomFSTileShop = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForTileShop() && selectedCustomTileShop !== null) {
            setCustomLoading(true);

            const shop_name = customTileShopName;
            const id = selectedCustomTileShop?.id;

            const data = await updateFSShop(shop_name, id!);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsTileShopsDataGet();
                handleResetCustomFSTileShopFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Shop updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForTileShop(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the shop.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleDeleteCustomFSTileShop = (shop: FSTileShop) => {
        if (shop) {
            handleResetCustomFSTileShopFields();
            const customTileShopId = shop?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>shop</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSTileShop(customTileShopId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Tile shop delete API
    const deleteCustomFSTileShop = async (customTileShopId: number) => {
        if (customTileShopId) {
            setDeleteTileShopLoadingId(customTileShopId);

            const id = customTileShopId;
            const result = await deleteFSShop(id);

            setDeleteTileShopLoadingId(null);
            if (result.statusCode === 200) {
                await fsTileShopsDataGet();
                setSelectedFSTileShop(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Shop deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the shop.",
                        life: 3000,
                    });
                }
            }
        }
    }
    /* ************************************************************* */


    /* ************************************************************* Kitchen ranges */
    const fsKitchenRangeDataGet = async () => {
        await dispatch(fetchFSKitchenRangeList());
    }

    useEffect(() => {
        if (fsKitchenRanges && fsKitchenRanges.length > 0) {
            let filteredData = fsKitchenRanges;

            if (selectedFSBrand) {
                filteredData = filteredData.filter(
                    (kitchenRange) => kitchenRange?.brand_id === selectedFSBrand.id
                );
            }

            if (selectedFSKitchenCollection) {
                filteredData = filteredData.filter(
                    (kitchenRange) =>
                        kitchenRange?.collection_id === selectedFSKitchenCollection.id
                );
            }

            if (fsKitchenRangeSearchKey.trim() !== "") {
                filteredData = filteredData.filter((kitchenRange) =>
                    kitchenRange?.range_name
                        ?.toLowerCase()
                        .includes(fsKitchenRangeSearchKey.toLowerCase())
                );
            }

            setFSKitchenRangesData(filteredData);
        } else {
            setFSKitchenRangesData([]);
        }
    }, [
        fsKitchenRanges,
        fsKitchenRangeSearchKey,
        selectedFSBrand,
        selectedFSKitchenCollection,
    ]);

    const handleCloseKitchenRangeListModal = () => {
        setShowKitchenRangeListModal(false);
        setFSKitchenRangeSearchKey('');
        handleResetCustomFSKitchenRangeFields();
    }

    const handleResetCustomFSKitchenRangeFields = () => {
        setCustomKitchenRangeName('');
        setCustomKitchenRangeNameError('');
        setCustomDataState('Add');
        setSelectedCustomKitchenRange(null);
    }

    const handleAddKitchenRange = () => {
        setShowKitchenRangeListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectKitchenRange = (kitchenRange: FSKitchenRange) => {
        setSelectedFSKitchenRange(kitchenRange);

        setTimeout(() => {
            handleCloseKitchenRangeListModal();
        }, 200);
    };

    function showAPIErrorForKitchenRange(keyName: string, error: string): void {
        if (keyName === "range_name") {
            setCustomKitchenRangeNameError(error);
        }
    }

    useEffect(() => {
        checkText(customKitchenRangeName, false, setCustomKitchenRangeNameError);
    }, [customKitchenRangeName])

    function checkCredentialsForKitchenRange(): boolean {
        const isValidCustomKitchenRangeName = checkText(customKitchenRangeName, true, setCustomKitchenRangeNameError);

        return isValidCustomKitchenRangeName;
    }

    // Kitchen range add API
    const handleCreateCustomFSKitchenRange = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForKitchenRange()) {
            setCustomLoading(true);

            const brand_id = selectedFSBrand?.id;
            const collection_id = selectedFSKitchenCollection?.id;
            const range_name = customKitchenRangeName;

            const data = await createFSKitchenRange(
                brand_id!,
                collection_id!,
                range_name
            );

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsKitchenRangeDataGet();
                handleResetCustomFSKitchenRangeFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Kitchen range added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForKitchenRange(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the kitchen range.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleEditCustomKitchenRange = (kitchenRange: FSKitchenRange) => {
        if (kitchenRange) {
            setSelectedCustomKitchenRange(kitchenRange);

            setCustomKitchenRangeName(kitchenRange?.range_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomKitchenRange(null);
        }
    }

    useEffect(() => {
        if (selectedCustomKitchenRange) {
            if (customKitchenRangeName && customKitchenRangeName !== selectedCustomKitchenRange?.range_name) {
                setCustomKitchenRangeUpdateHasChanges(true);
            } else {
                setCustomKitchenRangeUpdateHasChanges(false);
            }
        }
    }, [selectedCustomKitchenRange, customKitchenRangeName]);

    // Kitchen range update API
    const handleUpdateCustomFSKitchenRange = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForKitchenRange() && selectedCustomKitchenRange !== null) {
            setCustomLoading(true);

            const brand_id = selectedFSBrand?.id;
            const collection_id = selectedFSKitchenCollection?.id;
            const range_name = customKitchenRangeName;
            const id = selectedCustomKitchenRange?.id;

            const data = await updateFSKitchenRange(
                brand_id!,
                collection_id!,
                range_name,
                id
            );

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsKitchenRangeDataGet();
                handleResetCustomFSKitchenRangeFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Kitchen range updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForKitchenRange(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the kitchen range.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleDeleteCustomFSKitchenRange = (kitchenRange: FSKitchenRange) => {
        if (kitchenRange) {
            handleResetCustomFSKitchenRangeFields();
            const customKitchenRangeId = kitchenRange?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>kitchen range</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSKitchenRange(customKitchenRangeId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Kitchen range delete API
    const deleteCustomFSKitchenRange = async (customKitchenRangeId: number) => {
        if (customKitchenRangeId) {
            setDeleteKitchenRangeLoadingId(customKitchenRangeId);

            const id = customKitchenRangeId;
            const result = await deleteFSKitchenRange(id);

            setDeleteKitchenRangeLoadingId(null);
            if (result.statusCode === 200) {
                await fsKitchenRangeDataGet();
                setSelectedFSKitchenRange(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Kitchen range deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the kitchen range.",
                        life: 3000,
                    });
                }
            }
        }
    }
    /* ************************************************************* */


    /* ************************************************************* Kitchen styles */
    const fsKitchenStyleDataGet = async () => {
        await dispatch(fetchFSKitchenStyleList());
    }

    useEffect(() => {
        if (fsKitchenStyles && fsKitchenStyles?.length > 0) {
            const filteredData = fsKitchenStyles.filter((kitchenStyle) =>
                kitchenStyle
                    ?.style_name!.toLowerCase()
                    .includes(fsKitchenStyleSearchKey.toLowerCase())
            );

            setFSKitchenStylesData(filteredData);
        } else {
            setFSKitchenStylesData([]);
        }
    }, [fsKitchenStyles, fsKitchenStyleSearchKey])

    const handleCloseKitchenStyleListModal = () => {
        setShowKitchenStyleListModal(false);
        setFSKitchenStyleSearchKey('');
        handleResetCustomFSKitchenStyleFields();
    }

    const handleResetCustomFSKitchenStyleFields = () => {
        setCustomKitchenStyleName('');
        setCustomKitchenStyleNameError('');
        setCustomDataState('Add');
        setSelectedCustomKitchenStyle(null);
    }

    const handleAddKitchenStyle = () => {
        setShowKitchenStyleListModal(true);
        setCustomDataState('Add');
    };

    const handleSelectKitchenStyle = (kitchenStyle: FSKitchenStyle) => {
        setSelectedFSKitchenStyle(kitchenStyle);

        setTimeout(() => {
            handleCloseKitchenStyleListModal();
        }, 200);
    };

    function showAPIErrorForKitchenStyle(keyName: string, error: string): void {
        if (keyName === "style_name") {
            setCustomKitchenStyleNameError(error);
        }
    }

    useEffect(() => {
        checkText(customKitchenStyleName, false, setCustomKitchenStyleNameError);
    }, [customKitchenStyleName])

    function checkCredentialsForKitchenStyle(): boolean {
        const isValidCustomKitchenStyleName = checkText(customKitchenStyleName, true, setCustomKitchenStyleNameError);

        return isValidCustomKitchenStyleName;
    }

    // Kitchen style add API
    const handleCreateCustomFSKitchenStyle = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForKitchenStyle()) {
            setCustomLoading(true);

            const style_name = customKitchenStyleName;
            const data = await createFSKitchenStyle(style_name);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsKitchenStyleDataGet();
                handleResetCustomFSKitchenStyleFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Kitchen style added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForKitchenStyle(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the kitchen style.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleEditCustomKitchenStyle = (kitchenStyle: FSKitchenStyle) => {
        if (kitchenStyle) {
            setSelectedCustomKitchenStyle(kitchenStyle);

            setCustomKitchenStyleName(kitchenStyle?.style_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomKitchenStyle(null);
        }
    }

    useEffect(() => {
        if (selectedCustomKitchenStyle) {
            if (customKitchenStyleName && customKitchenStyleName !== selectedCustomKitchenStyle?.style_name) {
                setCustomKitchenStyleUpdateHasChanges(true);
            } else {
                setCustomKitchenStyleUpdateHasChanges(false);
            }
        }
    }, [selectedCustomKitchenStyle, customKitchenStyleName]);

    // Kitchen style update API
    const handleUpdateCustomFSKitchenStyle = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForKitchenStyle() && selectedCustomKitchenStyle !== null) {
            setCustomLoading(true);

            const style_name = customKitchenStyleName;
            const id = selectedCustomKitchenStyle?.id;

            const data = await updateFSKitchenStyle(style_name, id);

            setCustomLoading(false);
            if (data.statusCode === 200) {
                await fsKitchenStyleDataGet();
                handleResetCustomFSKitchenStyleFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Kitchen style updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForKitchenStyle(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the kitchen style.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleDeleteCustomFSKitchenStyle = (kitchenStyle: FSKitchenStyle) => {
        if (kitchenStyle) {
            handleResetCustomFSKitchenStyleFields();
            const customKitchenStyleId = kitchenStyle?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>kitchen style</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomFSKitchenStyle(customKitchenStyleId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Kitchen style delete API
    const deleteCustomFSKitchenStyle = async (customKitchenStyleId: number) => {
        if (customKitchenStyleId) {
            setDeleteKitchenStyleLoadingId(customKitchenStyleId);

            const id = customKitchenStyleId;
            const result = await deleteFSKitchenStyle(id);

            setDeleteKitchenStyleLoadingId(null);
            if (result.statusCode === 200) {
                await fsKitchenStyleDataGet();
                setSelectedFSKitchenStyle(null);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Kitchen style deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the kitchen style.",
                        life: 3000,
                    });
                }
            }
        }
    }
    /* ************************************************************* */


    /* ************************************************************* Finishing schedule - Light */
    useEffect(() => {
        if (fsLights && fsLights?.length > 0) {
            setFSLightsData(fsLights.filter(
                light => light?.is_default_feature === 0
            ) || []);
        } else {
            setFSLightsData([]);
        }
    }, [fsLights]);

    // Light location
    useEffect(() => {
        if (fsLightsData && fsLightsData?.length > 0) {
            const savedLocationId = localStorage.getItem("activeLightLocationId");

            if (savedLocationId) {
                const savedLocation = fsLightsData.find(
                    (l) => l.id.toString() === savedLocationId
                );
                if (savedLocation) {
                    setActiveLightLocation(savedLocation);
                    return;
                }
            }

            setActiveLightLocation(fsLightsData[0]);
        } else {
            setActiveLightLocation(null);
        }
    }, [fsLightsData]);

    const handleSelectLightLocation = (lightLocation: FSLight) => {
        setActiveLightLocation(lightLocation);
        localStorage.setItem("activeLightLocationId", lightLocation.id.toString());
        goToTop();
    }

    const handleCloseLightLocationModal = () => {
        setShowLightLocationModal(false);
        handleResetLightLocationFields();
    }

    const handleResetLightLocationFields = () => {
        setSelectedFSLocations([]);
        setLightLocationError('');
    }

    function checkCredentialsForLightLocation(): boolean {
        return selectedFSLocations.length > 0;
    }

    const handleAddLightLocation = () => {
        setShowLightLocationModal(true);
        setDataState('Add');
    }

    // Light location add API
    const addLightLocation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForLightLocation()) {
            setLoading(true);

            const fs_feature_id = activeFSFeature?.id;
            const location_id_list = selectedFSLocations?.map((e) => e.id);

            const data = await addFSLightLocation(fs_feature_id!, location_id_list);
            setLoading(false);

            if (data.statusCode === 200) {
                fsLightDataGet();
                handleCloseLightLocationModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Light location(s) added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the light location.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleDeleteLightLocation = (lightLocation: FSLight) => {
        const lightLocationId = lightLocation?.id;

        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>Are you sure you want to delete the <b className="text-capitalize">{(lightLocation?.location_name)?.toLowerCase()}</b> location?</span>
                    <span>This action will <b>delete all</b> records associated with it.</span>
                </div>
            ),
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteLightLocation(lightLocationId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Light location delete API
    const deleteLightLocation = async (lightLocationId: number) => {
        if (lightLocationId) {
            setLightLocationDeleteLoadingId(lightLocationId);

            const id = lightLocationId;
            const data = await deleteFSLightLocation(id);

            setLightLocationDeleteLoadingId(null);

            if (data.statusCode === 200) {
                fsLightDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Light location deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the light location.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const lightLocationModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;light location
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseLightLocationModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const lightLocationModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseLightLocationModal}
            />

            <Button
                label={
                    loading ? 'Processing' :
                        `Add${selectedFSLocations?.length > 0 ? `(${String(selectedFSLocations?.length).padStart(2, '0')})` : ''}`
                }
                onClick={addLightLocation}
                loading={loading}
                className="custom_btn primary"
                disabled={selectedFSLocations?.length === 0}
            />
        </div>
    );
    // 

    // Light details
    const handleCloseLightDetailModal = () => {
        setShowLightDetailModal(false);
        handleResetLightDetailFields();
    }

    const handleResetLightDetailFields = () => {
        setSelectedFSItem(null);
        setLightNumber(null);
        setSelectedFSType(null);
        setLightLink(null);
        setLightFiles([]);
        setLightImageFile(null);
        setLightImageFileName('');

        setSelectedLightDetail(null);

        setLightItemError('');
        setLightNumberError('');
        setLightTypeError('');
        setLightLinkError('');
        setLightFilesError('');
        setLightImageFileError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSItem != null, false, setLightItemError);
    }, [selectedFSItem]);

    useEffect(() => {
        checkNumber(lightNumber!, false, setLightNumberError);
    }, [lightNumber]);

    useEffect(() => {
        checkModelSelected(selectedFSType != null, false, setLightTypeError);
    }, [selectedFSType]);

    useEffect(() => {
        checkText(lightLink!, false, setLightLinkError);
    }, [lightLink]);

    useEffect(() => {
        checkFileOtherList(lightFiles!, false, setLightFilesError);
    }, [lightFiles]);

    useEffect(() => {
        checkFileOthers(lightImageFile!, false, setLightImageFileError);
    }, [lightImageFile]);

    function checkCredentialsForLightDetail(fileRequired: boolean): boolean {
        const isLightItemValid = checkModelSelected(selectedFSItem != null, true, setLightItemError);
        const isLightNumberValid = checkNumber(lightNumber!, true, setLightNumberError);
        const isLightTypeValid = checkModelSelected(selectedFSType != null, true, setLightTypeError);
        const isLightLinkValid = checkText(lightLink!, false, setLightLinkError);
        const isLightFilesValid = checkFileOtherList(lightFiles!, fileRequired, setLightFilesError);
        const isLightImageValid = checkFileOthers(lightImageFile!, fileRequired, setLightImageFileError);

        return (
            isLightItemValid &&
            isLightNumberValid &&
            isLightTypeValid &&
            isLightLinkValid &&
            isLightFilesValid &&
            isLightImageValid
        );
    }

    function showAPIErrorForLightDetail(keyName: string, error: string): void {
        if (keyName === "item_id") {
            setLightItemError(error);
        }

        if (keyName === "number") {
            setLightNumberError(error);
        }

        if (keyName === "type_id") {
            setLightTypeError(error);
        }

        if (keyName === "link") {
            setLightLinkError(error);
        }

        if (keyName === "file_list[]") {
            setLightFilesError(error);
        }

        if (keyName === "image_path") {
            setLightImageFileError(error);
        }
    }

    const handleAddLightDetail = () => {
        setShowLightDetailModal(true);
        setDataState('Add');
    }

    // Light detail add API
    const handleCreateLightDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForLightDetail(false)) {
            setLoading(true);

            const fs_data_id = activeLightLocation?.id;
            const item_id = selectedFSItem?.id;
            const type_id = selectedFSType?.id;
            const number = lightNumber;
            const link = lightLink;
            const image_path = lightImageFile;
            const file_list = lightFiles;

            const data = await fsLightCreate(
                fs_data_id!,
                item_id!,
                type_id!,
                number!,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsLightDataGet();
                handleCloseLightDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Light detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForLightDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the light detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedLightDetail) {
            if (selectedFSItem?.id !== selectedLightDetail?.item_id) {
                setLightDetailUpdateHasChanges(true);
            } else if (selectedFSType?.id !== selectedLightDetail?.type_id) {
                setLightDetailUpdateHasChanges(true);
            } else if (lightNumber !== null && lightNumber !== selectedLightDetail?.number) {
                setLightDetailUpdateHasChanges(true);
            } else if (lightLink !== null && lightLink !== selectedLightDetail?.link) {
                setLightDetailUpdateHasChanges(true);
            } else if (lightImageFile !== null) {
                setLightDetailUpdateHasChanges(true);
            } else if (lightFiles?.length !== 0) {
                setLightDetailUpdateHasChanges(true);
            } else {
                setLightDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedLightDetail,
        selectedFSItem,
        selectedFSType,
        lightNumber,
        lightLink,
        lightImageFile,
        lightFiles
    ]);

    const handleEditLightDetail = (lightDetail: FSLightData) => {
        if (lightDetail) {
            setShowLightDetailModal(true);
            setDataState('Edit');

            setSelectedLightDetail(lightDetail);

            const existLightItem = fsItems?.find(item => item?.id === lightDetail?.item_id);
            const existLightType = fsTypes?.find(type => type?.id === lightDetail?.type_id);

            setSelectedFSItem(existLightItem || null);
            setLightNumber(lightDetail?.number || null);
            setSelectedFSType(existLightType || null);
            setLightLink(lightDetail?.link || null);
        }
    }

    // Light detail update API
    const handleUpdateLightDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForLightDetail(false)) {
            setLoading(true);

            const id = selectedLightDetail?.id;
            const item_id = selectedFSItem?.id;
            const type_id = selectedFSType?.id;
            const number = lightNumber;
            const link = lightLink;
            const image_path = lightImageFile;
            const file_list = lightFiles;

            const data = await fsLightUpdate(
                id!,
                item_id!,
                type_id!,
                number!,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsLightDataGet();
                handleCloseLightDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Light detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForLightDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the light detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeleteLightDetail = (lightDetail: FSLightData) => {
        const lightDetailId = lightDetail?.id;

        confirmDialog({
            message: `Are you sure you want to delete this light data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteLightDetail(lightDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Light detail delete API
    const deleteLightDetail = async (lightDetailId: number) => {
        if (lightDetailId) {
            setLightDetailDeleteLoadingId(lightDetailId);

            const id = lightDetailId;
            const data = await fsLightDelete(id);

            setLightDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsLightDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Light detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the light detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const lightDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;light detail <span className="custom">{dataState === 'Add' ? ` - ${activeLightLocation?.location_name}` : ''}</span>
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseLightDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const lightDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseLightDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateLightDetail : handleUpdateLightDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !lightDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadLightImageFile = (file: File) => {
        setLightImageFile(file);
        setLightImageFileName(file.name);
    };

    const handleClearLightImageFile = () => {
        setLightImageFile(null);
        setLightImageFileName("");
    };

    const handleUploadLightFiles = (files: File[]) => {
        setLightFiles(files);
    };

    const handleClearLightFiles = () => {
        setLightFiles([]);
    };

    const lightDetailTableActionBody = (rowData: FSLightData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewLightDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateLight && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditLightDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteLight && (
                        <TableActionButton
                            icon={`${lightDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteLightDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={lightDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewLightDetail = (data: FSLightData) => {
        setSelectedLightDetail(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Door */
    useEffect(() => {
        if (fsDoors && fsDoors.length > 0) {
            setFSDoorData(
                fsDoors.filter(
                    door => door?.location_name?.toLowerCase() !== 'accessory' &&
                        door?.is_default_feature === 1
                ) || []
            );
        } else {
            setFSDoorData([]);
        }
    }, [fsDoors]);

    useEffect(() => {
        if (!activeFSFeature) return;

        if (activeFSFeature?.feature === 'Door') {
            dispatch(fetchFSDoorSizeList());
        }
    }, [activeFSFeature, dispatch]);

    // Door details
    const handleCloseDoorDetailModal = () => {
        setShowDoorDetailModal(false);
        handleResetDoorDetailFields();
    }

    const handleResetDoorDetailFields = () => {
        setSelectedFSColor(null);
        setDoorFireResistanceRating(null);
        setDoorSizeType('Standard size');
        setDoorSize(null);
        setDoorManualSize(null);
        setDoorNumber(null);
        setDoorFinishStatus('Prefinished');
        setDoorNote(null);
        setDoorImageFile(null);
        setDoorImageFileName('');
        setDoorFiles([]);

        setSelectedFSDoorData(null);
        setSelectedDoorDetail(null);

        setDoorColorError('');
        setDoorFireResistanceRatingError('');
        setDoorSizeTypeError('');
        setDoorSizeError('');
        setDoorManualSizeError('');
        setDoorNumberError('');
        setDoorFinishStatusError('');
        setDoorNoteError('');
        setDoorImageFileError('');
        setDoorFilesError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSColor != null, false, setDoorColorError);
    }, [selectedFSColor]);

    useEffect(() => {
        checkText(doorFireResistanceRating!, false, setDoorFireResistanceRatingError);
    }, [doorFireResistanceRating]);

    useEffect(() => {
        checkText(doorSizeType, false, setDoorSizeTypeError);
    }, [doorSizeType]);

    useEffect(() => {
        checkModelSelected(doorSize != null, false, setDoorSizeError);
    }, [doorSize]);

    useEffect(() => {
        checkText(doorManualSize!, false, setDoorManualSizeError);
    }, [doorManualSize]);

    useEffect(() => {
        checkNumber(doorNumber!, false, setDoorNumberError);
    }, [doorNumber]);

    useEffect(() => {
        checkText(doorFinishStatus, false, setDoorFinishStatusError);
    }, [doorFinishStatus]);

    useEffect(() => {
        checkText(doorNote!, false, setDoorNoteError);
    }, [doorNote]);

    useEffect(() => {
        checkFileOthers(doorImageFile!, false, setDoorImageFileError);
    }, [doorImageFile]);

    useEffect(() => {
        checkFileOtherList(doorFiles!, false, setDoorFilesError);
    }, [doorFiles]);

    function checkCredentialsForDoorDetail(fileRequired: boolean): boolean {
        const isDoorColorValid = checkModelSelected(selectedFSColor != null, true, setDoorColorError);
        const isDoorFireResistanceRatingValid = checkText(doorFireResistanceRating!, false, setDoorFireResistanceRatingError);
        const isDoorSizeTypeValid = checkText(doorSizeType, true, setDoorSizeTypeError);
        const isDoorSizeValid = checkModelSelected(doorSize != null, (doorSizeType === 'Standard size' ? true : false), setDoorSizeError);
        const isDoorManulaSizeValid = checkText(doorManualSize!, (doorSizeType === 'Non standard size' ? true : false), setDoorManualSizeError);
        const isDooNumberValid = checkNumber(doorNumber!, true, setDoorNumberError);
        const isDoorFinishStatusValid = checkText(doorFinishStatus, true, setDoorFinishStatusError);
        const isDoorNoteValid = checkText(doorNote!, false, setDoorNoteError);
        const isDoorImageValid = checkFileOthers(doorImageFile!, fileRequired, setDoorImageFileError);
        const isDoorFilesValid = checkFileOtherList(doorFiles!, fileRequired, setDoorFilesError);

        return (
            isDoorColorValid &&
            isDoorFireResistanceRatingValid &&
            isDoorSizeTypeValid &&
            isDoorSizeValid &&
            isDoorManulaSizeValid &&
            isDooNumberValid &&
            isDoorFinishStatusValid &&
            isDoorNoteValid &&
            isDoorImageValid &&
            isDoorFilesValid
        );
    }

    function showAPIErrorForDoorDetail(keyName: string, error: string): void {
        if (keyName === "color_id") {
            setDoorColorError(error);
        }

        if (keyName === "fire_resistance_rating") {
            setDoorFireResistanceRatingError(error);
        }

        if (keyName === "size_type") {
            setDoorSizeTypeError(error);
        }

        if (keyName === "size_id") {
            setDoorSizeError(error);
        }

        if (keyName === "manual_size") {
            setDoorManualSizeError(error);
        }

        if (keyName === "number") {
            setDoorNumberError(error);
        }

        if (keyName === "status") {
            setDoorFinishStatusError(error);
        }

        if (keyName === "note") {
            setDoorNoteError(error);
        }

        if (keyName === "image_path") {
            setDoorImageFileError(error);
        }

        if (keyName === "file_list[]") {
            setDoorFilesError(error);
        }
    }

    const handleAddDoorDetails = (door: FSDoor) => {
        setSelectedFSDoorData(door);
        setShowDoorDetailModal(true);
        setDataState('Add');
    }

    // Door details add API
    const handleCreateDoorDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForDoorDetail(false)) {
            setLoading(true);

            const fs_data_id = selectedFSDoorData?.id;
            const color_id = selectedFSColor?.id;
            const fire_resistance_rating = doorFireResistanceRating;
            const size_type = doorSizeType;
            const size_id = doorSizeType === 'Standard size' ? doorSize?.id : null;
            const manual_size = doorSizeType === 'Non standard size' ? doorManualSize : null;
            const number = doorNumber;
            const status = doorFinishStatus;
            const note = doorNote;
            const image_path = doorImageFile;
            const file_list = doorFiles;

            const data = await fsDoorCreate(
                fs_data_id!,
                color_id!,
                fire_resistance_rating,
                size_type,
                size_id!,
                manual_size,
                number!,
                status,
                note,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsDoorDataGet();
                handleCloseDoorDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Door detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForDoorDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the door detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedDoorDetail) {
            if (selectedFSColor?.id !== selectedDoorDetail?.color_id) {
                setDoorDetailUpdateHasChanges(true);
            } else if (doorFireResistanceRating !== selectedDoorDetail?.fire_resistance_rating) {
                setDoorDetailUpdateHasChanges(true);
            } else if (doorSizeType !== selectedDoorDetail?.size_type) {
                setDoorDetailUpdateHasChanges(true);
            } else if (selectedDoorDetail?.size_type === 'Standard size' && doorSize?.id !== selectedDoorDetail?.size_id) {
                setDoorDetailUpdateHasChanges(true);
            } else if (selectedDoorDetail?.size_type === 'Non standard size' && doorManualSize !== null && doorManualSize !== selectedDoorDetail?.manual_size) {
                setDoorDetailUpdateHasChanges(true);
            } else if (doorNumber !== null && doorNumber !== selectedDoorDetail?.number) {
                setDoorDetailUpdateHasChanges(true);
            } else if (doorFinishStatus !== selectedDoorDetail?.status) {
                setDoorDetailUpdateHasChanges(true);
            } else if (doorNote !== null && doorNote !== selectedDoorDetail?.note) {
                setDoorDetailUpdateHasChanges(true);
            } else if (doorImageFile !== null) {
                setDoorDetailUpdateHasChanges(true);
            } else if (doorFiles?.length !== 0) {
                setDoorDetailUpdateHasChanges(true);
            } else {
                setDoorDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedDoorDetail,
        selectedFSColor,
        doorFireResistanceRating,
        doorSizeType,
        doorSize,
        doorManualSize,
        doorNumber,
        doorFinishStatus,
        doorNote,
        doorImageFile,
        doorFiles
    ]);

    const handleEditDoorDetail = (doorDetail: FSDoorData) => {
        if (doorDetail) {
            setShowDoorDetailModal(true);
            setDataState('Edit');

            setSelectedDoorDetail(doorDetail);

            const existDoorColor = fsColors?.find(color => color?.id === doorDetail?.color_id);
            const existDoorSize = fsDoorSizes?.find(size => size?.id === doorDetail?.size_id);

            setSelectedFSColor(existDoorColor || null);
            setDoorFireResistanceRating(doorDetail?.fire_resistance_rating || null);
            setDoorSizeType(doorDetail?.size_type);
            setDoorSize(existDoorSize || null);
            setDoorManualSize(doorDetail?.manual_size || null);
            setDoorNumber(doorDetail?.number || null);
            setDoorFinishStatus(doorDetail?.status);
            setDoorNote(doorDetail?.note || null);
        }
    }

    // Door details update API
    const handleUpdateDoorDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForDoorDetail(false)) {
            setLoading(true);

            const id = selectedDoorDetail?.id;
            const color_id = selectedFSColor?.id;
            const fire_resistance_rating = doorFireResistanceRating;
            const size_type = doorSizeType;
            const size_id = doorSizeType === 'Standard size' ? doorSize?.id : null;
            const manual_size = doorSizeType === 'Non standard size' ? doorManualSize : null;
            const number = doorNumber;
            const status = doorFinishStatus;
            const note = doorNote;
            const image_path = doorImageFile;
            const file_list = doorFiles;

            const data = await fsDoorUpdate(
                id!,
                color_id!,
                fire_resistance_rating,
                size_type,
                size_id!,
                manual_size,
                number!,
                status,
                note,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsDoorDataGet();
                handleCloseDoorDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Door detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForDoorDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the door detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeleteDoorDetail = (doorDetail: FSDoorData) => {
        const doorDetailId = doorDetail?.id;

        confirmDialog({
            message: `Are you sure you want to delete this door data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteDoorDetail(doorDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Door details delete API
    const deleteDoorDetail = async (doorDetailId: number) => {
        if (doorDetailId) {
            setDoorDetailDeleteLoadingId(doorDetailId);

            const id = doorDetailId;
            const data = await fsDoorDelete(id);

            setDoorDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsDoorDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Door detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the door detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const doorDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;detail <span className="custom">{dataState === 'Add' ? ` - ${selectedFSDoorData?.location_name}` : ''}</span>
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseDoorDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const doorDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseDoorDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateDoorDetail : handleUpdateDoorDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !doorDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadDoorImageFile = (file: File) => {
        setDoorImageFile(file);
        setDoorImageFileName(file.name);
    };

    const handleClearDoorImageFile = () => {
        setDoorImageFile(null);
        setDoorImageFileName("");
    };

    const handleUploadDoorFiles = (files: File[]) => {
        setDoorFiles(files);
    };

    const handleClearDoorFiles = () => {
        setDoorFiles([]);
    };

    const doorDetailTableActionBody = (rowData: FSDoorData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewDoorDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateDoor && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditDoorDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteDoor && (
                        <TableActionButton
                            icon={`${doorDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteDoorDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={doorDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewDoorDetail = (data: FSDoorData) => {
        setSelectedDoorDetail(data);
        setShowFSDataViewModal(true);
    }

    const handleCheckboxChange = (rating: 'FD30' | 'FD60') => {
        setDoorFireResistanceRating(prev =>
            prev === rating ? null : rating
        );
    };
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Paint */
    useEffect(() => {
        if (fsPaints && fsPaints.length > 0) {
            setFSPaintData(
                fsPaints.find(
                    paint => paint?.location_name?.toLowerCase() === 'paint'
                ) || null
            );
        } else {
            setFSPaintData(null);
        }
    }, [fsPaints]);

    // Paint detail
    const handleClosePaintDetailModal = () => {
        setShowPaintDetailModal(false);
        handleResetPaintDetailFields();
    }

    const handleResetPaintDetailFields = () => {
        setSelectedFSBrand(null);
        setPaintType(null);
        setSelectedFSColor(null);
        setSelectedFSLocation(null);
        setPaintLink(null);
        setPaintImageFile(null);
        setPaintImageFileName('');
        setPaintFiles([]);

        setSelectedPaintDetail(null);

        setPaintBrandError('');
        setPaintTypeError('');
        setPaintColorError('');
        setPaintLocationError('');
        setPaintLinkError('');
        setPaintImageFileError('');
        setPaintFilesError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSBrand != null, false, setPaintBrandError);
    }, [selectedFSBrand]);

    useEffect(() => {
        checkText(paintType!, false, setPaintTypeError);
    }, [paintType]);

    useEffect(() => {
        checkModelSelected(selectedFSColor != null, false, setPaintColorError);
    }, [selectedFSColor]);

    useEffect(() => {
        checkModelSelected(selectedFSLocation != null, false, setPaintLocationError);
    }, [selectedFSLocation]);

    useEffect(() => {
        checkText(paintLink!, false, setPaintLinkError);
    }, [paintLink]);

    useEffect(() => {
        checkFileOthers(paintImageFile!, false, setPaintImageFileError);
    }, [paintImageFile]);

    useEffect(() => {
        checkFileOtherList(paintFiles!, false, setPaintFilesError);
    }, [paintFiles]);

    function checkCredentialsForPaintDetail(fileRequired: boolean): boolean {
        const isPaintBrandValid = checkModelSelected(selectedFSBrand != null, true, setPaintBrandError);
        const isPaintTypeValid = checkText(paintType!, true, setPaintTypeError);
        const isPaintColorValid = checkModelSelected(selectedFSColor != null, true, setPaintColorError);
        const isPaintLocationValid = checkModelSelected(selectedFSLocation != null, true, setPaintLocationError);
        const isPaintLinkValid = checkText(paintLink!, false, setPaintLinkError);
        const isPaintImageValid = checkFileOthers(paintImageFile!, fileRequired, setPaintImageFileError);
        const isPaintFilesValid = checkFileOtherList(paintFiles!, fileRequired, setPaintFilesError);

        return (
            isPaintBrandValid &&
            isPaintTypeValid &&
            isPaintColorValid &&
            isPaintLocationValid &&
            isPaintLinkValid &&
            isPaintImageValid &&
            isPaintFilesValid
        );
    }

    function showAPIErrorForPaintDetail(keyName: string, error: string): void {
        if (keyName === "brand_id") {
            setPaintBrandError(error);
        }

        if (keyName === "type") {
            setPaintTypeError(error);
        }

        if (keyName === "color_id") {
            setPaintColorError(error);
        }

        if (keyName === "location_id") {
            setPaintLocationError(error);
        }

        if (keyName === "link") {
            setPaintLinkError(error);
        }

        if (keyName === "image_path") {
            setPaintImageFileError(error);
        }

        if (keyName === "file_list[]") {
            setPaintFilesError(error);
        }
    }

    const handleAddPaintDetails = () => {
        setShowPaintDetailModal(true);
        setDataState('Add');
    }

    // Paint details add API
    const handleCreatePaintDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForPaintDetail(false)) {
            setLoading(true);

            const fs_data_id = fsPaintData?.id;
            const brand_id = selectedFSBrand?.id;
            const color_id = selectedFSColor?.id;
            const location_id = selectedFSLocation?.id;
            const type = paintType;
            const link = paintLink || null;
            const image_path = paintImageFile || null;
            const file_list = paintFiles || [];

            const data = await fsPaintCreate(
                fs_data_id!,
                brand_id!,
                color_id!,
                location_id!,
                type!,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsPaintDataGet();
                handleClosePaintDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Paint detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForPaintDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the paint detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedPaintDetail) {
            if (selectedFSBrand?.id !== selectedPaintDetail?.brand_id) {
                setPaintDetailUpdateHasChanges(true);
            } else if (paintType !== selectedPaintDetail?.type) {
                setPaintDetailUpdateHasChanges(true);
            } else if (selectedFSColor?.id !== selectedPaintDetail?.color_id) {
                setPaintDetailUpdateHasChanges(true);
            } else if (selectedFSLocation?.id !== selectedPaintDetail?.location_id) {
                setPaintDetailUpdateHasChanges(true);
            } else if (paintLink !== null && paintLink !== selectedPaintDetail?.link) {
                setPaintDetailUpdateHasChanges(true);
            } else if (paintImageFile !== null) {
                setPaintDetailUpdateHasChanges(true);
            } else if (paintFiles?.length !== 0) {
                setPaintDetailUpdateHasChanges(true);
            } else {
                setPaintDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedPaintDetail,
        selectedFSBrand,
        paintType,
        selectedFSColor,
        selectedFSLocation,
        paintLink,
        paintImageFile,
        paintFiles
    ]);

    const handleEditPaintDetail = (paintDetail: FSPaintData) => {
        if (paintDetail) {
            setShowPaintDetailModal(true);
            setDataState('Edit');

            setSelectedPaintDetail(paintDetail);

            const existPaintBrand = fsBrands?.find(brand => brand?.id === paintDetail?.brand_id);
            const existPaintColor = fsColors?.find(color => color?.id === paintDetail?.color_id);
            const existPaintLocation = fsLocations?.find(location => location?.id === paintDetail?.location_id);

            setSelectedFSBrand(existPaintBrand || null);
            setPaintType(paintDetail?.type || null);
            setSelectedFSColor(existPaintColor || null);
            setSelectedFSLocation(existPaintLocation || null);
            setPaintLink(paintDetail?.link || null)
        }
    }

    // Paint details update API
    const handleUpdatePaintDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForPaintDetail(false)) {
            setLoading(true);

            const id = selectedPaintDetail?.id;
            const brand_id = selectedFSBrand?.id;
            const color_id = selectedFSColor?.id;
            const location_id = selectedFSLocation?.id;
            const type = paintType;
            const link = paintLink || null;
            const image_path = paintImageFile || null;
            const file_list = paintFiles || [];

            const data = await fsPaintUpdate(
                id!,
                brand_id!,
                color_id!,
                location_id!,
                type!,
                link,
                image_path,
                file_list
            );
            setLoading(false);

            if (data.statusCode === 200) {
                fsPaintDataGet();
                handleClosePaintDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Paint detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForPaintDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the paint detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeletePaintDetail = (paintDetail: FSPaintData) => {
        const paintDetailId = paintDetail?.id;

        confirmDialog({
            message: `Are you sure you want to delete this paint data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deletePaintDetail(paintDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Paint details delete API
    const deletePaintDetail = async (paintDetailId: number) => {
        if (paintDetailId) {
            setPaintDetailDeleteLoadingId(paintDetailId);

            const id = paintDetailId
            const data = await fsPaintDelete(id);

            setPaintDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsPaintDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Paint detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the paint detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const paintDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;paint detail
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleClosePaintDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const paintDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleClosePaintDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreatePaintDetail : handleUpdatePaintDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !paintDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadPaintImageFile = (file: File) => {
        setPaintImageFile(file);
        setPaintImageFileName(file.name);
    };

    const handleClearPaintImageFile = () => {
        setPaintImageFile(null);
        setPaintImageFileName("");
    };

    const handleUploadPaintFiles = (files: File[]) => {
        setPaintFiles(files);
    };

    const handleClearPaintFiles = () => {
        setPaintFiles([]);
    };

    const paintDetailTableActionBody = (rowData: FSPaintData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewPaintDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdatePaint && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditPaintDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeletePaint && (
                        <TableActionButton
                            icon={`${paintDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeletePaintDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={paintDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewPaintDetail = (data: FSPaintData) => {
        setSelectedPaintDetail(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */


    /* ************************************************************* Finishing schedule - Bathroom */
    // //////////////////////////////////////////// Bathroom location
    useEffect(() => {
        if (fsBathrooms && fsBathrooms?.length > 0) {
            const savedLocationId = localStorage.getItem("activeBathroomLocationId");

            if (savedLocationId) {
                const savedLocation = fsBathrooms.find(
                    (l) => l.id.toString() === savedLocationId
                );
                if (savedLocation) {
                    setActiveBathroomLocation(savedLocation);
                    return;
                }
            }

            setActiveBathroomLocation(fsBathrooms[0]);
        } else {
            setActiveBathroomLocation(null);
        }
    }, [fsBathrooms]);

    const handleSelectBathroomLocation = (bathroomLocation: FSBathroom) => {
        setActiveBathroomLocation(bathroomLocation);
        localStorage.setItem("activeBathroomLocationId", bathroomLocation.id.toString());
        goToTop();
    }

    const handleCloseBathroomLocationModal = () => {
        setShowBathroomLocationModal(false);
        handleResetBathroomLocationFields();
    }

    const handleResetBathroomLocationFields = () => {
        setSelectedFSLocations([]);
        setBathroomLocationError('');
    }

    function checkCredentialsForBathroomLocation(): boolean {
        return selectedFSLocations.length > 0;
    }

    const handleAddBathroomLocation = () => {
        setShowBathroomLocationModal(true);
        setDataState('Add');
    }

    // Bathroom location add API
    const addBathroomLocation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForBathroomLocation()) return;

        setLoading(true);

        try {
            const fs_feature_id = activeFSFeature?.id;
            const location_id_list = selectedFSLocations?.map((e) => e.id);

            const data = await addFSBathroomLocation(fs_feature_id!, location_id_list);

            if (data.statusCode === 200) {
                fsBathroomDataGet();
                handleCloseBathroomLocationModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Bathroom location(s) added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the bathroom location.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the bathroom location:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the bathroom location.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteBathroomLocation = (bathroomLocation: FSBathroom) => {
        const bathroomLocationId = bathroomLocation?.id;

        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>Are you sure you want to delete the <b className="text-capitalize">{(bathroomLocation?.location_name).toLowerCase()}</b> location?</span>
                    <span>This action will <b>delete all</b> records associated with it.</span>
                </div>
            ),
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteBathroomLocation(bathroomLocationId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Bathroom location delete API
    const deleteBathroomLocation = async (bathroomLocationId: number) => {
        if (!bathroomLocationId) return;

        setBathroomLocationDeleteLoadingId(bathroomLocationId);

        try {
            const id = bathroomLocationId;
            const data = await deleteFSBathroomLocation(id);

            if (data.statusCode === 200) {
                fsBathroomDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Bathroom location deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the bathroom location.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the bathroom location:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the bathroom location.",
                life: 3000,
            });
        } finally {
            setBathroomLocationDeleteLoadingId(null);
        }
    }

    /* Modal header */
    const bathroomLocationModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;bathroom location
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseBathroomLocationModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const bathroomLocationModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseBathroomLocationModal}
            />

            <Button
                label={
                    loading ? 'Processing' :
                        `Add${selectedFSLocations?.length > 0 ? `(${String(selectedFSLocations?.length).padStart(2, '0')})` : ''}`
                }
                onClick={addBathroomLocation}
                loading={loading}
                className="custom_btn primary"
                disabled={selectedFSLocations?.length === 0}
            />
        </div>
    );
    /* //////////////////////////////////////////// */

    // //////////////////////////////////////////// Bathroom feature
    useEffect(() => {
        if (!activeFSFeature) return;

        const fetchData = async () => {
            if (activeFSFeature?.feature === 'Bathroom') {
                await fsBathroomFeatureDataGet();
            }
        }

        fetchData();
    }, [activeFSFeature, dispatch]);

    const fsBathroomFeatureDataGet = async () => {
        await dispatch(fetchFSBathroomFeatureList());
    }

    useEffect(() => {
        if (fsBathroomFeatures && fsBathroomFeatures?.length > 0) {
            const filteredData = fsBathroomFeatures.filter((bathroomFeature) =>
                bathroomFeature
                    ?.feature_name!.toLowerCase()
                    .includes(fsBathroomFeatureSearchKey.toLowerCase())
            );

            setBathroomFeatureData(filteredData);
        } else {
            setBathroomFeatureData([]);
        }
    }, [fsBathroomFeatures, fsBathroomFeatureSearchKey])

    const handleCloseBathroomFeatureListModal = () => {
        setSelectedBathroomFeatures([]);
        setSelectedBathroom(null);
        setFSBathroomFeatureSearchKey('');
        setShowBathroomFeatureListModal(false);
    }

    const handleAddBathroomFeature = (bathroom: FSBathroom) => {
        setSelectedBathroom(bathroom);
        setShowBathroomFeatureListModal(true);
        setDataState('Add');
    }

    const handleSelectBathroomFeature = (bathroomFeature: FSBathroomFeature, isChecked: boolean) => {
        if (isChecked) {
            setSelectedBathroomFeatures((prevState) => [...prevState, bathroomFeature]);
        } else {
            setSelectedBathroomFeatures((prevState) =>
                prevState.filter(
                    (existingBathroomFeature) => existingBathroomFeature.id !== bathroomFeature.id
                )
            );
        }
    };

    const isSelectedBathroomFeature = (bathroomFeature: FSBathroomFeature): boolean =>
        selectedBathroomFeatures.some(
            (existingBathroomFeature) => existingBathroomFeature?.id === bathroomFeature?.id
        );

    const isAlreadyExistBathroomFeature = (bathroomFeature: FSBathroomFeature): boolean => {
        if (!selectedBathroom) return false;

        return selectedBathroom?.feature_list?.some(
            (existingBathroomFeature) => existingBathroomFeature?.id === bathroomFeature?.id
        );
    };

    function checkCredentialsForBathroomFeature(): boolean {
        return selectedBathroomFeatures.length > 0;
    }

    // Bathroom feature add API
    const addBathroomFeatures = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForBathroomFeature()) return;

        setLoading(true);

        try {
            const fs_data_id = activeBathroomLocation?.id;
            const feature_id_list = selectedBathroomFeatures?.map((e) => e.id);

            const data = await addFSBathroomFeature(fs_data_id!, feature_id_list);

            if (data.statusCode === 200) {
                fsBathroomDataGet();
                handleCloseBathroomFeatureListModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Bathroom feature(s) added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the bathroom feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the bathroom feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the bathroom feature.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteBathroomFeature = (bathroomFeature: FSBathroomFeatureData) => {
        const bathroomFeatureId = bathroomFeature?.id;

        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>Are you sure you want to delete the <b className="text-capitalize">{(bathroomFeature?.feature_name).toLowerCase()}</b>?</span>
                    <span>This action will <b>delete all</b> records associated with it.</span>
                </div>
            ),
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteBathroomFeature(bathroomFeatureId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Bathroom feature delete API
    const deleteBathroomFeature = async (bathroomFeatureId: number) => {
        if (!bathroomFeatureId) return;

        setBathroomFeatureDeleteLoadingId(bathroomFeatureId);

        try {
            const fs_data_id = activeBathroomLocation?.id;
            const bathroom_feature_id = bathroomFeatureId;

            const data = await deleteFSBathroomFeature(fs_data_id!, bathroom_feature_id);

            if (data.statusCode === 200) {
                fsBathroomDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Bathroom feature deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the bathroom feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the bathroom feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the bathroom feature.",
                life: 3000,
            });
        } finally {
            setBathroomFeatureDeleteLoadingId(null);
        }
    }

    /* Modal header */
    const bathroomFeatureModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;<span className="custom">{dataState === 'Add' ? `(${selectedBathroom?.location_name})` : ''}</span> area(s).
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseBathroomFeatureListModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const bathroomFeatureModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Cancel"
                className="custom_btn secondary"
                onClick={handleCloseBathroomFeatureListModal}
            />

            <Button
                label={loading ? 'Processing' :
                    `Add${selectedBathroomFeatures?.length > 0 ? `(${String(selectedBathroomFeatures?.length).padStart(2, '0')})` : ''}`
                }
                onClick={addBathroomFeatures}
                loading={loading}
                className="custom_btn primary"
                disabled={selectedBathroomFeatures?.length === 0}
            />
        </div>
    );
    /* //////////////////////////////////////////// */

    // //////////////////////////////////////////// Bathroom sub feature
    useEffect(() => {
        if (!selectedBathroomFeature || !fsBathroomFeatures?.length) {
            setBathroomSubFeatureData([]);
            return;
        }

        const bathroomFeature = fsBathroomFeatures.find(
            (feature) => feature?.id === selectedBathroomFeature?.id
        );

        if (!bathroomFeature?.sub_feature) {
            setBathroomSubFeatureData([]);
            return;
        }

        const filteredData = bathroomFeature.sub_feature.filter((subFeature) =>
            subFeature?.sub_feature_name
                ?.toLowerCase()
                .includes(fsBathroomSubFeatureSearchKey.toLowerCase())
        );

        setBathroomSubFeatureData(filteredData ?? []);
    }, [fsBathroomFeatures, selectedBathroomFeature, fsBathroomSubFeatureSearchKey]);

    const handleCloseBathroomSubFeatureListModal = () => {
        setSelectedBathroomFeature(null);
        setSelectedBathroomSubFeatures([]);
        setFSBathroomSubFeatureSearchKey('');
        setShowBathroomSubFeatureListModal(false);
        handleResetCustomBathroomSubFeatureFields();
    }

    const handleResetCustomBathroomSubFeatureFields = () => {
        setCustomBathroomSubFeatureName('');
        setCustomBathroomSubFeatureNameError('');
        setCustomDataState('Add');
        setSelectedCustomBathroomSubFeature(null);
    }

    const handleAddBathroomSubFeature = (bathroomFeature: FSBathroomFeatureData) => {
        setSelectedBathroomFeature(bathroomFeature);
        setDataState('Add');
        setShowBathroomSubFeatureListModal(true);
    }

    const handleSelectBathroomSubFeature = (bathroomSubFeature: FSBathroomSubFeature, isChecked: boolean) => {
        if (isChecked) {
            setSelectedBathroomSubFeatures((prevState) => [...prevState, bathroomSubFeature]);
        } else {
            setSelectedBathroomSubFeatures((prevState) =>
                prevState.filter(
                    (existingBathroomSubFeature) => existingBathroomSubFeature.id !== bathroomSubFeature.id
                )
            );
        }
    };

    const isSelectedBathroomSubFeature = (bathroomSubFeature: FSBathroomSubFeature): boolean =>
        selectedBathroomSubFeatures.some(
            (existingBathroomSubFeature) => existingBathroomSubFeature?.id === bathroomSubFeature?.id
        );

    const isAlreadyExistBathroomSubFeature = (bathroomSubFeature: FSBathroomSubFeature): boolean => {
        if (!selectedBathroomFeature) return false;

        return selectedBathroomFeature?.data_bathroom?.some(
            (existingBathroomSubFeature) => existingBathroomSubFeature?.sub_feature_id === bathroomSubFeature?.id
        );
    };

    useEffect(() => {
        checkText(customBathroomSubFeatureName, false, setCustomBathroomSubFeatureNameError);
    }, [customBathroomSubFeatureName]);

    function checkCredentialsForCustomBathroomSubFeature(): boolean {
        const isValidCustomBathroomSubFeatureName = checkText(customBathroomSubFeatureName, true, setCustomBathroomSubFeatureNameError);

        return isValidCustomBathroomSubFeatureName;
    }

    function showAPIErrorForCustomBathroomSubFeature(keyName: string, error: string): void {
        if (keyName === "sub_feature_name") {
            setCustomBathroomSubFeatureNameError(error);
        }
    }

    // Sub feature add API
    const handleCreateCustomBathroomSubFeature = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForCustomBathroomSubFeature()) return;

        setCustomLoading(true);

        try {
            const bathroom_feature_id = selectedBathroomFeature?.id;
            const sub_feature_name = customBathroomSubFeatureName;

            const data = await addFSBathroomSubFeature(bathroom_feature_id!, sub_feature_name);

            if (data.statusCode === 200) {
                fsBathroomFeatureDataGet();
                handleResetCustomBathroomSubFeatureFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Sub feature added successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForCustomBathroomSubFeature(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the sub feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the sub feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the sub feature.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleEditCustomBathroomSubFeature = (bathroomSubFeature: FSBathroomSubFeature) => {
        if (bathroomSubFeature) {
            setSelectedCustomBathroomSubFeature(bathroomSubFeature);

            setCustomBathroomSubFeatureName(bathroomSubFeature?.sub_feature_name || '');
            setCustomDataState('Edit');
        } else {
            setSelectedCustomBathroomSubFeature(null);
        }
    }

    useEffect(() => {
        if (selectedCustomBathroomSubFeature) {
            if (customBathroomSubFeatureName && customBathroomSubFeatureName !== selectedCustomBathroomSubFeature?.sub_feature_name) {
                setCustomBathroomSubFeatureUpdateHasChanges(true);
            } else {
                setCustomBathroomSubFeatureUpdateHasChanges(false);
            }
        }
    }, [selectedCustomBathroomSubFeature, customBathroomSubFeatureName]);

    // Sub feature update API
    const handleUpdateCustomBathroomSubFeature = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForCustomBathroomSubFeature() || selectedCustomBathroomSubFeature === null) return;

        setCustomLoading(true);

        try {
            const id = selectedCustomBathroomSubFeature?.id;
            const bathroom_feature_id = selectedBathroomFeature?.id;
            const sub_feature_name = customBathroomSubFeatureName;

            const data = await updateFSBathroomSubFeature(
                id!,
                bathroom_feature_id!,
                sub_feature_name
            );

            if (data.statusCode === 200) {
                fsBathroomFeatureDataGet();
                handleResetCustomBathroomSubFeatureFields();

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Sub feature updated successfully.",
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForCustomBathroomSubFeature(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the sub feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the sub feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the sub feature.",
                life: 3000,
            });
        } finally {
            setCustomLoading(false);
        }
    };

    const handleDeleteCustomBathroomSubFeature = (bathroomSubFeature: FSBathroomSubFeature) => {
        if (bathroomSubFeature) {
            handleResetCustomBathroomSubFeatureFields();
            const customBathroomSubFeatureId = bathroomSubFeature?.id;

            confirmDialog({
                message: (
                    <div className="text-center d-flex justify-content-center flex-column">
                        <span>Are you sure you want to delete this <b>sub feature</b>?</span>
                        <span>This action will <b>delete all</b> records associated with it.</span>
                    </div>
                ),
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteCustomBathroomSubFeature(customBathroomSubFeatureId!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Sub feature delete API
    const deleteCustomBathroomSubFeature = async (customBathroomSubFeatureId: number) => {
        if (!customBathroomSubFeatureId) return;

        setDeleteBathroomSubFeatureLoadingId(customBathroomSubFeatureId);

        try {
            const id = customBathroomSubFeatureId;
            const result = await deleteFSBathroomSubFeature(id);

            if (result.statusCode === 200) {
                fsBathroomFeatureDataGet();
                setSelectedBathroomFeatures([]);

                setSelectedBathroomSubFeatures((prev) =>
                    prev ? prev.filter((sub) => sub.id !== customBathroomSubFeatureId) : []
                );

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Sub feature deleted successfully.",
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error deleting the sub feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the bathroom sub feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the bathroom sub feature.",
                life: 3000,
            });
        } finally {
            setDeleteBathroomSubFeatureLoadingId(null);
        }
    }

    function checkCredentialsForBathroomSubFeature(): boolean {
        return selectedBathroomSubFeatures.length > 0;
    }

    // Bathroom Sub features add API
    const addBathroomSubFeatures = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForBathroomSubFeature()) return;

        setLoading(true);

        try {
            const fs_data_id = activeBathroomLocation?.id;
            const bathroom_feature_id = selectedBathroomFeature?.id;
            const sub_feature_id_list = selectedBathroomSubFeatures?.map((e) => e.id);

            const data = await fsBathroomCreate(
                fs_data_id!,
                bathroom_feature_id!,
                sub_feature_id_list
            );

            if (data.statusCode === 200) {
                fsBathroomDataGet();
                handleCloseBathroomSubFeatureListModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Bathroom sub feature(s) added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the bathroom sub feature.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error adding the bathroom sub feature:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while adding the bathroom sub feature.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    /* Modal header */
    const bathroomSubFeatureModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;<span className="custom">{dataState === 'Add' ? `(${(selectedBathroomFeature?.feature_name)?.toLowerCase()})` : ''}</span> feature(s).
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseBathroomSubFeatureListModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const bathroomSubFeatureModalFooter = (
        <React.Fragment>
            {hasPermissionForAddSubFeature && (
                <div className="page_form_group data_select_modal_footer inside_modal_footer mb-0">
                    <div className="input_with_button_area">
                        <InputText
                            key={`customBathroomSubFeatureName`}
                            id="customBathroomSubFeatureName"
                            value={customBathroomSubFeatureName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomBathroomSubFeatureName(e.target.value)}
                            className="custom_form_input has_add_value custom_data_input"
                            placeholder="Enter feature name"
                            autoComplete="off"
                        />
                        <button
                            className="add_value_btn fill p-ripple"
                            onClick={customDataState === 'Add' ? handleCreateCustomBathroomSubFeature : handleUpdateCustomBathroomSubFeature}
                            disabled={(customLoading || customBathroomSubFeatureName === "") || (customDataState === 'Edit' && !customBathroomSubFeatureUpdateHasChanges)}
                        >
                            <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                            <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                            <Ripple />
                        </button>
                    </div>
                    {customBathroomSubFeatureNameError && (
                        <small className="form_error_msg text-start">
                            {customBathroomSubFeatureNameError}
                        </small>
                    )}
                </div>
            )}

            <div className="custom_modal_footer">
                <Button
                    label="Cancel"
                    className="custom_btn secondary"
                    onClick={handleCloseBathroomSubFeatureListModal}
                />

                <Button
                    label={loading ? 'Processing' :
                        `Add${selectedBathroomSubFeatures?.length > 0 ? `(${String(selectedBathroomSubFeatures?.length).padStart(2, '0')})` : ''}`
                    }
                    onClick={addBathroomSubFeatures}
                    loading={loading}
                    className="custom_btn primary"
                    disabled={selectedBathroomSubFeatures?.length === 0}
                />
            </div>
        </React.Fragment>
    );
    /* //////////////////////////////////////////// */

    // //////////////////////////////////////////// Bathroom detail
    const handleCloseBathroomDetailModal = () => {
        setShowBathroomDetailModal(false);
        handleResetBathroomDetailFields();
    }

    const handleResetBathroomDetailFields = () => {
        setSelectedFSItem(null);
        setBathroomName('');
        setSelectedFSBrand(null);
        setSelectedFSColor(null);
        setBathroomSize('');
        setBathroomLink(null);
        setBathroomImageFile(null);
        setBathroomImageFileName('');
        setBathroomFiles([]);

        setSelectedBathroomDetail(null);
        setSelectedBathroom(null);

        setBathroomNameError('');
        setBathroomBrandError('');
        setBathroomColorError('');
        setBathroomSizeError('');
        setBathroomLinkError('');
        setBathroomImageFileError('');
        setBathroomFilesError('');
    }

    useEffect(() => {
        checkText(bathroomName, false, setBathroomNameError);
    }, [bathroomName]);

    useEffect(() => {
        checkModelSelected(selectedFSBrand != null, false, setBathroomBrandError);
    }, [selectedFSBrand]);

    useEffect(() => {
        checkModelSelected(selectedFSColor != null, false, setBathroomColorError);
    }, [selectedFSColor]);

    useEffect(() => {
        checkText(bathroomSize, false, setBathroomSizeError);
    }, [bathroomSize]);

    useEffect(() => {
        checkText(bathroomLink!, false, setBathroomLinkError);
    }, [bathroomLink]);

    useEffect(() => {
        checkFileOthers(bathroomImageFile!, false, setBathroomImageFileError);
    }, [bathroomImageFile]);

    useEffect(() => {
        checkFileOtherList(bathroomFiles!, false, setBathroomFilesError);
    }, [bathroomFiles]);

    function checkCredentialsForBathroomDetail(fileRequired: boolean): boolean {
        const isBathroomNameValid = checkText(bathroomName, true, setBathroomNameError);
        const isBathroomBrandValid = checkModelSelected(selectedFSBrand != null, true, setBathroomBrandError);
        const isBathroomColorValid = checkModelSelected(selectedFSColor != null, true, setBathroomColorError);
        const isBathroomSizeValid = checkText(bathroomSize, true, setBathroomSizeError);
        const isBathroomLinkValid = checkText(bathroomLink!, false, setBathroomLinkError);
        const isBathroomImageValid = checkFileOthers(bathroomImageFile!, fileRequired, setBathroomImageFileError);
        const isBathroomFilesValid = checkFileOtherList(bathroomFiles!, fileRequired, setBathroomFilesError);

        return (
            isBathroomNameValid &&
            isBathroomBrandValid &&
            isBathroomColorValid &&
            isBathroomSizeValid &&
            isBathroomLinkValid &&
            isBathroomImageValid &&
            isBathroomFilesValid
        );
    }

    function showAPIErrorForBathroomDetail(keyName: string, error: string): void {
        if (keyName === "name") {
            setBathroomNameError(error);
        }

        if (keyName === "brand_id") {
            setBathroomBrandError(error);
        }

        if (keyName === "color_id") {
            setBathroomColorError(error);
        }

        if (keyName === "size") {
            setBathroomSizeError(error);
        }

        if (keyName === "link") {
            setBathroomLinkError(error);
        }

        if (keyName === "image_path") {
            setBathroomImageFileError(error);
        }

        if (keyName === "file_list[]") {
            setBathroomFilesError(error);
        }
    }

    useEffect(() => {
        if (selectedBathroomDetail) {
            if (bathroomName !== selectedBathroomDetail?.name) {
                setBathroomDetailUpdateHasChanges(true);
            } else if (selectedFSBrand?.id !== selectedBathroomDetail?.brand_id) {
                setBathroomDetailUpdateHasChanges(true);
            } else if (selectedFSColor?.id !== selectedBathroomDetail?.color_id) {
                setBathroomDetailUpdateHasChanges(true);
            } else if (bathroomSize !== null && bathroomSize !== selectedBathroomDetail?.size) {
                setBathroomDetailUpdateHasChanges(true);
            } else if (bathroomLink !== null && bathroomLink !== selectedBathroomDetail?.link) {
                setBathroomDetailUpdateHasChanges(true);
            } else if (bathroomImageFile !== null) {
                setBathroomDetailUpdateHasChanges(true);
            } else if (bathroomFiles?.length !== 0) {
                setBathroomDetailUpdateHasChanges(true);
            } else {
                setBathroomDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedBathroomDetail,
        bathroomName,
        selectedFSBrand,
        selectedFSColor,
        bathroomSize,
        bathroomLink,
        bathroomImageFile,
        bathroomFiles
    ]);

    const handleEditBathroomDetail = (bathroomDetail: FSBathroomData) => {
        if (bathroomDetail) {
            setShowBathroomDetailModal(true);

            if (bathroomDetail?.is_not_updated === 0) {
                setDataState('Edit');
            } else {
                setDataState('Add');
            }

            setSelectedBathroomDetail(bathroomDetail);

            setBathroomName(bathroomDetail?.name || '');
            setSelectedFSBrand(bathroomDetail?.brand || null);
            setSelectedFSColor(bathroomDetail?.color || null);
            setBathroomSize(bathroomDetail?.size || '');
            setBathroomLink(bathroomDetail?.link || null)
        }
    }

    // Bathroom detail update API
    const handleUpdateBathroomDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForBathroomDetail(false)) return;

        setLoading(true);

        try {
            const id = selectedBathroomDetail?.id;
            const brand_id = selectedFSBrand?.id;
            const color_id = selectedFSColor?.id;
            const name = bathroomName;
            const size = bathroomSize;
            const link = bathroomLink;
            const image_path = bathroomImageFile;
            const file_list = bathroomFiles;

            const data = await fsBathroomUpdate(
                id!,
                brand_id!,
                color_id!,
                name,
                size,
                link,
                image_path,
                file_list
            );

            if (data.statusCode === 200) {
                fsBathroomDataGet();
                handleCloseBathroomDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Bathroom detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForBathroomDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the bathroom detail.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the bathroom detail:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the bathroom detail.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteBathroomDetail = (bathroomDetail: FSBathroomData) => {
        const bathroomDetailId = bathroomDetail?.id;

        confirmDialog({
            message: `Are you sure you want to delete this bathroom data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteBathroomDetail(bathroomDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Bathroom detail delete API
    const deleteBathroomDetail = async (bathroomDetailId: number) => {
        if (!bathroomDetailId) return;

        setBathroomDetailDeleteLoadingId(bathroomDetailId);

        try {
            const id = bathroomDetailId;
            const data = await fsBathroomDelete(id);

            if (data.statusCode === 200) {
                fsBathroomDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Bathroom detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the bathroom detail.",
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error deleting the bathroom detail:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while deleting the bathroom detail.",
                life: 3000,
            });
        } finally {
            setBathroomDetailDeleteLoadingId(null);
        }
    }

    /* Modal header */
    const bathroomDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;bathroom detail <span className="custom">- {selectedBathroomDetail?.sub_feature?.sub_feature_name}</span>
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseBathroomDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const bathroomDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseBathroomDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={handleUpdateBathroomDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !bathroomDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadBathroomImageFile = (file: File) => {
        setBathroomImageFile(file);
        setBathroomImageFileName(file.name);
    };

    const handleClearBathroomImageFile = () => {
        setBathroomImageFile(null);
        setBathroomImageFileName("");
    };

    const handleUploadBathroomFiles = (files: File[]) => {
        setBathroomFiles(files);
    };

    const handleClearBathroomFiles = () => {
        setBathroomFiles([]);
    };

    const bathroomDetailTableActionBody = (rowData: FSBathroomData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewBathroomDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        disabled={data?.is_not_updated === 1}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForAddBathroom && hasPermissionForUpdateBathroom && (
                        <TableActionButton
                            icon={`bi ${data?.is_not_updated ? 'bi-plus-lg' : 'bi-pencil-square'}`}
                            onClick={() => handleEditBathroomDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip={(data?.is_not_updated === 1 ? 'Add' : 'Edit') + ' detail'}
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteBathroom && (
                        <TableActionButton
                            icon={`${bathroomDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteBathroomDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={bathroomDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewBathroomDetail = (data: FSBathroomData) => {
        setSelectedBathroomDetail(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */


    /* ************************************************************* Finishing schedule - Kitchen */
    useEffect(() => {
        if (activeFSFeature && activeFSFeature?.feature === 'Kitchen') {
            const fetchData = async () => {
                await dispatch(fetchFSKitchenCollectionList());
                await dispatch(fetchFSKitchenFinishList());
                await fsKitchenRangeDataGet();
                await fsKitchenStyleDataGet();
            }

            fetchData();
        }
    }, [activeFSFeature])

    // Kitchen details
    useEffect(() => {
        if (fsKitchens && fsKitchens.length > 0) {
            setFSKitchenData(
                fsKitchens.find(
                    kitchen => kitchen?.location_name?.toLowerCase() === 'kitchen'
                ) || null
            );
        } else {
            setFSKitchenData(null);
        }
    }, [fsKitchens]);

    const handleAddKitchenDetail = () => {
        setShowKitchenOptionModal(true);
        setDataState('Add');
    }

    const handleCloseKitchenOptionModal = () => {
        setShowKitchenOptionModal(false);
        setSelectedKitchenOption(null);
    }

    const kitchenOptionModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;kitchen detail for:
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseKitchenOptionModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    const handleSelectKitchenOption = (option: KitchenOption) => {
        setSelectedKitchenOption(option);
        setShowKitchenOptionModal(false);
        setShowKitchenDetailModal(true);
        setSelectedSubCategory(option);
        setDataState('Add');
    }

    const handleCloseKitchenDetailModal = () => {
        handleResetKitchenDetailFields();
        setShowKitchenDetailModal(false);

        if (dataState === 'Add') {
            setShowKitchenOptionModal(true);
        }
    }

    const handleResetKitchenDetailFields = () => {
        setSelectedFSBrand(null);
        setSelectedFSKitchenCollection(null);
        setSelectedFSKitchenRange(null);
        setSelectedFSColor(null);
        setSelectedFSType(null);
        setSelectedFSKitchenStyle(null);
        setSelectedFSKitchenFinish(null);
        setKitchenName('');
        setKitchenDepth(null);
        setKitchenThickness(null);
        setKitchenNumber(null);
        setKitchenLink(null);
        setKitchenImageFile(null);
        setKitchenImageFileName('');
        setKitchenFiles([]);

        setSelectedKitchenDetail(null);
        setSelectedKitchenOption(null);
        setSelectedSubCategory(null);

        setKitchenBrandError('');
        setKitchenNameError('');
        setKitchenDepthError('');
        setKitchenThicknessError('');
        setKitchenStyleError('');
        setKitchenNumberError('');
        setKitchenCollectionError('');
        setKitchenRangeError('');
        setKitchenColorError('');
        setKitchenTypeError('');
        setKitchenFinishError('');
        setKitchenLinkError('');
        setKitchenImageFileError('');
        setKitchenFilesError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSBrand != null, false, setKitchenBrandError);
    }, [selectedFSBrand]);

    useEffect(() => {
        checkModelSelected(selectedFSKitchenCollection != null, false, setKitchenCollectionError);
    }, [selectedFSKitchenCollection]);

    useEffect(() => {
        checkModelSelected(selectedFSKitchenRange != null, false, setKitchenRangeError);
    }, [selectedFSKitchenRange]);

    useEffect(() => {
        checkModelSelected(selectedFSColor != null, false, setKitchenColorError);
    }, [selectedFSColor]);

    useEffect(() => {
        checkModelSelected(selectedFSType != null, false, setKitchenTypeError);
    }, [selectedFSType]);

    useEffect(() => {
        checkModelSelected(selectedFSKitchenFinish != null, false, setKitchenFinishError);
    }, [selectedFSKitchenFinish]);

    useEffect(() => {
        checkText(kitchenName, false, setKitchenNameError);
    }, [kitchenName]);

    useEffect(() => {
        checkModelSelected(selectedFSKitchenStyle != null, false, setKitchenStyleError);
    }, [selectedFSKitchenStyle]);

    useEffect(() => {
        checkNumber(kitchenNumber!, false, setKitchenNumberError);
    }, [kitchenNumber]);

    useEffect(() => {
        checkNumber(kitchenDepth!, false, setKitchenDepthError);
    }, [kitchenDepth]);

    useEffect(() => {
        checkNumber(kitchenThickness!, false, setKitchenThicknessError);
    }, [kitchenThickness]);

    useEffect(() => {
        checkText(kitchenLink!, false, setKitchenLinkError);
    }, [kitchenLink]);

    useEffect(() => {
        checkFileOtherList(kitchenFiles!, false, setKitchenFilesError);
    }, [kitchenFiles]);

    useEffect(() => {
        checkFileOthers(kitchenImageFile!, false, setKitchenImageFileError);
    }, [kitchenImageFile]);

    function checkCredentialsForKitchenDetail(fileRequired: boolean): boolean {
        const isKitchenBrandValid = checkModelSelected(selectedFSBrand != null, true, setKitchenBrandError);
        const isKitchenLinkValid = checkText(kitchenLink!, false, setKitchenLinkError);
        const isKitchenFilesValid = checkFileOtherList(kitchenFiles!, fileRequired, setKitchenFilesError);
        const isKitchenImageValid = checkFileOthers(kitchenImageFile!, fileRequired, setKitchenImageFileError);

        const isKitchenCollectionValid = checkModelSelected(selectedFSKitchenCollection != null, true, setKitchenCollectionError);
        const isKitchenRangeValid = checkModelSelected(selectedFSKitchenRange != null, true, setKitchenRangeError);
        const isKitchenColorValid = checkModelSelected(selectedFSColor != null, true, setKitchenColorError);
        const isKitchenTypeValid = checkModelSelected(selectedFSType != null, true, setKitchenTypeError);
        const isKitchenStyleValid = checkModelSelected(selectedFSKitchenStyle != null, true, setKitchenStyleError);
        const isKitchenFinishValid = checkModelSelected(selectedFSKitchenFinish != null, true, setKitchenFinishError);
        const isKitchenNameValid = checkText(kitchenName!, true, setKitchenNameError);
        const isKitchenNumberValid = checkNumber(kitchenNumber!, true, setKitchenNumberError);
        const isKitchenDepthValid = checkNumber(kitchenDepth!, true, setKitchenDepthError);
        const isKitchenThicknessValid = checkNumber(kitchenThickness!, true, setKitchenThicknessError);

        switch (selectedKitchenOption) {
            case 'Type':
            case 'Base Units':
            case 'Wall Units':
                return (
                    isKitchenBrandValid &&
                    isKitchenCollectionValid &&
                    isKitchenRangeValid &&
                    isKitchenColorValid &&
                    isKitchenStyleValid &&
                    isKitchenFinishValid &&
                    isKitchenLinkValid &&
                    isKitchenFilesValid &&
                    isKitchenImageValid
                );

            case 'Worktop':
                return (
                    isKitchenBrandValid &&
                    isKitchenNameValid &&
                    isKitchenTypeValid &&
                    isKitchenDepthValid &&
                    isKitchenThicknessValid &&
                    isKitchenLinkValid &&
                    isKitchenFilesValid &&
                    isKitchenImageValid
                );

            case 'Door':
                return (
                    isKitchenBrandValid &&
                    isKitchenNameValid &&
                    isKitchenStyleValid &&
                    isKitchenColorValid &&
                    isKitchenLinkValid &&
                    isKitchenFilesValid &&
                    isKitchenImageValid
                );

            case 'Handle':
                return (
                    isKitchenBrandValid &&
                    isKitchenNameValid &&
                    isKitchenNumberValid &&
                    isKitchenLinkValid &&
                    isKitchenFilesValid &&
                    isKitchenImageValid
                );

            default:
                return (
                    isKitchenBrandValid &&
                    isKitchenLinkValid &&
                    isKitchenFilesValid &&
                    isKitchenImageValid
                );
        }
    }

    function showAPIErrorForKitchenDetail(keyName: string, error: string): void {
        if (keyName === "brand_id") {
            setKitchenBrandError(error);
        }

        if (keyName === "collection_id") {
            setKitchenCollectionError(error);
        }

        if (keyName === "range_id") {
            setKitchenRangeError(error);
        }

        if (keyName === "color_id") {
            setKitchenColorError(error);
        }

        if (keyName === "type_id") {
            setKitchenTypeError(error);
        }

        if (keyName === "style_id") {
            setKitchenStyleError(error);
        }

        if (keyName === "finish_id") {
            setKitchenFinishError(error);
        }

        if (keyName === "name") {
            setKitchenNameError(error);
        }

        if (keyName === "size_depth") {
            setKitchenDepthError(error);
        }

        if (keyName === "size_thickness") {
            setKitchenThicknessError(error);
        }

        if (keyName === "number") {
            setKitchenNumberError(error);
        }

        if (keyName === "link") {
            setKitchenLinkError(error);
        }

        if (keyName === "file_list[]") {
            setKitchenFilesError(error);
        }

        if (keyName === "image_path") {
            setKitchenImageFileError(error);
        }
    }

    // Kitchen details add API
    const handleCreateKitchenDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForKitchenDetail(false)) return;

        setLoading(true);

        try {
            const fs_data_id = fsKitchenData?.id;
            const brand_id = selectedFSBrand?.id;
            const collection_id = selectedFSKitchenCollection?.id;
            const range_id = selectedFSKitchenRange?.id;
            const color_id = selectedFSColor?.id;
            const type_id = selectedFSType?.id;
            const style_id = selectedFSKitchenStyle?.id;
            const finish_id = selectedFSKitchenFinish?.id;
            const name = kitchenName;
            const size_depth = kitchenDepth;
            const size_thickness = kitchenThickness;
            const number = kitchenNumber;
            const link = kitchenLink;
            const image_path = kitchenImageFile;
            const file_list = kitchenFiles;

            let data;

            switch (selectedKitchenOption) {
                case "Type":
                    data = await fsKitchenTypeCreate(
                        fs_data_id!,
                        brand_id!,
                        collection_id!,
                        range_id!,
                        color_id!,
                        style_id!,
                        finish_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Base Units":
                    data = await fsKitchenBaseUnitCreate(
                        fs_data_id!,
                        brand_id!,
                        collection_id!,
                        range_id!,
                        color_id!,
                        style_id!,
                        finish_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Wall Units":
                    data = await fsKitchenWallUnitCreate(
                        fs_data_id!,
                        brand_id!,
                        collection_id!,
                        range_id!,
                        color_id!,
                        style_id!,
                        finish_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Worktop":
                    data = await fsKitchenWorktopCreate(
                        fs_data_id!,
                        brand_id!,
                        type_id!,
                        name,
                        size_depth!,
                        size_thickness!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Door":
                    data = await fsKitchenDoorCreate(
                        fs_data_id!,
                        brand_id!,
                        color_id!,
                        name,
                        style_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Handle":
                    data = await fsKitchenHandleCreate(
                        fs_data_id!,
                        brand_id!,
                        name,
                        number!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                default:
                    throw new Error("Invalid kitchen option selected.");
            }

            if (data?.statusCode === 200) {
                fsKitchenDataGet();
                handleCloseKitchenDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Kitchen ${(selectedKitchenOption)?.toLowerCase()} detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data?.statusCode === 422) {
                Object.entries(data.errors ?? {}).forEach(([key, value]) => {
                    showAPIErrorForKitchenDetail(key, (value as string[])[0]);
                });
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: `There was an error adding the kitchen ${(selectedKitchenOption)?.toLowerCase()} detail.`,
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error creating kitchen detail:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while creating kitchen detail.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!selectedKitchenDetail || !selectedKitchenOption) return;

        const isDifferent = (a: any, b: any) => a !== b && a != null;

        let hasChanges = false;

        if (isDifferent(selectedFSBrand?.id, selectedKitchenDetail?.brand_id)) hasChanges = true;
        if (isDifferent(kitchenLink, selectedKitchenDetail?.link)) hasChanges = true;
        if (kitchenImageFile !== null) hasChanges = true;
        if (kitchenFiles?.length) hasChanges = true;

        switch (selectedKitchenOption) {
            case 'Type':
            case 'Base Units':
            case 'Wall Units':
                if (isDifferent(selectedFSKitchenCollection?.id, selectedKitchenDetail?.collection_id)) hasChanges = true;
                if (isDifferent(selectedFSKitchenRange?.id, selectedKitchenDetail?.range_id)) hasChanges = true;
                if (isDifferent(selectedFSColor?.id, selectedKitchenDetail?.color_id)) hasChanges = true;
                if (isDifferent(selectedFSKitchenStyle?.id, selectedKitchenDetail?.style_id)) hasChanges = true;
                if (isDifferent(selectedFSKitchenFinish?.id, selectedKitchenDetail?.finish_id)) hasChanges = true;
                break;

            case 'Worktop':
                if (isDifferent(kitchenName, selectedKitchenDetail?.name)) hasChanges = true;
                if (isDifferent(selectedFSType?.id, selectedKitchenDetail?.type_id)) hasChanges = true;
                if (isDifferent(kitchenDepth, selectedKitchenDetail?.size_depth)) hasChanges = true;
                if (isDifferent(kitchenThickness, selectedKitchenDetail?.size_thickness)) hasChanges = true;
                break;

            case 'Door':
                if (isDifferent(kitchenName, selectedKitchenDetail?.name)) hasChanges = true;
                if (isDifferent(selectedFSKitchenStyle?.id, selectedKitchenDetail?.style_id)) hasChanges = true;
                if (isDifferent(selectedFSColor?.id, selectedKitchenDetail?.color_id)) hasChanges = true;
                break;

            case 'Handle':
                if (isDifferent(kitchenName, selectedKitchenDetail?.name)) hasChanges = true;
                if (isDifferent(kitchenNumber, selectedKitchenDetail?.number)) hasChanges = true;
                break;
        }

        setKitchenDetailUpdateHasChanges(hasChanges);
    }, [
        selectedKitchenDetail,
        selectedKitchenOption,
        selectedFSBrand,
        selectedFSKitchenCollection,
        selectedFSKitchenRange,
        selectedFSKitchenFinish,
        selectedFSColor,
        selectedFSType,
        selectedFSKitchenStyle,
        kitchenDepth,
        kitchenThickness,
        kitchenNumber,
        kitchenName,
        kitchenLink,
        kitchenImageFile,
        kitchenFiles,
    ]);

    const handleEditKitchenDetail = (kitchenDetail: FSKitchenData) => {
        if (!kitchenDetail) return;

        setDataState("Edit");
        setSelectedSubCategory(kitchenDetail?.category);
        const option = kitchenDetail?.category as KitchenOption;
        setSelectedKitchenOption(option);
        setSelectedKitchenDetail(kitchenDetail);

        setSelectedFSBrand(kitchenDetail?.brand || null);
        setKitchenLink(kitchenDetail?.link || null);

        setSelectedFSKitchenCollection(null);
        setSelectedFSKitchenRange(null);
        setSelectedFSColor(null);
        setSelectedFSType(null);
        setSelectedFSKitchenStyle(null);
        setSelectedFSKitchenFinish(null);
        setKitchenName('');
        setKitchenDepth(null);
        setKitchenThickness(null);

        switch (option) {
            case "Type":
            case "Base Units":
            case "Wall Units":
                setSelectedFSKitchenCollection(kitchenDetail?.collection || null);
                setSelectedFSKitchenRange(kitchenDetail?.range || null);
                setSelectedFSColor(kitchenDetail?.color || null);
                setSelectedFSKitchenStyle(kitchenDetail.kitchen_style || null);
                setSelectedFSKitchenFinish(kitchenDetail?.finish || null);
                break;

            case "Worktop":
                setKitchenName(kitchenDetail?.name || '');
                setSelectedFSType(kitchenDetail?.type || null);
                setKitchenDepth(kitchenDetail?.size_depth || null);
                setKitchenThickness(kitchenDetail?.size_thickness || null);
                break;

            case "Door":
                setKitchenName(kitchenDetail?.name || '');
                setSelectedFSKitchenStyle(kitchenDetail.kitchen_style || null);
                setSelectedFSColor(kitchenDetail?.color || null);
                break;

            case "Handle":
                setKitchenName(kitchenDetail?.name || '');
                setKitchenNumber(kitchenDetail?.number || null);
                break;
        }

        setShowKitchenDetailModal(true);
    };

    // Kitchen details update API
    const handleUpdateKitchenDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForKitchenDetail(false)) return;

        setLoading(true);

        try {
            const id = selectedKitchenDetail?.id;
            const brand_id = selectedFSBrand?.id;
            const collection_id = selectedFSKitchenCollection?.id;
            const range_id = selectedFSKitchenRange?.id;
            const color_id = selectedFSColor?.id;
            const type_id = selectedFSType?.id;
            const style_id = selectedFSKitchenStyle?.id;
            const finish_id = selectedFSKitchenFinish?.id;
            const name = kitchenName;
            const size_depth = kitchenDepth;
            const size_thickness = kitchenThickness;
            const number = kitchenNumber;
            const link = kitchenLink;
            const image_path = kitchenImageFile;
            const file_list = kitchenFiles;

            let data;

            switch (selectedKitchenOption) {
                case "Type":
                    data = await fsKitchenTypeUpdate(
                        id!,
                        brand_id!,
                        collection_id!,
                        range_id!,
                        color_id!,
                        style_id!,
                        finish_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Base Units":
                    data = await fsKitchenBaseUnitUpdate(
                        id!,
                        brand_id!,
                        collection_id!,
                        range_id!,
                        color_id!,
                        style_id!,
                        finish_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Wall Units":
                    data = await fsKitchenWallUnitUpdate(
                        id!,
                        brand_id!,
                        collection_id!,
                        range_id!,
                        color_id!,
                        style_id!,
                        finish_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Worktop":
                    data = await fsKitchenWorktopUpdate(
                        id!,
                        brand_id!,
                        type_id!,
                        name,
                        size_depth!,
                        size_thickness!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Door":
                    data = await fsKitchenDoorUpdate(
                        id!,
                        brand_id!,
                        color_id!,
                        name,
                        style_id!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                case "Handle":
                    data = await fsKitchenHandleUpdate(
                        id!,
                        brand_id!,
                        name,
                        number!,
                        link,
                        image_path,
                        file_list
                    );
                    break;

                default:
                    throw new Error("Invalid kitchen option selected.");
            }

            if (data?.statusCode === 200) {
                fsKitchenDataGet();
                handleCloseKitchenDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Kitchen ${(selectedKitchenOption)?.toLowerCase()} detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? {}).forEach(([key, value]) => {
                    showAPIErrorForKitchenDetail(key, (value as string[])[0]);
                });
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: `There was an error updating the kitchen ${(selectedKitchenOption)?.toLowerCase()} detail.`,
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating kitchen detail:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating kitchen detail.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteKitchenDetail = (kitchenDetail: FSKitchenData) => {
        const kitchenDetailId = kitchenDetail?.id;

        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>Are you sure you want to delete the kitchen <b className="text-capitalize">{kitchenDetail?.category}</b> data?</span>
                </div>
            ),
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteKitchenDetail(kitchenDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Kitchen detail delete API
    const deleteKitchenDetail = async (kitchenDetailId: number) => {
        if (kitchenDetailId) {
            setKitchenDetailDeleteLoadingId(kitchenDetailId);

            const id = kitchenDetailId
            const data = await fsKitchenDelete(id);

            setKitchenDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsKitchenDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Kitchen detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the kitchen detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const kitchenDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;kitchen {` > `}<span className="custom">
                    {dataState === 'Add' && selectedKitchenOption === 'Type' ? 'Manufacture' : selectedKitchenOption}
                </span> detail
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseKitchenDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    const kitchenDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseKitchenDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateKitchenDetail : handleUpdateKitchenDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !kitchenDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadKitchenImageFile = (file: File) => {
        setKitchenImageFile(file);
        setKitchenImageFileName(file.name);
    };

    const handleClearKitchenImageFile = () => {
        setKitchenImageFile(null);
        setKitchenImageFileName("");
    };

    const handleUploadKitchenFiles = (files: File[]) => {
        setKitchenFiles(files);
    };

    const handleClearKitchenFiles = () => {
        setKitchenFiles([]);
    };

    const renderInputsByKitchenOption = () => {
        const kitchenDetailInputs = {
            brand: (
                <div className="col-12 col-sm-6">
                    <DataListModalInput
                        key={`kitchenBrand`}
                        inputId="kitchenBrand"
                        label="Brand"
                        value={selectedFSBrand}
                        displayKey="brand_name"
                        onAdd={handleAddBrand}
                        required={true}
                        placeHolder="Click to select the brand"
                        error={kitchenBrandError}
                    />
                </div>
            ),
            kitchenCollection: (
                <div className="col-12 col-sm-6">
                    <div className="page_form_group">
                        <label htmlFor="kitchenCollection" className="custom_form_label is_required">Kitchen Collection</label>
                        <Dropdown
                            key={`kitchenCollection`}
                            id="kitchenCollection"
                            value={selectedFSKitchenCollection}
                            onChange={(e: DropdownChangeEvent) => setSelectedFSKitchenCollection(e.value)}
                            optionLabel="kitchen_collection_name"
                            options={fsKitchenCollections}
                            panelClassName="status_option_panel"
                            placeholder="Select collection"
                            className="form_dropdown w-100"
                            loading={loadingFSKitchenCollections}
                        />

                        {kitchenCollectionError &&
                            <small className="form_error_msg">{kitchenCollectionError}</small>
                        }

                        {errorFSKitchenCollections &&
                            <small className="form_error_msg">{errorFSKitchenCollections}</small>
                        }
                    </div>
                </div>
            ),
            range: (
                <div className="col-12 col-sm-6">
                    <DataListModalInput
                        key={`kitchenRange`}
                        inputId="kitchenRange"
                        label="Range"
                        value={selectedFSKitchenRange}
                        displayKey="range_name"
                        onAdd={handleAddKitchenRange}
                        required={selectedFSBrand !== null ? true : false}
                        placeHolder="Click to select the range"
                        error={kitchenRangeError}
                        disabled={selectedFSBrand === null}
                    />
                </div>
            ),
            color: (
                <div className="col-12 col-sm-6">
                    <DataListModalInput
                        key={`kitchenColor`}
                        inputId="kitchenColor"
                        label="Color"
                        value={selectedFSColor}
                        displayKey="color_name"
                        onAdd={handleAddColor}
                        required={true}
                        placeHolder="Click to select the color"
                        error={kitchenColorError}
                        inputClassName={selectedFSColor ? 'has_color_display' : ''}
                        hasColorDisplay
                        colorDisplayKey="color_code"
                    />
                </div>
            ),
            type: (
                <div className="col-12 col-sm-6">
                    <DataListModalInput
                        key={`kitchenType`}
                        inputId="kitchenType"
                        label="Type"
                        value={selectedFSType}
                        displayKey="type_name"
                        onAdd={handleAddType}
                        required={true}
                        placeHolder="Click to select the type"
                        error={kitchenTypeError}
                    />
                </div>
            ),
            finish: (
                <div className="col-12 col-sm-6">
                    <div className="page_form_group">
                        <label htmlFor="kitchenFinish" className="custom_form_label is_required">Finish</label>
                        <Dropdown
                            key={`kitchenFinish`}
                            id="kitchenFinish"
                            value={selectedFSKitchenFinish}
                            onChange={(e: DropdownChangeEvent) => setSelectedFSKitchenFinish(e.value)}
                            optionLabel="finish_name"
                            options={fsKitchenFinishes}
                            panelClassName="status_option_panel"
                            placeholder="Select finish"
                            className="form_dropdown w-100"
                            loading={loadingFSKitchenFinishes}
                        />

                        {kitchenFinishError &&
                            <small className="form_error_msg">{kitchenFinishError}</small>
                        }

                        {errorFSKitchenFinishes &&
                            <small className="form_error_msg">{errorFSKitchenFinishes}</small>
                        }
                    </div>
                </div>
            ),
            size: (
                <div className="col-12 col-sm-6">
                    <div className="page_form_group">
                        <label htmlFor="kitchenSize" className="custom_form_label is_required">Size</label>

                        <div className="input_flex_group align-items-start">
                            <div className="input_flex_group_sub">
                                <InputNumber
                                    className="custom_form_input w-100"
                                    inputId="kitchenDepth"
                                    value={kitchenDepth}
                                    placeholder="Depth"
                                    onChange={(e: InputNumberChangeEvent) => setKitchenDepth(e.value || null)}
                                    useGrouping={false}
                                />

                                {kitchenDepthError &&
                                    <small className="form_error_msg">{kitchenDepthError}</small>
                                }
                            </div>

                            <small style={{ marginTop: '12px' }}>x</small>

                            <div className="input_flex_group_sub">
                                <InputNumber
                                    className="custom_form_input w-100"
                                    inputId="kitchenThickness"
                                    value={kitchenThickness}
                                    placeholder="Thickness"
                                    onChange={(e: InputNumberChangeEvent) => setKitchenThickness(e.value || null)}
                                    useGrouping={false}
                                />

                                {kitchenThicknessError &&
                                    <small className="form_error_msg">{kitchenThicknessError}</small>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            ),
            name: (
                <div className="col-12 col-sm-6">
                    <TextInput
                        key={'kitchenName'}
                        id="kitchenName"
                        label="Name"
                        labelHtmlFor="kitchenName"
                        required={true}
                        value={kitchenName!}
                        placeholder="Enter name"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKitchenName(e.target.value)}
                        error={kitchenNameError}
                    />
                </div>
            ),
            number: (
                <div className="col-12 col-sm-6">
                    <NumberInput
                        key={'kitchenNumber'}
                        inputId="kitchenNumber"
                        label="Number"
                        labelHtmlFor="kitchenNumber"
                        placeholder="Enter number"
                        onChange={(e: InputNumberChangeEvent) => setKitchenNumber(e.value || null)}
                        value={kitchenNumber}
                        required={true}
                        min={0}
                        error={kitchenNumberError}
                    />
                </div>
            ),
            style: (
                <div className="col-12 col-sm-6">
                    <DataListModalInput
                        key={`kitchenStyle`}
                        inputId="kitchenStyle"
                        label="Style"
                        value={selectedFSKitchenStyle}
                        displayKey="style_name"
                        onAdd={handleAddKitchenStyle}
                        required={true}
                        placeHolder="Click to select the style"
                        error={kitchenStyleError}
                    />
                </div>
            ),
            link: (
                <div className="col-12 col-sm-6">
                    <TextInput
                        key={'kitchenLink'}
                        id="kitchenLink"
                        label="Link"
                        labelHtmlFor="kitchenLink"
                        required={false}
                        value={kitchenLink!}
                        placeholder="Enter link"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKitchenLink(e.target.value || '')}
                        error={kitchenLinkError}
                    />
                </div>
            ),
            files: (
                <div className="col-12 col-sm-6">
                    <MulipleFileInput
                        id="kitchenFiles"
                        label="File(s)"
                        labelHtmlFor="kitchenFiles"
                        required={false}
                        value={kitchenFiles.map(file => file.name).join(', ')}
                        onUpload={handleUploadKitchenFiles}
                        onClear={handleClearKitchenFiles}
                        toast={toast}
                        error={kitchenFilesError}
                    />
                </div>
            ),
            image: (
                <div className="col-12 col-sm-6">
                    <FileInput
                        key={`kitchenImageFile`}
                        id="kitchenImageFile"
                        label="Image"
                        labelHtmlFor="kitchenImageFile"
                        required={false}
                        value={kitchenImageFileName}
                        onlyImageUpload={true}
                        onUpload={handleUploadKitchenImageFile}
                        onClear={handleClearKitchenImageFile}
                        toast={toast}
                        error={kitchenImageFileError}
                        containerClassName="mb-3"
                    />
                </div>
            )
        }

        const kitchenOptionInputOrder: Record<KitchenOption, (keyof typeof kitchenDetailInputs)[]> = {
            'Type': ['brand', 'kitchenCollection', 'range', 'color', 'style', 'finish', 'link', 'files', 'image'],
            'Base Units': ['brand', 'kitchenCollection', 'range', 'color', 'style', 'finish', 'link', 'files', 'image'],
            'Wall Units': ['brand', 'kitchenCollection', 'range', 'color', 'style', 'finish', 'link', 'files', 'image'],
            'Worktop': ['brand', 'name', 'type', 'size', 'link', 'files', 'image'],
            'Door': ['brand', 'name', 'style', 'color', 'link', 'files', 'image'],
            'Handle': ['brand', 'name', 'number', 'link', 'files', 'image'],
        };

        if (!selectedKitchenOption) return null;

        const order = kitchenOptionInputOrder[selectedKitchenOption];

        return (
            <React.Fragment>
                {order.map((key) => kitchenDetailInputs[key])}
            </React.Fragment>
        );
    }

    const kitchenDetailTableActionBody = (rowData: FSKitchenData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewKitchenDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateKitchen && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditKitchenDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteKitchen && (
                        <TableActionButton
                            icon={`${kitchenDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteKitchenDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={kitchenDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewKitchenDetail = (data: FSKitchenData) => {
        setSelectedKitchenDetail(data);
        setShowFSDataViewModal(true);
    }

    // Kitchen appliance detail
    useEffect(() => {
        if (fsKitchens && fsKitchens.length > 0) {
            setFSKitchenApplianceData(
                fsKitchens.find(
                    kitchen => kitchen?.location_name?.toLowerCase() === 'appliances'
                ) || null
            );
        } else {
            setFSKitchenApplianceData(null);
        }
    }, [fsKitchens]);

    const handleCloseKitchenApplianceDetailModal = () => {
        setShowKitchenApplianceDetailModal(false);
        handleResetKitchenApplianceDetailFields();
    }

    const handleResetKitchenApplianceDetailFields = () => {
        setSelectedFSAppliance(null);
        setSelectedFSBrand(null);
        setKitchenApplianceName('');
        setSelectedFSColor(null);
        setKitchenApplianceLink(null);
        setKitchenApplianceImageFile(null);
        setKitchenApplianceImageFileName('');
        setKitchenApplianceFiles([]);

        setSelectedKitchenApplianceDetail(null);
        setSelectedSubCategory(null);

        setKitchenApplianceError('');
        setKitchenApplianceBrandError('');
        setKitchenApplianceNameError('');
        setKitchenApplianceColorError('');
        setKitchenApplianceLinkError('');
        setKitchenApplianceImageFileError('');
        setKitchenApplianceFilesError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSAppliance != null, false, setKitchenApplianceError);
    }, [selectedFSAppliance]);

    useEffect(() => {
        checkModelSelected(selectedFSBrand != null, false, setKitchenApplianceBrandError);
    }, [selectedFSBrand]);

    useEffect(() => {
        checkText(kitchenApplianceName, false, setKitchenApplianceNameError);
    }, [kitchenApplianceName]);

    useEffect(() => {
        checkModelSelected(selectedFSColor != null, false, setKitchenApplianceColorError);
    }, [selectedFSColor]);

    useEffect(() => {
        checkText(kitchenApplianceLink!, false, setKitchenApplianceLinkError);
    }, [kitchenApplianceLink]);

    useEffect(() => {
        checkFileOtherList(kitchenApplianceFiles!, false, setKitchenApplianceFilesError);
    }, [kitchenApplianceFiles]);

    useEffect(() => {
        checkFileOthers(kitchenApplianceImageFile!, false, setKitchenApplianceImageFileError);
    }, [kitchenApplianceImageFile]);

    function checkCredentialsForKitchenApplianceDetail(fileRequired: boolean): boolean {
        const isKitchenApplianceValid = checkModelSelected(selectedFSAppliance != null, true, setKitchenApplianceError);
        const isKitchenApplianceBrandValid = checkModelSelected(selectedFSBrand != null, true, setKitchenApplianceBrandError);
        const isKitchenApplianceNameValid = checkText(kitchenApplianceName, true, setKitchenApplianceNameError);
        const isKitchenApplianceColorValid = checkModelSelected(selectedFSColor != null, true, setKitchenApplianceColorError);
        const isKitchenApplianceLinkValid = checkText(kitchenApplianceLink!, false, setKitchenApplianceLinkError);
        const isKitchenApplianceFilesValid = checkFileOtherList(kitchenApplianceFiles!, fileRequired, setKitchenApplianceFilesError);
        const isKitchenApplianceImageValid = checkFileOthers(kitchenApplianceImageFile!, fileRequired, setKitchenApplianceImageFileError);

        return (
            isKitchenApplianceValid &&
            isKitchenApplianceBrandValid &&
            isKitchenApplianceNameValid &&
            isKitchenApplianceColorValid &&
            isKitchenApplianceLinkValid &&
            isKitchenApplianceFilesValid &&
            isKitchenApplianceImageValid
        );
    }

    function showAPIErrorForKitchenApplianceDetail(keyName: string, error: string): void {
        if (keyName === "appliance_id") {
            setKitchenApplianceError(error);
        }

        if (keyName === "brand_id") {
            setKitchenApplianceBrandError(error);
        }

        if (keyName === "name") {
            setKitchenApplianceNameError(error);
        }

        if (keyName === "color_id") {
            setKitchenApplianceColorError(error);
        }

        if (keyName === "link") {
            setKitchenApplianceLinkError(error);
        }

        if (keyName === "file_list[]") {
            setKitchenApplianceFilesError(error);
        }

        if (keyName === "image_path") {
            setKitchenApplianceImageFileError(error);
        }
    }

    const handleAddKitchenApplianceDetails = () => {
        setShowKitchenApplianceDetailModal(true);
        setSelectedSubCategory('Appliance');
        setDataState('Add');
    }

    // Kitchen appliance details add API
    const handleCreateKitchenApplianceDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForKitchenApplianceDetail(false)) {
            setLoading(true);

            const fs_data_id = fsKitchenApplianceData?.id;
            const brand_id = selectedFSBrand?.id;
            const appliance_id = selectedFSAppliance?.id;
            const color_id = selectedFSColor?.id;
            const name = kitchenApplianceName;
            const link = kitchenApplianceLink;
            const image_path = kitchenApplianceImageFile;
            const file_list = kitchenApplianceFiles;

            const data = await fsKitchenApplianceCreate(
                fs_data_id!,
                brand_id!,
                appliance_id!,
                color_id!,
                name,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsKitchenDataGet();
                handleCloseKitchenApplianceDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Kitchen appliance detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForKitchenApplianceDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the kitchen appliance detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedKitchenApplianceDetail) {
            if (selectedFSAppliance?.id !== selectedKitchenApplianceDetail?.appliance_id) {
                setKitchenApplianceDetailUpdateHasChanges(true);
            } else if (selectedFSBrand?.id !== selectedKitchenApplianceDetail?.brand_id) {
                setKitchenApplianceDetailUpdateHasChanges(true);
            } else if (kitchenApplianceName !== selectedKitchenApplianceDetail?.name) {
                setKitchenApplianceDetailUpdateHasChanges(true);
            } else if (selectedFSColor?.id !== selectedKitchenApplianceDetail?.color_id) {
                setKitchenApplianceDetailUpdateHasChanges(true);
            } else if (kitchenApplianceLink !== null && kitchenApplianceLink !== selectedKitchenApplianceDetail?.link) {
                setKitchenApplianceDetailUpdateHasChanges(true);
            } else if (kitchenApplianceImageFile !== null) {
                setKitchenApplianceDetailUpdateHasChanges(true);
            } else if (kitchenApplianceFiles?.length !== 0) {
                setKitchenApplianceDetailUpdateHasChanges(true);
            } else {
                setKitchenApplianceDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedKitchenApplianceDetail,
        selectedFSAppliance,
        selectedFSBrand,
        kitchenApplianceName,
        selectedFSColor,
        kitchenApplianceLink,
        kitchenApplianceImageFile,
        kitchenApplianceFiles
    ]);

    const handleEditKitchenApplianceDetail = (kitchenApplianceDetail: FSKitchenData) => {
        if (kitchenApplianceDetail) {
            setShowKitchenApplianceDetailModal(true);
            setSelectedSubCategory('Appliance');
            setDataState('Edit');

            setSelectedKitchenApplianceDetail(kitchenApplianceDetail);

            const existKitchenAppliance = fsAppliances?.find(appliance => appliance?.id === kitchenApplianceDetail?.appliance_id);
            const existKitchenApplianceBrand = fsBrands?.find(brand => brand?.id === kitchenApplianceDetail?.brand_id);
            const existKitchenApplianceColor = fsColors?.find(color => color?.id === kitchenApplianceDetail?.color_id);

            setSelectedFSAppliance(existKitchenAppliance || null);
            setSelectedFSBrand(existKitchenApplianceBrand || null);
            setKitchenApplianceName(kitchenApplianceDetail?.name || '');
            setSelectedFSColor(existKitchenApplianceColor || null);
            setKitchenApplianceLink(kitchenApplianceDetail?.link || null)
        }
    }

    // Kitchen appliance details update API
    const handleUpdateKitchenApplianceDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForKitchenApplianceDetail(false)) {
            setLoading(true);

            const id = selectedKitchenApplianceDetail?.id;
            const brand_id = selectedFSBrand?.id;
            const appliance_id = selectedFSAppliance?.id;
            const color_id = selectedFSColor?.id;
            const name = kitchenApplianceName;
            const link = kitchenApplianceLink;
            const image_path = kitchenApplianceImageFile;
            const file_list = kitchenApplianceFiles;

            const data = await fsKitchenApplianceUpdate(
                id!,
                brand_id!,
                appliance_id!,
                color_id!,
                name,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsKitchenDataGet();
                handleCloseKitchenApplianceDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Kitchen appliance detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForKitchenApplianceDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the kitchen appliance detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeleteKitchenApplianceDetail = (kitchenApplianceDetail: FSKitchenData) => {
        const kitchenApplianceDetailId = kitchenApplianceDetail?.id;

        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>Are you sure you want to delete the kitchen <b className="text-capitalize">{kitchenApplianceDetail?.category}</b> data?</span>
                </div>
            ),
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteKitchenApplianceDetail(kitchenApplianceDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // KitchenAppliance details delete API
    const deleteKitchenApplianceDetail = async (kitchenApplianceDetailId: number) => {
        if (kitchenApplianceDetailId) {
            setKitchenApplianceDetailDeleteLoadingId(kitchenApplianceDetailId);

            const id = kitchenApplianceDetailId;
            const data = await fsKitchenDelete(id);

            setKitchenApplianceDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsKitchenDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Kitchen appliance detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the kitchen appliance detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const kitchenApplianceDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;kitchen appliance detail
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseKitchenApplianceDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const kitchenApplianceDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseKitchenApplianceDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateKitchenApplianceDetail : handleUpdateKitchenApplianceDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !kitchenApplianceDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadKitchenApplianceImageFile = (file: File) => {
        setKitchenApplianceImageFile(file);
        setKitchenApplianceImageFileName(file.name);
    };

    const handleClearKitchenApplianceImageFile = () => {
        setKitchenApplianceImageFile(null);
        setKitchenApplianceImageFileName("");
    };

    const handleUploadKitchenApplianceFiles = (files: File[]) => {
        setKitchenApplianceFiles(files);
    };

    const handleClearKitchenApplianceFiles = () => {
        setKitchenApplianceFiles([]);
    };

    const kitchenApplianceDetailTableActionBody = (rowData: FSKitchenData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewKitchenApplianceDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateKitchenAppliance && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditKitchenApplianceDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteKitchenAppliance && (
                        <TableActionButton
                            icon={`${kitchenApplianceDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteKitchenApplianceDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={kitchenApplianceDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewKitchenApplianceDetail = (data: FSKitchenData) => {
        setSelectedKitchenApplianceDetail(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */


    /* ************************************************************* Finishing schedule - Tiles */
    useEffect(() => {
        if (fsTiles && fsTiles?.length > 0) {
            setFSTilesData(fsTiles.filter(
                tile => tile?.is_default_feature === 0
            ) || []);
        } else {
            setFSTilesData([]);
        }
    }, [fsTiles]);

    // Tile location
    useEffect(() => {
        if (fsTilesData && fsTilesData?.length > 0) {
            const savedLocationId = localStorage.getItem("activeTileLocationId");

            if (savedLocationId) {
                const savedLocation = fsTilesData.find(
                    (l) => l.id.toString() === savedLocationId
                );
                if (savedLocation) {
                    setActiveTileLocation(savedLocation);
                    return;
                }
            }

            setActiveTileLocation(fsTilesData[0]);
        } else {
            setActiveTileLocation(null);
        }
    }, [fsTilesData]);

    const handleSelectTileLocation = (tileLocation: FSTile) => {
        setActiveTileLocation(tileLocation);
        localStorage.setItem("activeTileLocationId", tileLocation.id.toString());
        goToTop();
    }

    const handleCloseTileModal = () => {
        setShowTilesModal(false);
        handleResetTileLocationFields();
    }

    const handleResetTileLocationFields = () => {
        setTileLocation('');
        setTileLocationError('');
    }

    useEffect(() => {
        checkText(tileLocation, false, setTileLocationError);
    }, [tileLocation]);

    function checkCredentialsForTileLocation(): boolean {
        const isTileLocationValid = checkText(tileLocation, true, setTileLocationError);

        return isTileLocationValid;
    }

    function showAPIErrorForTileLocation(keyName: string, error: string): void {
        if (keyName === "location_name") {
            setTileLocationError(error);
        }
    }

    const handleAddTileLocation = () => {
        setShowTilesModal(true);
        setDataState('Add');
    }

    // Tile location add API
    const handleCreateTileLocation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForTileLocation()) {
            setLoading(true);

            const fs_feature_id = activeFSFeature?.id;
            const location_name = tileLocation;

            const data = await fsTileLocationCreate(fs_feature_id!, location_name);
            setLoading(false);

            if (data.statusCode === 200) {
                fsTileDataGet();
                handleCloseTileModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Tile location added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForTileLocation(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the tile location.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleEditTileLocation = (tile: FSTile) => {
        if (tile) {
            setShowTilesModal(true);
            setDataState('Edit');

            setSelectedTile(tile);
            setTileLocation(tile?.location_name || '')
        }
    }

    useEffect(() => {
        if (selectedTile) {
            if (tileLocation !== selectedTile?.location_name) {
                setTileLocationUpdateHasChanges(true);
            } else {
                setTileLocationUpdateHasChanges(false);
            }
        }
    }, [selectedTile, tileLocation]);

    // Tile location update API
    const handleUpdateTileLocation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForTileLocation()) {
            setLoading(true);

            const id = selectedTile?.id;
            const fs_feature_id = activeFSFeature?.id;
            const location_name = tileLocation;

            const data = await fsTileLocationUpdate(id!, fs_feature_id!, location_name);
            setLoading(false);

            if (data.statusCode === 200) {
                fsTileDataGet();
                handleCloseTileModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Tile location updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForTileLocation(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the tile location.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeleteTileLocation = () => {
        const tileLocationId = selectedTile?.id;

        confirmDialog({
            message: `Are you sure you want to delete the ${selectedTile?.location_name} location`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteTileLocation(tileLocationId!),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Tile location delete API
    const deleteTileLocation = async (tileLocationId: number) => {
        if (tileLocationId) {
            setDeleteLoading(true);

            const id = tileLocationId;
            const data = await fsTileLocationDelete(id);

            setDeleteLoading(false);
            if (data.statusCode === 200) {
                fsTileDataGet();
                handleCloseTileModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Tile location deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the tile location.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const tileModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;tile location
            </h5>

            {dataState === "Edit" && hasPermissionForDeleteTileLocation ? (
                <React.Fragment>
                    {deleteLoading ? (
                        <TableActionLoader className="is_modal_loader" />
                    ) : (
                        <button
                            type="button"
                            className="close_modal_btn p-ripple"
                            onClick={handleDeleteTileLocation}
                        >
                            <i className="bi bi-trash3"></i>
                            <Ripple />
                        </button>
                    )}
                </React.Fragment>
            ) : (
                <button
                    type="button"
                    className="close_modal_btn p-ripple"
                    onClick={handleCloseTileModal}
                >
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    /* Modal footer */
    const tileModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseTileModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateTileLocation : handleUpdateTileLocation}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !tileLocationUpdateHasChanges}
            />
        </div>
    );
    // 

    // Tile details
    const handleCloseTileDetailModal = () => {
        setShowTileDetailModal(false);
        handleResetTileDetailFields();
    }

    const handleResetTileDetailFields = () => {
        setSelectedFSType(null);
        setTileName('');
        setTileQuantity(null);
        setSelectedFSTileShop(null);
        setSelectedFSColor(null);
        setTileSize(null);
        setTileLink(null);
        setTileImageFile(null);
        setTileImageFileName('');
        setTileFiles([]);

        setSelectedTile(null);
        setSelectedTileDetail(null);

        setTileTypeError('');
        setTileNameError('');
        setTileQuantityError('');
        setTileShopError('');
        setTileColorError('');
        setTileSizeError('');
        setTileLinkError('');
        setTileImageFileError('');
        setTileFilesError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSType != null, false, setTileTypeError);
    }, [selectedFSType]);

    useEffect(() => {
        checkText(tileName, false, setTileNameError);
    }, [tileName]);

    useEffect(() => {
        checkNumber(tileQuantity!, false, setTileQuantityError);
    }, [tileQuantity]);

    useEffect(() => {
        checkModelSelected(selectedFSTileShop != null, false, setTileShopError);
    }, [selectedFSTileShop]);

    useEffect(() => {
        checkModelSelected(selectedFSColor != null, false, setTileColorError);
    }, [selectedFSColor]);

    useEffect(() => {
        checkNumber(tileSize!, false, setTileSizeError);
    }, [tileSize]);

    useEffect(() => {
        checkText(tileLink!, false, setTileLinkError);
    }, [tileLink]);

    useEffect(() => {
        checkFileOthers(tileImageFile!, false, setTileImageFileError);
    }, [tileImageFile]);

    useEffect(() => {
        checkFileOtherList(tileFiles!, false, setTileFilesError);
    }, [tileFiles]);

    function checkCredentialsForTileDetail(fileRequired: boolean): boolean {
        const isTileTypeValid = checkModelSelected(selectedFSType != null, true, setTileTypeError);
        const isTileNameValid = checkText(tileName, true, setTileNameError);
        const isTileQuantityValid = checkNumber(tileQuantity!, true, setTileQuantityError);
        const isTileShopValid = checkModelSelected(selectedFSTileShop != null, true, setTileShopError);
        const isTileColorValid = checkModelSelected(selectedFSColor != null, true, setTileColorError);
        const isTileSizeValid = checkNumber(tileSize!, true, setTileSizeError);
        const isTileLinkValid = checkText(tileLink!, false, setTileLinkError);
        const isTileImageValid = checkFileOthers(tileImageFile!, fileRequired, setTileImageFileError);
        const isTileFilesValid = checkFileOtherList(tileFiles!, fileRequired, setTileFilesError);

        return (
            isTileTypeValid &&
            isTileNameValid &&
            isTileQuantityValid &&
            isTileShopValid &&
            isTileColorValid &&
            isTileLinkValid &&
            isTileSizeValid &&
            isTileImageValid &&
            isTileFilesValid
        );
    }

    function showAPIErrorForTileDetail(keyName: string, error: string): void {
        if (keyName === "type_id") {
            setTileTypeError(error);
        }

        if (keyName === "name") {
            setTileNameError(error);
        }

        if (keyName === "quantity") {
            setTileQuantityError(error);
        }

        if (keyName === "shop_id") {
            setTileShopError(error);
        }

        if (keyName === "color_id") {
            setTileColorError(error);
        }

        if (keyName === "size") {
            setTileSizeError(error);
        }

        if (keyName === "link") {
            setTileLinkError(error);
        }

        if (keyName === "image_path") {
            setTileImageFileError(error);
        }

        if (keyName === "file_list[]") {
            setTileFilesError(error);
        }
    }

    const handleAddTileDetail = (tile: FSTile) => {
        setSelectedTile(tile);
        setShowTileDetailModal(true);
        setDataState('Add');
    }

    // Tile detail add API
    const handleCreateTileDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForTileDetail(false)) {
            setLoading(true);

            const fs_data_id = selectedTile?.id;
            const shop_id = selectedFSTileShop?.id;
            const color_id = selectedFSColor?.id;
            const type_id = selectedFSType?.id;
            const name = tileName;
            const quantity = tileQuantity;
            const size = tileSize;
            const link = tileLink;
            const image_path = tileImageFile;
            const file_list = tileFiles;

            const data = await fsTilesCreate(
                fs_data_id!,
                shop_id!,
                color_id!,
                type_id!,
                name,
                quantity!,
                size!,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsTileDataGet();
                handleCloseTileDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Tile detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForTileDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the tile detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedTileDetail) {
            if (selectedFSType?.id !== selectedTileDetail?.type_id) {
                setTileDetailUpdateHasChanges(true);
            } else if (tileName !== selectedTileDetail?.name) {
                setTileDetailUpdateHasChanges(true);
            } else if (tileQuantity !== null && tileQuantity !== selectedTileDetail?.quantity) {
                setTileDetailUpdateHasChanges(true);
            } else if (selectedFSTileShop?.id !== selectedTileDetail?.shop_id) {
                setTileDetailUpdateHasChanges(true);
            } else if (selectedFSColor?.id !== selectedTileDetail?.color_id) {
                setTileDetailUpdateHasChanges(true);
            } else if (tileSize !== null && tileSize !== selectedTileDetail?.size) {
                setTileDetailUpdateHasChanges(true);
            } else if (tileLink !== null && tileLink !== selectedTileDetail?.link) {
                setTileDetailUpdateHasChanges(true);
            } else if (tileImageFile !== null) {
                setTileDetailUpdateHasChanges(true);
            } else if (tileFiles?.length !== 0) {
                setTileDetailUpdateHasChanges(true);
            } else {
                setTileDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedTileDetail,
        selectedFSType,
        tileName,
        tileQuantity,
        selectedFSTileShop,
        selectedFSColor,
        tileSize,
        tileLink,
        tileImageFile,
        tileFiles
    ]);

    const handleEditTileDetail = (tileDetail: FSTileData) => {
        if (tileDetail) {
            setShowTileDetailModal(true);
            setDataState('Edit');

            setSelectedTileDetail(tileDetail);

            const existTileType = fsTypes?.find(type => type?.id === tileDetail?.type_id);
            const existTileShop = fsTileShops?.find(shop => shop?.id === tileDetail?.shop_id);
            const existTileColor = fsColors?.find(color => color?.id === tileDetail?.color_id);

            setSelectedFSType(existTileType || null);
            setTileName(tileDetail?.name || '');
            setTileQuantity(tileDetail?.quantity || null);
            setSelectedFSTileShop(existTileShop || null);
            setSelectedFSColor(existTileColor || null);
            setTileSize(tileDetail?.size || null);
            setTileLink(tileDetail?.link || null);
        }
    }

    // Tile detail update API
    const handleUpdateTileDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForTileDetail(false)) {
            setLoading(true);

            const id = selectedTileDetail?.id;
            const shop_id = selectedFSTileShop?.id;
            const color_id = selectedFSColor?.id;
            const type_id = selectedFSType?.id;
            const name = tileName;
            const quantity = tileQuantity;
            const size = tileSize;
            const link = tileLink;
            const image_path = tileImageFile;
            const file_list = tileFiles;

            const data = await fsTilesUpdate(
                id!,
                shop_id!,
                color_id!,
                type_id!,
                name,
                quantity!,
                size!,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsTileDataGet();
                handleCloseTileDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Tile detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForTileDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the tile detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeleteTileDetail = (tileDetail: FSTileData) => {
        const tileDetailId = tileDetail?.id;

        confirmDialog({
            message: `Are you sure you want to delete this tile data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteTileDetail(tileDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Tile detail delete API
    const deleteTileDetail = async (tileDetailId: number) => {
        if (tileDetailId) {
            setTileDetailDeleteLoadingId(tileDetailId);

            const id = tileDetailId;
            const data = await fsTilesDelete(id);

            setTileDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsTileDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Tile detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the tile detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const tileDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;tile detail <span className="custom">{dataState === 'Add' ? ` - ${selectedTile?.location_name}` : ''}</span>
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseTileDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const tileDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseTileDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateTileDetail : handleUpdateTileDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !tileDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadTileImageFile = (file: File) => {
        setTileImageFile(file);
        setTileImageFileName(file.name);
    };

    const handleClearTileImageFile = () => {
        setTileImageFile(null);
        setTileImageFileName("");
    };

    const handleUploadTileFiles = (files: File[]) => {
        setTileFiles(files);
    };

    const handleClearTileFiles = () => {
        setTileFiles([]);
    };

    const tileDetailTableActionBody = (rowData: FSTileData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewTileDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateTile && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditTileDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteTile && (
                        <TableActionButton
                            icon={`${tileDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteTileDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={tileDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewTileDetail = (data: FSTileData) => {
        setSelectedTileDetail(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Floor finishing */
    useEffect(() => {
        if (fsFloorFinishing && fsFloorFinishing !== null) {
            setFloorFinishingData(fsFloorFinishing?.data_ff);
        } else {
            setFloorFinishingData([]);
        }
    }, [fsFloorFinishing]);

    const handleCloseFloorFinishingDetailModal = () => {
        setShowFloorFinishingDetailModal(false);
        handleResetFloorFinishingDetailFields();
    }

    const handleResetFloorFinishingDetailFields = () => {
        setSelectedFSLocation(null);
        setSelectedFSType(null);
        setFloorFinishingName('');
        setSelectedFSBrand(null);
        setFloorFinishingLink(null);
        setFloorFinishingNote(null);
        setFloorFinishingImageFile(null);
        setFloorFinishingImageFileName('');
        setFloorFinishingFiles([]);

        setSelectedFloorFinishingData(null);

        setFloorFinishingLocationError('');
        setFloorFinishingTypeError('');
        setFloorFinishingNameError('');
        setFloorFinishingBrandError('');
        setFloorFinishingLinkError('');
        setFloorFinishingNoteError('');
        setFloorFinishingImageFileError('');
        setFloorFinishingFilesError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSLocation != null, false, setFloorFinishingLocationError);
    }, [selectedFSLocation]);

    useEffect(() => {
        checkModelSelected(selectedFSType != null, false, setFloorFinishingTypeError);
    }, [selectedFSType]);

    useEffect(() => {
        checkText(floorFinishingName, false, setFloorFinishingNameError);
    }, [floorFinishingName]);

    useEffect(() => {
        checkModelSelected(selectedFSBrand != null, false, setFloorFinishingBrandError);
    }, [selectedFSBrand]);

    useEffect(() => {
        checkText(floorFinishingLink!, false, setFloorFinishingLinkError);
    }, [floorFinishingLink]);

    useEffect(() => {
        checkText(floorFinishingNote!, false, setFloorFinishingNoteError);
    }, [floorFinishingNote]);

    useEffect(() => {
        checkFileOthers(floorFinishingImageFile!, false, setFloorFinishingImageFileError);
    }, [floorFinishingImageFile]);

    useEffect(() => {
        checkFileOtherList(floorFinishingFiles!, false, setFloorFinishingFilesError);
    }, [floorFinishingFiles]);

    function checkCredentialsForFloorFinishingDetail(fileRequired: boolean): boolean {
        const isFloorFinishingLocationValid = checkModelSelected(selectedFSLocation != null, true, setFloorFinishingLocationError);
        const isFloorFinishingTypeValid = checkModelSelected(selectedFSType != null, true, setFloorFinishingTypeError);
        const isFloorFinishingNameValid = checkText(floorFinishingName, true, setFloorFinishingNameError);
        const isFloorFinishingBrandValid = checkModelSelected(selectedFSBrand != null, true, setFloorFinishingBrandError);
        const isFloorFinishingLinkValid = checkText(floorFinishingLink!, false, setFloorFinishingLinkError);
        const isFloorFinishingNoteValid = checkText(floorFinishingNote!, false, setFloorFinishingNoteError);
        const isFloorFinishingImageValid = checkFileOthers(floorFinishingImageFile!, fileRequired, setFloorFinishingImageFileError);
        const isFloorFinishingFilesValid = checkFileOtherList(floorFinishingFiles!, fileRequired, setFloorFinishingFilesError);

        return (
            isFloorFinishingLocationValid &&
            isFloorFinishingTypeValid &&
            isFloorFinishingNameValid &&
            isFloorFinishingBrandValid &&
            isFloorFinishingLinkValid &&
            isFloorFinishingNoteValid &&
            isFloorFinishingImageValid &&
            isFloorFinishingFilesValid
        );
    }

    function showAPIErrorForFloorFinishingDetail(keyName: string, error: string): void {
        if (keyName === "location_id") {
            setFloorFinishingLocationError(error);
        }

        if (keyName === "type_id") {
            setFloorFinishingTypeError(error);
        }

        if (keyName === "name") {
            setFloorFinishingNameError(error);
        }

        if (keyName === "brand_id") {
            setFloorFinishingBrandError(error);
        }

        if (keyName === "link") {
            setFloorFinishingLinkError(error);
        }

        if (keyName === "note") {
            setFloorFinishingNoteError(error);
        }

        if (keyName === "image_path") {
            setFloorFinishingImageFileError(error);
        }

        if (keyName === "file_list[]") {
            setFloorFinishingFilesError(error);
        }
    }

    const handleAddFloorFinishingDetails = () => {
        setShowFloorFinishingDetailModal(true);
        setDataState('Add');
    }

    // Floor finishing detail add API
    const handleCreateFloorFinishingDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForFloorFinishingDetail(false)) {
            setLoading(true);

            const fs_feature_id = activeFSFeature?.id;
            const brand_id = selectedFSBrand?.id;
            const location_id = selectedFSLocation?.id;
            const type_id = selectedFSType?.id;
            const name = floorFinishingName;
            const link = floorFinishingLink;
            const note = floorFinishingNote;
            const image_path = floorFinishingImageFile;
            const file_list = floorFinishingFiles;

            const data = await fsFloorFinishCreate(
                fs_feature_id!,
                brand_id!,
                location_id!,
                type_id!,
                name,
                link,
                note,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsFloorFinishingDataGet();
                handleCloseFloorFinishingDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Floor finishing detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForFloorFinishingDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the floor finishing detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedFloorFinishingData) {
            if (selectedFSLocation?.id !== selectedFloorFinishingData?.location_id) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else if (selectedFSType?.id !== selectedFloorFinishingData?.type_id) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else if (floorFinishingName !== selectedFloorFinishingData?.name) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else if (selectedFSBrand?.id !== selectedFloorFinishingData?.brand_id) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else if (floorFinishingLink !== null && floorFinishingLink !== selectedFloorFinishingData?.link) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else if (floorFinishingNote !== null && floorFinishingNote !== selectedFloorFinishingData?.note) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else if (floorFinishingImageFile !== null) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else if (floorFinishingFiles?.length !== 0) {
                setFloorFinishingDetailUpdateHasChanges(true);
            } else {
                setFloorFinishingDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedFloorFinishingData,
        selectedFSLocation,
        selectedFSType,
        floorFinishingName,
        selectedFSBrand,
        floorFinishingLink,
        floorFinishingNote,
        floorFinishingImageFile,
        floorFinishingFiles
    ]);

    const handleEditFloorFinishingDetail = (floorFinishingDetail: FSFloorFinishingData) => {
        if (floorFinishingDetail) {
            setShowFloorFinishingDetailModal(true);
            setDataState('Edit');

            setSelectedFloorFinishingData(floorFinishingDetail);

            const existFloorFinishingLocation = fsLocations?.find(location => location?.id === floorFinishingDetail?.location_id);
            const existFloorFinishingType = fsTypes?.find(type => type?.id === floorFinishingDetail?.type_id);
            const existFloorFinishingBrand = fsBrands?.find(brand => brand?.id === floorFinishingDetail?.brand_id);

            setSelectedFSLocation(existFloorFinishingLocation || null);
            setSelectedFSType(existFloorFinishingType || null);
            setFloorFinishingName(floorFinishingDetail?.name || '')
            setSelectedFSBrand(existFloorFinishingBrand || null);
            setFloorFinishingLink(floorFinishingDetail?.link || null);
            setFloorFinishingNote(floorFinishingDetail?.note || null);

        }
    }

    // Floor finishing detail update API
    const handleUpdateFloorFinishingDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForFloorFinishingDetail(false)) {
            setLoading(true);

            const id = selectedFloorFinishingData?.id;
            const brand_id = selectedFSBrand?.id;
            const location_id = selectedFSLocation?.id;
            const type_id = selectedFSType?.id;
            const name = floorFinishingName;
            const link = floorFinishingLink;
            const note = floorFinishingNote;
            const image_path = floorFinishingImageFile;
            const file_list = floorFinishingFiles;

            const data = await fsFloorFinishUpdate(
                id!,
                brand_id!,
                location_id!,
                type_id!,
                name,
                link,
                note,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsFloorFinishingDataGet();
                handleCloseFloorFinishingDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Floor finishing detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForFloorFinishingDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the floor finishing detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeleteFloorFinishingDetail = (floorFinishingDetail: FSFloorFinishingData) => {
        const floorFinishingDetailId = floorFinishingDetail?.id;

        confirmDialog({
            message: `Are you sure you want to delete this floor finishing data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteFloorFinishingDetail(floorFinishingDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Floor finishing detail delete API
    const deleteFloorFinishingDetail = async (floorFinishingDetailId: number) => {
        if (floorFinishingDetailId) {
            setFloorFinishingDetailDeleteLoadingId(floorFinishingDetailId);

            const id = floorFinishingDetailId;
            const data = await fsFloorFinishDelete(id);

            setFloorFinishingDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsFloorFinishingDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Floor finishing detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the floor finishing detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const floorFinishingDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;floor finishing detail
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseFloorFinishingDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const floorFinishingDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseFloorFinishingDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateFloorFinishingDetail : handleUpdateFloorFinishingDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !floorFinishingDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadFloorFinishingImageFile = (file: File) => {
        setFloorFinishingImageFile(file);
        setFloorFinishingImageFileName(file.name);
    };

    const handleClearFloorFinishingImageFile = () => {
        setFloorFinishingImageFile(null);
        setFloorFinishingImageFileName("");
    };

    const handleUploadFloorFinishingFiles = (files: File[]) => {
        setFloorFinishingFiles(files);
    };

    const handleClearFloorFinishingFiles = () => {
        setFloorFinishingFiles([]);
    };

    const floorFinishingDetailTableActionBody = (rowData: FSFloorFinishingData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewFloorFinishingDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateFloorFinishing && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditFloorFinishingDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteFloorFinishing && (
                        <TableActionButton
                            icon={`${floorFinishingDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteFloorFinishingDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={floorFinishingDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewFloorFinishingDetail = (data: FSFloorFinishingData) => {
        setSelectedFloorFinishingData(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */

    /* ************************************************************* Finishing schedule - Others */
    useEffect(() => {
        if (fsOthers && fsOthers?.length > 0) {
            setFSOthersData(fsOthers.filter(
                other => other?.is_default_feature === 0
            ) || []);
        } else {
            setFSOthersData([]);
        }
    }, [fsOthers]);

    // Others location
    useEffect(() => {
        if (fsOthersData && fsOthersData?.length > 0) {
            const savedLocationId = localStorage.getItem("activeOthersLocationId");

            if (savedLocationId) {
                const savedLocation = fsOthersData.find(
                    (l) => l.id.toString() === savedLocationId
                );
                if (savedLocation) {
                    setActiveOtherLocation(savedLocation);
                    return;
                }
            }

            setActiveOtherLocation(fsOthersData[0]);
        } else {
            setActiveOtherLocation(null);
        }
    }, [fsOthersData]);

    const handleSelectOtherLocation = (otherLocation: FSOther) => {
        setActiveOtherLocation(otherLocation);
        localStorage.setItem("activeOthersLocationId", otherLocation.id.toString());
        goToTop();
    }

    const handleCloseOtherLocationModal = () => {
        setShowOtherLocationModal(false);
        handleResetOtherLocationFields();
    }

    const handleResetOtherLocationFields = () => {
        setSelectedFSLocations([]);
        setOtherLocationError('');
    }

    function checkCredentialsForOtherLocation(): boolean {
        return selectedFSLocations.length > 0;
    }

    const handleAddOtherLocation = () => {
        setShowOtherLocationModal(true);
        setDataState('Add');
    }

    // Other location add API
    const addOtherLocation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForOtherLocation()) {
            setLoading(true);

            const fs_feature_id = activeFSFeature?.id;
            const location_id_list = selectedFSLocations?.map((e) => e.id);

            const data = await addFSOthersLocation(fs_feature_id!, location_id_list);
            setLoading(false);

            if (data.statusCode === 200) {
                fsOtherDataGet();
                handleCloseOtherLocationModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Other location(s) added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the other location.",
                        life: 3000,
                    });
                }
            }
        }
    };

    const handleDeleteOtherLocation = (otherLocation: FSOther) => {
        const otherLocationId = otherLocation?.id;

        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>Are you sure you want to delete the <b className="text-capitalize">{(otherLocation?.location_name)?.toLowerCase()}</b> location?</span>
                    <span>This action will <b>delete all</b> records associated with it.</span>
                </div>
            ),
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteOtherLocation(otherLocationId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Other location delete API
    const deleteOtherLocation = async (otherLocationId: number) => {
        if (otherLocationId) {
            setOtherLocationDeleteLoadingId(otherLocationId);

            const id = otherLocationId;
            const data = await deleteFSOthersLocation(id);

            setOtherLocationDeleteLoadingId(null);

            if (data.statusCode === 200) {
                fsOtherDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Other location deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the other location.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const otherLocationModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;other location
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseOtherLocationModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const otherLocationModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseOtherLocationModal}
            />

            <Button
                label={
                    loading ? 'Processing' :
                        `Add${selectedFSLocations?.length > 0 ? `(${String(selectedFSLocations?.length).padStart(2, '0')})` : ''}`
                }
                onClick={addOtherLocation}
                loading={loading}
                className="custom_btn primary"
                disabled={selectedFSLocations?.length === 0}
            />
        </div>
    );
    // 

    // Other details
    const handleCloseOtherDetailModal = () => {
        setShowOtherDetailModal(false);
        handleResetOtherDetailFields();
    }

    const handleResetOtherDetailFields = () => {
        setOtherFlooringScreed('');
        setSelectedFSBrand(null);
        setOtherNumber(null);
        setOtherLink(null);
        setOtherFiles([]);
        setOtherImageFile(null);
        setOtherImageFileName('');

        setSelectedOtherDetail(null);

        setOtherFlooringScreedError('');
        setOtherBrandError('');
        setOtherNumberError('');
        setOtherLinkError('');
        setOtherFilesError('');
        setOtherImageFileError('');
    }

    useEffect(() => {
        checkText(otherFlooringScreed, false, setOtherFlooringScreedError);
    }, [otherFlooringScreed]);

    useEffect(() => {
        checkModelSelected(selectedFSBrand != null, false, setOtherBrandError);
    }, [selectedFSBrand]);

    useEffect(() => {
        checkNumber(otherNumber!, false, setOtherNumberError);
    }, [otherNumber]);

    useEffect(() => {
        checkText(otherLink!, false, setOtherLinkError);
    }, [otherLink]);

    useEffect(() => {
        checkFileOtherList(otherFiles!, false, setOtherFilesError);
    }, [otherFiles]);

    useEffect(() => {
        checkFileOthers(otherImageFile!, false, setOtherImageFileError);
    }, [otherImageFile]);

    function checkCredentialsForOtherDetail(fileRequired: boolean): boolean {
        const isOtherFlooringScreedValid = checkText(otherFlooringScreed, true, setOtherFlooringScreedError);
        const isOtherBrandValid = checkModelSelected(selectedFSBrand != null, true, setOtherBrandError);
        const isOtherNumberValid = checkNumber(otherNumber!, true, setOtherNumberError);
        const isOtherLinkValid = checkText(otherLink!, false, setOtherLinkError);
        const isOtherFilesValid = checkFileOtherList(otherFiles!, fileRequired, setOtherFilesError);
        const isOtherImageValid = checkFileOthers(otherImageFile!, fileRequired, setOtherImageFileError);

        return (
            isOtherFlooringScreedValid &&
            isOtherBrandValid &&
            isOtherNumberValid &&
            isOtherLinkValid &&
            isOtherFilesValid &&
            isOtherImageValid
        );
    }

    function showAPIErrorForOtherDetail(keyName: string, error: string): void {
        if (keyName === "flooring_screed") {
            setOtherFlooringScreedError(error);
        }

        if (keyName === "brand_id") {
            setOtherBrandError(error);
        }

        if (keyName === "number") {
            setOtherNumberError(error);
        }

        if (keyName === "link") {
            setOtherLinkError(error);
        }

        if (keyName === "file_list[]") {
            setOtherFilesError(error);
        }

        if (keyName === "image_path") {
            setOtherImageFileError(error);
        }
    }

    const handleAddOtherDetail = () => {
        setShowOtherDetailModal(true);
        setDataState('Add');
    }

    // Other detail add API
    const handleCreateOtherDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForOtherDetail(false)) {
            setLoading(true);

            const fs_data_id = activeOtherLocation?.id;
            const flooring_screed = otherFlooringScreed;
            const brand_id = selectedFSBrand?.id;
            const number = otherNumber;
            const link = otherLink;
            const image_path = otherImageFile;
            const file_list = otherFiles;

            const data = await fsOthersCreate(
                fs_data_id!,
                flooring_screed,
                brand_id!,
                number!,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsOtherDataGet();
                handleCloseOtherDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Other detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForOtherDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error adding the other detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedOtherDetail) {
            if (otherFlooringScreed !== selectedOtherDetail?.flooring_screed) {
                setOtherDetailUpdateHasChanges(true);
            } else if (selectedFSBrand?.id !== selectedOtherDetail?.brand_id) {
                setOtherDetailUpdateHasChanges(true);
            } else if (otherNumber !== null && otherNumber !== selectedOtherDetail?.number) {
                setOtherDetailUpdateHasChanges(true);
            } else if (otherLink !== null && otherLink !== selectedOtherDetail?.link) {
                setOtherDetailUpdateHasChanges(true);
            } else if (otherImageFile !== null) {
                setOtherDetailUpdateHasChanges(true);
            } else if (otherFiles?.length !== 0) {
                setOtherDetailUpdateHasChanges(true);
            } else {
                setOtherDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedOtherDetail,
        otherFlooringScreed,
        selectedFSBrand,
        otherNumber,
        otherLink,
        otherImageFile,
        otherFiles
    ]);

    const handleEditOtherDetail = (otherDetail: FSOtherData) => {
        if (otherDetail) {
            setShowOtherDetailModal(true);
            setDataState('Edit');

            setSelectedOtherDetail(otherDetail);

            const existOtherBrand = fsBrands?.find(brand => brand?.id === otherDetail?.brand_id);

            setOtherFlooringScreed(otherDetail?.flooring_screed);
            setSelectedFSBrand(existOtherBrand || null);
            setOtherNumber(otherDetail?.number || null);
            setOtherLink(otherDetail?.link || null);
        }
    }

    // Other detail update API
    const handleUpdateOtherDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForOtherDetail(false)) {
            setLoading(true);

            const id = selectedOtherDetail?.id;
            const flooring_screed = otherFlooringScreed;
            const brand_id = selectedFSBrand?.id;
            const number = otherNumber;
            const link = otherLink;
            const image_path = otherImageFile;
            const file_list = otherFiles;

            const data = await fsOthersUpdate(
                id!,
                flooring_screed,
                brand_id!,
                number!,
                link,
                image_path,
                file_list
            );

            setLoading(false);

            if (data.statusCode === 200) {
                fsOtherDataGet();
                handleCloseOtherDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Other detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForOtherDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "There was an error updating the other detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    const handleDeleteOtherDetail = (otherDetail: FSOtherData) => {
        const otherDetailId = otherDetail?.id;

        confirmDialog({
            message: `Are you sure you want to delete this other data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteOtherDetail(otherDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Other detail delete API
    const deleteOtherDetail = async (otherDetailId: number) => {
        if (otherDetailId) {
            setOtherDetailDeleteLoadingId(otherDetailId);

            const id = otherDetailId;
            const data = await fsOthersDelete(id);

            setOtherDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                fsOtherDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Other detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: "An error occurred while deleting the other detail.",
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const otherDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;<span className="custom">{dataState === 'Add' ? `${activeOtherLocation?.location_name}` : ''} details</span>
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseOtherDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const otherDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseOtherDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateOtherDetail : handleUpdateOtherDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !otherDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadOtherImageFile = (file: File) => {
        setOtherImageFile(file);
        setOtherImageFileName(file.name);
    };

    const handleClearOtherImageFile = () => {
        setOtherImageFile(null);
        setOtherImageFileName("");
    };

    const handleUploadOtherFiles = (files: File[]) => {
        setOtherFiles(files);
    };

    const handleClearOtherFiles = () => {
        setOtherFiles([]);
    };

    const otherDetailTableActionBody = (rowData: FSOtherData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewOtherDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateOthers && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditOtherDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteOthers && (
                        <TableActionButton
                            icon={`${otherDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteOtherDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={otherDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewOtherDetail = (data: FSOtherData) => {
        setSelectedOtherDetail(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */

    /* ************************************************************* Accessory detail */
    useEffect(() => {
        if (loadingFSPaints || loadingFSDoors || loadingFSTiles || loadingFSFloorFinishing) {
            setLoadingAccessoryData(true);
        } else {
            setLoadingAccessoryData(false);
        }
    }, [loadingFSPaints, loadingFSDoors, loadingFSTiles, loadingFSFloorFinishing]);

    const accessoryDataGet = async () => {
        if (!activeFSFeature) return;

        switch (activeFSFeature.feature) {
            case 'Door':
                await fsDoorDataGet();
                break;
            case 'Paint':
                await fsPaintDataGet();
                break;
            case 'Tiles':
                await fsTileDataGet();
                break;
            case 'Floor Finishing':
                await fsFloorFinishingDataGet();
                break;
            default:
                break;
        }
    }

    const handleCloseAccessoryDetailModal = () => {
        setShowAccessoryDetailModal(false);
        handleResetAccessoryDetailFields();
    }

    const handleResetAccessoryDetailFields = () => {
        setSelectedFSAccessory(null);
        setSelectedFSAccessorySub(null);
        setAccessoryNumber(null);
        setAccessoryReference('');
        setAccessoryLink(null);
        setAccessoryImageFile(null);
        setAccessoryImageFileName('');
        setAccessoryFiles([]);

        setSelectedAccessoryDetail(null);

        setAccessoryNameError('');
        setSubAccessoryNameError('');
        setAccessoryNumberError('');
        setAccessoryReferenceError('');
        setAccessoryLinkError('');
        setAccessoryImageFileError('');
        setAccessoryFilesError('');
    }

    useEffect(() => {
        checkModelSelected(selectedFSAccessory != null, false, setAccessoryNameError);
    }, [selectedFSAccessory]);

    useEffect(() => {
        checkModelSelected(selectedFSAccessorySub != null, false, setSubAccessoryNameError);
    }, [selectedFSAccessorySub]);

    useEffect(() => {
        checkNumber(accessoryNumber!, false, setAccessoryNumberError);
    }, [accessoryNumber]);

    useEffect(() => {
        checkText(accessoryReference!, false, setAccessoryReferenceError);
    }, [accessoryReference]);

    useEffect(() => {
        checkText(accessoryLink!, false, setAccessoryLinkError);
    }, [accessoryLink]);

    useEffect(() => {
        checkFileOthers(accessoryImageFile!, false, setAccessoryImageFileError);
    }, [accessoryImageFile]);

    useEffect(() => {
        checkFileOtherList(accessoryFiles!, false, setAccessoryFilesError);
    }, [accessoryFiles]);

    function checkCredentialsForAccessoryDetail(fileRequired: boolean): boolean {
        const isAccessoryNameValid = checkModelSelected(selectedFSAccessory != null, true, setAccessoryNameError);
        const isAccessorySubNameValid = checkModelSelected(selectedFSAccessorySub != null, false, setSubAccessoryNameError);
        const isaccessoryNumberValid = checkNumber(accessoryNumber!, true, setAccessoryNumberError);
        const isAccessoryReferenceValid = checkText(accessoryReference!, false, setAccessoryReferenceError);
        const isAccessoryLinkValid = checkText(accessoryLink!, false, setAccessoryLinkError);
        const isAccessoryImageValid = checkFileOthers(accessoryImageFile!, fileRequired, setAccessoryImageFileError);
        const isAccessoryFilesValid = checkFileOtherList(accessoryFiles!, fileRequired, setAccessoryFilesError);

        return (
            isAccessoryNameValid &&
            isAccessorySubNameValid &&
            isaccessoryNumberValid &&
            isAccessoryReferenceValid &&
            isAccessoryLinkValid &&
            isAccessoryImageValid &&
            isAccessoryFilesValid
        );
    }

    function showAPIErrorForAccessoryDetail(keyName: string, error: string): void {
        if (keyName === "accessory_name_id") {
            setAccessoryNameError(error);
        }

        if (keyName === "accessory_sub_name_id") {
            setSubAccessoryNameError(error);
        }

        if (keyName === "number") {
            setAccessoryNumberError(error);
        }

        if (keyName === "reference") {
            setAccessoryReferenceError(error);
        }

        if (keyName === "link") {
            setAccessoryLinkError(error);
        }

        if (keyName === "image_path") {
            setAccessoryImageFileError(error);
        }

        if (keyName === "file_list[]") {
            setAccessoryFilesError(error);
        }
    }

    const handleAddAccessoryDetails = () => {
        setShowAccessoryDetailModal(true);
        setDataState('Add');
    }

    // Accessory detail add API
    const handleCreateAccessoryDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsForAccessoryDetail(false)) {
            setLoading(true);

            const fs_data_id = (
                activeFSFeature?.feature === 'Paint' ? fsPaintAccessoryData?.id :
                    activeFSFeature?.feature === 'Door' ? fsDoorAccessoryData?.id :
                        activeFSFeature?.feature === 'Tiles' ? fsTilesAccessoryData?.id :
                            activeFSFeature?.feature === 'Floor Finishing' ? fsFloorFinishing?.fs_data_id : null
            );
            const category = activeFSFeature?.feature;
            const accessory_name_id = selectedFSAccessory?.id;
            const accessory_sub_name_id = selectedFSAccessorySub?.id;
            const number = accessoryNumber;
            const reference = accessoryReference;
            const link = accessoryLink;
            const image_path = accessoryImageFile;
            const file_list = accessoryFiles;

            const data = await fsAccessoryCreate(
                fs_data_id!,
                category!,
                accessory_name_id!,
                accessory_sub_name_id!,
                number!,
                reference,
                link,
                image_path,
                file_list
            );
            setLoading(false);

            if (data.statusCode === 200) {
                accessoryDataGet();
                handleCloseAccessoryDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${activeFSFeature?.feature} accessory detail added successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAccessoryDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: `There was an error adding the accessory detail for ${(activeFSFeature?.feature)?.toLowerCase()}.`,
                        life: 3000,
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedAccessoryDetail) {
            if (selectedFSAccessory?.id !== selectedAccessoryDetail?.accessory_name_id) {
                setAccessoryDetailUpdateHasChanges(true);
            } else if (selectedFSAccessorySub?.id !== selectedAccessoryDetail?.accessory_sub_name_id) {
                setAccessoryDetailUpdateHasChanges(true);
            } else if (accessoryNumber !== selectedAccessoryDetail?.number) {
                setAccessoryDetailUpdateHasChanges(true);
            } else if (accessoryReference !== null && accessoryReference !== selectedAccessoryDetail?.reference) {
                setAccessoryDetailUpdateHasChanges(true);
            } else if (accessoryLink !== null && accessoryLink !== selectedAccessoryDetail?.link) {
                setAccessoryDetailUpdateHasChanges(true);
            } else if (accessoryImageFile !== null) {
                setAccessoryDetailUpdateHasChanges(true);
            } else if (accessoryFiles?.length !== 0) {
                setAccessoryDetailUpdateHasChanges(true);
            } else {
                setAccessoryDetailUpdateHasChanges(false);
            }
        }
    }, [
        selectedAccessoryDetail,
        selectedFSAccessory,
        selectedFSAccessorySub,
        accessoryNumber,
        accessoryReference,
        accessoryLink,
        accessoryImageFile,
        accessoryFiles
    ]);

    const handleEditAccessoryDetail = (accessoryData: FSAccessoryData) => {
        if (accessoryData) {
            setShowAccessoryDetailModal(true);
            setDataState('Edit');

            setSelectedAccessoryDetail(accessoryData);

            const existAccessory = fsAccessories?.find(accessory => accessory?.id === accessoryData?.accessory_name_id);
            const existPaintSubAccessory = fsSubAccessories?.find(subAccessory => subAccessory?.id === accessoryData?.accessory_sub_name_id);

            setSelectedFSAccessory(existAccessory || null);
            setSelectedFSAccessorySub(existPaintSubAccessory || null);
            setAccessoryNumber(accessoryData?.number || null);
            setAccessoryReference(accessoryData?.reference || null)
            setAccessoryLink(accessoryData?.link || null);
        }
    }

    // Accessory detail update API
    const handleUpdateAccessoryDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForAccessoryDetail(false)) return;

        setLoading(true);

        try {
            const id = selectedAccessoryDetail?.id;
            const category = activeFSFeature?.feature;
            const accessory_name_id = selectedFSAccessory?.id;
            const accessory_sub_name_id = selectedFSAccessorySub?.id;
            const number = accessoryNumber;
            const reference = accessoryReference;
            const link = accessoryLink;
            const image_path = accessoryImageFile;
            const file_list = accessoryFiles;

            const data = await fsAccessoryUpdate(
                id!,
                category!,
                accessory_name_id!,
                accessory_sub_name_id!,
                number!,
                reference,
                link,
                image_path,
                file_list
            );

            if (data.statusCode === 200) {
                accessoryDataGet();
                handleCloseAccessoryDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${activeFSFeature?.feature} accessory detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForAccessoryDetail(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: `There was an error updating the accessory detail for ${(activeFSFeature?.feature)?.toLowerCase()}.`,
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the accessory detail:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the accessory detail.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteAccessoryDetail = (accessory: FSAccessoryData) => {
        const accessoryDetailId = accessory?.id;

        confirmDialog({
            message: `Are you sure you want to delete this ${(activeFSFeature?.feature)?.toLowerCase()} accessory data?`,
            header: "Confirm the deletion",
            icon: "bi bi-info-circle",
            defaultFocus: "accept",
            acceptClassName: "p-button-danger",
            accept: () => deleteAccessoryDetail(accessoryDetailId),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // Accessory detail delete API
    const deleteAccessoryDetail = async (accessoryDetailId: number) => {
        if (accessoryDetailId) {
            setAccessoryDetailDeleteLoadingId(accessoryDetailId);

            const id = accessoryDetailId;
            const data = await fsAccessoryDelete(id);

            setAccessoryDetailDeleteLoadingId(null);
            if (data.statusCode === 200) {
                accessoryDataGet();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${activeFSFeature?.feature} accessory detail deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "failed",
                        detail: `An error occurred while deleting the accessory detail for ${(activeFSFeature?.feature)?.toLowerCase()}.`,
                        life: 3000,
                    });
                }
            }
        }
    }

    /* Modal header */
    const accessoryDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;{(activeFSFeature?.feature)?.toLowerCase()} accessory detail
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseAccessoryDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const accessoryDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseAccessoryDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateAccessoryDetail : handleUpdateAccessoryDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !accessoryDetailUpdateHasChanges}
            />
        </div>
    );

    const handleUploadaccessoryImageFile = (file: File) => {
        setAccessoryImageFile(file);
        setAccessoryImageFileName(file.name);
    };

    const handleClearaccessoryImageFile = () => {
        setAccessoryImageFile(null);
        setAccessoryImageFileName("");
    };

    const handleUploadAccessoryFiles = (files: File[]) => {
        setAccessoryFiles(files);
    };

    const handleClearAccessoryFiles = () => {
        setAccessoryFiles([]);
    };

    const accessoryDetailTableActionBody = (rowData: FSAccessoryData) => {
        const data = rowData;

        return (
            <React.Fragment>
                <div className="tabel_btn_area custom mt-1 mb-1">
                    <TableActionButton
                        icon="bi bi-eye"
                        onClick={() => handleViewAccessoryDetail(data)}
                        className="primary_table_btn"
                        tooltipTarget={`view_${data?.id}`}
                        tooltip="View all details"
                        tooltipPosition="left"
                    />

                    {hasPermissionForUpdateAccessoryDetail && (
                        <TableActionButton
                            icon={`bi bi-pencil-square`}
                            onClick={() => handleEditAccessoryDetail(data)}
                            className="primary_table_btn"
                            tooltipTarget={`edit_${data?.id}`}
                            tooltip="Edit detail"
                            tooltipPosition="left"
                        />
                    )}

                    {hasPermissionForDeleteAccessoryDetail && (
                        <TableActionButton
                            icon={`${accessoryDetailDeleteLoadingId === data?.id ? 'bi bi-arrow-repeat loading_spinner' : 'bi bi-trash3'}`}
                            onClick={() => handleDeleteAccessoryDetail(data)}
                            className="danger_table_btn"
                            tooltipTarget={`delete_${data?.id}`}
                            disabled={accessoryDetailDeleteLoadingId === data?.id}
                            tooltip="Delete"
                            tooltipPosition="left"
                        />
                    )}
                </div>
            </React.Fragment>
        );
    };

    const handleViewAccessoryDetail = (data: FSAccessoryData) => {
        setSelectedAccessoryDetail(data);
        setShowFSDataViewModal(true);
    }
    /* ************************************************************* */

    /* ************************************************************* Order */
    const handleCloseOrderDetailModal = () => {
        setShowOrderModal(false);
        handleResetOrderDetailFields();
    }

    const handleResetOrderDetailFields = () => {
        setOrderDataId(null);
        setOrderTitle(null);
        setOrderStatus('Pending');
        setOrderWeekCount(null);
        setOrderDayCount(null);
        setOrderDate(null);
        setOrderIsPriceIncluded(0);
        setOrderPrice(null);
        setOrderIsVatIncluded(1);
        setOrderNote(null);
        setOrderIsForAccessory(0);

        setSelectedOrderData(null);

        setOrderStatusError('');
        setOrderWeekError('');
        setOrderDayError('');
        setOrderDateError('');
        setOrderPriceError('');
        setOrderNoteError('');
    }

    const handleProcessOrder = (
        title: string,
        status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite' | null,
        orderData: FSDataOrder | null,
        dataId: number,
        isAccessoryData: boolean
    ) => {
        if (!status) return;

        setSelectedOrderData(orderData);
        setOrderTitle(title)
        setOrderStatus(status);
        setOrderDataId(dataId);
        setOrderIsForAccessory(isAccessoryData ? 1 : 0);

        if (orderData) {
            const {
                lead_time_week,
                lead_time_day,
                date,
                price,
                is_price_include,
                is_include_vat,
                note
            } = orderData;

            if (status === 'Ordered') {
                setOrderWeekCount(lead_time_week ?? null);
                setOrderDayCount(lead_time_day ?? null);
            } else {
                setOrderWeekCount(null);
                setOrderDayCount(null);
            }

            setOrderDate(date ? parseStringToDate(date) : null);
            setOrderPrice(price ?? null);
            setOrderIsPriceIncluded(is_price_include ?? 0);
            setOrderIsVatIncluded(is_include_vat ?? 1);
            setOrderNote(note ?? null);
        } else {
            setOrderWeekCount(null);
            setOrderDayCount(null);
            setOrderDate(null);
            setOrderPrice(null);
            setOrderIsPriceIncluded(0);
            setOrderIsVatIncluded(1);
            setOrderNote(null);
        }
        setShowOrderModal(true);
    }

    useEffect(() => {
        checkText(orderStatus, false, setOrderStatusError);
    }, [orderStatus]);

    useEffect(() => {
        checkNumber((orderWeekCount! || orderDayCount!), false, setOrderWeekError);
    }, [orderWeekCount, orderDayCount]);

    useEffect(() => {
        checkNumber((orderDayCount! || orderWeekCount!), false, setOrderDayError);
    }, [orderDayCount, orderWeekCount]);

    useEffect(() => {
        checkText(formatDate(orderDate!), false, setOrderDateError);
    }, [orderDate]);

    useEffect(() => {
        checkNumber(orderPrice!, false, setOrderPriceError);
    }, [orderPrice, orderIsPriceIncluded]);

    useEffect(() => {
        checkText(orderNote!, false, setOrderNoteError);
    }, [orderNote]);

    function checkCredentialsForOrderProcess(): boolean {
        const isOrderStatusValid = checkText(orderStatus, true, setOrderStatusError);
        const isOrderWeekCountValid = checkNumber(orderWeekCount!, ((orderStatus === 'Ordered' && orderDayCount === null) ? true : false), setOrderWeekError);
        const isOrderDayCountValid = checkNumber(orderDayCount!, ((orderStatus === 'Ordered' && orderWeekCount === null) ? true : false), setOrderDayError);
        const isOrderDateValid = checkText(formatDate(orderDate!), ((orderStatus === 'Instore' || orderStatus === 'Onsite') ? true : false), setOrderDateError);
        const isOrderPriceValid = checkNumber(orderPrice!, false, setOrderPriceError);
        const isOrderNoteValid = checkText(orderNote!, false, setOrderNoteError);

        return (
            isOrderStatusValid &&
            isOrderWeekCountValid &&
            isOrderDayCountValid &&
            isOrderDateValid &&
            isOrderPriceValid &&
            isOrderNoteValid
        );
    }

    function showAPIErrorForOrderProcess(keyName: string, error: string): void {
        if (keyName === "status") {
            setOrderStatusError(error);
        }

        if (keyName === "lead_time_week") {
            setOrderWeekError(error);
        }

        if (keyName === "lead_time_day") {
            setOrderDayError(error);
        }

        if (keyName === "date") {
            setOrderDateError(error);
        }

        if (keyName === "price") {
            setOrderPriceError(error);
        }

        if (keyName === "note") {
            setOrderNoteError(error);
        }
    }

    // Order process API
    const processFSDataOrder = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!checkCredentialsForOrderProcess()) return;

        setLoading(true);

        try {
            const category = activeFSFeature?.feature;
            const is_accessory_data = orderIsForAccessory;
            const status = orderStatus;
            const order_add_id = orderDataId;
            const lead_time_week = orderWeekCount;
            const lead_time_day = orderDayCount;
            const date = formatDate(orderDate!);
            const is_price_include = orderIsPriceIncluded;
            const price = orderPrice;
            const is_include_vat = orderIsVatIncluded;
            const note = orderNote;

            const data = await fsOrderProcess(
                category!,
                is_accessory_data,
                status,
                order_add_id!,
                lead_time_week,
                lead_time_day,
                date,
                is_price_include,
                price,
                is_include_vat,
                note
            );

            if (data.statusCode === 200) {
                handleCloseOrderDetailModal();

                const feature = activeFSFeature?.feature;

                switch (feature) {
                    case 'Light':
                        await fsLightDataGet();
                        break;
                    case 'Door':
                        await fsDoorDataGet();
                        break;
                    case 'Paint':
                        await fsPaintDataGet();
                        break;
                    case 'Bathroom':
                        await fsBathroomDataGet();
                        break;
                    case 'Kitchen':
                        await fsKitchenDataGet();
                        break;
                    case 'Tiles':
                        await fsTileDataGet();
                        break;
                    case 'Floor Finishing':
                        await fsFloorFinishingDataGet();
                        break;
                    case 'Others':
                        await fsOtherDataGet();
                        break;
                }

                // accessoryDataGet();
                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${activeFSFeature?.feature} order detail updated successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    showAPIErrorForOrderProcess(key, value[0])
                ));
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: `There was an error updating the order detail for ${(activeFSFeature?.feature)?.toLowerCase()}.`,
                        life: 3000,
                    });
                }
            }
        } catch (error) {
            console.error("Error updating the order detail:", error);
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Something went wrong while updating the order detail.",
                life: 3000,
            });
        } finally {
            setLoading(false);
        }
    }

    /* Modal header */
    const orderModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5 text-capitalize">
                {orderTitle}&nbsp;-&nbsp;<span className="custom">Order</span>
            </h5>

            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseOrderDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div >
    );

    /* Modal footer */
    const orderModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseOrderDetailModal}
            />

            <Button
                label={loading ? 'Processing' : selectedOrderData ? 'Update' : 'Save'}
                onClick={processFSDataOrder}
                loading={loading}
                className="custom_btn primary"
                disabled={!orderDetailUpdateHasChanges}
            />
        </div>
    );

    // Set order date
    useEffect(() => {
        if (orderStatus === "Ordered") {
            const today = new Date();

            let resultDate = today;
            if (orderWeekCount && orderWeekCount > 0) {
                resultDate = addWeeks(resultDate, orderWeekCount);
            }
            if (orderDayCount && orderDayCount > 0) {
                resultDate = addDays(resultDate, orderDayCount);
            }

            if (orderWeekCount || orderDayCount) {
                setOrderDate(resultDate);
            } else {
                setOrderDate(null);
            }
        }
    }, [orderWeekCount, orderDayCount, orderStatus]);

    // Set order price bay vat
    const handleVatChange = (value: 1 | 0) => {
        if (orderPrice === null) {
            setOrderIsVatIncluded(value);
            return;
        }

        let updatedPrice = orderPrice;

        if (value === 0 && orderIsVatIncluded === 1) {
            updatedPrice = Number((orderPrice / (1 + vatPercentage / 100)).toFixed(2));
        } else if (value === 1 && orderIsVatIncluded === 0) {
            updatedPrice = Number((orderPrice * (1 + vatPercentage / 100)).toFixed(2));
        }

        setOrderPrice(updatedPrice);
        setOrderIsVatIncluded(value);
    };

    useEffect(() => {
        if (selectedOrderData) {
            const status = selectedOrderData.status;
            const formattedOrderDate = orderDate ? formatDate(orderDate) : null;

            if (orderStatus !== status) {
                setOrderDetailUpdateHasChanges(true);
            }
            else if (status === 'Ordered' && orderWeekCount && orderWeekCount !== selectedOrderData.lead_time_week) {
                setOrderDetailUpdateHasChanges(true);
            }
            else if (status === 'Ordered' && orderDayCount && orderDayCount !== selectedOrderData.lead_time_day) {
                setOrderDetailUpdateHasChanges(true);
            }
            else if (status !== 'Pending' && formattedOrderDate !== selectedOrderData.date) {
                setOrderDetailUpdateHasChanges(true);
            }
            else if (orderIsPriceIncluded !== selectedOrderData.is_price_include) {
                setOrderDetailUpdateHasChanges(true);
            }
            else if (orderPrice !== null && orderPrice !== selectedOrderData.price) {
                setOrderDetailUpdateHasChanges(true);
            }
            else if (orderIsVatIncluded !== selectedOrderData.is_include_vat) {
                setOrderDetailUpdateHasChanges(true);
            }
            else if (orderNote !== selectedOrderData.note) {
                setOrderDetailUpdateHasChanges(true);
            }
            else {
                setOrderDetailUpdateHasChanges(false);
            }
        } else {
            setOrderDetailUpdateHasChanges(true);
        }
    }, [
        selectedOrderData,
        orderStatus,
        orderWeekCount,
        orderDayCount,
        orderDate,
        orderIsPriceIncluded,
        orderPrice,
        orderIsVatIncluded,
        orderNote,
    ]);
    /* ************************************************************* */

    /* ************************************************************* Common */
    const handleNavigateFSDocument = () => {
        navigate(`document`, { state: { projectData: finishingScheduleProject, fsFeatre: activeFSFeature } })
    }

    const tableOrderDateBody = (
        status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite' | null,
        orderDate: string | null,
        dateShort: string | null
    ) => {
        let icon = '';

        if (status === 'Pending') {
            icon = 'bi-clock-history'
        } else if (status === 'Ordered') {
            icon = 'bi-box-seam'
        } else if (status === 'Instore') {
            icon = 'bi-shop-window'
        } else if (status === 'Onsite') {
            icon = 'bi-building'
        }

        return (
            <React.Fragment>
                {orderDate ? (
                    <span className="order_date_area">
                        <span className="order_date_label">
                            <i className={`bi ${icon}`} ></i>
                            <span>{orderDate || ''}</span>
                        </span>
                        {status === 'Ordered' && (
                            <span className="order_date_short">
                                <i className="bi bi-arrow-return-right"></i>
                                {dateShort || ''}
                            </span>
                        )}
                    </span>
                ) : (
                    <span>---</span>
                )}
            </React.Fragment>
        )
    }

    const tableOrderStatusBody = (
        title: string,
        status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite' | null,
        orderData: FSDataOrder | null,
        dataId: number,
        isAccessoryData: boolean,
    ) => {
        return (
            <div className="tabel_btn_area mt-1 mb-1">
                {status ? (
                    <Button
                        severity={
                            status === 'Pending' ? 'danger' :
                                status === 'Ordered' ? 'warning' :
                                    status === 'Instore' ? 'success' :
                                        'info'
                        }
                        label={status}
                        className="table_status_btn"
                        onClick={() => {
                            if (hasPermissionForOrderProcess) {
                                handleProcessOrder(title, status, orderData, dataId, isAccessoryData);
                            }
                        }}
                        tooltipOptions={{ position: "left" }}
                        tooltip="Click for order process."
                        disabled={!hasPermissionForOrderProcess}
                    />
                ) : (
                    <span>---</span>
                )}
            </div>
        )
    }

    const tableColorBody = (colorCode: string | null) => {
        return (
            <span className="table_display_outer">
                <span className="table_color_display" style={{ backgroundColor: colorCode || '#FFF' }}>
                    {colorCode === null && <i className="bi bi-exclamation-circle"></i>}
                </span>
            </span>
        )
    }

    const tableImageBody = (imagePath: string | null) => {
        return (
            <span className="table_display_outer">
                {imagePath ? (
                    <Image
                        src={imagePath}
                        alt="Image"
                        preview
                        className="table_img_display"
                        loading="lazy"
                        draggable={false}
                        unstyled={false}
                    />
                ) : (
                    <img src={noImageIcon} className="table_img_empty" alt="N/A" draggable={false} />
                )}
            </span>
        )
    }

    const handleDeleteFile = (fileIndex: number, fileDataId: number, isAccessoryFile: boolean) => {
        if (fileIndex !== null && fileDataId !== null) {
            confirmDialog({
                message: "Are you sure you want to delete this file?",
                header: "Confirm the deletion",
                icon: "bi bi-info-circle",
                defaultFocus: "accept",
                acceptClassName: "p-button-danger",
                accept: () => deleteFile(fileIndex, fileDataId, isAccessoryFile),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    const deleteFile = async (fileIndex: number, fileDataId: number, isAccessoryFile: boolean) => {
        if (fileIndex === null || fileDataId === null || !activeFSFeature) return;

        setFileDeleteLoadingIndex(fileIndex);

        const res = await deleteFSFile(activeFSFeature.feature, isAccessoryFile, fileDataId, fileIndex);
        setFileDeleteLoadingIndex(null);

        if (res.statusCode !== 200) {
            toast.current?.show({
                severity: "error",
                summary: "Failed",
                detail: "An error occurred while deleting the file.",
                life: 3000,
            });
            return;
        }

        const feature = activeFSFeature.feature;

        const updateFileList = <T extends { file_list?: any[] }>(
            detail: T | null,
            setter: (value: T) => void
        ) => {
            if (!detail) return;
            const updatedFileList = detail.file_list?.filter(f => f.index !== fileIndex);
            setter({ ...detail, file_list: updatedFileList });
        };

        const updateAccessoryFileData = () => {
            if (isAccessoryFile && selectedAccessoryDetail) {
                const updatedFileList = selectedAccessoryDetail.file_list?.filter(
                    (file) => file.index !== fileIndex
                );
                setSelectedAccessoryDetail({ ...selectedAccessoryDetail, file_list: updatedFileList });
            }
        };

        switch (feature) {
            case 'Light':
                await fsLightDataGet();
                updateFileList(selectedLightDetail, setSelectedLightDetail);
                break;
            case 'Door':
                await fsDoorDataGet();
                updateFileList(selectedDoorDetail, setSelectedDoorDetail);
                updateAccessoryFileData();
                break;
            case 'Paint':
                await fsPaintDataGet();
                updateFileList(selectedPaintDetail, setSelectedPaintDetail);
                updateAccessoryFileData();
                break;
            case 'Bathroom':
                await fsBathroomDataGet();
                updateFileList(selectedBathroomDetail, setSelectedBathroomDetail);
                break;
            case 'Kitchen':
                await fsKitchenDataGet();
                updateFileList(selectedKitchenDetail, setSelectedKitchenDetail);
                updateFileList(selectedKitchenApplianceDetail, setSelectedKitchenApplianceDetail);
                break;
            case 'Tiles':
                await fsTileDataGet();
                updateFileList(selectedTileDetail, setSelectedTileDetail);
                updateAccessoryFileData();
                break;
            case 'Floor Finishing':
                await fsFloorFinishingDataGet();
                updateFileList(selectedFloorFinishingData, setSelectedFloorFinishingData);
                updateAccessoryFileData();
                break;
            case 'Others':
                await fsOtherDataGet();
                updateFileList(selectedOtherDetail, setSelectedOtherDetail);
                break;
        }

        toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: "File deleted successfully.",
            life: 3000,
        });
    }

    const handleCloseFSDataViewModal = () => {
        setShowFSDataViewModal(false);

        const feature = activeFSFeature?.feature;

        const resetActions: Record<string, () => void> = {
            'Bathroom': () => setSelectedBathroomDetail(null),
            'Door': () => setSelectedDoorDetail(null),
            'Floor Finishing': () => setSelectedFloorFinishingData(null),
            'Kitchen': () => {
                setSelectedKitchenDetail(null);
                setSelectedKitchenApplianceDetail(null);
            },
            'Light': () => setSelectedLightDetail(null),
            'Others': () => setSelectedOtherDetail(null),
            'Paint': () => setSelectedPaintDetail(null),
            'Tiles': () => setSelectedTileDetail(null),
        };

        if (feature && resetActions[feature]) {
            resetActions[feature]();
        } else if (selectedAccessoryDetail !== null) {
            setSelectedAccessoryDetail(null);
        }
    };

    const handleShowReportConfigModal = () => {
        setShowReportConfigModal(true);
    }

    const handleCloseReportConfigModal = () => {
        setShowReportConfigModal(false);
    }

    const handlePreviewReport = (fsData: FSProject, selectedOptions: FeatureOption[]) => {
        setSelectedFeatureOptions(selectedOptions);
        navigate("report", {
            state: {
                fsData,
                selectedFeatureOptions: selectedOptions,
            },
        });
    };
    /* ************************************************************* */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {loadingFSProjects && initialDataLoading ? (
                    <PageLoader />
                ) : errorFSProjects ? (
                    <ErrorPage errorMessage={errorFSProjects} />
                ) : (
                    <div className="page_content mt-0">
                        {finishingScheduleProject && finishingScheduleProject !== null && (
                            <React.Fragment>
                                <div className="page_breadcrumb_area">
                                    {navigateFrom && navigateFrom === 'Project' ? (
                                        <ul className="page_breadcrumb">
                                            <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                                {finishingScheduleProject?.job_number + ": " + finishingScheduleProject?.address}
                                            </li>
                                            <li className="page_breadcrumb_item active">
                                                Finishing schedule
                                            </li>
                                        </ul>
                                    ) : (
                                        <ul className="page_breadcrumb">
                                            <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                                Projects
                                            </li>
                                            <li className="page_breadcrumb_item has_child">
                                                {finishingScheduleProject?.job_number + ": " + finishingScheduleProject?.address}
                                            </li>
                                            <li className="page_breadcrumb_item active">
                                                Finishing schedule
                                            </li>
                                        </ul>
                                    )}

                                    <button className="back_btn p-ripple" onClick={goBack}>
                                        <i className="bi bi-arrow-left me-2"></i>
                                        Back
                                        <Ripple />
                                    </button>
                                </div>

                                <div className="page_header_area scrollable custom_wrap mt-sm-2">
                                    {finishingScheduleProject?.feature_list?.length > 0 ? (
                                        <React.Fragment>
                                            <div className="main_heading_tab_area custom">
                                                {finishingScheduleFeatures && finishingScheduleFeatures.length > 0 && (
                                                    <React.Fragment>
                                                        {finishingScheduleFeatures?.map((feature) => (
                                                            <React.Fragment key={`featureTab_${feature.id}`}>
                                                                <button
                                                                    className={`main_heading_as_tab is_tab ${activeFSFeature?.id === feature?.id ? "active" : ''} p-ripple is_btn text-capitalize`}
                                                                    type="button"
                                                                    role="tab"
                                                                    onClick={() => handleSelectFSFeature(feature)}
                                                                >
                                                                    {feature.feature}
                                                                    < Ripple />
                                                                </button>

                                                                <div className="tab_divider"></div>
                                                            </React.Fragment>
                                                        ))}

                                                        {hasPermissionForAddMainFeature && (
                                                            <Button
                                                                type="button"
                                                                icon="bi bi-plus-circle"
                                                                tooltip="Add feature"
                                                                label="Add"
                                                                className="add_tab_btn with_lbl"
                                                                tooltipOptions={{ position: 'top' }}
                                                                onClick={handleAddFSMainFeature}
                                                            />
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </div>

                                            <div className="page_action_area sticky">
                                                {hasPermissionForDeleteMainFeature && (
                                                    <React.Fragment>
                                                        <Tooltip
                                                            target={`.deleteFeature`}
                                                        />

                                                        <button
                                                            className={`add_data_link_btn deleteFeature file p-ripple`}
                                                            onClick={() => handleDeleteFSMainFeature(activeFSFeature!)}
                                                            data-pr-tooltip={`Delete ${activeFSFeature?.feature ? (activeFSFeature?.feature).toLowerCase() : ''} feature.`}
                                                            data-pr-position="left"
                                                            disabled={mainFeatureDeleteLoading}
                                                        >
                                                            <i className={`${mainFeatureDeleteLoading ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash3'}`}></i>
                                                            <Ripple />
                                                        </button>
                                                    </React.Fragment>
                                                )}

                                                <React.Fragment>
                                                    <Tooltip
                                                        target={`.featureReport`}
                                                    />

                                                    <button
                                                        className="add_data_link_btn featureReport p-ripple"
                                                        onClick={handleShowReportConfigModal}
                                                        data-pr-tooltip={`Report preview`}
                                                        data-pr-position="left"
                                                    >
                                                        <i className="bi bi-file-earmark-bar-graph"></i>
                                                        {/* <span className="btn_text">Report</span> */}
                                                        <Ripple />
                                                    </button>
                                                </React.Fragment>

                                                {hasPermissionForShareFeature && isOwnProject && (
                                                    <React.Fragment>
                                                        <Tooltip
                                                            target={`.shareFeature`}
                                                        />

                                                        <button
                                                            className="add_data_link_btn shareFeature p-ripple"
                                                            onClick={handleShareFeature}
                                                            data-pr-tooltip={`Share ${activeFSFeature?.feature ? activeFSFeature?.feature : ''} feature.`}
                                                            data-pr-position="left"
                                                            disabled={shareLoading}
                                                        >
                                                            <i className={`${shareLoading ? 'ri-loader-4-fill loading_spinner' : 'bi bi-share'}`}></i>
                                                            <Ripple />
                                                        </button>
                                                    </React.Fragment>
                                                )}

                                                <React.Fragment>
                                                    <Tooltip
                                                        target={`.featureDocument`}
                                                    />

                                                    <button
                                                        className="add_data_link_btn featureDocument p-ripple"
                                                        onClick={handleNavigateFSDocument}
                                                        data-pr-tooltip={`${activeFSFeature?.feature ? activeFSFeature?.feature : ''} documents.`}
                                                        data-pr-position="left"
                                                    >
                                                        <i className="bi bi-file-earmark-text"></i>
                                                        {/* <span className="btn_text">Document</span> */}
                                                        <Ripple />
                                                    </button>
                                                </React.Fragment>
                                            </div>
                                        </React.Fragment>
                                    ) : (
                                        <div className="page_action_area w-100 justify-content-end">
                                            {hasPermissionForAddMainFeature && (
                                                <button
                                                    className="add_data_link_btn p-ripple"
                                                    onClick={handleAddFSMainFeature}
                                                >
                                                    <i className="bi bi-plus-lg"></i>
                                                    <span className="btn_text">Add feature</span>
                                                    <Ripple />
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {activeFSFeature?.feature === 'Light' && (!loadingFSLights || !initialSubDataLoading) && (
                                    <div className={`page_tab_header mt-2 mt-sm-3 mt-lg-2 mb-3 ${fsLightsData?.length === 0 ? 'justify-content-end' : ''}`}>
                                        {fsLightsData && fsLightsData?.length > 0 && (
                                            <div className="contact_tabs">
                                                {fsLightsData?.map((lightLocation) => {
                                                    const isActive = activeLightLocation?.id === lightLocation?.id;

                                                    return (
                                                        <div className="contact_tab_item" key={`lightLocation_${lightLocation?.id}`}>
                                                            <button
                                                                type="button"
                                                                className={`contact_tab_btn min_width status_tab ${isActive ? "active" : ""} p-ripple`}
                                                                onClick={() => handleSelectLightLocation(lightLocation)}
                                                            >
                                                                {lightLocation?.location_name}
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}

                                        <div className="page_action_area">
                                            {hasPermissionForAddLightLocation && (
                                                <button
                                                    className="add_data_link_btn p-ripple"
                                                    onClick={handleAddLightLocation}
                                                >
                                                    <i className="bi bi-plus-circle"></i>
                                                    <span className="btn_text">Add</span>
                                                    <Ripple />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {activeFSFeature?.feature === 'Bathroom' && (!loadingFSBathrooms || !initialSubDataLoading) && (
                                    <div className={`page_tab_header mt-2 mt-sm-3 mt-lg-2 mb-3 ${fsBathrooms?.length === 0 ? 'justify-content-end' : ''}`}>
                                        {fsBathrooms && fsBathrooms?.length > 0 && (
                                            <div className="contact_tabs">
                                                {fsBathrooms?.map((bathroomLocation) => {
                                                    const isActive = activeBathroomLocation?.id === bathroomLocation?.id;

                                                    return (
                                                        <div className="contact_tab_item" key={`bathroomLocation_${bathroomLocation?.id}`}>
                                                            <button
                                                                type="button"
                                                                className={`contact_tab_btn min_width status_tab ${isActive ? "active" : ""} p-ripple`}
                                                                onClick={() => handleSelectBathroomLocation(bathroomLocation)}
                                                            >
                                                                {bathroomLocation?.location_name}
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}

                                        <div className="page_action_area">
                                            {hasPermissionForAddBathroomLocation && (
                                                <button
                                                    className="add_data_link_btn p-ripple"
                                                    onClick={handleAddBathroomLocation}
                                                >
                                                    <i className="bi bi-plus-circle"></i>
                                                    <span className="btn_text">Add</span>
                                                    <Ripple />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {activeFSFeature?.feature === 'Tiles' && (!loadingFSTiles || !initialSubDataLoading) && (
                                    <div className={`page_tab_header mt-2 mt-sm-3 mt-lg-2 mb-3 ${fsTilesData?.length === 0 ? 'justify-content-end' : ''}`}>
                                        {fsTilesData && fsTilesData?.length > 0 && (
                                            <div className="contact_tabs">
                                                {fsTilesData?.map((tileLocation) => {
                                                    const isActive = activeTileLocation?.id === tileLocation?.id;

                                                    return (
                                                        <div className="contact_tab_item" key={`tileLocation_${tileLocation?.id}`}>
                                                            <button
                                                                type="button"
                                                                className={`contact_tab_btn min_width status_tab ${isActive ? "active" : ""} p-ripple`}
                                                                onClick={() => handleSelectTileLocation(tileLocation)}
                                                            >
                                                                {tileLocation?.location_name}
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}

                                        <div className="page_action_area">
                                            {hasPermissionForAddTileLocation && (
                                                <button
                                                    className="add_data_link_btn p-ripple"
                                                    onClick={handleAddTileLocation}
                                                >
                                                    <i className="bi bi-plus-circle"></i>
                                                    <span className="btn_text">Add</span>
                                                    <Ripple />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {activeFSFeature?.feature === 'Others' && (!loadingFSOthers || !initialSubDataLoading) && (
                                    <div className={`page_tab_header mt-2 mt-sm-3 mt-lg-2 mb-3 ${fsOthersData?.length === 0 ? 'justify-content-end' : ''}`}>
                                        {fsOthersData && fsOthersData?.length > 0 && (
                                            <div className="contact_tabs">
                                                {fsOthersData?.map((otherLocation) => {
                                                    const isActive = activeOtherLocation?.id === otherLocation?.id;

                                                    return (
                                                        <div className="contact_tab_item" key={`otherLocation_${otherLocation?.id}`}>
                                                            <button
                                                                type="button"
                                                                className={`contact_tab_btn min_width status_tab ${isActive ? "active" : ""} p-ripple`}
                                                                onClick={() => handleSelectOtherLocation(otherLocation)}
                                                            >
                                                                {otherLocation?.location_name}
                                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                            </button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}

                                        <div className="page_action_area">
                                            {hasPermissionForAddOthersLocation && (
                                                <button
                                                    className="add_data_link_btn p-ripple"
                                                    onClick={handleAddOtherLocation}
                                                >
                                                    <i className="bi bi-plus-circle"></i>
                                                    <span className="btn_text">Add</span>
                                                    <Ripple />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {finishingScheduleFeatures && finishingScheduleFeatures?.length > 0 ? (
                                    <article className="page_main_content_section mt-2">
                                        {(
                                            loadingFSLights ||
                                            loadingFSDoors ||
                                            loadingFSPaints ||
                                            loadingFSBathrooms ||
                                            loadingFSKitchens ||
                                            loadingFSTiles ||
                                            loadingFSFloorFinishing ||
                                            loadingFSOthers
                                        ) && initialSubDataLoading ? (
                                            <PageLoader containerClassName="pos_abs" />
                                        ) : (
                                            <React.Fragment>
                                                {/* Light */}
                                                {activeFSFeature?.feature === 'Light' && (
                                                    <React.Fragment>
                                                        {errorFSLights ? (
                                                            <ErrorPage errorMessage={errorFSLights} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsLightsData && fsLightsData?.length > 0 ? (
                                                                    <React.Fragment>
                                                                        {activeLightLocation && activeLightLocation !== null && (
                                                                            <div key={`light_${activeLightLocation?.id}`} className="page_sub_content_section">
                                                                                <div className="page_sub_content_header">
                                                                                    <h4 className="page_sub_content_head">
                                                                                        {activeLightLocation?.location_name}
                                                                                    </h4>

                                                                                    <div className="page_sub_content_header_btn_area">
                                                                                        {hasPermissionForDeleteLightLocation && (
                                                                                            <TableButton
                                                                                                label={lightLocationDeleteLoadingId === activeLightLocation?.id ? 'Processing' : 'Delete'}
                                                                                                icon={lightLocationDeleteLoadingId === activeLightLocation?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash3'}
                                                                                                disabled={lightLocationDeleteLoadingId === activeLightLocation?.id}
                                                                                                iconClassName="me-2"
                                                                                                onClick={() => handleDeleteLightLocation(activeLightLocation)}
                                                                                                tooltip="Delete Location"
                                                                                                tooltipTarget={`lightLocationDelete_${activeLightLocation?.id}`}
                                                                                                tooltipPosition="left"
                                                                                            />
                                                                                        )}

                                                                                        {hasPermissionForAddLight && (
                                                                                            <TableButton
                                                                                                label="Add"
                                                                                                icon="bi bi-plus-lg"
                                                                                                iconClassName="me-2"
                                                                                                onClick={handleAddLightDetail}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="page_sub_content_body">
                                                                                    {activeLightLocation?.data_light && activeLightLocation?.data_light?.length > 0 ? (
                                                                                        <DataTable
                                                                                            value={activeLightLocation?.data_light}
                                                                                            size="small"
                                                                                            // paginator
                                                                                            // rows={5}
                                                                                            // rowsPerPageOptions={[5, 10, 25, 50]}
                                                                                            // paginatorDropdownAppendTo={"self"}
                                                                                            // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                            // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                            dataKey="id"
                                                                                            className="page_table fs_data_table p-0"
                                                                                            rowClassName={() => 'project_data_row secondary'}
                                                                                            rowHover
                                                                                            scrollable
                                                                                            scrollHeight="490px"
                                                                                            tableStyle={{ minWidth: "50rem" }}
                                                                                            loading={loadingFSLights}
                                                                                            emptyMessage="No light data available!"
                                                                                        >
                                                                                            <Column
                                                                                                header="Image"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="image_path"
                                                                                                body={(rowData: FSLightData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableImageBody(rowData?.image_path || null)}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Item"
                                                                                                headerClassName="text_purple"
                                                                                                field="item.item_name"
                                                                                                body={(rowData: FSLightData) => (
                                                                                                    <span className="text-capitalize">
                                                                                                        {rowData?.item?.item_name ? rowData?.item?.item_name : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Price"
                                                                                                headerClassName="text_purple"
                                                                                                alignHeader={'right'}
                                                                                                field="order_data.price"
                                                                                                body={(rowData: FSLightData) => (
                                                                                                    <span className="position-relative">
                                                                                                        <span className="text_no_wrap flex_end">
                                                                                                            {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                        </span>
                                                                                                        {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                            <span className="vat_label">Inc. VAT</span>
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Type"
                                                                                                headerClassName="text_purple"
                                                                                                field="type.type_name"
                                                                                                body={(rowData: FSLightData) => (
                                                                                                    <span className="text-capitalize">
                                                                                                        {rowData?.type?.type_name ? rowData?.type?.type_name : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="No."
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="number"
                                                                                                body={(rowData: FSLightData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {rowData?.number ? String(rowData?.number).padStart(2, '0') : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "10%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Date"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_data.date"
                                                                                                body={(rowData: FSLightData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderDateBody(
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data?.date!,
                                                                                                            rowData?.order_date_data!
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Order"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_status"
                                                                                                body={(rowData: FSLightData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderStatusBody(
                                                                                                            `Light (${rowData?.item?.item_name!})`,
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data!,
                                                                                                            rowData?.id,
                                                                                                            false
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                body={lightDetailTableActionBody}
                                                                                                frozen={window.innerWidth > 575}
                                                                                                alignFrozen="right"
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>
                                                                                        </DataTable>
                                                                                    ) : (
                                                                                        <NoDataCreated
                                                                                            containerClassname="pos_rel sub custom_height"
                                                                                            message={`No ${(activeLightLocation?.location_name)?.toLowerCase()} details has been added. ${hasPermissionForAddLight ? 'Click the Add button to add the details.' : ''}`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <div className="page_sub_content_section">
                                                                        <div className="page_sub_content_header">
                                                                            <h4 className="page_sub_content_head">
                                                                                Light
                                                                            </h4>
                                                                        </div>

                                                                        <div className="page_sub_content_body">
                                                                            <NoDataCreated
                                                                                containerClassname="pos_rel sub custom_height"
                                                                                message={`No light location has been added. ${hasPermissionForAddLightLocation ? 'Click the Add button to add the location(s).' : ''}`}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Door */}
                                                {activeFSFeature?.feature === 'Door' && (
                                                    <React.Fragment>
                                                        {errorFSDoors ? (
                                                            <ErrorPage errorMessage={errorFSDoors} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsDoorData && fsDoorData?.length > 0 ? (
                                                                    <React.Fragment>
                                                                        {fsDoorData?.map((door) => {
                                                                            return (
                                                                                <div key={`door_${door?.id}`} className="page_sub_content_section">
                                                                                    <div className="page_sub_content_header">
                                                                                        <h4 className="page_sub_content_head">
                                                                                            {door?.location_name}
                                                                                        </h4>

                                                                                        <div className="page_sub_content_header_btn_area">
                                                                                            {hasPermissionForAddDoor && (
                                                                                                <TableButton
                                                                                                    label="Add"
                                                                                                    icon="bi bi-plus-lg"
                                                                                                    iconClassName="me-2"
                                                                                                    onClick={() => handleAddDoorDetails(door)}
                                                                                                />
                                                                                            )}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="page_sub_content_body">
                                                                                        {door?.data_door && door?.data_door?.length > 0 ? (
                                                                                            <DataTable
                                                                                                value={door?.data_door}
                                                                                                size="small"
                                                                                                // paginator
                                                                                                // rows={5}
                                                                                                // rowsPerPageOptions={[5, 10, 25, 50]}
                                                                                                // paginatorDropdownAppendTo={"self"}
                                                                                                // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                                // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                                dataKey="id"
                                                                                                className="page_table fs_data_table p-0"
                                                                                                rowClassName={() => 'project_data_row secondary'}
                                                                                                rowHover
                                                                                                scrollable
                                                                                                tableStyle={{ minWidth: "50rem" }}
                                                                                                scrollHeight="490px"
                                                                                                loading={loadingFSDoors}
                                                                                                emptyMessage="No doors data available!"
                                                                                            >
                                                                                                <Column
                                                                                                    header="Image"
                                                                                                    alignHeader={'center'}
                                                                                                    headerClassName="text_purple"
                                                                                                    field="image_path"
                                                                                                    body={(rowData: FSDoorData) => (
                                                                                                        <span className="flex_center">
                                                                                                            {tableImageBody(rowData?.image_path || null)}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    style={{ width: "10%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    header="Color"
                                                                                                    headerClassName="text_purple"
                                                                                                    field="color.color_name"
                                                                                                    body={(rowData: FSDoorData) => (
                                                                                                        <span className="text-capitalize">
                                                                                                            {rowData?.color?.color_name ? rowData?.color?.color_name : "---"}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    style={{ width: "10%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    header="Price"
                                                                                                    headerClassName="text_purple"
                                                                                                    alignHeader={'right'}
                                                                                                    field="order_data.price"
                                                                                                    body={(rowData: FSDoorData) => (
                                                                                                        <span className="position-relative">
                                                                                                            <span className="text_no_wrap flex_end">
                                                                                                                {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                            </span>
                                                                                                            {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                                <span className="vat_label">Inc. VAT</span>
                                                                                                            )}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    style={{ width: "12%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    header={() => {
                                                                                                        return (
                                                                                                            <React.Fragment>
                                                                                                                <Tooltip
                                                                                                                    target={`.info_tooltip`}
                                                                                                                />
                                                                                                                <span>FRR
                                                                                                                    <i className="bi bi-info-circle ms-1 info_tooltip text-dark"
                                                                                                                        data-pr-tooltip="Fire Resistance Rating"
                                                                                                                        data-pr-position="top"
                                                                                                                    ></i>
                                                                                                                </span>
                                                                                                            </React.Fragment>
                                                                                                        )
                                                                                                    }}
                                                                                                    alignHeader={'center'}
                                                                                                    headerClassName="text_purple"
                                                                                                    field="fire_resistance_rating"
                                                                                                    body={(rowData: FSDoorData) => (
                                                                                                        <span className="flex_center">
                                                                                                            {rowData?.fire_resistance_rating ? rowData?.fire_resistance_rating : "---"}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    style={{ width: "6%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    header="No."
                                                                                                    alignHeader={'center'}
                                                                                                    headerClassName="text_purple"
                                                                                                    field="number"
                                                                                                    body={(rowData: FSDoorData) => (
                                                                                                        <span className="flex_center">
                                                                                                            {rowData?.number ? String(rowData?.number).padStart(2, '0') : "---"}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    style={{ width: "6%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    header="Size"
                                                                                                    headerClassName="text_purple"
                                                                                                    field="rowData.size_type"
                                                                                                    body={(rowData: FSDoorData) => {
                                                                                                        const sizeText =
                                                                                                            rowData?.size_type === "Standard size"
                                                                                                                ? rowData?.size?.size_name ?? "---"
                                                                                                                : rowData?.manual_size ?? "---";

                                                                                                        const match = sizeText.match(/^(.+?)\s*\((.+)\)$/);
                                                                                                        const mainSize = match ? match[1].trim() : sizeText;
                                                                                                        const subSize = match ? match[2].trim() : null;

                                                                                                        return (
                                                                                                            <span>
                                                                                                                {mainSize}
                                                                                                                {subSize && (
                                                                                                                    <>
                                                                                                                        <br />
                                                                                                                        <small>({subSize})</small>
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </span>
                                                                                                        );
                                                                                                    }}
                                                                                                    style={{ width: "17%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    header="Date"
                                                                                                    alignHeader={'center'}
                                                                                                    headerClassName="text_purple"
                                                                                                    field="order_data.date"
                                                                                                    body={(rowData: FSDoorData) => (
                                                                                                        <span className="flex_center">
                                                                                                            {tableOrderDateBody(
                                                                                                                rowData?.order_status,
                                                                                                                rowData?.order_data?.date!,
                                                                                                                rowData?.order_date_data!
                                                                                                            )}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    style={{ width: "12%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    header="Order"
                                                                                                    alignHeader={'center'}
                                                                                                    headerClassName="text_purple"
                                                                                                    field="order_status"
                                                                                                    body={(rowData: FSDoorData) => (
                                                                                                        <span className="flex_center">
                                                                                                            {tableOrderStatusBody(
                                                                                                                `Door (${rowData?.color?.color_name!})`,
                                                                                                                rowData?.order_status,
                                                                                                                rowData?.order_data!,
                                                                                                                rowData?.id,
                                                                                                                false
                                                                                                            )}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    style={{ width: "12%" }}
                                                                                                ></Column>

                                                                                                <Column
                                                                                                    // headerClassName="d-none"
                                                                                                    body={doorDetailTableActionBody}
                                                                                                    frozen={window.innerWidth > 575}
                                                                                                    alignFrozen="right"
                                                                                                    style={{ width: "15%" }}
                                                                                                ></Column>
                                                                                            </DataTable>
                                                                                        ) : (
                                                                                            <NoDataCreated
                                                                                                containerClassname="pos_rel sub"
                                                                                                message={`No ${(door?.location_name)?.toLowerCase()} details has been added. ${hasPermissionForAddDoor ? 'Click the Add button to add the details.' : ''}`}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <NoDataCreated
                                                                        message={`No door data found.`}
                                                                    />
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Paint */}
                                                {activeFSFeature?.feature === 'Paint' && (
                                                    <React.Fragment>
                                                        {errorFSPaints ? (
                                                            <ErrorPage errorMessage={errorFSPaints} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsPaints && fsPaints?.length > 0 ? (
                                                                    <React.Fragment>
                                                                        {fsPaintData && fsPaintData !== null && (
                                                                            <div key={`paint_${fsPaintData?.id}`} className="page_sub_content_section">
                                                                                <div className="page_sub_content_header">
                                                                                    <h4 className="page_sub_content_head">
                                                                                        {fsPaintData?.location_name}
                                                                                    </h4>

                                                                                    <div className="page_sub_content_header_btn_area">
                                                                                        {hasPermissionForAddPaint && (
                                                                                            <TableButton
                                                                                                label="Add"
                                                                                                icon="bi bi-plus-lg"
                                                                                                iconClassName="me-2"
                                                                                                onClick={handleAddPaintDetails}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="page_sub_content_body">
                                                                                    {fsPaintData?.data_paint && fsPaintData?.data_paint?.length > 0 ? (
                                                                                        <DataTable
                                                                                            value={fsPaintData?.data_paint}
                                                                                            size="small"
                                                                                            // paginator
                                                                                            // rows={5}
                                                                                            // rowsPerPageOptions={[5, 10, 15, 20]}
                                                                                            // paginatorDropdownAppendTo={"self"}
                                                                                            // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                            // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                            dataKey="id"
                                                                                            className="page_table fs_data_table p-0"
                                                                                            rowClassName={() => 'project_data_row secondary'}
                                                                                            rowHover
                                                                                            scrollable
                                                                                            tableStyle={{ minWidth: "50rem" }}
                                                                                            scrollHeight="490px"
                                                                                            loading={loadingFSPaints}
                                                                                            emptyMessage="No paint data available!"
                                                                                        >
                                                                                            <Column
                                                                                                header="Color"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="color_code"
                                                                                                body={(rowData: FSPaintData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableColorBody(rowData?.color?.color_code || null)}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "10%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Type"
                                                                                                headerClassName="text_purple"
                                                                                                field="type"
                                                                                                body={(rowData: FSPaintData) => (
                                                                                                    <span className="text-capitalize">{rowData?.type ?? "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Price"
                                                                                                headerClassName="text_purple"
                                                                                                alignHeader={'right'}
                                                                                                field="order_data.price"
                                                                                                body={(rowData: FSPaintData) => (
                                                                                                    <span className="position-relative">
                                                                                                        <span className="text_no_wrap flex_end">
                                                                                                            {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                        </span>
                                                                                                        {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                            <span className="vat_label">Inc. VAT</span>
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Brand"
                                                                                                headerClassName="text_purple"
                                                                                                field="brand?.brand_name"
                                                                                                body={(rowData: FSPaintData) => (
                                                                                                    <span className="text-capitalize">{rowData?.brand?.brand_name ?? "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Location"
                                                                                                headerClassName="text_purple"
                                                                                                field="location.location_name"
                                                                                                body={(rowData: FSPaintData) => (
                                                                                                    <span className="text-capitalize">{rowData?.location?.location_name ?? "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Date"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_data.date"
                                                                                                body={(rowData: FSPaintData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderDateBody(
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data?.date!,
                                                                                                            rowData?.order_date_data!
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Order"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_status"
                                                                                                body={(rowData: FSPaintData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderStatusBody(
                                                                                                            `Paint (${rowData?.color?.color_name!})`,
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data!,
                                                                                                            rowData?.id,
                                                                                                            false
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                body={paintDetailTableActionBody}
                                                                                                frozen={window.innerWidth > 575}
                                                                                                alignFrozen="right"
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>
                                                                                        </DataTable>
                                                                                    ) : (
                                                                                        <NoDataCreated
                                                                                            containerClassname="pos_rel sub"
                                                                                            message={`No ${(fsPaintData?.location_name)?.toLowerCase()} details has been added. ${hasPermissionForAddPaint ? 'Click the Add button to add the details.' : ''}`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <NoDataCreated
                                                                        message={`No paint data has been added.`}
                                                                    />
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Bathroom */}
                                                {activeFSFeature?.feature === 'Bathroom' && (
                                                    <React.Fragment>
                                                        {errorFSBathrooms ? (
                                                            <ErrorPage errorMessage={errorFSBathrooms} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsBathrooms && fsBathrooms?.length > 0 ? (
                                                                    <React.Fragment>
                                                                        {activeBathroomLocation && activeBathroomLocation !== null && (
                                                                            <div key={`bathroom_${activeBathroomLocation?.id}`} className="page_sub_content_section">
                                                                                <div className="page_sub_content_header">
                                                                                    <h4 className="page_sub_content_head">
                                                                                        {activeBathroomLocation?.location_name} areas
                                                                                    </h4>

                                                                                    <div className="page_sub_content_header_btn_area">
                                                                                        {hasPermissionForDeleteBathroomLocation && (
                                                                                            <TableButton
                                                                                                label={bathroomLocationDeleteLoadingId === activeBathroomLocation?.id ? 'Processing' : 'Delete'}
                                                                                                icon={bathroomLocationDeleteLoadingId === activeBathroomLocation?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash3'}
                                                                                                disabled={bathroomLocationDeleteLoadingId === activeBathroomLocation?.id}
                                                                                                iconClassName="me-2"
                                                                                                onClick={() => handleDeleteBathroomLocation(activeBathroomLocation)}
                                                                                                tooltip="Delete location"
                                                                                                tooltipTarget={`bathroomLocationDelete_${activeBathroomLocation?.id}`}
                                                                                                tooltipPosition="left"
                                                                                            />
                                                                                        )}

                                                                                        {hasPermissionForAddBathroomFeature && (
                                                                                            <TableButton
                                                                                                label="Add"
                                                                                                icon="bi bi-plus-lg"
                                                                                                iconClassName="me-2"
                                                                                                onClick={() => handleAddBathroomFeature(activeBathroomLocation)}
                                                                                                tooltip="Add area(s)"
                                                                                                tooltipTarget={`bathroomFeatureAdd_${activeBathroomLocation?.id}`}
                                                                                                tooltipPosition="left"
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="page_sub_content_body">
                                                                                    {activeBathroomLocation?.feature_list && activeBathroomLocation?.feature_list?.length > 0 ? (
                                                                                        <div className="page_sub_content_child_area">
                                                                                            {activeBathroomLocation?.feature_list?.map((bathroomFeature) => {
                                                                                                return (
                                                                                                    <div className="page_sub_content_child_container">
                                                                                                        <div className="page_sub_content_header">
                                                                                                            <h4 className="page_sub_content_head">
                                                                                                                <i className="bi bi-arrow-return-right me-2"></i>
                                                                                                                {bathroomFeature?.feature_name}
                                                                                                            </h4>

                                                                                                            <div className="page_sub_content_header_btn_area">
                                                                                                                {hasPermissionForDeleteBathroomFeature && (
                                                                                                                    <TableButton
                                                                                                                        label={bathroomFeatureDeleteLoadingId === bathroomFeature?.id ? 'Processing' : 'Delete'}
                                                                                                                        icon={bathroomFeatureDeleteLoadingId === bathroomFeature?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash3'}
                                                                                                                        disabled={bathroomFeatureDeleteLoadingId === bathroomFeature?.id}
                                                                                                                        iconClassName="me-2"
                                                                                                                        onClick={() => handleDeleteBathroomFeature(bathroomFeature)}
                                                                                                                        className="outlined"
                                                                                                                        tooltip="Delete area"
                                                                                                                        tooltipTarget={`bathroomFeatureDelete_${bathroomFeature?.id}_${activeBathroomLocation?.id}`}
                                                                                                                        tooltipPosition="left"
                                                                                                                    />
                                                                                                                )}

                                                                                                                {hasPermissionForAddBathroomSubFeature && (
                                                                                                                    <TableButton
                                                                                                                        label="Add"
                                                                                                                        icon="bi bi-plus-lg"
                                                                                                                        iconClassName="me-2"
                                                                                                                        onClick={() => handleAddBathroomSubFeature(bathroomFeature)}
                                                                                                                        className="outlined"
                                                                                                                        tooltip="Add feature"
                                                                                                                        tooltipTarget={`bathroomSubFeatureAdd_${bathroomFeature?.id}_${activeBathroomLocation?.id}`}
                                                                                                                        tooltipPosition="left"
                                                                                                                    />
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div className="page_sub_content_body">
                                                                                                            {bathroomFeature?.data_bathroom && bathroomFeature?.data_bathroom?.length > 0 ? (
                                                                                                                <DataTable
                                                                                                                    value={bathroomFeature?.data_bathroom}
                                                                                                                    size="small"
                                                                                                                    // paginator
                                                                                                                    // rows={5}
                                                                                                                    // rowsPerPageOptions={[5, 10, 25, 50]}
                                                                                                                    // paginatorDropdownAppendTo={"self"}
                                                                                                                    // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                                                    // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                                                    // paginatorClassName="custom_pagination"
                                                                                                                    dataKey="id"
                                                                                                                    className="page_table fs_data_table p-0"
                                                                                                                    rowClassName={() => 'project_data_row secondary'}
                                                                                                                    rowHover
                                                                                                                    scrollable
                                                                                                                    tableStyle={{ minWidth: "50rem" }}
                                                                                                                    scrollHeight="490px"
                                                                                                                    loading={loadingFSBathrooms}
                                                                                                                    emptyMessage="No details available!"
                                                                                                                >
                                                                                                                    <Column
                                                                                                                        header="Image"
                                                                                                                        alignHeader={'center'}
                                                                                                                        headerClassName="text_purple"
                                                                                                                        field="image_path"
                                                                                                                        body={(rowData: FSBathroomData) => (
                                                                                                                            <span className="flex_center">
                                                                                                                                {tableImageBody(
                                                                                                                                    rowData?.image_path ? rowData?.image_path :
                                                                                                                                        rowData?.sub_feature?.image_path ?
                                                                                                                                            rowData?.sub_feature?.image_path : null
                                                                                                                                )}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                        style={{ width: "12%" }}
                                                                                                                    ></Column>

                                                                                                                    <Column
                                                                                                                        header="Feature"
                                                                                                                        headerClassName="text_purple"
                                                                                                                        field="sub_feature.sub_feature_name"
                                                                                                                        body={(rowData: FSBathroomData) => (
                                                                                                                            <span className="text-capitalize">
                                                                                                                                {rowData?.sub_feature?.sub_feature_name ?? "---"}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                        style={{ width: "15%" }}
                                                                                                                    ></Column>

                                                                                                                    <Column
                                                                                                                        header="Price"
                                                                                                                        headerClassName="text_purple"
                                                                                                                        alignHeader={'right'}
                                                                                                                        field="order_data.price"
                                                                                                                        body={(rowData: FSBathroomData) => (
                                                                                                                            <span className="text_no_wrap flex_end">
                                                                                                                                <span className="text_no_wrap flex_end">
                                                                                                                                    {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                                                </span>
                                                                                                                                {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                                                    <span className="vat_label">Inc. VAT</span>
                                                                                                                                )}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                        style={{ width: "12%" }}
                                                                                                                    ></Column>

                                                                                                                    <Column
                                                                                                                        header="Name"
                                                                                                                        headerClassName="text_purple"
                                                                                                                        field="name"
                                                                                                                        body={(rowData: FSBathroomData) => (
                                                                                                                            <span className="text-capitalize">
                                                                                                                                {rowData?.name ?? "---"}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                        style={{ width: "15%" }}
                                                                                                                    ></Column>

                                                                                                                    <Column
                                                                                                                        header="Date"
                                                                                                                        alignHeader={'center'}
                                                                                                                        headerClassName="text_purple"
                                                                                                                        field="order_data.date"
                                                                                                                        body={(rowData: FSBathroomData) => (
                                                                                                                            <span className="flex_center">
                                                                                                                                {tableOrderDateBody(
                                                                                                                                    rowData?.order_status,
                                                                                                                                    rowData?.order_data?.date!,
                                                                                                                                    rowData?.order_date_data!
                                                                                                                                )}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                        style={{ width: "12%" }}
                                                                                                                    ></Column>

                                                                                                                    <Column
                                                                                                                        header="Size"
                                                                                                                        headerClassName="text_purple"
                                                                                                                        field="size"
                                                                                                                        body={(rowData: FSBathroomData) => (
                                                                                                                            <span className="text-capitalize">
                                                                                                                                {rowData?.size ?? "---"}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                        style={{ width: "9%" }}
                                                                                                                    ></Column>

                                                                                                                    <Column
                                                                                                                        header="Order"
                                                                                                                        alignHeader={'center'}
                                                                                                                        headerClassName="text_purple"
                                                                                                                        field="order_status"
                                                                                                                        body={(rowData: FSBathroomData) => (
                                                                                                                            <span className="flex_center">
                                                                                                                                {rowData?.is_not_updated === 0 ? (
                                                                                                                                    tableOrderStatusBody(
                                                                                                                                        rowData?.sub_feature?.sub_feature_name!,
                                                                                                                                        rowData?.order_status,
                                                                                                                                        rowData?.order_data!,
                                                                                                                                        rowData?.id,
                                                                                                                                        false
                                                                                                                                    )
                                                                                                                                ) : ('---')}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                        style={{ width: "10%" }}
                                                                                                                    ></Column>

                                                                                                                    <Column
                                                                                                                        body={bathroomDetailTableActionBody}
                                                                                                                        frozen={window.innerWidth > 575}
                                                                                                                        alignFrozen="right"
                                                                                                                        style={{ width: "15%" }}
                                                                                                                    ></Column>
                                                                                                                </DataTable>
                                                                                                            ) : (
                                                                                                                <NoDataCreated
                                                                                                                    containerClassname="pos_rel sub"
                                                                                                                    message={`No ${(bathroomFeature?.feature_name)?.toLowerCase()} feature details has been added. ${hasPermissionForAddBathroomSubFeature ? 'Click the Add button to add the details.' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            })}
                                                                                        </div>
                                                                                    ) : (
                                                                                        <NoDataCreated
                                                                                            containerClassname="pos_rel sub custom_height"
                                                                                            message={`No ${(activeBathroomLocation?.location_name)?.toLowerCase()} features has been added. ${hasPermissionForAddBathroomFeature ? 'Click the Add button to add features.' : ''}`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <div className="page_sub_content_section">
                                                                        <div className="page_sub_content_header">
                                                                            <h4 className="page_sub_content_head">
                                                                                Bathroom
                                                                            </h4>
                                                                        </div>

                                                                        <div className="page_sub_content_body">
                                                                            <NoDataCreated
                                                                                containerClassname="pos_rel sub custom_height"
                                                                                message={`No bathroom location(S) have been added. ${hasPermissionForAddBathroomLocation ? 'Click the Add button to add location(s).' : ''}`}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Kitchen */}
                                                {activeFSFeature?.feature === 'Kitchen' && (
                                                    <React.Fragment>
                                                        {errorFSKitchens ? (
                                                            <ErrorPage errorMessage={errorFSKitchens} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsKitchens && fsKitchens?.length > 0 ? (
                                                                    <React.Fragment>
                                                                        {fsKitchenData && fsKitchenData !== null && (
                                                                            <div className="page_sub_content_section">
                                                                                <div className="page_sub_content_header">
                                                                                    <h4 className="page_sub_content_head">
                                                                                        {fsKitchenData?.location_name}
                                                                                    </h4>

                                                                                    <div className="page_sub_content_header_btn_area">
                                                                                        {hasPermissionForAddKitchen && (
                                                                                            <TableButton
                                                                                                label="Add"
                                                                                                icon="bi bi-plus-lg"
                                                                                                iconClassName="me-2"
                                                                                                onClick={handleAddKitchenDetail}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="page_sub_content_body">
                                                                                    {fsKitchenData?.data_kitchen && fsKitchenData?.data_kitchen?.length > 0 ? (
                                                                                        <DataTable
                                                                                            value={fsKitchenData?.data_kitchen}
                                                                                            size="small"
                                                                                            // paginator
                                                                                            // rows={5}
                                                                                            // rowsPerPageOptions={[5, 10, 15, 20]}
                                                                                            // paginatorDropdownAppendTo={"self"}
                                                                                            // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                            // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                            dataKey="id"
                                                                                            className="page_table fs_data_table p-0"
                                                                                            rowClassName={() => 'project_data_row secondary'}
                                                                                            rowHover
                                                                                            scrollable
                                                                                            tableStyle={{ minWidth: "50rem" }}
                                                                                            scrollHeight="490px"
                                                                                            loading={loadingFSKitchens}
                                                                                            emptyMessage="No kitchen data available!"
                                                                                        >
                                                                                            <Column
                                                                                                header="Image"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="image_path"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableImageBody(rowData?.image_path || null)}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "10%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Category"
                                                                                                headerClassName="text_purple"
                                                                                                field="category"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="text-capitalize">{rowData?.category ? rowData?.category : "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Price"
                                                                                                headerClassName="text_purple"
                                                                                                alignHeader={'right'}
                                                                                                field="order_data.price"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="position-relative">
                                                                                                        <span className="text_no_wrap flex_end">
                                                                                                            {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                        </span>
                                                                                                        {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                            <span className="vat_label">Inc. VAT</span>
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Brand"
                                                                                                headerClassName="text_purple"
                                                                                                field="brand.brand_name"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="text-capitalize">{rowData?.brand?.brand_name ? rowData?.brand?.brand_name : "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Color"
                                                                                                headerClassName="text_purple"
                                                                                                field="color.color_name"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="text-capitalize">{rowData?.color?.color_name ? rowData?.color?.color_name : "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Date"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_data.date"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderDateBody(
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data?.date!,
                                                                                                            rowData?.order_date_data!
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Order"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_status"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderStatusBody(
                                                                                                            `Kitchen (${rowData?.category!})`,
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data!,
                                                                                                            rowData?.id,
                                                                                                            false
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                body={kitchenDetailTableActionBody}
                                                                                                frozen={window.innerWidth > 575}
                                                                                                alignFrozen="right"
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>
                                                                                        </DataTable>
                                                                                    ) : (
                                                                                        <NoDataCreated
                                                                                            containerClassname="pos_rel sub"
                                                                                            message={`No kitchen details has been added. ${hasPermissionForAddKitchen ? 'Click the Add button to add the details.' : ''}`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {fsKitchenApplianceData && fsKitchenApplianceData !== null && (
                                                                            <div className="page_sub_content_section">
                                                                                <div className="page_sub_content_header">
                                                                                    <h4 className="page_sub_content_head">
                                                                                        {fsKitchenApplianceData?.location_name}
                                                                                    </h4>

                                                                                    <div className="page_sub_content_header_btn_area">
                                                                                        {hasPermissionForAddKitchenAppliance && (
                                                                                            <TableButton
                                                                                                label="Add"
                                                                                                icon="bi bi-plus-lg"
                                                                                                iconClassName="me-2"
                                                                                                onClick={handleAddKitchenApplianceDetails}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="page_sub_content_body">
                                                                                    {fsKitchenApplianceData?.data_kitchen && fsKitchenApplianceData?.data_kitchen?.length > 0 ? (
                                                                                        <DataTable
                                                                                            value={fsKitchenApplianceData?.data_kitchen}
                                                                                            size="small"
                                                                                            // paginator
                                                                                            // rows={5}
                                                                                            // rowsPerPageOptions={[5, 10, 15, 20]}
                                                                                            // paginatorDropdownAppendTo={"self"}
                                                                                            // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                            // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                            dataKey="id"
                                                                                            className="page_table fs_data_table p-0"
                                                                                            rowClassName={() => 'project_data_row secondary'}
                                                                                            rowHover
                                                                                            scrollable
                                                                                            tableStyle={{ minWidth: "50rem" }}
                                                                                            scrollHeight="490px"
                                                                                            loading={loadingFSKitchens}
                                                                                            emptyMessage="No kitchen appliance data available!"
                                                                                        >
                                                                                            <Column
                                                                                                header="Image"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="image_path"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableImageBody(rowData?.image_path || null)}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "10%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Appliance"
                                                                                                headerClassName="text_purple"
                                                                                                field="appliance.appliance_name"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="text-capitalize">{rowData?.appliance?.appliance_name ? rowData?.appliance?.appliance_name : "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Price"
                                                                                                headerClassName="text_purple"
                                                                                                alignHeader={'right'}
                                                                                                field="order_data.price"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="position-relative">
                                                                                                        <span className="text_no_wrap flex_end">
                                                                                                            {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                        </span>
                                                                                                        {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                            <span className="vat_label">Inc. {vatPercentage}% VAT</span>
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Brand"
                                                                                                headerClassName="text_purple"
                                                                                                field="brand.brand_name"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="text-capitalize">{rowData?.brand?.brand_name ? rowData?.brand?.brand_name : "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Name"
                                                                                                headerClassName="text_purple"
                                                                                                field="name"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="text-capitalize">{rowData?.name ? rowData?.name : "---"}</span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Date"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_data.date"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderDateBody(
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data?.date!,
                                                                                                            rowData?.order_date_data!
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Order"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_status"
                                                                                                body={(rowData: FSKitchenData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderStatusBody(
                                                                                                            `Kitchen (${rowData?.category!})`,
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data!,
                                                                                                            rowData?.id,
                                                                                                            false
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                body={kitchenApplianceDetailTableActionBody}
                                                                                                frozen={window.innerWidth > 575}
                                                                                                alignFrozen="right"
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>
                                                                                        </DataTable>
                                                                                    ) : (
                                                                                        <NoDataCreated
                                                                                            containerClassname="pos_rel sub"
                                                                                            message={`No kitchen appliance details has been added. ${hasPermissionForAddKitchenAppliance ? 'Click the Add button to add the details.' : ''}`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <NoDataCreated
                                                                        message={`No kitchen data has been added.`}
                                                                    />
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Tiles */}
                                                {activeFSFeature?.feature === 'Tiles' && (
                                                    <React.Fragment>
                                                        {errorFSTiles ? (
                                                            <ErrorPage errorMessage={errorFSTiles} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsTilesData && fsTilesData?.length > 0 ? (
                                                                    <React.Fragment>
                                                                        {activeTileLocation && activeTileLocation !== null && (
                                                                            <div key={`tile_${activeTileLocation?.id}`} className="page_sub_content_section">
                                                                                <div className="page_sub_content_header">
                                                                                    <h4 className="page_sub_content_head">
                                                                                        {activeTileLocation?.location_name}
                                                                                    </h4>

                                                                                    <div className="page_sub_content_header_btn_area">
                                                                                        {hasPermissionForUpdateTileLocation && (
                                                                                            <TableButton
                                                                                                label="Edit"
                                                                                                icon="bi bi-pencil-square"
                                                                                                iconClassName="me-2"
                                                                                                onClick={() => handleEditTileLocation(activeTileLocation)}
                                                                                            />
                                                                                        )}

                                                                                        {hasPermissionForAddTile && (
                                                                                            <TableButton
                                                                                                label="Add"
                                                                                                icon="bi bi-plus-lg"
                                                                                                iconClassName="me-2"
                                                                                                onClick={() => handleAddTileDetail(activeTileLocation)}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="page_sub_content_body">
                                                                                    {activeTileLocation?.data_tile && activeTileLocation?.data_tile?.length > 0 ? (
                                                                                        <DataTable
                                                                                            value={activeTileLocation?.data_tile}
                                                                                            size="small"
                                                                                            // paginator
                                                                                            // rows={5}
                                                                                            // rowsPerPageOptions={[5, 10, 25, 50]}
                                                                                            // paginatorDropdownAppendTo={"self"}
                                                                                            // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                            // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                            dataKey="id"
                                                                                            className="page_table fs_data_table p-0"
                                                                                            rowClassName={() => 'project_data_row secondary'}
                                                                                            rowHover
                                                                                            scrollable
                                                                                            tableStyle={{ minWidth: "50rem" }}
                                                                                            scrollHeight="490px"
                                                                                            loading={loadingFSTiles}
                                                                                            emptyMessage="No tiles data available!"
                                                                                        >
                                                                                            <Column
                                                                                                header="Image"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="image_path"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableImageBody(rowData?.image_path || null)}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "10%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Type"
                                                                                                headerClassName="text_purple"
                                                                                                field="type.type_name"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="text-capitalize">
                                                                                                        {rowData?.type?.type_name ? rowData?.type?.type_name : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Price"
                                                                                                headerClassName="text_purple"
                                                                                                alignHeader={'right'}
                                                                                                field="order_data.price"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="position-relative">
                                                                                                        <span className="text_no_wrap flex_end">
                                                                                                            {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                        </span>
                                                                                                        {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                            <span className="vat_label">Inc. VAT</span>
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Name"
                                                                                                headerClassName="text_purple"
                                                                                                field="name"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="text-capitalize">
                                                                                                        {rowData?.name ? rowData?.name : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="QTY"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="quantity"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {rowData?.quantity ? String(rowData?.quantity).padStart(2, '0') : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "6%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Size"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="size"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {rowData?.size ? `${String(rowData?.size).padStart(2, '0')}sqm` : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "6%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Date"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_data.date"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderDateBody(
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data?.date!,
                                                                                                            rowData?.order_date_data!
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Order"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_status"
                                                                                                body={(rowData: FSTileData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderStatusBody(
                                                                                                            `Tile (${rowData?.type?.type_name!})`,
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data!,
                                                                                                            rowData?.id,
                                                                                                            false
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "12%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                body={tileDetailTableActionBody}
                                                                                                frozen={window.innerWidth > 575}
                                                                                                alignFrozen="right"
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>
                                                                                        </DataTable>
                                                                                    ) : (
                                                                                        <NoDataCreated
                                                                                            containerClassname="pos_rel sub"
                                                                                            message={`No ${(activeTileLocation?.location_name)?.toLowerCase()} details has been added. ${hasPermissionForAddTile ? 'Click the Add button to add the details.' : ''}`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <div className="page_sub_content_section">
                                                                        <div className="page_sub_content_header">
                                                                            <h4 className="page_sub_content_head">
                                                                                Tiles
                                                                            </h4>
                                                                        </div>

                                                                        <div className="page_sub_content_body">
                                                                            <NoDataCreated
                                                                                containerClassname="pos_rel sub"
                                                                                message={`No tile location has been added. ${hasPermissionForAddTileLocation ? 'Click the Add button to add the location.' : ''}`}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Floor Finishing */}
                                                {activeFSFeature?.feature === 'Floor Finishing' && (
                                                    <React.Fragment>
                                                        {errorFSFloorFinishing ? (
                                                            <ErrorPage errorMessage={errorFSFloorFinishing} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsFloorFinishing && fsFloorFinishing !== null ? (
                                                                    <div className="page_sub_content_section">
                                                                        <div className="page_sub_content_header">
                                                                            <h4 className="page_sub_content_head">
                                                                                Floor finishing
                                                                            </h4>

                                                                            <div className="page_sub_content_header_btn_area">
                                                                                {hasPermissionForAddFloorFinishing && (
                                                                                    <TableButton
                                                                                        label="Add"
                                                                                        icon="bi bi-plus-lg"
                                                                                        iconClassName="me-2"
                                                                                        onClick={handleAddFloorFinishingDetails}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                        <div className="page_sub_content_body">
                                                                            {floorFinishingData && floorFinishingData?.length > 0 ? (
                                                                                <DataTable
                                                                                    value={floorFinishingData}
                                                                                    size="small"
                                                                                    // paginator
                                                                                    // rows={5}
                                                                                    // rowsPerPageOptions={[5, 10, 25, 50]}
                                                                                    // paginatorDropdownAppendTo={"self"}
                                                                                    // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                    // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                    dataKey="id"
                                                                                    className="page_table fs_data_table p-0"
                                                                                    rowClassName={() => 'project_data_row secondary'}
                                                                                    rowHover
                                                                                    scrollable
                                                                                    tableStyle={{ minWidth: "50rem" }}
                                                                                    scrollHeight="490px"
                                                                                    loading={loadingFSFloorFinishing}
                                                                                    emptyMessage="No floor finishing data available!"
                                                                                >
                                                                                    <Column
                                                                                        header="Image"
                                                                                        alignHeader={'center'}
                                                                                        headerClassName="text_purple"
                                                                                        field="image_path"
                                                                                        body={(rowData: FSFloorFinishingData) => (
                                                                                            <span className="flex_center">
                                                                                                {tableImageBody(rowData?.image_path || null)}
                                                                                            </span>
                                                                                        )}
                                                                                        style={{ width: "10%" }}
                                                                                    ></Column>

                                                                                    <Column
                                                                                        header="Location"
                                                                                        headerClassName="text_purple"
                                                                                        body={(rowData: FSFloorFinishingData) => (
                                                                                            <span className="text-capitalize">
                                                                                                {rowData?.location?.location_name ? rowData?.location?.location_name : "---"}
                                                                                            </span>
                                                                                        )}
                                                                                        style={{ width: "12%" }}
                                                                                    ></Column>

                                                                                    <Column
                                                                                        header="Price"
                                                                                        headerClassName="text_purple"
                                                                                        alignHeader={'right'}
                                                                                        field="order_data.price"
                                                                                        body={(rowData: FSFloorFinishingData) => (
                                                                                            <span className="position-relative">
                                                                                                <span className="text_no_wrap flex_end">
                                                                                                    {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                </span>
                                                                                                {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                    <span className="vat_label">Inc. VAT</span>
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                        style={{ width: "12%" }}
                                                                                    ></Column>

                                                                                    <Column
                                                                                        header="Type"
                                                                                        headerClassName="text_purple"
                                                                                        field="type.type_name"
                                                                                        body={(rowData: FSFloorFinishingData) => (
                                                                                            <span className="text-capitalize">
                                                                                                {rowData?.type?.type_name ? rowData?.type?.type_name : "---"}
                                                                                            </span>
                                                                                        )}
                                                                                        style={{ width: "12%" }}
                                                                                    ></Column>

                                                                                    <Column
                                                                                        header="Name"
                                                                                        headerClassName="text_purple"
                                                                                        field="name"
                                                                                        body={(rowData: FSFloorFinishingData) => (
                                                                                            <span className="text-capitalize">
                                                                                                {rowData?.name ? rowData?.name : "---"}
                                                                                            </span>
                                                                                        )}
                                                                                        style={{ width: "12%" }}
                                                                                    ></Column>

                                                                                    <Column
                                                                                        header="Date"
                                                                                        alignHeader={'center'}
                                                                                        headerClassName="text_purple"
                                                                                        field="order_data.date"
                                                                                        body={(rowData: FSFloorFinishingData) => (
                                                                                            <span className="flex_center">
                                                                                                {tableOrderDateBody(
                                                                                                    rowData?.order_status,
                                                                                                    rowData?.order_data?.date!,
                                                                                                    rowData?.order_date_data!
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                        style={{ width: "15%" }}
                                                                                    ></Column>

                                                                                    <Column
                                                                                        header="Order"
                                                                                        alignHeader={'center'}
                                                                                        headerClassName="text_purple"
                                                                                        field="order_status"
                                                                                        body={(rowData: FSFloorFinishingData) => (
                                                                                            <span className="flex_center">
                                                                                                {tableOrderStatusBody(
                                                                                                    `Floor finishing (${rowData?.location?.location_name!})`,
                                                                                                    rowData?.order_status,
                                                                                                    rowData?.order_data!,
                                                                                                    rowData?.id,
                                                                                                    false
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                        style={{ width: "12%" }}
                                                                                    ></Column>

                                                                                    <Column
                                                                                        body={floorFinishingDetailTableActionBody}
                                                                                        frozen={window.innerWidth > 575}
                                                                                        alignFrozen="right"
                                                                                        style={{ width: "15%" }}
                                                                                    ></Column>
                                                                                </DataTable>
                                                                            ) : (
                                                                                <NoDataCreated
                                                                                    containerClassname="pos_rel sub"
                                                                                    message={`No floor finishing details has been added. ${hasPermissionForAddFloorFinishing ? 'Click the Add button to add the details.' : ''}`}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <NoDataCreated
                                                                        message={`No floor finishing data found.`}
                                                                    />
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Others */}
                                                {activeFSFeature?.feature === 'Others' && (
                                                    <React.Fragment>
                                                        {errorFSOthers ? (
                                                            <ErrorPage errorMessage={errorFSOthers} />
                                                        ) : (
                                                            <React.Fragment>
                                                                {fsOthersData && fsOthersData?.length > 0 ? (
                                                                    <React.Fragment>
                                                                        {activeOtherLocation && activeOtherLocation !== null && (
                                                                            <div key={`others_${activeOtherLocation?.id}`} className="page_sub_content_section">
                                                                                <div className="page_sub_content_header">
                                                                                    <h4 className="page_sub_content_head">
                                                                                        {activeOtherLocation?.location_name}
                                                                                    </h4>

                                                                                    <div className="page_sub_content_header_btn_area">
                                                                                        {hasPermissionForDeleteOthersLocation && (
                                                                                            <TableButton
                                                                                                label={otherLocationDeleteLoadingId === activeOtherLocation?.id ? 'Processing' : 'Delete'}
                                                                                                icon={otherLocationDeleteLoadingId === activeOtherLocation?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash3'}
                                                                                                disabled={otherLocationDeleteLoadingId === activeOtherLocation?.id}
                                                                                                iconClassName="me-2"
                                                                                                onClick={() => handleDeleteOtherLocation(activeOtherLocation)}
                                                                                                tooltip="Delete Location"
                                                                                                tooltipTarget={`otherLocationDelete_${activeOtherLocation?.id}`}
                                                                                                tooltipPosition="left"
                                                                                            />
                                                                                        )}

                                                                                        {hasPermissionForAddOthers && (
                                                                                            <TableButton
                                                                                                label="Add"
                                                                                                icon="bi bi-plus-lg"
                                                                                                iconClassName="me-2"
                                                                                                onClick={handleAddOtherDetail}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="page_sub_content_body">
                                                                                    {activeOtherLocation?.data_other && activeOtherLocation?.data_other?.length > 0 ? (
                                                                                        <DataTable
                                                                                            value={activeOtherLocation?.data_other}
                                                                                            size="small"
                                                                                            // paginator
                                                                                            // rows={5}
                                                                                            // rowsPerPageOptions={[5, 10, 25, 50]}
                                                                                            // paginatorDropdownAppendTo={"self"}
                                                                                            // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                                            // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                                            dataKey="id"
                                                                                            className="page_table fs_data_table p-0"
                                                                                            rowClassName={() => 'project_data_row secondary'}
                                                                                            rowHover
                                                                                            scrollable
                                                                                            tableStyle={{ minWidth: "50rem" }}
                                                                                            scrollHeight="490px"
                                                                                            loading={loadingFSOthers}
                                                                                            emptyMessage="No other data available!"
                                                                                        >
                                                                                            <Column
                                                                                                header="Image"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="image_path"
                                                                                                body={(rowData: FSOtherData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableImageBody(rowData?.image_path || null)}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "10%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Flooring Screed"
                                                                                                headerClassName="text_purple"
                                                                                                field="flooring_screed"
                                                                                                body={(rowData: FSOtherData) => (
                                                                                                    <span className="text-capitalize">
                                                                                                        {rowData?.flooring_screed ? rowData?.flooring_screed : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Price"
                                                                                                headerClassName="text_purple"
                                                                                                alignHeader={'right'}
                                                                                                field="order_data.price"
                                                                                                body={(rowData: FSOtherData) => (
                                                                                                    <span className="position-relative">
                                                                                                        <span className="text_no_wrap flex_end">
                                                                                                            {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                                        </span>
                                                                                                        {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                                            <span className="vat_label">Inc. VAT</span>
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="No."
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="number"
                                                                                                body={(rowData: FSOtherData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {rowData?.number ? String(rowData?.number).padStart(2, '0') : "---"}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "10%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Date"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_data.date"
                                                                                                body={(rowData: FSOtherData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderDateBody(
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data?.date!,
                                                                                                            rowData?.order_date_data!
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                header="Order"
                                                                                                alignHeader={'center'}
                                                                                                headerClassName="text_purple"
                                                                                                field="order_status"
                                                                                                body={(rowData: FSOtherData) => (
                                                                                                    <span className="flex_center">
                                                                                                        {tableOrderStatusBody(
                                                                                                            `Other (${rowData?.brand?.brand_name!})`,
                                                                                                            rowData?.order_status,
                                                                                                            rowData?.order_data!,
                                                                                                            rowData?.id,
                                                                                                            false
                                                                                                        )}
                                                                                                    </span>
                                                                                                )}
                                                                                                style={{ width: "15%" }}
                                                                                            ></Column>

                                                                                            <Column
                                                                                                body={otherDetailTableActionBody}
                                                                                                frozen={window.innerWidth > 575}
                                                                                                alignFrozen="right"
                                                                                                style={{ width: "20%" }}
                                                                                            ></Column>
                                                                                        </DataTable>
                                                                                    ) : (
                                                                                        <NoDataCreated
                                                                                            containerClassname="pos_rel sub custom_height"
                                                                                            message={`No ${(activeOtherLocation?.location_name)?.toLowerCase()} details has been added. ${hasPermissionForAddOthers ? 'Click the Add button to add the details.' : ''}`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <div className="page_sub_content_section">
                                                                        <div className="page_sub_content_header">
                                                                            <h4 className="page_sub_content_head">
                                                                                Others
                                                                            </h4>
                                                                        </div>

                                                                        <div className="page_sub_content_body">
                                                                            <NoDataCreated
                                                                                containerClassname="pos_rel sub custom_height"
                                                                                message={`No other location has been added. ${hasPermissionForAddOthersLocation ? 'Click the Add button to add the location(s).' : ''}`}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )}

                                                {/* Accessory data */}
                                                {(activeFSFeature?.feature === 'Door' ||
                                                    activeFSFeature?.feature === 'Paint' ||
                                                    activeFSFeature?.feature === 'Tiles' ||
                                                    activeFSFeature?.feature === 'Floor Finishing') && (
                                                        <div className="page_sub_content_section">
                                                            <div className="page_sub_content_header">
                                                                <h4 className="page_sub_content_head">
                                                                    {activeFSFeature?.feature} Accessory
                                                                </h4>

                                                                <div className="page_sub_content_header_btn_area">
                                                                    {hasPermissionForAddAccessoryDetail && (
                                                                        <TableButton
                                                                            label="Add"
                                                                            icon="bi bi-plus-lg"
                                                                            iconClassName="me-2"
                                                                            onClick={handleAddAccessoryDetails}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="page_sub_content_body">
                                                                {fsDataAccessory && fsDataAccessory?.length > 0 ? (
                                                                    <DataTable
                                                                        value={fsDataAccessory}
                                                                        size="small"
                                                                        // paginator
                                                                        // rows={5}
                                                                        // rowsPerPageOptions={[5, 10, 15, 20]}
                                                                        // paginatorDropdownAppendTo={"self"}
                                                                        // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                                        // currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                                        dataKey="id"
                                                                        className="page_table fs_data_table p-0"
                                                                        rowClassName={() => 'project_data_row secondary'}
                                                                        rowHover
                                                                        scrollable
                                                                        tableStyle={{ minWidth: "50rem" }}
                                                                        scrollHeight="490px"
                                                                        loading={loadingAccessoryData}
                                                                        emptyMessage="No accessories data found!"
                                                                    >
                                                                        <Column
                                                                            header="Image"
                                                                            alignHeader={'center'}
                                                                            headerClassName="text_purple"
                                                                            field="image_path"
                                                                            body={(rowData: FSAccessoryData) => (
                                                                                <span className="flex_center">
                                                                                    {tableImageBody(rowData?.image_path || null)}
                                                                                </span>
                                                                            )}
                                                                            style={{ width: "12%" }}
                                                                        ></Column>

                                                                        <Column
                                                                            header="Accessory"
                                                                            headerClassName="text_purple"
                                                                            field="accessory.accessory_name"
                                                                            body={(rowData: FSAccessoryData) => (
                                                                                <span className="text-capitalize">
                                                                                    {rowData?.accessory?.accessory_name ? rowData?.accessory?.accessory_name : "---"}
                                                                                </span>
                                                                            )}
                                                                            style={{ width: "12%" }}
                                                                        ></Column>

                                                                        <Column
                                                                            header="Price"
                                                                            headerClassName="text_purple"
                                                                            alignHeader={'right'}
                                                                            field="order_data.price"
                                                                            body={(rowData: FSAccessoryData) => (
                                                                                <span className="position-relative">
                                                                                    <span className="text_no_wrap flex_end">
                                                                                        {currencySymbol} {rowData?.order_data ? (rowData?.order_data?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                                                                    </span>
                                                                                    {rowData?.order_data && rowData?.order_data?.is_include_vat === 1 && (
                                                                                        <span className="vat_label">Inc. VAT</span>
                                                                                    )}
                                                                                </span>
                                                                            )}
                                                                            style={{ width: "12%" }}
                                                                        ></Column>

                                                                        <Column
                                                                            header="No."
                                                                            alignHeader={'center'}
                                                                            headerClassName="text_purple"
                                                                            field="number"
                                                                            body={(rowData: FSAccessoryData) => (
                                                                                <span className="flex_center">
                                                                                    {rowData?.number ? String(rowData?.number).padStart(2, '0') : "---"}
                                                                                </span>
                                                                            )}
                                                                            style={{ width: "10%" }}
                                                                        ></Column>

                                                                        <Column
                                                                            header="Sub Acc."
                                                                            headerClassName="text_purple"
                                                                            field="accessory_sub.accessory_sub_name"
                                                                            body={(rowData: FSAccessoryData) => (
                                                                                <span className="text-capitalize">
                                                                                    {rowData?.accessory_sub?.accessory_sub_name ? rowData?.accessory_sub?.accessory_sub_name : "---"}
                                                                                </span>
                                                                            )}
                                                                            style={{ width: "12%" }}
                                                                        ></Column>

                                                                        <Column
                                                                            header="Date"
                                                                            alignHeader={'center'}
                                                                            headerClassName="text_purple"
                                                                            field="order_data.date"
                                                                            body={(rowData: FSAccessoryData) => (
                                                                                <span className="flex_center">
                                                                                    {tableOrderDateBody(
                                                                                        rowData?.order_status,
                                                                                        rowData?.order_data?.date!,
                                                                                        rowData?.order_date_data!
                                                                                    )}
                                                                                </span>
                                                                            )}
                                                                            style={{ width: "15%" }}
                                                                        ></Column>

                                                                        <Column
                                                                            header="Order"
                                                                            alignHeader={'center'}
                                                                            headerClassName="text_purple"
                                                                            field="order_status"
                                                                            body={(rowData: FSAccessoryData) => (
                                                                                <span className="flex_center">
                                                                                    {tableOrderStatusBody(
                                                                                        `Accessory (${rowData?.accessory?.accessory_name!})`,
                                                                                        rowData?.order_status,
                                                                                        rowData?.order_data!,
                                                                                        rowData?.id,
                                                                                        true
                                                                                    )}
                                                                                </span>
                                                                            )}
                                                                            style={{ width: "12%" }}
                                                                        ></Column>

                                                                        <Column
                                                                            body={accessoryDetailTableActionBody}
                                                                            frozen={window.innerWidth > 575}
                                                                            alignFrozen="right"
                                                                            style={{ width: "15%" }}
                                                                        ></Column>
                                                                    </DataTable>
                                                                ) : (
                                                                    <NoDataCreated
                                                                        containerClassname="pos_rel sub"
                                                                        message={`No accessory details has been added to the ${(activeFSFeature?.feature)?.toLowerCase()}. Click the Add button to add the details.`}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </React.Fragment>
                                        )}
                                    </article>
                                ) : (
                                    <article className="page_main_content_section mt-3">
                                        <NoDataCreated
                                            message={`No features have been added yet. ${hasPermissionForAddMainFeature ? 'Click the Add button to add a feature.' : ''} `}
                                        />
                                    </article>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                )}
            </div>


            {/* Finishing schedule main feature list modal */}
            <Dialog
                visible={showFSMainFeatureListModal}
                header={fsMainFeatureModalHeader}
                footer={fsMainFeatureModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_xsm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseFSMainFeatureListModal}
                dismissableMask
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header custom">
                        <DataListModalSearch
                            key={`fsMainFeatureSearchKey`}
                            inputId="fsMainFeatureSearchKey"
                            value={fsMainFeatureSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSMainFeatureSearchKey(e.target.value)}
                            placeholder="Search feature by name"
                            onClear={() => setFSMainFeatureSearchKey("")}
                        />
                    </div>

                    {loadingFSMainFeatures ? (
                        <CustomTableLoader />
                    ) : errorFSMainFeatures ? (
                        <div className="data_select_modal_body">
                            <DataException
                                message={errorFSMainFeatures}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body">
                            {fsMainFeatureData && fsMainFeatureData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsMainFeatureData?.map((feature) => (
                                        <div key={`feature_${feature?.id}`} className="data_select_option_check_area">
                                            <Checkbox
                                                onChange={(e) => handleSelectFSMainFeatures(feature, e.checked || false)}
                                                checked={isSelectedFSMainFeature(feature) || isAlreadyExistFSMainFeature(feature)}
                                                disabled={isAlreadyExistFSMainFeature(feature)}
                                            ></Checkbox>

                                            <div
                                                className={`data_select_option p-ripple 
                                                    ${isSelectedFSMainFeature(feature) ? "selected" : ""}
                                                    ${isAlreadyExistFSMainFeature(feature) ? "disabled selected" : ""}
                                                `}
                                                onClick={() => !isAlreadyExistFSMainFeature(feature) && handleSelectFSMainFeatures(feature, !isSelectedFSMainFeature(feature))}
                                            >
                                                <span>{feature?.feature}</span>
                                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsMainFeatureSearchKey ? 'The feature you were looking for is not found!' : `No features found.`}
                                />
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* ******************************************************************** Light */}
            {/* Light location modal */}
            <Dialog
                visible={showLightLocationModal}
                header={lightLocationModalHeader}
                footer={lightLocationModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseLightLocationModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Location */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label
                                        htmlFor="lightLocation"
                                        className="custom_form_label is_required"
                                    >
                                        Location(s)
                                    </label>
                                    <div className="input_with_button_area">
                                        <InputText
                                            key={`lightLocation`}
                                            id="lightLocation"
                                            value={selectedFSLocations?.length > 0 ?
                                                selectedFSLocations.map(location => location.location_name).join(', ') : ""}
                                            className="custom_form_input has_add_value"
                                            placeholder="Click to select location(s)."
                                            readOnly={true}
                                            autoComplete="off"
                                            onClick={handleAddMultiLocation}
                                        />
                                        <button
                                            className="add_value_btn p-ripple"
                                            onClick={handleAddMultiLocation}
                                        >
                                            {selectedFSLocations?.length === 0 ? (
                                                <React.Fragment>
                                                    <i className="bi bi-plus-lg"></i>
                                                    <span>Add</span>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <i className="bi bi-pencil-square"></i>
                                                    <span>Change</span>
                                                </React.Fragment>
                                            )}
                                            <Ripple />
                                        </button>
                                    </div>

                                    {lightLocationError && (
                                        <small className="form_error_msg">{lightLocationError}</small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}

            {/* Light details modal */}
            <Dialog
                visible={showLightDetailModal}
                header={lightDetailModalHeader}
                footer={lightDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseLightDetailModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Item */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`lightItem`}
                                    inputId="lightItem"
                                    label="Item"
                                    value={selectedFSItem}
                                    displayKey="item_name"
                                    onAdd={handleAddItem}
                                    required={true}
                                    placeHolder="Click to select the item"
                                    error={lightItemError}
                                />
                            </div>

                            {/* Number */}
                            <div className="col-12 col-sm-6">
                                <NumberInput
                                    key={'lightNumber'}
                                    inputId="lightNumber"
                                    label="Number"
                                    labelHtmlFor="lightNumber"
                                    placeholder="Enter number"
                                    onChange={(e: InputNumberChangeEvent) => setLightNumber(e.value || null)}
                                    value={lightNumber}
                                    required={true}
                                    min={0}
                                    error={lightNumberError}
                                />
                            </div>

                            {/* Type */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`lightType`}
                                    inputId="lightType"
                                    label="Type"
                                    value={selectedFSType}
                                    displayKey="type_name"
                                    onAdd={handleAddType}
                                    required={true}
                                    placeHolder="Click to select the type"
                                    error={lightTypeError}
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'lightLink'}
                                    id="lightLink"
                                    label="Link"
                                    labelHtmlFor="lightLink"
                                    required={false}
                                    value={lightLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLightLink(e.target.value || null)}
                                    error={lightLinkError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="lightFiles"
                                    label="File(s)"
                                    labelHtmlFor="lightFiles"
                                    required={false}
                                    value={lightFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadLightFiles}
                                    onClear={handleClearLightFiles}
                                    toast={toast}
                                    error={lightFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`lightImageFile`}
                                    id="lightImageFile"
                                    label="Image"
                                    labelHtmlFor="lightImageFile"
                                    required={false}
                                    value={lightImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadLightImageFile}
                                    onClear={handleClearLightImageFile}
                                    toast={toast}
                                    error={lightImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Door */}
            {/* Door details modal */}
            <Dialog
                visible={showDoorDetailModal}
                header={doorDetailModalHeader}
                footer={doorDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseDoorDetailModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Color */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`doorColor`}
                                    inputId="doorColor"
                                    label="Color"
                                    value={selectedFSColor}
                                    displayKey="color_name"
                                    onAdd={handleAddColor}
                                    required={true}
                                    placeHolder="Click to select the color"
                                    error={doorColorError}
                                    inputClassName={selectedFSColor ? 'has_color_display' : ''}
                                    hasColorDisplay
                                    colorDisplayKey="color_code"
                                />
                            </div>

                            {/* Door fire resistance rating */}
                            <div className="col-12 col-sm-6">
                                <div className="page_form_group">
                                    <div className="response_state_area custom mb-2">
                                        <div className="response_state">
                                            <Checkbox
                                                inputId="FD30"
                                                className="checkbox_lg"
                                                name="doorFireResistanceRating"
                                                value="FD30"
                                                onChange={() => handleCheckboxChange('FD30')}
                                                checked={doorFireResistanceRating === 'FD30'}
                                            />
                                            <label htmlFor="FD30">FD30</label>
                                        </div>
                                        <div className="response_state">
                                            <Checkbox
                                                inputId="FD60"
                                                className="checkbox_lg"
                                                name="doorFireResistanceRating"
                                                value="FD60"
                                                onChange={() => handleCheckboxChange('FD60')}
                                                checked={doorFireResistanceRating === 'FD60'}
                                            />
                                            <label htmlFor="FD60">FD60</label>
                                        </div>
                                    </div>

                                    {doorFireResistanceRatingError && (
                                        <small className="form_error_msg">{doorFireResistanceRatingError}</small>
                                    )}
                                </div>
                            </div>

                            {/* Door size */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <div className="page_form_label_area">
                                        <label htmlFor="doorSize" className="custom_form_label is_required">Size</label>

                                        <div className="page_radio_option_group custom">
                                            <div className="page_radio_option_item as_label">
                                                <RadioButton
                                                    inputId="standardSize"
                                                    name="doorSizeType"
                                                    value="Standard size"
                                                    onChange={(e: RadioButtonChangeEvent) => setDoorSizeType(e.value)}
                                                    checked={doorSizeType === 'Standard size'}
                                                />
                                                <label htmlFor="standardSize">Standard size</label>
                                            </div>

                                            <div className="page_radio_option_item as_label">
                                                <RadioButton
                                                    inputId="nonStandardSize"
                                                    name="doorSizeType"
                                                    value="Non standard size"
                                                    onChange={(e: RadioButtonChangeEvent) => {
                                                        setDoorSizeType(e.value);
                                                        setDoorSize(null);
                                                    }}
                                                    checked={doorSizeType === 'Non standard size'}
                                                />
                                                <label htmlFor="nonStandardSize">Non standard size</label>
                                            </div>
                                        </div>
                                    </div>

                                    {doorSizeType === 'Standard size' ? (
                                        <React.Fragment>
                                            <Dropdown
                                                id="doorSize"
                                                value={doorSize}
                                                onChange={(e: DropdownChangeEvent) => setDoorSize(e.value)}
                                                options={fsDoorSizes}
                                                panelClassName="status_option_panel"
                                                optionLabel="size_name"
                                                placeholder="Select size"
                                                className="form_dropdown w-100"
                                                showClear
                                                loading={loadingFSDoorSizes}
                                            />

                                            {errorFSDoorSizes &&
                                                <small className="form_error_msg">{errorFSDoorSizes}</small>
                                            }

                                            {doorSizeError &&
                                                <small className="form_error_msg">{doorSizeError}</small>
                                            }
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <InputText
                                                key={`doorManualSize`}
                                                id="doorManualSize"
                                                value={doorManualSize}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDoorManualSize(e.target.value)}
                                                className="custom_form_input"
                                                placeholder="Enter size"
                                            />

                                            {doorManualSizeError &&
                                                <small className="form_error_msg">{doorManualSizeError}</small>
                                            }
                                        </React.Fragment>
                                    )}

                                    {doorSizeTypeError &&
                                        <small className="form_error_msg">{doorSizeTypeError}</small>
                                    }
                                </div>
                            </div>

                            {/* Number */}
                            <div className="col-12 col-sm-6">
                                <NumberInput
                                    key={'doorNumber'}
                                    inputId="doorNumber"
                                    label="Number"
                                    labelHtmlFor="doorNumber"
                                    placeholder="Enter number"
                                    onChange={(e: InputNumberChangeEvent) => setDoorNumber(e.value || null)}
                                    value={doorNumber}
                                    required={true}
                                    min={0}
                                    error={doorNumberError}
                                />
                            </div>

                            {/* Door finish status */}
                            <div className="col-12 col-sm-6">
                                <div className="page_form_group">
                                    <label htmlFor="doorFinishStatus" className="custom_form_label is_required">Finish</label>
                                    <Dropdown
                                        key={`doorFinishStatus`}
                                        id="doorFinishStatus"
                                        value={doorFinishStatus}
                                        onChange={(e: DropdownChangeEvent) => setDoorFinishStatus(e.value)}
                                        options={doorFinishStatuses}
                                        panelClassName="status_option_panel"
                                        placeholder="Select status"
                                        className="form_dropdown w-100"
                                    />

                                    {doorFinishStatusError &&
                                        <small className="form_error_msg">{doorFinishStatusError}</small>
                                    }
                                </div>
                            </div>

                            {/* Note */}
                            <div className="col-12">
                                <Textarea
                                    key={`doorNote`}
                                    id="doorNote"
                                    label="Note"
                                    labelHtmlFor="doorNote"
                                    required={false}
                                    value={doorNote!}
                                    placeholder="Enter note or reference"
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDoorNote(e.target.value || null)}
                                    error={doorNoteError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="doorFiles"
                                    label="File(s)"
                                    labelHtmlFor="doorFiles"
                                    required={false}
                                    value={doorFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadDoorFiles}
                                    onClear={handleClearDoorFiles}
                                    toast={toast}
                                    error={doorFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`doorImageFile`}
                                    id="doorImageFile"
                                    label="Image"
                                    labelHtmlFor="doorImageFile"
                                    required={false}
                                    value={doorImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadDoorImageFile}
                                    onClear={handleClearDoorImageFile}
                                    toast={toast}
                                    error={doorImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/* ******************************************************************** */}


            {/* ******************************************************************** Paint */}
            {/* Paint details modal */}
            <Dialog
                visible={showPaintDetailModal}
                header={paintDetailModalHeader}
                footer={paintDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleClosePaintDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Brand */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`paintBrand`}
                                    inputId="paintBrand"
                                    label="Brand"
                                    value={selectedFSBrand}
                                    displayKey="brand_name"
                                    onAdd={handleAddBrand}
                                    required={true}
                                    placeHolder="Click to select the brand"
                                    error={paintBrandError}
                                />
                            </div>

                            {/* Type */}
                            <div className="col-12 col-sm-6">
                                <div className="page_form_group">
                                    <label htmlFor="paintType" className="custom_form_label is_required">Type</label>
                                    <Dropdown
                                        id="paintType"
                                        value={paintType}
                                        onChange={(e: DropdownChangeEvent) => setPaintType(e.value)}
                                        options={paintTypes}
                                        panelClassName="status_option_panel"
                                        placeholder="Select type"
                                        className="form_dropdown w-100"
                                        showClear
                                    />

                                    {paintTypeError &&
                                        <small className="form_error_msg">{paintTypeError}</small>
                                    }
                                </div>
                            </div>

                            {/* Color */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`paintColor`}
                                    inputId="paintColor"
                                    label="Color"
                                    value={selectedFSColor}
                                    displayKey="color_name"
                                    onAdd={handleAddColor}
                                    required={true}
                                    placeHolder="Click to select the color"
                                    error={paintColorError}
                                    inputClassName={selectedFSColor ? 'has_color_display' : ''}
                                    hasColorDisplay
                                    colorDisplayKey="color_code"
                                />
                            </div>

                            {/* Location */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`paintLocation`}
                                    inputId="paintLocation"
                                    label="Location"
                                    value={selectedFSLocation}
                                    displayKey="location_name"
                                    onAdd={handleAddLocation}
                                    required={true}
                                    placeHolder="Click to select the location"
                                    error={paintLocationError}
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'paintLink'}
                                    id="paintLink"
                                    label="Link"
                                    labelHtmlFor="paintLink"
                                    required={false}
                                    value={paintLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPaintLink(e.target.value || null)}
                                    error={paintLinkError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="paintFiles"
                                    label="File(s)"
                                    labelHtmlFor="paintFiles"
                                    required={false}
                                    value={paintFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadPaintFiles}
                                    onClear={handleClearPaintFiles}
                                    toast={toast}
                                    error={paintFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`paintImageFile`}
                                    id="paintImageFile"
                                    label="Image"
                                    labelHtmlFor="paintImageFile"
                                    required={false}
                                    value={paintImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadPaintImageFile}
                                    onClear={handleClearPaintImageFile}
                                    toast={toast}
                                    error={paintImageFileError}
                                    containerClassName="mb-3"
                                />

                                {dataState === 'Edit' && selectedPaintDetail && (
                                    <div className="checklist_img_container">
                                        <div className="note_image_container response_image_container">
                                            {selectedPaintDetail?.image_path && (
                                                <Image
                                                    src={selectedPaintDetail?.image_path}
                                                    alt={`paintImage`}
                                                    className="note_img response_image"
                                                    preview
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Bathroom */}
            {/* Bathroom location modal */}
            <Dialog
                visible={showBathroomLocationModal}
                header={bathroomLocationModalHeader}
                footer={bathroomLocationModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseBathroomLocationModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Location */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label
                                        htmlFor="bathroomLocation"
                                        className="custom_form_label is_required"
                                    >
                                        Location(s)
                                    </label>
                                    <div className="input_with_button_area">
                                        <InputText
                                            key={`bathroomLocation`}
                                            id="bathroomLocation"
                                            value={selectedFSLocations?.length > 0 ?
                                                selectedFSLocations.map(location => location.location_name).join(', ') : ""}
                                            className="custom_form_input has_add_value"
                                            placeholder="Click to select location(s)."
                                            readOnly={true}
                                            autoComplete="off"
                                            onClick={handleAddMultiLocation}
                                        />
                                        <button
                                            className="add_value_btn p-ripple"
                                            onClick={handleAddMultiLocation}
                                        >
                                            {selectedFSLocations?.length === 0 ? (
                                                <React.Fragment>
                                                    <i className="bi bi-plus-lg"></i>
                                                    <span>Add</span>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <i className="bi bi-pencil-square"></i>
                                                    <span>Change</span>
                                                </React.Fragment>
                                            )}
                                            <Ripple />
                                        </button>
                                    </div>

                                    {bathroomLocationError && (
                                        <small className="form_error_msg">{bathroomLocationError}</small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}

            {/* Bathroom feature list modal */}
            <Dialog
                visible={showBathroomFeatureListModal}
                header={bathroomFeatureModalHeader}
                footer={bathroomFeatureModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseBathroomFeatureListModal}
                dismissableMask
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsBathroomFeatureSearchKey`}
                            inputId="fsBathroomFeatureSearchKey"
                            value={fsBathroomFeatureSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSBathroomFeatureSearchKey(e.target.value)}
                            placeholder="Search area by name"
                            disabled={fsBathroomFeatures?.length === 0}
                            onClear={() => setFSBathroomFeatureSearchKey("")}
                        />
                    </div>

                    {loadingFSBathroomFeatures ? (
                        <CustomTableLoader />
                    ) : errorFSBathroomFeatures ? (
                        <div className="data_select_modal_body">
                            <DataException
                                containerClassName="custom_height"
                                message={errorFSBathroomFeatures}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body custom">
                            {bathroomFeatureData && bathroomFeatureData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {bathroomFeatureData?.map((bathroomFeature) => (
                                        <div key={`bathroomFeature_${bathroomFeature?.id}`} className="data_select_option_check_area">
                                            <Checkbox
                                                onChange={(e) => handleSelectBathroomFeature(bathroomFeature, e.checked || false)}
                                                checked={isSelectedBathroomFeature(bathroomFeature) || isAlreadyExistBathroomFeature(bathroomFeature)}
                                                disabled={isAlreadyExistBathroomFeature(bathroomFeature)}
                                            ></Checkbox>

                                            <div
                                                className={`data_select_option p-ripple 
                                                    ${isSelectedBathroomFeature(bathroomFeature) ? "selected" : ""}
                                                    ${isAlreadyExistBathroomFeature(bathroomFeature) ? "disabled selected" : ""}
                                                `}
                                                onClick={() => !isAlreadyExistBathroomFeature(bathroomFeature) && handleSelectBathroomFeature(bathroomFeature, !isSelectedBathroomFeature(bathroomFeature))}
                                            >
                                                <span>{bathroomFeature?.feature_name}</span>
                                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    containerClassName="custom_height"
                                    message={fsBathroomFeatureSearchKey ? 'The area you were looking for is not found!' : `No areas found for the ${(activeBathroomLocation?.location_name)?.toLowerCase()}.`}
                                />
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}

            {/* Bathroom sub feature list modal */}
            <Dialog
                visible={showBathroomSubFeatureListModal}
                header={bathroomSubFeatureModalHeader}
                footer={bathroomSubFeatureModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm data_select_modal has_footer_input"
                contentClassName="data_select_modal_content"
                onHide={handleCloseBathroomSubFeatureListModal}
                dismissableMask
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header custom">
                        <DataListModalSearch
                            key={`fsBathroomSubFeatureSearchKey`}
                            inputId="fsBathroomSubFeatureSearchKey"
                            value={fsBathroomSubFeatureSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSBathroomSubFeatureSearchKey(e.target.value)}
                            placeholder="Search feature by name"
                            onClear={() => setFSBathroomSubFeatureSearchKey("")}
                        />
                    </div>

                    {loadingFSBathroomFeatures ? (
                        <CustomTableLoader />
                    ) : errorFSBathroomFeatures ? (
                        <div className="data_select_modal_body">
                            <DataException
                                message={errorFSBathroomFeatures}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body custom">
                            {bathroomSubFeatureData && bathroomSubFeatureData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {bathroomSubFeatureData?.map((bathroomSubFeature) => (
                                        <div key={`bathroomSubFeature_${bathroomSubFeature?.id}`} className="data_select_option_check_area">
                                            <Checkbox
                                                onChange={(e) => handleSelectBathroomSubFeature(bathroomSubFeature, e.checked || false)}
                                                checked={isSelectedBathroomSubFeature(bathroomSubFeature) || isAlreadyExistBathroomSubFeature(bathroomSubFeature)}
                                                disabled={isAlreadyExistBathroomSubFeature(bathroomSubFeature)}
                                            ></Checkbox>

                                            <div
                                                className={`data_select_option p-ripple has_img
                                                    ${isSelectedBathroomSubFeature(bathroomSubFeature) ? "selected" : ""}
                                                    ${isAlreadyExistBathroomSubFeature(bathroomSubFeature) ? "disabled selected" : ""}
                                                    ${bathroomSubFeature?.created_by !== null ? 'custom' : ''}
                                                `}
                                                onClick={() => !isAlreadyExistBathroomSubFeature(bathroomSubFeature) && handleSelectBathroomSubFeature(bathroomSubFeature, !isSelectedBathroomSubFeature(bathroomSubFeature))}
                                            >
                                                {bathroomSubFeature?.image_path ? (
                                                    <img
                                                        src={bathroomSubFeature?.image_path}
                                                        className="option_image"
                                                        alt={bathroomSubFeature?.sub_feature_name || ''}
                                                    />
                                                ) : (
                                                    <span className="option_image no_img">
                                                        <img src={noImageIcon} alt={bathroomSubFeature?.sub_feature_name || ''} />
                                                    </span>
                                                )}

                                                <span>{bathroomSubFeature?.sub_feature_name}</span>
                                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                                {bathroomSubFeature?.created_by !== null && (
                                                    <div className="custom_data_action_area">
                                                        {hasPermissionForUpdateSubFeature && (
                                                            <button className="is_btn data_select_option_edit_btn p-ripple"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();

                                                                    if (selectedCustomBathroomSubFeature !== null) {
                                                                        handleResetCustomBathroomSubFeatureFields();
                                                                    } else {
                                                                        handleEditCustomBathroomSubFeature(bathroomSubFeature);
                                                                    }
                                                                }}>
                                                                <i className={`bi ${(selectedCustomBathroomSubFeature !== null && selectedCustomBathroomSubFeature?.id === bathroomSubFeature?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                            </button>
                                                        )}

                                                        {hasPermissionForDeleteSubFeature && (
                                                            <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDeleteCustomBathroomSubFeature(bathroomSubFeature);
                                                                }}
                                                                disabled={deleteBathroomSubFeatureLoadingId === bathroomSubFeature?.id}
                                                            >
                                                                <i className={deleteBathroomSubFeatureLoadingId === bathroomSubFeature?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsBathroomSubFeatureSearchKey ? 'The feature you were looking for is not found!' :
                                        `No features found for the ${(selectedBathroomFeature?.feature_name)?.toLowerCase()}. ${hasPermissionForAddSubFeature ? 'To add the feature click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}

            {/* Bathroom details modal */}
            <Dialog
                visible={showBathroomDetailModal}
                header={bathroomDetailModalHeader}
                footer={bathroomDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseBathroomDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Item */}
                            {selectedBathroomDetail && (
                                <div className="col-12 col-sm-6">
                                    <TextInput
                                        key={'bathroomItem'}
                                        id="bathroomItem"
                                        label={`Item (${selectedBathroomDetail?.feature?.feature_name ?? ''})`}
                                        labelHtmlFor="bathroomItem"
                                        value={selectedBathroomDetail?.sub_feature?.sub_feature_name ?? ''}
                                        placeholder="Bathroom item"
                                        inputDisabled
                                    />
                                </div>
                            )}

                            {/* Name */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'bathroomName'}
                                    id="bathroomName"
                                    label="Name"
                                    labelHtmlFor="bathroomName"
                                    required={true}
                                    value={bathroomName}
                                    placeholder="Enter name"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBathroomName(e.target.value)}
                                    error={bathroomNameError}
                                />
                            </div>

                            {/* Brand */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`bathroomBrand`}
                                    inputId="bathroomBrand"
                                    label="Brand"
                                    value={selectedFSBrand}
                                    displayKey="brand_name"
                                    onAdd={handleAddBrand}
                                    required={true}
                                    placeHolder="Click to select the brand"
                                    error={bathroomBrandError}
                                />
                            </div>

                            {/* Color */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`bathroomColor`}
                                    inputId="bathroomColor"
                                    label="Color"
                                    value={selectedFSColor}
                                    displayKey="color_name"
                                    onAdd={handleAddColor}
                                    required={true}
                                    placeHolder="Click to select the color"
                                    error={bathroomColorError}
                                    inputClassName={selectedFSColor ? 'has_color_display' : ''}
                                    hasColorDisplay
                                    colorDisplayKey="color_code"
                                />
                            </div>

                            {/* Size */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'bathroomSize'}
                                    id="bathroomSize"
                                    label="Size"
                                    labelHtmlFor="bathroomSize"
                                    required={true}
                                    value={bathroomSize}
                                    placeholder="Enter size"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBathroomSize(e.target.value)}
                                    error={bathroomSizeError}
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'bathroomLink'}
                                    id="bathroomLink"
                                    label="Link"
                                    labelHtmlFor="bathroomLink"
                                    required={false}
                                    value={bathroomLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBathroomLink(e.target.value || null)}
                                    error={bathroomLinkError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="bathroomFiles"
                                    label="File(s)"
                                    labelHtmlFor="bathroomFiles"
                                    required={false}
                                    value={bathroomFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadBathroomFiles}
                                    onClear={handleClearBathroomFiles}
                                    toast={toast}
                                    error={bathroomFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`bathroomImageFile`}
                                    id="bathroomImageFile"
                                    label="Image"
                                    labelHtmlFor="bathroomImageFile"
                                    required={false}
                                    value={bathroomImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadBathroomImageFile}
                                    onClear={handleClearBathroomImageFile}
                                    toast={toast}
                                    error={bathroomImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Kitchen */}
            {/* Kitchen option modal */}
            <Dialog
                visible={showKitchenOptionModal}
                header={kitchenOptionModalHeader}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_xsm"
                onHide={handleCloseKitchenOptionModal}
                dismissableMask
            >
                <div className="custom_modal_body data_select_modal_area custom">
                    <div className="data_select_modal_body custom_height">
                        {kitchenOptions && kitchenOptions?.length > 0 ? (
                            <div className="data_select_option_area">
                                <div
                                    key={`kitchen_Type`}
                                    className={`data_select_option p-ripple ${selectedKitchenOption === 'Type' ? "selected" : ""}`}
                                    onClick={() => handleSelectKitchenOption('Type')}
                                >
                                    <span>Manufacture</span>
                                    <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                    <i className="bi bi-chevron-right arrow_icon"></i>
                                </div>

                                <div
                                    key={`kitchen_Worktop`}
                                    className={`data_select_option p-ripple ${selectedKitchenOption === 'Worktop' ? "selected" : ""}`}
                                    onClick={() => handleSelectKitchenOption('Worktop')}
                                >
                                    <span>Worktop</span>
                                    <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                    <i className="bi bi-chevron-right arrow_icon"></i>
                                </div>

                                <div
                                    key={`kitchen_Handle`}
                                    className={`data_select_option p-ripple ${selectedKitchenOption === 'Handle' ? "selected" : ""}`}
                                    onClick={() => handleSelectKitchenOption('Handle')}
                                >
                                    <span>Handle</span>
                                    <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                    <i className="bi bi-chevron-right arrow_icon"></i>
                                </div>

                                {/* {kitchenOptions?.map((option) => (
                                    <div
                                        key={`kitchen_${option}`}
                                        className={`data_select_option p-ripple ${option === selectedKitchenOption ? "selected" : ""}`}
                                        onClick={() => handleSelectKitchenOption(option)}
                                    >
                                        <span>{option}</span>
                                        <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                                        <i className="bi bi-chevron-right arrow_icon"></i>
                                    </div>
                                ))} */}
                            </div>
                        ) : (
                            <DataException
                                message={'There are no options for adding kitchen details.'}
                            />
                        )}
                    </div>
                </div>
            </Dialog>
            {/*  */}

            {/* Kitchen details modal */}
            <Dialog
                visible={showKitchenDetailModal}
                header={kitchenDetailModalHeader}
                footer={kitchenDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseKitchenDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {renderInputsByKitchenOption()}
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}

            {/* Kitchen appliance modal */}
            <Dialog
                visible={showKitchenApplianceDetailModal}
                header={kitchenApplianceDetailModalHeader}
                footer={kitchenApplianceDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseKitchenApplianceDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Appliance */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`kitchenAppliance`}
                                    inputId="kitchenAppliance"
                                    label="Appliance"
                                    value={selectedFSAppliance}
                                    displayKey="appliance_name"
                                    onAdd={handleAddAppliance}
                                    required={true}
                                    placeHolder="Click to select the appliance"
                                    error={kitchenApplianceError}
                                />
                            </div>

                            {/* Brand */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`kitchenApplianceBrand`}
                                    inputId="kitchenApplianceBrand"
                                    label="Brand"
                                    value={selectedFSBrand}
                                    displayKey="brand_name"
                                    onAdd={handleAddBrand}
                                    required={true}
                                    placeHolder="Click to select the brand"
                                    error={kitchenApplianceBrandError}
                                />
                            </div>

                            {/* Name */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'kitchenApplianceName'}
                                    id="kitchenApplianceName"
                                    label="Name"
                                    labelHtmlFor="kitchenApplianceName"
                                    required={true}
                                    value={kitchenApplianceName}
                                    placeholder="Enter name"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKitchenApplianceName(e.target.value)}
                                    error={kitchenApplianceNameError}
                                />
                            </div>

                            {/* Color */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`kitchenApplianceColor`}
                                    inputId="kitchenApplianceColor"
                                    label="Color"
                                    value={selectedFSColor}
                                    displayKey="color_name"
                                    onAdd={handleAddColor}
                                    required={false}
                                    placeHolder="Click to select the color"
                                    error={kitchenApplianceColorError}
                                    inputClassName={selectedFSColor ? 'has_color_display' : ''}
                                    hasColorDisplay
                                    colorDisplayKey="color_code"
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'kitchenApplianceLink'}
                                    id="kitchenApplianceLink"
                                    label="Link"
                                    labelHtmlFor="kitchenApplianceLink"
                                    required={false}
                                    value={kitchenApplianceLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKitchenApplianceLink(e.target.value || null)}
                                    error={kitchenApplianceLinkError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="kitchenApplianceFiles"
                                    label="File(s)"
                                    labelHtmlFor="kitchenApplianceFiles"
                                    required={false}
                                    value={kitchenApplianceFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadKitchenApplianceFiles}
                                    onClear={handleClearKitchenApplianceFiles}
                                    toast={toast}
                                    error={kitchenApplianceFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`kitchenApplianceImageFile`}
                                    id="kitchenApplianceImageFile"
                                    label="Image"
                                    labelHtmlFor="kitchenApplianceImageFile"
                                    required={false}
                                    value={kitchenApplianceImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadKitchenApplianceImageFile}
                                    onClear={handleClearKitchenApplianceImageFile}
                                    toast={toast}
                                    error={kitchenApplianceImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Tile */}
            {/* Tile location modal */}
            <Dialog
                visible={showTilesModal}
                header={tileModalHeader}
                footer={tileModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseTileModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Tile location */}
                            <div className="col-12">
                                <TextInput
                                    key={'tileLocation'}
                                    id="tileLocation"
                                    label="Location"
                                    labelHtmlFor="tileLocation"
                                    required={true}
                                    value={tileLocation}
                                    placeholder="Enter location"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTileLocation(e.target.value)}
                                    error={tileLocationError}
                                    formGroupClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}

            {/* Tile details modal */}
            <Dialog
                visible={showTileDetailModal}
                header={tileDetailModalHeader}
                footer={tileDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseTileDetailModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Type */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`tileType`}
                                    inputId="tileType"
                                    label="Type"
                                    value={selectedFSType}
                                    displayKey="type_name"
                                    onAdd={handleAddType}
                                    required={true}
                                    placeHolder="Click to select the type"
                                    error={tileTypeError}
                                />
                            </div>

                            {/* Tile name */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'tileName'}
                                    id="tileName"
                                    label="Name"
                                    labelHtmlFor="tileName"
                                    required={true}
                                    value={tileName}
                                    placeholder="Enter name"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTileName(e.target.value)}
                                    error={tileNameError}
                                />
                            </div>

                            {/* Quantity */}
                            <div className="col-12 col-sm-6">
                                <NumberInput
                                    key={'tileQuantity'}
                                    inputId="tileQuantity"
                                    label="Quantity"
                                    labelHtmlFor="tileQuantity"
                                    placeholder="Enter quantity"
                                    onChange={(e: InputNumberChangeEvent) => setTileQuantity(e.value || null)}
                                    value={tileQuantity}
                                    required={true}
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                    min={0}
                                    error={tileQuantityError}
                                />
                            </div>

                            {/* Shop */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`tileShop`}
                                    inputId="tileShop"
                                    label="Shop"
                                    value={selectedFSTileShop}
                                    displayKey="shop_name"
                                    onAdd={handleAddTileShop}
                                    required={true}
                                    placeHolder="Click to select the shop"
                                    error={tileShopError}
                                />
                            </div>

                            {/* Color */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`tileColor`}
                                    inputId="tileColor"
                                    label="Color"
                                    value={selectedFSColor}
                                    displayKey="color_name"
                                    onAdd={handleAddColor}
                                    required={true}
                                    placeHolder="Click to select the color"
                                    error={tileColorError}
                                    inputClassName={selectedFSColor ? 'has_color_display' : ''}
                                    hasColorDisplay
                                    colorDisplayKey="color_code"
                                />
                            </div>

                            {/* Size */}
                            <div className="col-12 col-sm-6">
                                <NumberInput
                                    key={'tileSize'}
                                    inputId="tileSize"
                                    label="Size (sqm)"
                                    labelHtmlFor="tileSize"
                                    placeholder="Enter size"
                                    onChange={(e: InputNumberChangeEvent) => setTileSize(e.value || null)}
                                    value={tileSize}
                                    required={true}
                                    suffix=" sqm"
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                    min={0}
                                    error={tileSizeError}
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'tileLink'}
                                    id="tileLink"
                                    label="Link"
                                    labelHtmlFor="tileLink"
                                    required={false}
                                    value={tileLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTileLink(e.target.value || null)}
                                    error={tileLinkError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="tileFiles"
                                    label="File(s)"
                                    labelHtmlFor="tileFiles"
                                    required={false}
                                    value={tileFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadTileFiles}
                                    onClear={handleClearTileFiles}
                                    toast={toast}
                                    error={tileFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`tileImageFile`}
                                    id="tileImageFile"
                                    label="Image"
                                    labelHtmlFor="tileImageFile"
                                    required={false}
                                    value={tileImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadTileImageFile}
                                    onClear={handleClearTileImageFile}
                                    toast={toast}
                                    error={tileImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Floor finishing */}
            {/* Floor finishing details modal */}
            <Dialog
                visible={showFloorFinishingDetailModal}
                header={floorFinishingDetailModalHeader}
                footer={floorFinishingDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseFloorFinishingDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Location */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`floorFinishingLocation`}
                                    inputId="floorFinishingLocation"
                                    label="Location"
                                    value={selectedFSLocation}
                                    displayKey="location_name"
                                    onAdd={handleAddLocation}
                                    required={true}
                                    placeHolder="Click to select the location"
                                    error={floorFinishingLocationError}
                                />
                            </div>

                            {/* Type */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`floorFinishingType`}
                                    inputId="floorFinishingType"
                                    label="Type"
                                    value={selectedFSType}
                                    displayKey="type_name"
                                    onAdd={handleAddType}
                                    required={true}
                                    placeHolder="Click to select the type"
                                    error={floorFinishingTypeError}
                                />
                            </div>

                            {/* Name */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'floorFinishingName'}
                                    id="floorFinishingName"
                                    label="Name"
                                    labelHtmlFor="floorFinishingName"
                                    required={true}
                                    value={floorFinishingName}
                                    placeholder="Enter name"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFloorFinishingName(e.target.value)}
                                    error={floorFinishingNameError}
                                />
                            </div>

                            {/* Brand */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`floorFinishingBrand`}
                                    inputId="floorFinishingBrand"
                                    label="Brand"
                                    value={selectedFSBrand}
                                    displayKey="brand_name"
                                    onAdd={handleAddBrand}
                                    required={true}
                                    placeHolder="Click to select the brand"
                                    error={floorFinishingBrandError}
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12">
                                <TextInput
                                    key={'floorFinishingLink'}
                                    id="floorFinishingLink"
                                    label="Link"
                                    labelHtmlFor="floorFinishingLink"
                                    required={false}
                                    value={floorFinishingLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFloorFinishingLink(e.target.value || null)}
                                    error={floorFinishingLinkError}
                                />
                            </div>

                            {/* Note */}
                            <div className="col-12">
                                <Textarea
                                    key={`floorFinishingNote`}
                                    id="floorFinishingNote"
                                    label="Note"
                                    labelHtmlFor="floorFinishingNote"
                                    required={false}
                                    value={floorFinishingNote!}
                                    placeholder="Enter note or reference"
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFloorFinishingNote(e.target.value || null)}
                                    error={floorFinishingNoteError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="floorFinishingFiles"
                                    label="File(s)"
                                    labelHtmlFor="floorFinishingFiles"
                                    required={false}
                                    value={floorFinishingFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadFloorFinishingFiles}
                                    onClear={handleClearFloorFinishingFiles}
                                    toast={toast}
                                    error={floorFinishingFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`floorFinishingImageFile`}
                                    id="floorFinishingImageFile"
                                    label="Image"
                                    labelHtmlFor="floorFinishingImageFile"
                                    required={false}
                                    value={floorFinishingImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadFloorFinishingImageFile}
                                    onClear={handleClearFloorFinishingImageFile}
                                    toast={toast}
                                    error={floorFinishingImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Others */}
            {/* Other location modal */}
            <Dialog
                visible={showOtherLocationModal}
                header={otherLocationModalHeader}
                footer={otherLocationModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseOtherLocationModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Location */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label
                                        htmlFor="otherLocation"
                                        className="custom_form_label is_required"
                                    >
                                        Location(s)
                                    </label>
                                    <div className="input_with_button_area">
                                        <InputText
                                            key={`otherLocation`}
                                            id="otherLocation"
                                            value={selectedFSLocations?.length > 0 ?
                                                selectedFSLocations.map(location => location.location_name).join(', ') : ""}
                                            className="custom_form_input has_add_value"
                                            placeholder="Click to select location(s)."
                                            readOnly={true}
                                            autoComplete="off"
                                            onClick={handleAddMultiLocation}
                                        />
                                        <button
                                            className="add_value_btn p-ripple"
                                            onClick={handleAddMultiLocation}
                                        >
                                            {selectedFSLocations?.length === 0 ? (
                                                <React.Fragment>
                                                    <i className="bi bi-plus-lg"></i>
                                                    <span>Add</span>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <i className="bi bi-pencil-square"></i>
                                                    <span>Change</span>
                                                </React.Fragment>
                                            )}
                                            <Ripple />
                                        </button>
                                    </div>

                                    {otherLocationError && (
                                        <small className="form_error_msg">{otherLocationError}</small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}

            {/* Other details modal */}
            <Dialog
                visible={showOtherDetailModal}
                header={otherDetailModalHeader}
                footer={otherDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseOtherDetailModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Flooring screed */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'otherFlooringScreed'}
                                    id="otherFlooringScreed"
                                    label="Flooring screed"
                                    labelHtmlFor="otherFlooringScreed"
                                    required={true}
                                    value={otherFlooringScreed}
                                    placeholder="Enter flooring screed"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOtherFlooringScreed(e.target.value)}
                                    error={otherFlooringScreedError}
                                />
                            </div>

                            {/* Brand */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`otherBrand`}
                                    inputId="otherBrand"
                                    label="Brand"
                                    value={selectedFSBrand}
                                    displayKey="brand_name"
                                    onAdd={handleAddBrand}
                                    required={true}
                                    placeHolder="Click to select the brand"
                                    error={otherBrandError}
                                />
                            </div>

                            {/* Number */}
                            <div className="col-12 col-sm-6">
                                <NumberInput
                                    key={'otherNumber'}
                                    inputId="otherNumber"
                                    label="Number"
                                    labelHtmlFor="otherNumber"
                                    placeholder="Enter number"
                                    onChange={(e: InputNumberChangeEvent) => setOtherNumber(e.value || null)}
                                    value={otherNumber}
                                    required={true}
                                    min={0}
                                    error={otherNumberError}
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'otherLink'}
                                    id="otherLink"
                                    label="Link"
                                    labelHtmlFor="otherLink"
                                    required={false}
                                    value={otherLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOtherLink(e.target.value || null)}
                                    error={otherLinkError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="otherFiles"
                                    label="File(s)"
                                    labelHtmlFor="otherFiles"
                                    required={false}
                                    value={otherFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadOtherFiles}
                                    onClear={handleClearOtherFiles}
                                    toast={toast}
                                    error={otherFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`otherImageFile`}
                                    id="otherImageFile"
                                    label="Image"
                                    labelHtmlFor="otherImageFile"
                                    required={false}
                                    value={otherImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadOtherImageFile}
                                    onClear={handleClearOtherImageFile}
                                    toast={toast}
                                    error={otherImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Accessory details */}
            {/* Accessory details modal */}
            <Dialog
                visible={showAccessoryDetailModal}
                header={accessoryDetailModalHeader}
                footer={accessoryDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_nm"
                onHide={handleCloseAccessoryDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Accessory name */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`accessoryName`}
                                    inputId="accessoryName"
                                    label="Name"
                                    value={selectedFSAccessory}
                                    displayKey="accessory_name"
                                    onAdd={handleAddAccessory}
                                    required={true}
                                    placeHolder="Click to select the name"
                                    error={accessoryNameError}
                                />
                            </div>

                            {/* Sub accessory name */}
                            <div className="col-12 col-sm-6">
                                <DataListModalInput
                                    key={`subAccessoryName`}
                                    inputId="subAccessoryName"
                                    label="Sub name"
                                    value={selectedFSAccessorySub}
                                    displayKey="accessory_sub_name"
                                    onAdd={handleAddAccessorySub}
                                    required={false}
                                    placeHolder="Click to select the sub name"
                                    error={subAccessoryNameError}
                                    disabled={selectedFSAccessory === null}
                                />
                            </div>

                            {/* Numbers */}
                            <div className="col-12 col-sm-6">
                                <NumberInput
                                    key={'accessoryNumber'}
                                    inputId="accessoryNumber"
                                    label="Numbers"
                                    labelHtmlFor="accessoryNumber"
                                    placeholder="Enter numbers"
                                    onChange={(e: InputNumberChangeEvent) => setAccessoryNumber(e.value || null)}
                                    value={accessoryNumber}
                                    required={true}
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                    min={0}
                                    error={accessoryNumberError}
                                />
                            </div>

                            {/* Reference */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'accessoryReference'}
                                    id="accessoryReference"
                                    label="Reference"
                                    labelHtmlFor="accessoryReference"
                                    required={false}
                                    value={accessoryReference!}
                                    placeholder="Enter reference"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAccessoryReference(e.target.value)}
                                    error={accessoryReferenceError}
                                />
                            </div>

                            {/* Link */}
                            <div className="col-12 col-sm-6">
                                <TextInput
                                    key={'accessoryLink'}
                                    id="accessoryLink"
                                    label="Link"
                                    labelHtmlFor="accessoryLink"
                                    required={false}
                                    value={accessoryLink!}
                                    placeholder="Enter link"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAccessoryLink(e.target.value)}
                                    error={accessoryLinkError}
                                />
                            </div>

                            {/* Files */}
                            <div className="col-12 col-sm-6">
                                <MulipleFileInput
                                    id="accessoryFiles"
                                    label="File(s)"
                                    labelHtmlFor="accessoryFiles"
                                    required={false}
                                    value={accessoryFiles.map(file => file.name).join(', ')}
                                    onUpload={handleUploadAccessoryFiles}
                                    onClear={handleClearAccessoryFiles}
                                    toast={toast}
                                    error={accessoryFilesError}
                                />
                            </div>

                            {/* Image */}
                            <div className="col-12 col-sm-6">
                                <FileInput
                                    key={`accessoryImageFile`}
                                    id="accessoryImageFile"
                                    label="Image"
                                    labelHtmlFor="accessoryImageFile"
                                    required={false}
                                    value={accessoryImageFileName}
                                    onlyImageUpload={true}
                                    onUpload={handleUploadaccessoryImageFile}
                                    onClear={handleClearaccessoryImageFile}
                                    toast={toast}
                                    error={accessoryImageFileError}
                                    containerClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* ******************************************************************** Order details */}
            {/* Order modal */}
            <Dialog
                visible={showOrderModal}
                header={orderModalHeader}
                footer={orderModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseOrderDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-3 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        {/* Status */}
                        <div className="page_form_group">
                            <div className="row page_radio_option_row">
                                {orderStatuses?.map((status, index) => (
                                    <div key={index} className="col-6 col-sm-3">
                                        <div className="page_radio_option_item">
                                            <RadioButton
                                                inputId={(status).toLowerCase()}
                                                name="orderStatus"
                                                value={status}
                                                onChange={(e: RadioButtonChangeEvent) => {
                                                    setOrderStatus(e.value);
                                                    setOrderDateError('');
                                                    setOrderDayError('');
                                                    setOrderWeekError('');
                                                    if (e.value === 'Pending') {
                                                        setOrderDate(null);
                                                    }
                                                }}
                                                checked={orderStatus === status}
                                            />
                                            <label htmlFor={(status).toLowerCase()}>{status}</label>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {orderStatusError && (
                                <small className="form_error_msg mt-2">{orderStatusError}</small>
                            )}
                        </div>

                        <hr className="my-4" />

                        {/* Lead time */}
                        {orderStatus === 'Ordered' && (
                            <div className="page_form_group">
                                <h6 className="page_form_head">Lead time</h6>

                                <div className="row">
                                    {/* Week count */}
                                    <div className="col-6">
                                        <NumberInput
                                            key={'orderWeekCount'}
                                            inputId="orderWeekCount"
                                            label="Week"
                                            labelHtmlFor="orderWeekCount"
                                            placeholder="No. of weeks"
                                            onChange={(e: InputNumberChangeEvent) => setOrderWeekCount(e.value || null)}
                                            value={orderWeekCount}
                                            required={orderDayCount === null ? true : false}
                                            min={0}
                                            error={orderWeekError}
                                            formGroupClassName="mb-0"
                                        />
                                    </div>

                                    {/* Day count */}
                                    <div className="col-6">
                                        <NumberInput
                                            key={'orderDayCount'}
                                            inputId="orderDayCount"
                                            label="Day(s) - (1 - 7)"
                                            labelHtmlFor="orderDayCount"
                                            placeholder="No. of days"
                                            onChange={(e: InputNumberChangeEvent) => setOrderDayCount(e.value || null)}
                                            value={orderDayCount}
                                            required={orderWeekCount === null ? true : false}
                                            max={7}
                                            min={0}
                                            error={orderDayError}
                                            formGroupClassName="mb-0"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {orderStatus !== 'Pending' && (
                            <React.Fragment>
                                {/* Date */}
                                <div className="page_form_group">
                                    <DatePicker
                                        key={`orderDate`}
                                        id="orderDate"
                                        label="Date"
                                        labelHtmlFor="orderDate"
                                        required={(orderStatus === 'Instore' || orderStatus === 'Onsite') ? true : false}
                                        value={orderDate}
                                        placeholder="dd/mm/yyyy"
                                        onChange={setOrderDate}
                                        error={orderDateError}
                                        showClear={orderStatus !== 'Ordered'}
                                        onClear={() => setOrderDate(null)}
                                        inputDisabled={orderStatus === 'Ordered'}
                                        className="readonly_disabled"
                                    />
                                </div>

                                <hr className="my-4" />
                            </React.Fragment>
                        )}

                        {/* Price */}
                        <div className="page_form_group">
                            <div className="response_state_area pt-0 mb-3">
                                <div className="response_state">
                                    <Checkbox
                                        inputId="priceInclude"
                                        name="priceInclude"
                                        onChange={(e) => {
                                            const checked = e.checked ? 1 : 0;
                                            setOrderIsPriceIncluded(checked);
                                            setOrderPrice(null);
                                        }}
                                        checked={orderIsPriceIncluded === 1}
                                    />
                                    <label htmlFor="priceInclude">Price Included</label>
                                </div>
                            </div>

                            <div className="input_flex_group">
                                <label htmlFor="orderPrice" className={`custom_form_label`}>Price&nbsp;({currencySymbol})</label>

                                <InputNumber
                                    className="custom_form_input w-50"
                                    inputId="orderPrice"
                                    value={orderPrice}
                                    placeholder="Price"
                                    onChange={(e: InputNumberChangeEvent) => {
                                        const val = e.value || null;
                                        setOrderPrice(val);
                                    }}
                                    useGrouping={false}
                                    minFractionDigits={2}
                                    maxFractionDigits={2}
                                    disabled={orderIsPriceIncluded === 1}
                                    prefix={`${currencySymbol} `}
                                />
                            </div>

                            {orderPriceError && (
                                <small className="form_error_msg text-end">{orderPriceError}</small>
                            )}
                        </div>

                        {/* Vat */}
                        <div className="page_form_group">
                            <label htmlFor="vatPercentage" className={`custom_form_label mb-3`}>VAT&nbsp;({String(vatPercentage).padStart(2, '0')}%)</label>

                            <div className="page_radio_option_group">
                                <div className="page_radio_option_item">
                                    <RadioButton
                                        inputId="incVAT"
                                        name="vat"
                                        value={1}
                                        onChange={(e: RadioButtonChangeEvent) => handleVatChange(e.value)}
                                        checked={orderIsVatIncluded === 1}
                                    />
                                    <label htmlFor="incVAT">Inc. VAT</label>
                                </div>

                                <div className="page_radio_option_item">
                                    <RadioButton
                                        inputId="exVAT"
                                        name="vat"
                                        value={0}
                                        onChange={(e: RadioButtonChangeEvent) => handleVatChange(e.value)}
                                        checked={orderIsVatIncluded === 0}
                                    />
                                    <label htmlFor="exVAT">Ex. VAT</label>
                                </div>
                            </div>
                        </div>

                        {/* Note */}
                        <div className="page_form_group">
                            <Textarea
                                key={`orderNote`}
                                id="orderNote"
                                label="Note"
                                labelHtmlFor="orderNote"
                                required={false}
                                value={orderNote!}
                                placeholder="Enter note"
                                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setOrderNote(e.target.value || null)}
                                error={orderNoteError}
                                formGroupClassName="mb-2"
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}
            {/* ******************************************************************** */}


            {/* Color list modal */}
            <Dialog
                visible={showColorListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseColorListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsColorSearchKey`}
                            inputId="fsColorSearchKey"
                            value={fsColorSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSColorSearchKey(e.target.value)}
                            placeholder="Search color by name"
                            disabled={fsColors?.length === 0}
                            onClear={() => setFSColorSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseColorListModal}
                        />
                    </div>

                    {loadingFSColors ? (
                        <CustomTableLoader />
                    ) : errorFSColors ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSColors}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsColorsData && fsColorsData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsColorsData?.map((color) => (
                                        <div
                                            key={`color_${color?.id}`}
                                            className={`data_select_option has_data_value p-ripple ${color?.id === selectedFSColor?.id ? "selected" : ""}
                                        ${color?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectColor(color)}
                                        >
                                            <span>{color?.color_name}</span>
                                            <small className="text_muted">({color?.color_code})</small>
                                            <div className="input_color_display" style={{ backgroundColor: color?.color_code || '#FFF' }} />
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {color?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateColor && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomColor !== null) {
                                                                    handleResetCustomFSColorFields();
                                                                } else {
                                                                    handleEditCustomColor(color);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomColor !== null && selectedCustomColor?.id === color?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteColor && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSColor(color);
                                                            }}
                                                            disabled={deleteColorLoadingId === color?.id}
                                                        >
                                                            <i className={deleteColorLoadingId === color?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsColorSearchKey ? 'The color you were looking for is not found!'
                                        : `No colors found. ${hasPermissionForAddColor ? 'To add the color click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddColor && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <div className="input_with_button_area_sub">
                                    <InputText
                                        key={`customColorName`}
                                        id="customColorName"
                                        value={customColorName}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomColorName(e.target.value)}
                                        className="custom_form_input custom_data_input"
                                        placeholder="Enter color name"
                                        autoComplete="off"
                                    />
                                </div>

                                <div className="input_with_button_area_sub">
                                    {customColorCode && (
                                        <div className="input_color_display" style={{ backgroundColor: `${customColorCode}` || '#FFF' }} />
                                    )}

                                    <InputText
                                        key={`customColorCode`}
                                        id="customColorCode"
                                        value={customColorCode}
                                        className={`custom_form_input ${customColorCode ? 'has_data_value' : ''} pe-5 custom_data_input`}
                                        placeholder="Pick color"
                                        readOnly
                                        autoComplete="off"
                                    />

                                    <label htmlFor="colorPicker" title="Choose your color" className="color_option picker p-ripple">
                                        <input
                                            type="color"
                                            id="colorPicker"
                                            value={customColorCode}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const newColor = e.target.value;
                                                setCustomColorCode(newColor);
                                            }}
                                            style={{
                                                visibility: 'hidden',
                                                position: 'absolute',
                                                opacity: 0,
                                                width: 0,
                                                height: 0,
                                            }}
                                        />
                                        <i className="bi bi-palette"></i>
                                        <Ripple />
                                    </label>
                                </div>

                                <button
                                    className="tabel_btn custom p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSColor : handleUpdateCustomFSColor}
                                    disabled={(customLoading || customColorName === "" || customColorCode === "") || (customDataState === 'Edit' && !customColorUpdateHasChanges)}
                                >
                                    <i className={`${customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}`}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>

                            {customColorNameError && (
                                <small className="form_error_msg">{customColorNameError}</small>
                            )}

                            {customColorCodeError && (
                                <small className="form_error_msg mt-1">{customColorCodeError}</small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Brand list modal */}
            <Dialog
                visible={showBrandListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseBrandListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsBrandSearchKey`}
                            inputId="fsBrandSearchKey"
                            value={fsBrandSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSBrandSearchKey(e.target.value)}
                            placeholder="Search brand by name"
                            disabled={fsBrands?.length === 0}
                            onClear={() => setFSBrandSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseBrandListModal}
                        />
                    </div>

                    {loadingFSBrands ? (
                        <CustomTableLoader />
                    ) : errorFSBrands ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSBrands}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsBrandsData && fsBrandsData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsBrandsData?.map((brand) => (
                                        <div
                                            key={`brand_${brand?.id}`}
                                            className={`data_select_option p-ripple ${brand?.id === selectedFSBrand?.id ? "selected" : ""}
                                        ${brand?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectBrand(brand)}
                                        >
                                            <span>{brand?.brand_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {brand?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateBrand && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomBrand !== null) {
                                                                    handleResetCustomFSBrandFields();
                                                                } else {
                                                                    handleEditCustomBrand(brand);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomBrand !== null && selectedCustomBrand?.id === brand?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteBrand && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSBrand(brand);
                                                            }}
                                                            disabled={deleteBrandLoadingId === brand?.id}
                                                        >
                                                            <i className={deleteBrandLoadingId === brand?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsBrandSearchKey ? 'The brand you were looking for is not found!' :
                                        `No brands found. ${hasPermissionForAddBrand ? 'To add the brand click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddBrand && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customBrandName`}
                                    id="customBrandName"
                                    value={customBrandName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomBrandName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter brand name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSBrand : handleUpdateCustomFSBrand}
                                    disabled={(customLoading || customBrandName === "") || (customDataState === 'Edit' && !customBrandUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customBrandNameError && (
                                <small className="form_error_msg">
                                    {customBrandNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Location list modal */}
            <Dialog
                visible={showLocationListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseLocationListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsLocationSearchKey`}
                            inputId="fsLocationSearchKey"
                            value={fsLocationSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSLocationSearchKey(e.target.value)}
                            placeholder="Search location by name"
                            disabled={fsLocations?.length === 0}
                            onClear={() => setFSLocationSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseLocationListModal}
                        />
                    </div>

                    {loadingFSLocations ? (
                        <CustomTableLoader />
                    ) : errorFSLocations ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSLocations}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsLocationsData && fsLocationsData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsLocationsData?.map((location) => (
                                        <div
                                            key={`location_${location?.id}`}
                                            className={`data_select_option p-ripple ${location?.id === selectedFSLocation?.id ? "selected" : ""}
                                        ${location?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectLocation(location)}
                                        >
                                            <span>{location?.location_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {location?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateLocation && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomLocation !== null) {
                                                                    handleResetCustomFSLocationFields();
                                                                } else {
                                                                    handleEditCustomLocation(location);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomLocation !== null && selectedCustomLocation?.id === location?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteLocation && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSLocation(location);
                                                            }}
                                                            disabled={deleteLocationLoadingId === location?.id}
                                                        >
                                                            <i className={deleteLocationLoadingId === location?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsLocationSearchKey ? 'The location you were looking for is not found!' :
                                        `No locations found. ${hasPermissionForAddLocation ? 'To add the location click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddLocation && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customLocationName`}
                                    id="customLocationName"
                                    value={customLocationName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomLocationName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter location name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSLocation : handleUpdateCustomFSLocation}
                                    disabled={(customLoading || customLocationName === "") || (customDataState === 'Edit' && !customLocationUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customLocationNameError && (
                                <small className="form_error_msg">
                                    {customLocationNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Multi location list modal */}
            <Dialog
                visible={showMultiLocationListModal}
                footer={locationModalFooter}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={() => handleCloseMultiLocationListModal(true)}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsLocationSearchKey`}
                            inputId="fsLocationSearchKey"
                            value={fsLocationSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSLocationSearchKey(e.target.value)}
                            placeholder="Search location by name"
                            disabled={fsLocations?.length === 0}
                            onClear={() => setFSLocationSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={() => handleCloseMultiLocationListModal(true)}
                        />
                    </div>

                    {loadingFSLocations ? (
                        <CustomTableLoader />
                    ) : errorFSLocations ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSLocations}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsLocationsData && fsLocationsData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsLocationsData?.map((location) => (
                                        <div key={`multiLocation_${location?.id}`} className="data_select_option_check_area">
                                            <Checkbox
                                                onChange={(e) => handleSelectMultiLocation(location, e.checked || false)}
                                                checked={isSelectedLocation(location) || isAlreadyExistLocation(location)}
                                                disabled={isAlreadyExistLocation(location)}
                                            ></Checkbox>

                                            <div
                                                className={`data_select_option p-ripple 
                                                    ${isSelectedLocation(location) ? "selected" : ""}
                                                    ${isAlreadyExistLocation(location) ? "disabled selected" : ""}
                                                    ${location?.created_by !== null ? 'custom' : ''}
                                                `}
                                                onClick={() => !isAlreadyExistLocation(location) && handleSelectMultiLocation(location, !isSelectedLocation(location))}
                                            >
                                                <span>{location?.location_name}</span>
                                                <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                                {location?.created_by !== null && (
                                                    <div className="custom_data_action_area">
                                                        {hasPermissionForUpdateLocation && (
                                                            <button className="is_btn data_select_option_edit_btn p-ripple"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();

                                                                    if (selectedCustomLocation !== null) {
                                                                        handleResetCustomFSLocationFields();
                                                                    } else {
                                                                        handleEditCustomLocation(location);
                                                                    }
                                                                }}>
                                                                <i className={`bi ${(selectedCustomLocation !== null && selectedCustomLocation?.id === location?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                            </button>
                                                        )}

                                                        {hasPermissionForDeleteLocation && (
                                                            <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDeleteCustomFSLocation(location);
                                                                }}
                                                                disabled={deleteLocationLoadingId === location?.id || isAlreadyExistLocation(location)}
                                                            >
                                                                <i className={deleteLocationLoadingId === location?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsLocationSearchKey ? 'The location you were looking for is not found!' :
                                        `No locations found. ${hasPermissionForAddLocation ? 'To add the location click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddLocation && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customLocationName`}
                                    id="customLocationName"
                                    value={customLocationName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomLocationName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter location name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSLocation : handleUpdateCustomFSLocation}
                                    disabled={(customLoading || customLocationName === "") || (customDataState === 'Edit' && !customLocationUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customLocationNameError && (
                                <small className="form_error_msg">
                                    {customLocationNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Type list modal */}
            <Dialog
                visible={showTypeListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseTypeListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsTypeSearchKey`}
                            inputId="fsTypeSearchKey"
                            value={fsTypeSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSTypeSearchKey(e.target.value)}
                            placeholder="Search type by name"
                            disabled={fsTypes?.length === 0}
                            onClear={() => setFSTypeSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseTypeListModal}
                        />
                    </div>

                    {loadingFSTypes ? (
                        <CustomTableLoader />
                    ) : errorFSTypes ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSTypes}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsTypesData && fsTypesData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsTypesData?.map((type) => (
                                        <div
                                            key={`type_${type?.id}`}
                                            className={`data_select_option p-ripple ${type?.id === selectedFSType?.id ? "selected" : ""}
                                        ${type?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectType(type)}
                                        >
                                            <span>{type?.type_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {type?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateType && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomType !== null) {
                                                                    handleResetCustomFSTypeFields();
                                                                } else {
                                                                    handleEditCustomType(type);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomType !== null && selectedCustomType?.id === type?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteType && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSType(type);
                                                            }}
                                                            disabled={deleteTypeLoadingId === type?.id}
                                                        >
                                                            <i className={deleteTypeLoadingId === type?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsTypeSearchKey ? 'The type you were looking for is not found!' :
                                        `No types found. ${hasPermissionForAddType ? 'To add the type click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddType && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customTypeName`}
                                    id="customTypeName"
                                    value={customTypeName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomTypeName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter type name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSType : handleUpdateCustomFSType}
                                    disabled={(customLoading || customTypeName === "") || (customDataState === 'Edit' && !customTypeUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customTypeNameError && (
                                <small className="form_error_msg">
                                    {customTypeNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Tile shop list modal */}
            <Dialog
                visible={showTileShopListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseTileShopListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsTileShopSearchKey`}
                            inputId="fsTileShopSearchKey"
                            value={fsTileShopSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSTileShopSearchKey(e.target.value)}
                            placeholder="Search shop by name"
                            disabled={fsTileShops?.length === 0}
                            onClear={() => setFSTileShopSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseTileShopListModal}
                        />
                    </div>

                    {loadingFSTileShops ? (
                        <CustomTableLoader />
                    ) : errorFSTileShops ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSTileShops}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsTileShopsData && fsTileShopsData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsTileShopsData?.map((shop) => (
                                        <div
                                            key={`shop_${shop?.id}`}
                                            className={`data_select_option p-ripple ${shop?.id === selectedFSTileShop?.id ? "selected" : ""}
                                        ${shop?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectTileShop(shop)}
                                        >
                                            <span>{shop?.shop_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {shop?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateTileShop && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomTileShop !== null) {
                                                                    handleResetCustomFSTileShopFields();
                                                                } else {
                                                                    handleEditCustomTileShop(shop);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomTileShop !== null && selectedCustomTileShop?.id === shop?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteTileShop && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSTileShop(shop);
                                                            }}
                                                            disabled={deleteTileShopLoadingId === shop?.id}
                                                        >
                                                            <i className={deleteTileShopLoadingId === shop?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsTileShopSearchKey ? 'The shop you were looking for is not found!' :
                                        `No shops found. ${hasPermissionForAddTileShop ? 'To add the shop click on add button.' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddTileShop && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customTileShopName`}
                                    id="customTileShopName"
                                    value={customTileShopName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomTileShopName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter shop name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSTileShop : handleUpdateCustomFSTileShop}
                                    disabled={(customLoading || customTileShopName === "") || (customDataState === 'Edit' && !customTileShopUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customTileShopNameError && (
                                <small className="form_error_msg">
                                    {customTileShopNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Kitchen range modal */}
            <Dialog
                visible={showKitchenRangeListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseKitchenRangeListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsKitchenRangeSearchKey`}
                            inputId="fsKitchenRangeSearchKey"
                            value={fsKitchenRangeSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSKitchenRangeSearchKey(e.target.value)}
                            placeholder="Search kitchen range by name"
                            disabled={fsKitchenRanges?.length === 0}
                            onClear={() => setFSKitchenRangeSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseKitchenRangeListModal}
                        />
                    </div>

                    {loadingFSKitchenRanges ? (
                        <CustomTableLoader />
                    ) : errorFSKitchenRanges ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSKitchenRanges}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsKitchenRangesData && fsKitchenRangesData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsKitchenRangesData?.map((kitchenRange) => (
                                        <div
                                            key={`kitchenRange_${kitchenRange?.id}`}
                                            className={`data_select_option p-ripple ${kitchenRange?.id === selectedFSKitchenRange?.id ? "selected" : ""}
                                            ${kitchenRange?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectKitchenRange(kitchenRange)}
                                        >
                                            <span>{kitchenRange?.range_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {kitchenRange?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateKitchenRange && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomKitchenRange !== null) {
                                                                    handleResetCustomFSKitchenRangeFields();
                                                                } else {
                                                                    handleEditCustomKitchenRange(kitchenRange);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomKitchenRange !== null && selectedCustomKitchenRange?.id === kitchenRange?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteKitchenRange && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSKitchenRange(kitchenRange);
                                                            }}
                                                            disabled={deleteKitchenRangeLoadingId === kitchenRange?.id}
                                                        >
                                                            <i className={deleteKitchenRangeLoadingId === kitchenRange?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsKitchenRangeSearchKey ? 'The kitchen range you were looking for is not found!' :
                                        `No kitchen ranges found for the '${selectedFSBrand ? selectedFSBrand?.brand_name : ''}' brand${selectedFSKitchenCollection ? ` in ${(selectedFSKitchenCollection?.kitchen_collection_name)?.toLowerCase()}` : ''}. ${hasPermissionForAddKitchenRange ? 'To add the kitchen range click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddKitchenRange && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customKitchenRangeName`}
                                    id="customKitchenRangeName"
                                    value={customKitchenRangeName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomKitchenRangeName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter range name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSKitchenRange : handleUpdateCustomFSKitchenRange}
                                    disabled={(customLoading || customKitchenRangeName === "") || (customDataState === 'Edit' && !customKitchenRangeUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customKitchenRangeNameError && (
                                <small className="form_error_msg">
                                    {customKitchenRangeNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Kitchen style modal */}
            <Dialog
                visible={showKitchenStyleListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseKitchenStyleListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsKitchenStyleSearchKey`}
                            inputId="fsKitchenStyleSearchKey"
                            value={fsKitchenStyleSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSKitchenStyleSearchKey(e.target.value)}
                            placeholder="Search kitchen style by name"
                            disabled={fsKitchenStyles?.length === 0}
                            onClear={() => setFSKitchenStyleSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseKitchenStyleListModal}
                        />
                    </div>

                    {loadingFSKitchenStyles ? (
                        <CustomTableLoader />
                    ) : errorFSKitchenStyles ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSKitchenStyles}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsKitchenStylesData && fsKitchenStylesData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsKitchenStylesData?.map((kitchenStyle) => (
                                        <div
                                            key={`kitchenStyle_${kitchenStyle?.id}`}
                                            className={`data_select_option p-ripple ${kitchenStyle?.id === selectedFSKitchenStyle?.id ? "selected" : ""}
                                            ${kitchenStyle?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectKitchenStyle(kitchenStyle)}
                                        >
                                            <span>{kitchenStyle?.style_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {kitchenStyle?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateKitchenStyle && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomKitchenStyle !== null) {
                                                                    handleResetCustomFSKitchenStyleFields();
                                                                } else {
                                                                    handleEditCustomKitchenStyle(kitchenStyle);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomKitchenStyle !== null && selectedCustomKitchenStyle?.id === kitchenStyle?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteKitchenStyle && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSKitchenStyle(kitchenStyle);
                                                            }}
                                                            disabled={deleteKitchenStyleLoadingId === kitchenStyle?.id}
                                                        >
                                                            <i className={deleteKitchenStyleLoadingId === kitchenStyle?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsKitchenStyleSearchKey ? 'The kitchen style you were looking for is not found!' :
                                        `No kitchen styles found. ${hasPermissionForAddKitchenStyle ? 'To add the kitchen style click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddKitchenStyle && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customKitchenStyleName`}
                                    id="customKitchenStyleName"
                                    value={customKitchenStyleName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomKitchenStyleName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter style name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSKitchenStyle : handleUpdateCustomFSKitchenStyle}
                                    disabled={(customLoading || customKitchenStyleName === "") || (customDataState === 'Edit' && !customKitchenStyleUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customKitchenStyleNameError && (
                                <small className="form_error_msg">
                                    {customKitchenStyleNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Accessory list modal */}
            <Dialog
                visible={showAccessoryListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseAccessoryListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsAccessorySearchKey`}
                            inputId="fsAccessorySearchKey"
                            value={fsAccessorySearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSAccessorySearchKey(e.target.value)}
                            placeholder="Search accessory by name"
                            disabled={fsAccessories?.length === 0}
                            onClear={() => setFSAccessorySearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseAccessoryListModal}
                        />
                    </div>

                    {loadingFSAccessories ? (
                        <CustomTableLoader />
                    ) : errorFSAccessories ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSAccessories}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsAccessoriesData && fsAccessoriesData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsAccessoriesData?.map((accessory) => (
                                        <div
                                            key={`accessory_${accessory?.id}`}
                                            className={`data_select_option p-ripple ${accessory?.id === selectedFSAccessory?.id ? "selected" : ""}
                                        ${accessory?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectAccessory(accessory)}
                                        >
                                            <span>{accessory?.accessory_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {accessory?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateAccessory && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomAccessory !== null) {
                                                                    handleResetCustomFSAccessoryFields();
                                                                } else {
                                                                    handleEditCustomAccessory(accessory);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomAccessory !== null && selectedCustomAccessory?.id === accessory?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteAccessory && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSAccessory(accessory);
                                                            }}
                                                            disabled={deleteAccessoryLoadingId === accessory?.id}
                                                        >
                                                            <i className={deleteAccessoryLoadingId === accessory?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsAccessorySearchKey ? 'The accessory you were looking for is not found!' :
                                        `No accessories found. ${hasPermissionForAddAccessory ? 'To add the accessory click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddAccessory && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customAccessoryName`}
                                    id="customAccessoryName"
                                    value={customAccessoryName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomAccessoryName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter accessory name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSAccessory : handleUpdateCustomFSAccessory}
                                    disabled={(customLoading || customAccessoryName === "") || (customDataState === 'Edit' && !customAccessoryUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customAccessoryNameError && (
                                <small className="form_error_msg">
                                    {customAccessoryNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Sub accessory list modal */}
            <Dialog
                visible={showAccessorySubListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseAccessorySubListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsAccessorySubSearchKey`}
                            inputId="fsAccessorySubSearchKey"
                            value={fsAccessorySubSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSAccessorySubSearchKey(e.target.value)}
                            placeholder="Search sub accessory by name"
                            disabled={fsSubAccessories?.length === 0}
                            onClear={() => setFSAccessorySubSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseAccessorySubListModal}
                        />
                    </div>

                    {loadingFSSubAccessories ? (
                        <CustomTableLoader />
                    ) : errorFSSubAccessories ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSSubAccessories}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsSubAccessoriesData && fsSubAccessoriesData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsSubAccessoriesData?.map((subAccessory) => (
                                        <div
                                            key={`subAccessory_${subAccessory?.id}`}
                                            className={`data_select_option p-ripple ${subAccessory?.id === selectedFSAccessorySub?.id ? "selected" : ""}
                                        ${subAccessory?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectAccessorySub(subAccessory)}
                                        >
                                            <span>{subAccessory?.accessory_sub_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {subAccessory?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateSubAccessory && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomAccessorySub !== null) {
                                                                    handleResetCustomFSAccessorySubFields();
                                                                } else {
                                                                    handleEditCustomAccessorySub(subAccessory);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomAccessorySub !== null && selectedCustomAccessorySub?.id === subAccessory?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteSubAccessory && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSAccessorySub(subAccessory);
                                                            }}
                                                            disabled={deleteAccessorySubLoadingId === subAccessory?.id}
                                                        >
                                                            <i className={deleteAccessorySubLoadingId === subAccessory?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsAccessorySubSearchKey ? 'The sub accessory you were looking for is not found!' :
                                        `No sub accessories found. ${hasPermissionForAddSubAccessory ? 'To add the sub accessory click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddSubAccessory && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customAccessorySubName`}
                                    id="customAccessorySubName"
                                    value={customAccessorySubName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomAccessorySubName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter sub accessory name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSAccessorySub : handleUpdateCustomFSAccessorySub}
                                    disabled={(customLoading || customAccessorySubName === "") || (customDataState === 'Edit' && !customAccessorySubUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customAccessorySubNameError && (
                                <small className="form_error_msg">
                                    {customAccessorySubNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Item list modal */}
            <Dialog
                visible={showItemListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseItemListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsItemSearchKey`}
                            inputId="fsItemSearchKey"
                            value={fsItemSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSItemSearchKey(e.target.value)}
                            placeholder="Search item by name"
                            disabled={fsItems?.length === 0}
                            onClear={() => setFSItemSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseItemListModal}
                        />
                    </div>

                    {loadingFSItems ? (
                        <CustomTableLoader />
                    ) : errorFSItems ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSItems}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsItemsData && fsItemsData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsItemsData?.map((item) => (
                                        <div
                                            key={`item_${item?.id}`}
                                            className={`data_select_option p-ripple ${item?.id === selectedFSItem?.id ? "selected" : ""}
                                        ${item?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectItem(item)}
                                        >
                                            <span>{item?.item_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {item?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateItem && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomItem !== null) {
                                                                    handleResetCustomFSItemFields();
                                                                } else {
                                                                    handleEditCustomItem(item);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomItem !== null && selectedCustomItem?.id === item?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteItem && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSItem(item);
                                                            }}
                                                            disabled={deleteItemLoadingId === item?.id}
                                                        >
                                                            <i className={deleteItemLoadingId === item?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsItemSearchKey ? 'The Item you were looking for is not found!' :
                                        `No items found. ${hasPermissionForAddItem ? 'To add the item click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddItem && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customItemName`}
                                    id="customItemName"
                                    value={customItemName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomItemName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter item name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSItem : handleUpdateCustomFSItem}
                                    disabled={(customLoading || customItemName === "") || (customDataState === 'Edit' && !customItemUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customItemNameError && (
                                <small className="form_error_msg">
                                    {customItemNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Appliance list modal */}
            <Dialog
                visible={showApplianceListModal}
                headerClassName="d-none"
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm data_select_modal"
                contentClassName="data_select_modal_content"
                onHide={handleCloseApplianceListModal}
            >
                <div className="custom_modal_body data_select_modal_area">
                    <div className="data_select_modal_header">
                        <DataListModalSearch
                            key={`fsApplianceSearchKey`}
                            inputId="fsApplianceSearchKey"
                            value={fsApplianceSearchKey}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFSApplianceSearchKey(e.target.value)}
                            placeholder="Search appliance by name"
                            disabled={fsAppliances?.length === 0}
                            onClear={() => setFSApplianceSearchKey("")}
                        />

                        <DataListModalClose
                            onClose={handleCloseApplianceListModal}
                        />
                    </div>

                    {loadingFSAppliances ? (
                        <CustomTableLoader />
                    ) : errorFSAppliances ? (
                        <div className="data_select_modal_body has_custom_input">
                            <DataException
                                message={errorFSAppliances}
                            />
                        </div>
                    ) : (
                        <div className="data_select_modal_body has_custom_input">
                            {fsAppliancesData && fsAppliancesData?.length > 0 ? (
                                <div className="data_select_option_area">
                                    {fsAppliancesData?.map((appliance) => (
                                        <div
                                            key={`appliance_${appliance?.id}`}
                                            className={`data_select_option p-ripple ${appliance?.id === selectedFSAppliance?.id ? "selected" : ""}
                                        ${appliance?.created_by !== null ? 'custom' : ''}`}
                                            onClick={() => handleSelectAppliance(appliance)}
                                        >
                                            <span>{appliance?.appliance_name}</span>
                                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                                            {appliance?.created_by !== null && (
                                                <div className="custom_data_action_area">
                                                    {hasPermissionForUpdateAppliance && (
                                                        <button className="is_btn data_select_option_edit_btn p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                if (selectedCustomAppliance !== null) {
                                                                    handleResetCustomFSApplianceFields();
                                                                } else {
                                                                    handleEditCustomAppliance(appliance);
                                                                }
                                                            }}>
                                                            <i className={`bi ${(selectedCustomAppliance !== null && selectedCustomAppliance?.id === appliance?.id) ? 'bi-x-lg' : 'bi-pencil-square'}`}></i>
                                                        </button>
                                                    )}

                                                    {hasPermissionForDeleteAppliance && (
                                                        <button className="is_btn data_select_option_edit_btn delete p-ripple"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteCustomFSAppliance(appliance);
                                                            }}
                                                            disabled={deleteApplianceLoadingId === appliance?.id}
                                                        >
                                                            <i className={deleteApplianceLoadingId === appliance?.id ? 'ri-loader-4-fill loading_spinner' : 'bi bi-trash'}></i>
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <DataException
                                    message={fsApplianceSearchKey ? 'The appliance you were looking for is not found!' :
                                        `No appliances found. ${hasPermissionForAddAppliance ? 'To add the appliance click on add button' : ''}`}
                                />
                            )}
                        </div>
                    )}

                    {hasPermissionForAddAppliance && (
                        <div className="page_form_group data_select_modal_footer mb-0">
                            <div className="input_with_button_area">
                                <InputText
                                    key={`customApplianceName`}
                                    id="customApplianceName"
                                    value={customApplianceName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomApplianceName(e.target.value)}
                                    className="custom_form_input has_add_value custom_data_input"
                                    placeholder="Enter appliance name"
                                    autoComplete="off"
                                />
                                <button
                                    className="add_value_btn fill p-ripple"
                                    onClick={customDataState === 'Add' ? handleCreateCustomFSAppliance : handleUpdateCustomFSAppliance}
                                    disabled={(customLoading || customApplianceName === "") || (customDataState === 'Edit' && !customApplianceUpdateHasChanges)}
                                >
                                    <i className={customLoading ? "ri-loader-4-fill loading_spinner" : customDataState === 'Edit' ? "bi bi-pencil-square" : "bi bi-plus-lg"}></i>
                                    <span>{customLoading ? "Processing" : customDataState === 'Edit' ? "Update" : "Add"}</span>
                                    <Ripple />
                                </button>
                            </div>
                            {customApplianceNameError && (
                                <small className="form_error_msg">
                                    {customApplianceNameError}
                                </small>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            {/*  */}


            {/* Kitchen style list modal */}
            {/*  */}


            {/* Feature data View modal */}
            <FeatureDataViewModal
                isOpen={showFSDataViewModal}
                onClose={handleCloseFSDataViewModal}
                feature={activeFSFeature?.feature!}
                lightData={selectedLightDetail}
                doorData={selectedDoorDetail}
                paintData={selectedPaintDetail}
                bathroomData={selectedBathroomDetail}
                kitchenData={selectedKitchenDetail}
                kitchenApplianceData={selectedKitchenApplianceDetail}
                tileData={selectedTileDetail}
                floorFinishingData={selectedFloorFinishingData}
                otherData={selectedOtherDetail}
                accessoryData={selectedAccessoryDetail}
                canDelete={hasPermissionForDeleteFile}
                fileDeleteLoadingIndex={fileDeleteLoadingIndex}
                onDeleteFile={handleDeleteFile}
            />
            {/*  */}


            {/* Share feature modal */}
            <ShareModal
                key={activeFSFeature?.id}
                isOpen={showContactShareModal}
                canEditOption={false}
                loading={loading}
                sharedList={sharedList}
                projectContactIds={projectContactIds}
                onClose={handleCloseShareModal}
                onShare={shareFeature}
                title={`Share ${activeFSFeature?.feature} feature`}
            />
            {/*  */}


            {/* Report config modal */}
            <FSReportConfigModal
                isOpen={showReportConfigModal}
                onClose={handleCloseReportConfigModal}
                fsData={finishingScheduleProject}
                defaultSelectedOptions={selectedFeatureOptions}
                onPreview={handlePreviewReport}
            />
        </React.Fragment >
    )
}

export default FinishingSchedule;